const strings = {
  'es': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'No encontramos ese código. Revisa que esté completo, por ejemplo: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Este código ya se ha utilizado. Si ya te registraste, inicia sesión. Si no, pide un código nuevo a ACES.',
    'codigo_expirado': 'Este código ha caducado. Pide un código nuevo a ACES.',
    'codigo_admin': 'Este código es de administración y no sirve para registrarse aquí. Contacta con ACES.',
    'registro_error_general': 'No se pudo completar el registro y no se ha creado ninguna cuenta. Inténtalo de nuevo; si vuelve a fallar, escribe a ACES.',
    'email_ya_registrado_login': 'Este email ya tiene una cuenta. Pulsa "Iniciar sesión" y, si no recuerdas la contraseña, usa "¿Olvidaste tu contraseña?".',
    'nueva_gala_btn': 'Crear gala',
    'programar_visita': 'Programar visita de evaluación',
    'guardar_notas': 'Guardar notas',
    'historial_estados': 'Historial de estados',
    'notas_privadas_hint': 'Notas privadas sobre esta candidatura (solo visible para masters)...',
    'voto_emitido': 'Voto emitido:',
    'voto_en_contra': 'En contra',
    'voto_a_favor': 'A favor',
    'voto_final_desc': 'La candidatura está en fase de votación. Emite tu voto.',
    'voto_final_titulo': 'Voto final requerido',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titularidades — próximamente',
    'email_abierto': 'Se abrió tu cliente de email',
    'cargo_hint': 'Ej: Concejal de Deportes',
    'password_repetir_hint': 'Repite la contraseña',
    'password_min': 'Mínimo 6 caracteres',
    'placeholder_apellido_ej': 'García',
    'placeholder_nombre_ej': 'María',
    'error_guardar': 'Error al guardar',
    'error_label': 'Error',
    'error_subir': 'Error al subir',
    'error_cambiar_password': 'Error al cambiar contraseña',
    'candidatura_no_encontrada': 'Candidatura no encontrada',
    'puntuacion_final': 'Puntuación final',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Destino',
    'origen_label': 'Origen',
    'notif_actividad_desc': 'La actividad de tus candidaturas aparecerá aquí.',
    'placeholder_ej_espana': 'Ej: España',
    'placeholder_ej_madrid': 'Ej: Madrid',
    'gala_lugar_hint': 'Ej: Palacio de Congresos',
    'gala_titulo_hint': 'Ej: Gala ACES América 2026',
    'gala_descripcion_hint': 'Descripción del evento...',
    'gala_pais': 'País del evento',
    'gala_ciudad': 'Ciudad del evento',
    'gala_lugar': 'Lugar de la ceremonia',
    'gala_titulo_label': 'Título de la gala',
    'visible_ciudades': 'Visible para ciudades',
    'nueva_gala': 'Nueva gala',
    'sin_galas': 'Sin galas configuradas',
    'gala_gestion': 'Gestión de la ceremonia de gala',
    'gala_aces_titulo': 'Gala ACES',
    'codigo_copiado': 'Código copiado',
    'error_generar_codigo': 'Error al generar código',
    'nombre_eval_email': 'Nombre del evaluador (para el email)',
    'invitar_evaluador': 'Invitar evaluador',
    'sin_evaluadores': 'Sin evaluadores registrados',
    'preview': 'Preview',
    'ver_todos': 'Ver todos',
    'total_candidaturas': 'Total candidaturas',
    'titulos_adjudicados': 'Títulos adjudicados',
    'tamano_comite': 'Tamaño del comité (evaluadores)',
    'sanciones_asistencia': 'Sanciones por no asistencia (€)',
    'tasas_participacion': 'Tasas de participación (€)',
    'config_sistema_perfil': 'Sistema y perfil',
    'sin_candidaturas_desc2': 'Prueba a cambiar los filtros o crea una nueva.',
    'placeholder_pais_ej': 'Ej: Argentina',
    'placeholder_ciudad_ej': 'Ej: Buenos Aires',
    'buscar_evaluador': 'Buscar evaluador...',
    'notas_decision_hint': 'Notas internas sobre la decisión...',
    'concepto_placeholder': 'Ej: Tasa de participación 2026',
    'sin_jefe_asignado': 'Sin jefe asignado',
    'jefe_comision': 'Jefe de comisión',
    'ciudad_label': 'Ciudad',
    'descargar_app_store': 'Descargar en App Store',
    'aforo_maximo': 'Aforo máximo',
    'descripcion_label': 'Descripción',
    'convocatoria_label': 'Convocatoria',
    'abrir_email': 'Abrir email',
    'crear_gala': 'Crear gala',
    'en_evaluacion': 'En evaluación',
    'emails_institucionales': 'Emails institucionales',
    'email_evaluador': 'Email del evaluador',
    'codigo_acceso_label': 'Código de acceso',
    'codigos_acceso': 'Códigos de acceso',
    'seleccionar_galardon': 'Seleccionar galardón...',
    'todos_galardones': 'Todos los galardones',
    'todos_estados': 'Todos los estados',
    'cargando_dashboard': 'Cargando dashboard...',
    'candidaturas_recientes': 'Candidaturas recientes',
    'candidaturas_activas': 'Candidaturas activas',
    'alertas_sistema': 'Alertas del sistema',
    'accesos_rapidos': 'Accesos rápidos',
    'viaje_titulo': 'Viaje',
    'nuevo': 'Nuevo',
    'estado': 'Estado',
    'abrir_votacion': 'Abrir votación',
    'accion_anadir_evaluador': 'Añadir evaluador',
    'accion_master': 'Acción de master',
    'accion_nueva_candidatura': 'Nueva candidatura',
    'accion_ver_alertas': 'Ver alertas',
    'actividad': 'Actividad',
    'agenda_notas': 'Notas internas',
    'agenda_notas_hint': 'Ej: El evaluador será recibido por el Alcalde...',
    'agenda_pdf_listo': 'PDF de agenda adjunto',
    'agenda_propuesta_enviada': 'Evento de agenda enviado',
    'agenda_subir_pdf': 'Subir PDF de agenda completa (opcional)',
    'agenda_tipo_evento': 'Tipo de evento',
    'agenda_titulo_evento': 'Título del evento',
    'agenda_vacia': 'Agenda vacía',
    'alerta_decision_pendiente': 'Decision pendiente',
    'alerta_docs_pendientes': 'Documentos pendientes',
    'alerta_pago_vencido': 'Pago vencido',
    'alerta_sin_evaluadores': 'Sin evaluadores asignados',
    'alertas_titulo': 'Alertas',
    'anos': 'años',
    'anterior': 'Anterior',
    'apellidos': 'Apellidos',
    'aprobar': 'Aprobar',
    'asignacion_ciudad_hint': 'Ej: Madrid',
    'asignacion_ciudad_salida': 'Ciudad de salida para la visita',
    'asignacion_ciudad_salida_desc': 'Ciudad desde la que partirás para la visita de evaluación.',
    'asignacion_compartir_ciudad': 'Compartir teléfono con la ciudad',
    'asignacion_compartir_ciudad_desc': 'La ciudad podrá ver tu número de teléfono y WhatsApp.',
    'asignacion_compartir_eval_desc': 'Los demás evaluadores de esta candidatura podrán ver tu contacto.',
    'asignacion_compartir_evaluadores': 'Compartir con otros evaluadores',
    'asignacion_confirmar': 'Confirmar y comenzar',
    'asignacion_nota': 'Nota para la ciudad (opcional)',
    'asignacion_nota_desc': 'Esta nota será visible para el equipo de la ciudad candidata.',
    'asignacion_nota_hint': 'Ej: Llegaré en AVE desde Málaga el martes por la mañana...',
    'asignacion_privacidad': 'Privacidad y contacto',
    'asignacion_sub': 'Antes de empezar, configura tus datos de contacto para esta candidatura.',
    'asignacion_titulo': 'Nueva asignación',
    'asignar_ciudad_titulo': 'Asignar ciudad',
    'asignar_evaluador': 'Asignar evaluador',
    'auth_cargando': 'Iniciando...',
    'auth_cerrar_sesion': 'Cerrar sesión',
    'auth_email': 'Email',
    'auth_entrar': 'Iniciar sesión',
    'auth_error_credenciales': 'Email o contraseña incorrectos.',
    'auth_error_red': 'Sin conexión a internet.',
    'auth_password': 'Contraseña',
    'auth_subtitulo': 'Plataforma de candidaturas deportivas ACES',
    'avanzar_a': 'Avanzar a',
    'borrar': 'Borrar',
    'borrar_todas': 'Borrar todas',
    'buscar_ciudad_email': 'Buscar ciudad, email...',
    'buscar_pais': 'Buscar país...',
    'buscar_placeholder': 'Buscar ciudad, galardón...',
    'cambios': 'Cambios',
    'campos_obligatorios': 'Completa todos los campos obligatorios.',
    'cancelar': 'Cancelar',
    'candidatura_asignada_ok': 'Candidatura asignada',
    'cargando_candidatura': 'Cargando candidatura...',
    'cargo': 'Cargo',
    'cat_carta': 'Carta de intención',
    'cat_eventos': 'Eventos',
    'cat_galardones': 'Galardones previos',
    'cat_infra': 'Infraestructura',
    'cat_otros': 'Otros',
    'cat_presupuesto': 'Presupuesto',
    'categoria': 'Categoría',
    'cerrar': 'Cerrar',
    'cerrar_votacion': 'Cerrar votación',
    'chat_ciudad': 'Chat con ACES',
    'chat_ciudad_aces': 'Ciudad ↔ ACES',
    'chat_ciudad_aces_desc': 'Comunicacion entre tu ciudad y ACES',
    'chat_conversaciones': 'Conversaciones',
    'chat_elige_conversacion': 'Elige una conversacion',
    'chat_escribir': 'Escribe un mensaje...',
    'chat_interno': 'Chat de comisión',
    'chat_interno_desc': 'Canal privado con la comisión de evaluación',
    'chat_mis_chats': 'Mis chats',
    'chat_sin_activos': 'Sin chats activos',
    'chat_sin_activos_desc': 'Los chats con candidaturas aparecerán aquí',
    'chat_sin_mensajes': 'Sin mensajes aún',
    'chat_adjuntar': 'Adjuntar archivo',
    'chat_adjunto_expira': 'Archivo disponible 7 dias',
    'chat_adjunto_max': 'Archivo demasiado grande (max 10MB)',
    'chat_borrar': 'Borrar para todos',
    'chat_buscar_conv': 'Buscar ciudad o galardon...',
    'chat_confirmar_borrar': 'Borrar este mensaje para todos?',
    'chat_filtro_no_leidas': 'No leidas',
    'chat_filtro_todas': 'Todas',
    'chat_mensaje_borrado': 'Mensaje eliminado',
    'chat_no_leidos': 'no leidos',
    'chat_activas': 'chats activos',
    'chat_recargar': 'Actualizar',
    'chat_responder': 'Responder',
    'chat_sin_no_leidos': 'Todo leido',
    'warn_poblacion_min': 'Poblacion minima requerida',
    'warn_poblacion_max': 'Poblacion maxima permitida',
    'warn_actual': 'Actual',
    'warn_max_candidaturas': 'Maximo candidaturas para este galardon',
    'warn_actuales': 'Actuales',
    'warn_espera': 'Periodo de espera',
    'warn_anos': 'anos',
    'warn_ultima': 'Ultima adjudicacion',
    'warn_elegible_desde': 'Elegible desde',
    'warn_elegibilidad': 'Warnings de elegibilidad',
    'warn_override': 'Override Master: crear candidatura igualmente',
    'warn_override_required': 'Hay warnings de elegibilidad. Marca Override para continuar.',
    'tasa_auto': 'Se creara pago automatico de',
    'poblacion_label': 'Poblacion',
    'galardon_label': 'Galardon',
    'calendario_procesal': 'Calendario procesal (Art. 15)',
    'regla_25_titulo': 'Regla 2.5 puntos (Art. 15)',
    'regla_25_desc': 'La diferencia entre los dos primeros es',
    'regla_25_info': 'El Master puede adjudicar al segundo clasificado si lo justifica.',
    'regla_25_justificacion_hint': 'Justifica la decision, especialmente si se aplica regla 2.5...',
    'resumen_puntuaciones': 'Puntuaciones evaluadores',
    'candidatura_adjudicada': 'Candidatura adjudicada!',
    'error_campos_obligatorios': 'Ciudad, pais y galardon son obligatorios.',
    'checklist_aprobado': 'APROBADA',
    'checklist_titulo': 'Requisitos de documentación',
    'ciudad': 'Ciudad',
    'ciudad_asignada': 'Ciudad asignada',
    'ciudad_asignar': 'Asignar',
    'ciudad_cambiar': 'Cambiar',
    'ciudad_cargo': 'Cargo',
    'ciudad_contacto_principal': 'Contacto principal',
    'ciudad_desde': 'Ciudad desde',
    'ciudad_email': 'Email',
    'ciudad_historico': 'Historial',
    'ciudad_modulos': 'Módulos',
    'ciudad_nombre': 'Nombre',
    'ciudad_recursos': 'Recursos ACES',
    'ciudad_rol': 'Rol',
    'ciudad_salida': 'Ciudad de salida',
    'ciudad_salida_desc': 'La ciudad candidata necesita saber desde dónde viajas para reservar tu vuelo.',
    'ciudad_salida_hint': 'Ej: Madrid, Barcelona...',
    'ciudad_salida_pendiente': 'Ciudad de salida pendiente',
    'ciudad_sin_asignar': 'Sin ciudad asignada',
    'ciudad_sin_candidatura': 'Sin candidatura activa',
    'ciudad_sin_candidatura_desc': 'Contacta con ACES para iniciar el proceso.',
    'ciudad_telefono': 'Teléfono',
    'codigo_activando': 'Activando...',
    'codigo_activar': 'Activar código',
    'codigo_error_invalido': 'Código inválido o ya utilizado.',
    'codigo_generado_label': 'CÓDIGO GENERADO',
    'codigo_invalido': 'Código no válido o ya utilizado.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Introduce el código ACESCN que te proporcionó ACES.',
    'codigo_titulo': 'Código de acceso',
    'codigo_vacio': 'Introduce tu código de acceso.',
    'codigo_validar': 'Validar código',
    'codigos_disponibles': 'Disponibles',
    'codigos_generados': 'Códigos generados',
    'codigos_usados': 'Códigos usados',
    'comision_sin_otros': 'Solo tú en la comisión',
    'comision_sin_otros_desc': 'Aún no hay otros evaluadores asignados a esta candidatura.',
    'comision_titulo': 'Comisión evaluadora',
    'completado': 'completado',
    'comprobante_desc': 'Sube el justificante de transferencia bancaria en PDF o imagen.',
    'comprobante_subido': 'Comprobante subido correctamente',
    'comprobante_titulo': 'Comprobante de pago',
    'config_comite': 'Tamaño del comité',
    'config_convocatorias': 'Convocatorias abiertas',
    'config_correos_desc': 'Configura las direcciones de correo del sistema',
    'config_correos_titulo': 'Correos del sistema',
    'config_guardada': 'Configuración guardada',
    'config_sanciones': 'Sanciones por no asistencia a gala (€)',
    'config_sistema_titulo': 'Configuración del sistema',
    'config_tasas': 'Tasas de participación (€)',
    'confirmada': 'Confirmada',
    'confirmando': 'Confirmando...',
    'confirmar_asistencia': 'Confirmar asistencia',
    'contacto_principal': 'Contacto principal',
    'continuar': 'Continuar',
    'continuar_evaluacion': 'Continuar evaluación',
    'convocatoria': 'Convocatoria',
    'creando': 'Creando...',
    'crear_candidatura': 'Crear candidatura',
    'crear_cuenta': 'Crear cuenta',
    'dashboard_accesos_rapidos': 'Accesos rápidos',
    'dashboard_awos_sub': 'Registra tus actividades deportivas y accede a estadísticas globales.',
    'dashboard_awos_titulo': 'AWoS Activa',
    'dashboard_documentos': 'Documentos',
    'dashboard_estado': 'Estado candidatura',
    'dashboard_mensajes': 'Mensajes',
    'dashboard_pagos_pendientes': 'Pagos pendientes',
    'datos_opcionales': 'Estos datos son opcionales y puedes actualizarlos desde tu perfil.',
    'de': 'de',
    'decision_adjudicar': 'Adjudicar',
    'decision_advertencia': 'Esta decisión es inapelable y quedará registrada permanentemente.',
    'decision_confirmar': 'Confirmar decisión',
    'decision_nav': 'Decisión final',
    'decision_notas': 'Notas de la decisión (obligatorio)',
    'decision_rechazar': 'No adjudicar',
    'decision_selecciona': 'Selecciona la decisión',
    'decision_titulo': 'Decisión final',
    'desbloquear': 'Desbloquear',
    'desde': 'desde',
    'destino': 'Destino',
    'dia': 'Día',
    'dias': 'días',
    'dias_label': 'días',
    'dias_visita_label': 'días de visita',
    'doc_subido_ok': 'Documento subido correctamente',
    'docs_pendientes': 'Docs pendientes',
    'documento_pendiente': 'Documento pendiente de recibir',
    'duracion_visita_label': 'DURACIÓN DE LA VISITA',
    'editar': 'Editar',
    'eliminar': 'Eliminar',
    'eliminar_cuenta': 'Eliminar mi cuenta',
    'eliminar_cuenta_desc': 'Esta acción es irreversible. Tus datos serán anonimizados conforme al RGPD.',
    'eliminar_cuenta_password': 'Introduce tu contraseña para confirmar',
    'eliminar_cuenta_titulo': 'Eliminar cuenta',
    'eliminar_documento': 'Eliminar documento',
    'email_ciudad_label': 'EMAIL DE LA CIUDAD',
    'email_contacto': 'Email de contacto',
    'email_enviado': 'Correo enviado correctamente',
    'email_enviar': 'Enviar correo oficial',
    'email_idioma': 'Idioma del correo',
    'email_invalido': 'Email no válido.',
    'email_preview': 'Vista previa del correo',
    'email_remitente': 'Enviar desde',
    'email_ya_registrado': 'Este email ya está registrado.',
    'emitir_factura_titulo': 'Emitir factura',
    'emitir_nueva_factura': 'Emitir nueva factura',
    'enviada': 'Enviada',
    'enviado_por_aces': 'Enviado por ACES',
    'enviando': 'Enviando...',
    'enviar': 'Enviar',
    'enviar_evaluacion': 'Enviar evaluación',
    'enviar_propuesta': 'Enviar propuesta',
    'eres_jefe_comision': 'Eres jefe de comisión',
    'error_generico': 'Ha ocurrido un error. Inténtalo de nuevo.',
    'escribiendo': 'está escribiendo',
    'estado_aceptada': 'Aceptada',
    'estado_adjudicada': 'Adjudicada',
    'estado_decision': 'Decisión pendiente',
    'estado_documentacion': 'Documentación',
    'estado_evaluacion': 'En evaluación',
    'estado_pipeline': 'Pipeline de candidatura',
    'estado_rechazada': 'No adjudicada',
    'estado_solicitada': 'Solicitada',
    'estado_visita': 'Visita programada',
    'estado_votacion': 'En votación',
    'eval_abrev': 'eval.',
    'eval_abrir_motor': 'Abrir motor de evaluación',
    'eval_anterior': 'Anterior',
    'eval_asignadas': 'Mis asignadas',
    'eval_asignado_ok': 'Evaluador asignado',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Cargando evaluación...',
    'eval_comentario_placeholder': 'Comenta tu puntuación...',
    'eval_comentario_voto': 'Comentario al voto final',
    'eval_comision_pendiente': 'Información de evaluadores disponible próximamente.',
    'eval_comision_titulo': 'Evaluadores asignados',
    'eval_confirmar_desc': 'Una vez enviada no podrás modificarla sin que el Master la desbloquee.',
    'eval_confirmar_envio': 'Enviar evaluación',
    'eval_conflicto_interes': 'Conflicto de interés: eres del mismo país que la ciudad candidata a Capital.',
    'eval_desfavorable': 'Desfavorable',
    'eval_enviada_desc': 'Tu evaluación ha sido registrada correctamente.',
    'eval_enviada_ok': 'Evaluación enviada correctamente',
    'eval_enviada_titulo': 'Evaluación enviada',
    'eval_enviadas': 'enviadas',
    'eval_enviar': 'Enviar',
    'eval_enviar_btn': 'Enviar',
    'eval_favorable': 'Favorable',
    'eval_habilitada': 'Evaluación habilitada',
    'eval_ir_motor': 'Ir al motor de evaluación',
    'eval_lista': 'Evaluadores',
    'eval_mi_evaluacion': 'Mi evaluación',
    'eval_mis_candidaturas': 'Mis candidaturas',
    'eval_motor_titulo': 'Motor de evaluación',
    'eval_no_habilitada': 'La evaluación aún no está habilitada por ACES.',
    'eval_notas_comentario': 'Notas y comentarios',
    'eval_quitado': 'Evaluador quitado',
    'eval_registrados': 'Registrados',
    'eval_seccion': 'Sección',
    'eval_siguiente': 'Siguiente',
    'eval_sin_activas': 'Sin candidaturas activas',
    'eval_sin_asignadas': 'Sin candidaturas asignadas',
    'eval_sin_asignadas_desc': 'El Master asignará candidaturas a tu comisión.',
    'eval_sin_documentos': 'Sin documentos',
    'eval_sin_documentos_desc': 'La ciudad aún no ha subido documentos.',
    'eval_sin_reservas': 'Sin reservas aún',
    'eval_stat_asignadas': 'Asignadas',
    'eval_stat_completadas': 'Completadas',
    'eval_stat_pendientes': 'Pendientes',
    'eval_todas': 'Todas activas',
    'eval_todas_activas': 'Candidaturas activas',
    'eval_todas_aviso': 'Vista de solo lectura. Detalle completo solo para tus candidaturas asignadas.',
    'eval_total_seccion': 'Puntuación de esta sección',
    'eval_ver_escala': 'Ver escala de puntuación',
    'eval_voto_final': 'Voto final',
    'eval_voto_informativo': 'Tu voto es informativo. La decisión final corresponde al Master ACES.',
    'evaluacion_titulo': 'Evaluación',
    'evaluaciones_enviadas': 'evaluaciones enviadas',
    'evaluadores_asignados': 'evaluadores asignados',
    'evaluadores_asignados_label': 'EVALUADORES ASIGNADOS',
    'evento_almuerzo': 'Almuerzo',
    'evento_cena': 'Cena',
    'evento_desayuno': 'Desayuno',
    'evento_descanso': 'Descanso',
    'evento_llegada': 'Llegada',
    'evento_otro': 'Otro',
    'evento_recepcion': 'Recepción',
    'evento_reunion': 'Reunión',
    'evento_rueda_prensa': 'Rueda prensa',
    'evento_salida': 'Salida',
    'evento_traslado': 'Traslado',
    'evento_visita': 'Visita',
    'factura_creada_ok': 'Factura registrada. Ahora sube el PDF.',
    'factura_detalle': 'Detalle / Concepto ampliado',
    'factura_detalle_hint': 'Descripción detallada de los servicios, condiciones de pago, datos bancarios...',
    'factura_subida_ok': 'Factura subida correctamente',
    'facturas_aces': 'De ACES',
    'fecha_llegada_label': 'FECHA DE LLEGADA',
    'fecha_regreso': 'Fecha de regreso',
    'fecha_salida': 'Fecha de salida',
    'fecha_vencimiento_label': 'FECHA DE VENCIMIENTO',
    'filtro_estado': 'Estado',
    'filtro_tipo': 'Tipo',
    'filtro_todas': 'Todas',
    'filtro_todos': 'Todos',
    'gala_asistencia_confirmada': 'Asistencia confirmada',
    'gala_invitacion_titulo': 'Invitación a la Gala',
    'gala_pendiente_desc': 'ACES activará tu invitación cuando llegue el momento.',
    'gala_pendiente_invitacion': 'Invitación pendiente',
    'gala_representantes': 'Representantes',
    'gala_sin_datos': 'Sin datos de gala',
    'gala_sin_datos_desc': 'No hay información de la ceremonia para este año.',
    'gala_sin_representantes': 'Sin representantes añadidos',
    'galardon': 'Galardón',
    'general_error': 'Ha ocurrido un error',
    'general_reintentar': 'Reintentar',
    'generar_codigo': 'Generar código',
    'generar_codigo_titulo': 'Nuevo código de acceso',
    'gestionar_comision': 'Gestionar comisión',
    'guardado': 'Guardado',
    'guardando': 'Guardando...',
    'guardar': 'Guardar',
    'guardar_ciudad_salida': 'Guardar ciudad de salida',
    'guardar_config': 'Guardar configuración',
    'guardar_y_siguiente': 'Guardar y siguiente',
    'historico_titulo': 'Candidaturas anteriores',
    'hora': 'Hora',
    'hora_fin_opc': 'Hora fin (opcional)',
    'hora_inicio': 'Hora inicio',
    'idioma_titulo': 'Idioma de la interfaz',
    'iniciar_evaluacion': 'Iniciar evaluación',
    'invitacion_enviada': 'Invitación enviada',
    'invitar_ciudad_titulo': 'Invitar ciudad',
    'invitar_codigo_generado': 'Código generado',
    'invitar_copiar': 'Copiar',
    'invitar_cuerpo_eval': 'Le invitamos a unirse a ACES Cities Network como evaluador.\\n\\nSu código de acceso es:',
    'invitar_email': 'Enviar por email',
    'invitar_evaluador_sub': 'Genera un código y compártelo por WhatsApp o email',
    'invitar_evaluador_titulo': 'Invitar evaluador',
    'invitar_generar_codigo': 'Generar código de acceso',
    'invitar_nombre': 'Nombre del evaluador',
    'invitar_pie': 'Descargue la app ACES Cities Network, regístrese e introduzca su código cuando se le solicite.\\n\\n— ACES',
    'invitar_saludo': 'Estimado/a',
    'invitar_whatsapp': 'Enviar por WhatsApp',
    'jefe_comision_ninguno': 'Sin jefe asignado',
    'jefe_comision_sin_eval': 'Asigna evaluadores primero para designar un jefe.',
    'jefe_comision_titulo': 'Jefe de comisión',
    'jefe_designado_ok': 'Jefe de comisión designado',
    'jefe_eliminado_ok': 'Jefe de comisión eliminado',
    'llegada': 'Llegada',
    'llegada_label': 'Llegada',
    'login_crear_cuenta': '¿Primera vez? Crear cuenta →',
    'login_olvide_contrasena': '¿Olvidaste tu contraseña?',
    'login_proximamente': 'Próximamente',
    'login_recuperar_desc': 'Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.',
    'login_recuperar_titulo': 'Recuperar acceso',
    'login_requiere_codigo': 'El acceso a Cities Network requiere un código de invitación ACES.',
    'login_restablecer': 'Restablecer contraseña',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Lugar',
    'marcar_leidas': 'Marcar todas leídas',
    'master_label': 'MASTER ACES',
    'master_panel_desc': 'Control total de candidaturas, evaluaciones y decisiones.',
    'master_recientes': 'Candidaturas recientes',
    'master_saludo': 'Panel ACES',
    'master_sin_candidaturas': 'Sin candidaturas aún',
    'mi_evaluacion': 'Mi evaluación',
    'mis_pagos': 'Mis pagos',
    'mod_chat': 'Chat ACES',
    'mod_documentos': 'Documentos',
    'mod_facturas_pagos': 'Facturas y Pagos',
    'mod_gala': 'Gala',
    'mod_pagos': 'Pagos',
    'mod_titularidad': 'Titularidad',
    'mod_viaje': 'Logística',
    'modo_evaluador': 'Evaluador',
    'modo_master': 'Master',
    'motor_evaluacion': 'Motor de evaluación',
    'no_configurado': 'No configurado — edita tu perfil',
    'nombre': 'Nombre',
    'nombre_documento': 'Nombre del documento',
    'nombre_hotel': 'Nombre del hotel',
    'notas_hint': 'Ej: Aterrizar en T4, hotel recomendado...',
    'notas_internas_label': 'NOTAS INTERNAS (opcional)',
    'notif_candidatura_actualizada': 'Candidatura actualizada',
    'notif_candidatura_desasignada': 'Candidatura desasignada',
    'notif_documento_revisado': 'Documento revisado',
    'notif_estado_actualizado': 'Estado actualizado',
    'notif_evaluacion_completada': 'Evaluación completada',
    'notif_limpiar_desc': 'Se eliminarán todas las notificaciones. Esta acción no se puede deshacer.',
    'notif_limpiar_todas': 'Limpiar todas',
    'notif_marcar_leida': 'Marcar leída',
    'notif_nueva_asignacion': 'Nueva candidatura asignada',
    'notif_pago_vencido': 'Pago próximo a vencer',
    'notif_sin_leer': 'Sin leer',
    'notif_sin_notifs': 'Sin notificaciones',
    'notif_visita_programada': 'Visita de evaluación programada',
    'notificar_ciudad': 'Notificar ciudad',
    'nueva_candidatura': 'Nueva candidatura',
    'nueva_propuesta': 'Nueva propuesta',
    'num_habitaciones': 'Número de habitaciones',
    'origen': 'Origen',
    'pago_enviar_recordatorio': 'Abrir correo',
    'pago_factura': 'Factura',
    'pago_instrucciones': 'Realiza la transferencia bancaria y sube el comprobante.',
    'pago_recibido': 'Cobrado',
    'pago_recordatorio': 'Recordatorio',
    'pago_recordatorio_desc': 'Se abrirá tu gestor de correo con el mensaje preparado.',
    'pago_recordatorio_titulo': 'Enviar recordatorio de pago',
    'pagos_ciudad': 'Mis pagos',
    'pagos_pendientes': 'Pagos pendientes',
    'pais': 'País',
    'pais_buscar': 'Buscar país...',
    'pais_seleccionado': 'País seleccionado',
    'pais_seleccionar': 'Seleccionar país',
    'paso_datos': 'Datos de la factura',
    'paso_subir_pdf': 'Subir PDF de factura',
    'password_actual': 'Contraseña actual',
    'password_cambiada': 'Contraseña cambiada correctamente',
    'password_cambiar': 'Cambiar contraseña',
    'password_corta': 'La contraseña debe tener al menos 6 caracteres.',
    'password_nueva': 'Nueva contraseña',
    'password_repetir': 'Repetir contraseña',
    'passwords_no_coinciden': 'Las contraseñas no coinciden.',
    'error_red': 'Error de red. Verifica tu conexión a Internet.',
    'error_demasiados_intentos': 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Carta de solicitud recibida',
    'hito_aprobada': 'Candidatura aprobada',
    'hito_reglamento_enviado': 'Reglamento enviado para firma',
    'hito_reglamento_firmado': 'Reglamento firmado recibido',
    'hito_datos_factura': 'Datos de factura recibidos',
    'hito_pago_confirmado': 'Pago confirmado',
    'hito_fechas_visita': 'Fechas de visita propuestas',
    'hito_comision_creada': 'Comisión de evaluación creada',
    'hito_viajes_cerrados': 'Viajes cerrados',
    'hito_agenda_enviada': 'Agenda enviada',
    'hito_bid_file': 'BID File recibido',
    'doc_tipo_carta_solicitud': 'Carta de solicitud',
    'doc_tipo_agenda_visita': 'Agenda de visita',
    // Logistica simplificada
    'mod_logistica': 'Logística',
    'agenda_vacia_ciudad': 'No hay agenda subida aún. Sube el PDF de la agenda de visita.',
    'agenda_aviso_master': 'La agenda es visible para evaluadores y la ciudad. Sube el PDF definitivo.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES publicará la agenda de visita cuando esté disponible.',
    'eval_reservas_desc': 'Tus reservas de vuelo y hotel confirmadas aparecerán aquí.',
    'eval_sin_reservas_desc': 'ACES o la ciudad subirán tus reservas de viaje cuando estén confirmadas.',
    'perfil_actualizado': 'Perfil actualizado',
    'perfil_apellidos': 'Apellidos',
    'perfil_cambiar_foto': 'Foto de perfil',
    'perfil_cargo': 'Cargo',
    'perfil_ciudad': 'Ciudad',
    'perfil_compartir_ciudad': 'Compartir teléfono con ciudades',
    'perfil_compartir_ciudad_desc': 'Las ciudades candidatas podrán ver tu número de contacto.',
    'perfil_compartir_eval_desc': 'Los evaluadores de tu misma comisión podrán ver tu contacto.',
    'perfil_compartir_evaluadores': 'Compartir con otros evaluadores',
    'perfil_contacto': 'Contacto',
    'perfil_cuenta': 'Cuenta',
    'perfil_datos': 'Datos personales',
    'perfil_datos_evaluador': 'Datos de comisión',
    'perfil_datos_personales': 'Datos personales',
    'perfil_elegir_foto': 'Seleccionar foto',
    'perfil_eval_config': 'Configuración evaluador',
    'perfil_evaluador': 'Configuración como evaluador',
    'perfil_fecha_nac': 'Fecha de nacimiento',
    'perfil_foto_actualizada': 'Foto actualizada correctamente',
    'perfil_guardado': 'Perfil guardado correctamente',
    'perfil_guardar': 'Guardar perfil',
    'perfil_idioma': 'Idioma de la app',
    'perfil_nombre': 'Nombre',
    'perfil_notificaciones': 'Notificaciones',
    'perfil_pais': 'País',
    'perfil_provincia': 'Provincia',
    'perfil_talla': 'Talla polo (comisión)',
    'perfil_telefono': 'Teléfono',
    'perfil_titulo': 'Mi perfil',
    'perfil_ubicacion': 'Ubicación',
    'pipeline_aceptada_desc': 'Candidatura aceptada. Prepara la documentación requerida.',
    'pipeline_adjudicada_desc': '¡Enhorabuena! Tu ciudad ha sido adjudicada.',
    'pipeline_decision_desc': 'La decisión final está siendo preparada por ACES.',
    'pipeline_documentacion_desc': 'Estamos revisando tu documentación.',
    'pipeline_evaluacion_desc': 'La comisión está analizando tu candidatura.',
    'pipeline_rechazada_desc': 'Tu candidatura no fue seleccionada en esta convocatoria.',
    'pipeline_solicitada_desc': 'Tu candidatura ha sido recibida y está siendo revisada.',
    'pipeline_visita_desc': 'Se está organizando la visita de evaluación.',
    'pipeline_votacion_desc': 'La comisión está deliberando sobre tu candidatura.',
    'precio_aprox': 'Precio aproximado (€)',
    'precio_estimado': 'Precio estimado (€)',
    'preview_email_label': 'PREVIEW DEL EMAIL',
    'programar_visita_titulo': 'Programar visita',
    'proponer_agenda': 'Agenda',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Vuelo',
    'provincia': 'Provincia / Estado',
    'provincia_seleccionar': 'Seleccionar provincia / región',
    'rechazar': 'Rechazar',
    'recomendaciones_titulo': 'Recomendaciones',
    'recordatorio_asunto': 'Recordatorio de pago — {ciudad}',
    'recordatorio_cuerpo': 'Estimado equipo de {ciudad},\\n\\nLe recordamos que se encuentra pendiente el pago correspondiente a: {concepto}.\\n\\nLe agradecemos que realice la transferencia a la mayor brevedad. Si tiene alguna duda, no dude en contactarnos.\\n\\nAtentamente,\\nACES',
    'reg_ciudad': 'Ciudad / Municipio *',
    'reg_creando': 'Creando cuenta...',
    'reg_crear_cuenta': 'Crear cuenta',
    'reg_pais': 'País *',
    'reg_provincia': 'Provincia / Región',
    'reg_resumen_titulo': 'Resumen de tu cuenta',
    'reg_telefono': 'Teléfono de contacto *',
    'reg_tipo': 'Tipo de acceso',
    'reg_ubicacion_sub': 'Información de tu organización',
    'reg_ubicacion_titulo': 'Tu ubicación',
    'registro_cancelar_salir': 'Cancelar y salir',
    'registro_codigo_label': 'CÓDIGO DE ACCESO ACES',
    'registro_contrasena_label': 'CONTRASEÑA',
    'registro_crear_cuenta': 'Crea tu cuenta',
    'registro_datos_personales': 'Datos personales',
    'registro_elige_rol': '¿Con qué rol accedes a Cities Network?',
    'registro_email_label': 'EMAIL',
    'registro_paso_1': 'Paso 1 de 3',
    'registro_paso_2': 'Paso 2 de 3',
    'registro_paso_2_desc': 'Estos datos se usan para la logística de visitas de evaluación.',
    'registro_paso_3': 'Paso 3 de 3',
    'registro_siguiente': 'Siguiente →',
    'registro_verifica_desc': 'Te hemos enviado un email de verificación. Ábrelo y haz clic en el enlace antes de continuar.',
    'registro_verifica_titulo': 'Verifica tu email',
    'rol_ciudad': 'Ciudad',
    'rol_evaluador': 'Evaluador',
    'rol_master': 'Master ACES',
    'salida': 'Salida',
    'salida_label': 'Salida',
    'saludo_buenas_noches': 'Buenas noches,',
    'saludo_buenas_tardes': 'Buenas tardes,',
    'saludo_buenos_dias': 'Buenos días,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Sección',
    'seleccionar': 'Seleccionar',
    'seleccionar_pais': 'Seleccionar país',
    'seleccionar_provincia': 'Seleccionar provincia',
    'sin_agenda': 'Sin agenda',
    'sin_agenda_desc': 'La ciudad aún no ha propuesto un calendario de visita.',
    'sin_candidaturas': 'Sin candidaturas',
    'sin_candidaturas_desc': 'No hay candidaturas con este filtro.',
    'sin_ciudad_asignada': 'Sin ciudad asignada',
    'sin_codigos_disponibles': 'Sin códigos disponibles',
    'sin_documentos': 'Sin documentos',
    'sin_documentos_desc': 'Sube los documentos requeridos para tu candidatura.',
    'sin_evaluaciones': 'Sin evaluaciones',
    'sin_evaluadores_desc': 'Registra evaluadores con un código ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Sin evaluadores registrados',
    'sin_facturas_aces': 'Sin facturas recibidas',
    'sin_facturas_aces_desc': 'Las facturas enviadas por ACES aparecerán aquí.',
    'sin_notificaciones': 'Sin notificaciones',
    'sin_notificaciones_desc': 'Cuando haya actividad en tus candidaturas aparecerá aquí.',
    'sin_pagos': 'Sin pagos',
    'sin_pagos_desc': 'Los pagos de tu candidatura aparecerán aquí.',
    'stat_activas': 'Activas',
    'stat_decision': 'Decisión pendiente',
    'stat_dias_visita': 'Días hasta visita',
    'stat_docs_pendientes': 'Docs. pendientes',
    'stat_evaluacion': 'En evaluación',
    'stat_mensajes_nuevos': 'Mensajes nuevos',
    'stat_notif': 'Sin leer',
    'stat_pagos_pendientes': 'Pagos pendientes',
    'stat_sin_visita': 'Sin visita fijada',
    'stat_titulos': 'Títulos activos',
    'stat_total': 'Total',
    'subir_comprobante': 'Subir comprobante',
    'subir_documento': 'Subir documento',
    'subir_factura': 'Subir factura',
    'subir_factura_desc': 'Sube el PDF de la factura. La ciudad podrá descargarlo desde su panel.',
    'subir_factura_titulo': 'Subir factura PDF',
    'subir_nota': 'Selecciona el archivo desde tu dispositivo',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidatura',
    'tab_candidaturas': 'Candidaturas',
    'tab_chat': 'Chat',
    'tab_config': 'Configuración',
    'tab_documentos': 'Documentos',
    'tab_evaluaciones': 'Evaluaciones',
    'tab_evaluadores': 'Evaluadores',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Inicio',
    'tab_notif': 'Notificaciones',
    'tab_pagos': 'Pagos',
    'tab_perfil': 'Perfil',
    'tab_recursos': 'Recursos',
    'tab_resumen': 'Resumen',
    'tab_viaje': 'Logística',
    'talla_polo': 'Talla de polo',
    'telefono': 'Teléfono',
    'template_no_disponible': 'El template de evaluación no está disponible aún.',
    'tipo_codigo': 'Tipo de código',
    'tit_ano_titulo': 'Año de titularidad',
    'tit_evidencias': 'Evidencias subidas',
    'tit_item_calendario': 'Calendario deportivo',
    'tit_item_congreso': 'Congreso o conferencia',
    'tit_item_imagen': 'Uso correcto del título',
    'tit_item_memoria': 'Memoria final',
    'tit_no_aplica': 'Sin año de titularidad',
    'tit_no_aplica_desc': 'Este módulo se activa cuando tu ciudad gana un galardón ACES.',
    'tit_sanciones': 'Sanciones',
    'tit_sin_datos': 'Sin titularidades activas',
    'tit_titulo': 'Año de titularidad',
    'toca_abrir_documento': 'Toca para abrir el documento',
    'toca_copiar': 'Toca el código para copiar',
    'toca_para_abrir': 'Toca para abrir',
    'toca_para_copiar': 'Toca para copiar',
    'tomar_decision': 'Decisión final',
    'tu_ciudad_salida': 'Tu ciudad de salida',
    'upload_error': 'Error al subir',
    'upload_exito': '¡Subido correctamente!',
    'upload_formatos': 'PDF, JPG o PNG · máx. 20 MB',
    'upload_no_cierres': 'No cierres la app',
    'upload_reintentar': 'Intentar de nuevo',
    'upload_subiendo': 'Subiendo archivo...',
    'vence': 'Vence',
    'ver_comprobante': 'Ver comprobante',
    'ver_detalle': 'Ver detalle',
    'ver_documento_adjunto': 'Ver documento adjunto',
    'ver_factura': 'Ver factura',
    'verifica_desc': 'Hemos enviado un email de verificación. Revisa tu bandeja de entrada.',
    'verifica_reenviar': 'Reenviar email de verificación',
    'viaje_aviso_privacidad': 'La identidad de los evaluadores es confidencial. Solo verás fechas y logística.',
    'viaje_ciudad_salida': 'Tu ciudad de salida para vuelos',
    'viaje_proponer_vuelo': 'Proponer vuelo',
    'viaje_propuesta_enviada': 'Propuesta enviada correctamente',
    'viaje_sin_propuestas': 'Sin propuestas de viaje',
    'viaje_sin_propuestas_desc': 'Propón opciones de vuelo, hotel y agenda para la visita.',
    'visita_evaluadores': 'Visita de evaluadores',
    'visita_programada': 'Visita programada',
    'visita_sin_programar': 'Visita aún no programada',
    'visita_titulo': 'Visita de evaluación',
    'volver': 'Volver',
    'votacion_abierta': 'Votación abierta',
    'votacion_cerrada': 'Votación cerrada',
    'walkthrough_ver_guia': 'Ver guía de inicio',
    'whatsapp': 'WhatsApp (con prefijo)',
    'ya_tengo_cuenta': '¿Ya tienes cuenta?',
    'tab_titularidades': 'Titularidades',
    'acciones_rapidas': 'Acciones rápidas',
    'evaluadores_titulo': 'Evaluadores',
    'evaluadores_registrados': 'Evaluadores registrados',
    'codigos_disponibles_label': 'Códigos disponibles',
    'evaluadores_seccion': 'Evaluadores',
    'codigos_acceso_titulo': 'Códigos de acceso',
    'config_pais': 'País',
    'config_telefono': 'Teléfono',
    'config_correos_inst': 'Correos institucionales',
    'config_capital': 'Capital',
    'config_city': 'Ciudad',
    'config_town': 'Municipio',
    'evaluacion_habilitada': 'Evaluación habilitada',
    'evaluaciones_titulo_card': 'Evaluaciones',
    'decision_final_titulo': 'Decisión final',
    'gestionar_comision_titulo': 'Gestionar comisión',
    'programar_visita_modal': 'Programar visita de evaluación',
    'fecha_llegada': 'Fecha de llegada',
    'req_documentacion': 'Requisitos de documentación',
    'todo_leido': 'Todo leído',
    'confirmar_borrar_notifs': '¿Borrar todas las notificaciones?',
    'gala_creada_ok': 'Gala creada correctamente',
    'gala_error_crear': 'Error al crear gala',
    'gala_activada': 'Gala activada para ciudades',
    'gala_desactivada': 'Gala desactivada',
    'titularidades_titulo': 'Titularidades',
    'titularidades_desc': 'Ciudades con galardón ACES activo y seguimiento de obligaciones',
    'obligaciones_titulo': 'Obligaciones del titular',
    'obligacion_imagen': 'Respetar las normas de imagen ACES',
    'obligacion_calendario': 'Diseñar calendario deportivo anual',
    'obligacion_congreso': 'Organizar congreso o competición internacional',
    'obligacion_memoria': 'Presentar memoria y conclusiones al final del año',
    'obligacion_awos': 'Participar activamente en AWoS/EWoS',
    'cumplidas': 'cumplidas',
    'viaje_confirmar': 'Confirmar propuesta',
    'viaje_rechazar': 'Rechazar propuesta',
    'viaje_confirmado': 'Propuesta confirmada',
    'viaje_rechazado': 'Propuesta rechazada',
    'nota_respuesta': 'Nota de respuesta (opcional)',
    'voto_favor_confirm': '¿Confirmar voto favorable?',
    'voto_contra_confirm': '¿Confirmar voto en contra?',
    'historial_sin_cambios': 'Sin cambios de estado registrados',
    'candidatura_buscar': 'Buscar ciudad, galardón...',
    'candidatura_ciudad_ph': 'Ej: Buenos Aires',
    'candidatura_pais_ph': 'Ej: Argentina',
    'candidatura_email_ph': 'ciudad@email.com',
    'dias_visita': 'días de visita',
    'propuestas_viaje': 'Propuestas de viaje',
    'sin_propuestas_viaje': 'Sin propuestas de viaje',
    'sin_propuestas_desc': 'Los evaluadores aún no han propuesto itinerario.',
    'sin_evaluaciones_desc': 'Asigna evaluadores y habilita la evaluación.',
    'seleccionar_pdf': 'Seleccionar PDF',
    'rechazar_candidatura': 'Rechazar candidatura',
    'motivo_rechazo': 'Motivo del rechazo (obligatorio)',
    'tit_sin_datos_desc': 'Las ciudades adjudicadas aparecerán aquí automáticamente.',
    'marcado_cumplido': 'Marcado como cumplido',
    'desmarcado': 'Desmarcado',
    'finalizada': 'Finalizada',
    'finalizadas': 'Finalizadas',
    'notas_label': 'Notas',
    'sin_leer': 'sin leer',
    'confirmar_cerrar_sesion': '¿Cerrar sesión?',
    'email_aces_europa': 'Email ACES Europa',
    'email_aces_america': 'Email ACES América',
    'gala_fecha_evento': 'Fecha del evento',
    'gala_primera_desc': 'Crea la primera gala para comenzar a gestionar las ceremonias.',
    'evaluadores_gestion': 'Gestión de la comisión evaluadora ACES',
    'adjudicar': 'Adjudicar',
    'adjudicada_ok': '¡Candidatura adjudicada!',
    'candidatura_rechazada': 'Candidatura rechazada',
    'error_decision': 'Error al registrar decisión',
    'evaluador_asignado': 'Evaluador asignado',
    'evaluador_quitado': 'Evaluador quitado',
    'jefe_designado': 'Jefe de comisión designado',
    'jefe_eliminado': 'Jefe de comisión eliminado',
    'notas_guardadas': 'Notas guardadas',
    'notas_visita_hint': 'Ej: Hotel recomendado, instrucciones de aeropuerto...',
    'visita_ok': 'Visita programada correctamente',
    'error_visita': 'Error al programar visita',
    'evaluacion_hab_ok': 'Evaluación habilitada',
    'evaluacion_deshab_ok': 'Evaluación deshabilitada',
    'programar': 'Programar',
    'confirmar_decision': 'Confirmar decisión',
    'cambiar_modo': 'Cambiar modo',
    'de_preposicion': 'de',
    'notas_decision_label': 'Notas de la decisión (opcional)',
    'generar': 'Generar',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File recibido',
    'documentos_firmados': 'Documentos firmados',
    'pago_confirmado': 'Pago confirmado',
    'subiendo_label': 'Subiendo...',
    'pagado_label': 'Pagado',
    'factura_label': 'Factura',
    'marcar_factura': 'Marcar factura emitida',
    'desmarcar_factura': 'Desmarcar factura',
    'marcar_pago': 'Marcar pago recibido',
    'desmarcar_pago': 'Desmarcar pago',
    'evaluacion_enviada': 'Enviada',
    'disponible_label': 'Disponible',
    'ver_codigos_btn': 'Ver códigos',
    'invitar_eval_btn': 'Invitar evaluador',
    'generar_codigo_btn': 'Generar nuevo código',
    'idioma_destinatario': 'Idioma del destinatario',
    'candidaturas_count': 'candidaturas',
    'sin_alertas_ok': 'Todo en orden. Sin alertas pendientes.',
    'sin_galas_configuradas': 'Sin galas configuradas',
    'gala_activada_ciudades': 'Gala activada para ciudades',
    'ver_alertas_label': 'Ver alertas',
    'modo_evaluador_activo': 'Modo evaluador activo',
    'modo_master_activo': 'Vista Master ACES',
    'cambiar_a_eval': 'Modo evaluador',
    'cambiar_a_master': 'Volver a Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Reglamento',
    'doc_tipo_comprobante': 'Comprobante de pago',
    'doc_tipo_contrato': 'Contrato',
    'doc_tipo_memoria': 'Memoria / Informe',
    'doc_tipo_pres': 'Presentación',
    'doc_tipo_otro': 'Otro',
    'selecciona_tipo_doc': '¿Qué tipo de documento es?',
    'todos_label': 'Todos',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Evento',
    'mis_propuestas': 'Mis propuestas',
    'propuestas_label': 'propuestas',
    'ciudad_hotel': 'Ciudad',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/noche',
    'hotel_notas_hint': 'Ej: Habitación doble, desayuno incluido...',
    'vuelo_notas_hint': 'Ej: Vuelo directo, escala en Madrid...',
    'fecha_label': 'Fecha',
    'hora_label': 'Hora',
    'lugar_label': 'Lugar',
    'tipo_reunion': 'Reunión',
    'tipo_visita_instalacion': 'Visita instalación',
    'tipo_acto': 'Acto oficial',
    'tipo_almuerzo': 'Almuerzo / Cena',
    'tipo_transporte': 'Transporte',
    'tipo_otro': 'Otro',
    'galardones_titulo': 'Galardones',
    'reglamentos_titulo': 'Reglamentos',
    'sin_candidatura_titulo': 'Sin candidatura asignada',
    'sin_candidatura_desc': 'Tu cuenta aún no tiene una candidatura vinculada.',
    'bienvenida_ciudad_saludo': 'Hola, {nombre}',
    'bienvenida_ciudad_titulo': 'Tu cuenta está activa',
    'bienvenida_ciudad_desc': 'Estamos preparando tu candidatura. En cuanto el equipo ACES te asigne una, aparecerá aquí con todo su seguimiento.',
    'bienvenida_ciudad_chip_activa': 'Cuenta activa',
    'bienvenida_ciudad_chip_espera': 'Esperando asignación',
    'bienvenida_ciudad_contacto': '¿Tienes dudas? Contacta con ACES',
    'chat_ciudad_desc': 'Comunicación directa con el equipo ACES.',
    'mensajes_label': 'Mensajes',
    'motor_seccion_de': 'de',
    'gala_confirmar_desc': 'Indica si tu ciudad asistirá a la ceremonia de gala.',
    'eval_completadas': 'Completadas',
    'secciones_completadas': 'secciones completadas',
    'evaluaciones_enviadas_abrev': 'evaluaciones enviadas',
    'awos_activa_desc': 'Registra tu actividad física y accede a los eventos ACES',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Tus datos de viaje son solo visibles para ACES — la ciudad no ve la identidad de los evaluadores.',
    'eval_docs_solo_lectura': 'Puedes ver los documentos enviados por la ciudad.',
    'conflicto_titulo': 'Declaración de conflicto de interés',
    'conflicto_desc': 'Antes de evaluar, confirma que no tienes conflicto de interés con esta candidatura.',
    'conflicto_sin_conflicto': 'Sin conflicto — continuar',
    'conflicto_con_conflicto': 'Tengo conflicto de interés',
    'conflicto_aviso': 'Notifica a ACES inmediatamente. No puedes evaluar esta candidatura.',
    'sin_fecha': 'Sin fecha',
    'subir_reserva_hint': 'Sube el PDF de la reserva de vuelo u hotel confirmada.',
    'subir_reserva_hint_eval': 'Sube el PDF de tu reserva de vuelo u hotel.',
    'login_sin_cuenta': 'No tienes cuenta?',
    'agenda_oficial_titulo': 'Agenda oficial de visita',
    'agenda_anadir_evento': 'Anadir evento',
    'agenda_editar_evento': 'Editar evento',
    'agenda_oficial_aviso': 'Esta agenda es visible para los evaluadores. La ciudad ve fechas y logistica, pero no los nombres de los evaluadores.',
    'agenda_oficial_vacia': 'Aun no hay eventos publicados. Anade el programa de visita para que los evaluadores lo vean.',
    'publicar_evento': 'Publicar evento',
    'evento_publicado': 'Evento publicado en la agenda',
    'evento_guardado': 'Evento actualizado',
    'evento_eliminado': 'Evento eliminado',
    'confirmar_eliminar': 'Eliminar este evento?',
    'guardar_cambios': 'Guardar cambios',
    'pipeline_titulo': 'Pipeline de candidaturas',
    'revenue_titulo': 'Ingresos',
    'revenue_total': 'Total facturado',
    'cobrado': 'Cobrado',
    'visitas_proximas': 'Visitas proximas',
    'paises_titulo': 'Por pais',
    'awos_banner_desc': 'Registra tu actividad fisica y accede a los eventos ACES',
    'fecha_limite_confirmar': 'Fecha limite para confirmar',
    'info_parlamento': 'Info Parlamento Europeo',
    'info_venue': 'Venue / Lugar',
    'norma_hotel': 'Normas hotel',
    'norma_vuelo': 'Normas vuelo',
    'programa_dia': 'Programa del dia',
    'sin_programa': 'Sin programa definido',
    'actividad_placeholder': 'Actividad...',
    'anadir': 'Anadir',
    'representantes_label': 'Representantes',
    'confirmados_label': 'Confirmados',
    'fecha_limite': 'Fecha limite',
    'deadline_pasada': 'Plazo vencido',
    'restantes': 'restantes',
    'anadir_representante': 'Anadir representante',
    'sin_representantes': 'Sin representantes',
    'representante_anadido': 'Representante anadido',
    'representante_eliminado': 'Representante eliminado',
    'programa_actualizado': 'Programa actualizado',
    'confirmado': 'CONFIRMADO',
    'nombre_label': 'Nombre completo',
    'cargo_label': 'Cargo',
    'telefono_label': 'Telefono',
    'logistica_evaluadores': 'Logistica evaluadores',
    'vuelo_short': 'Vuelo',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Documentos obligatorios',
    'evidencia_subida': 'Evidencia subida',
    'sancion_anadida': 'Sancion registrada',
    'memoria_subida': 'Memoria final subida',
    'nueva_sancion': 'Nueva sancion',
    'motivo_sancion': 'Motivo',
    'motivo_sancion_hint': 'Ej: No asistencia a gala sin justificacion',
    'importe_label': 'Importe',
    'divisa_label': 'Divisa',
    'registrar_sancion': 'Registrar sancion',
    'subir_evidencia': 'Subir',
    'memoria_final_titulo': 'Memoria final',
    'memoria_deadline': 'Antes del 31 de enero',
    'subir_memoria': 'Subir memoria final (PDF)',
    'sin_sanciones': 'Sin sanciones registradas',
    'evidencias_short': 'evidencias',
    'memoria_ok': 'Memoria OK',
    'sanciones_short': 'sanciones',
    'dias_en_fase': 'Dias en fase',
    'proximo_pago': 'Proximo pago',
    'vencido': 'Vencido',
    'visita_label': 'Visita',
    // === Paquete 2 — 85 keys faltantes (es) ===
    'abrir_nueva_pestana': 'Abrir en nueva pestana',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Articulos',
    'auth_accediendo': 'Accediendo...',
    'auth_email_enviado': 'Email enviado. Revisa tu bandeja de entrada.',
    'auth_enviar_enlace': 'Enviar enlace',
    'auth_error_intentos': 'Demasiados intentos. Espera un momento.',
    'auth_error_password': 'Contrasena incorrecta',
    'auth_error_reset': 'Error al enviar el email de recuperacion',
    'auth_error_usuario': 'Usuario no encontrado',
    'auth_introduce_email': 'Introduce tu email',
    'auth_olvido_password': 'He olvidado mi contrasena',
    'auth_recuperar': 'Recuperar contrasena',
    'auth_recuperar_desc': 'Te enviaremos un enlace para restablecer tu contrasena.',
    'aw_h': 'Semana Americana del Deporte',
    'aw_lbl': 'AWoS',
    'aw_p': 'Celebra el deporte y la actividad fisica con tu ciudad durante la Semana Americana del Deporte.',
    'bonus_desc': 'Puntos adicionales por iniciativas destacadas',
    'buscar_articulo': 'Buscar articulo...',
    'buscar_recursos': 'Buscar en recursos...',
    'comite_evaluacion': 'Comite de evaluacion',
    'confirmar_eliminar_pago': 'Seguro que deseas eliminar este pago?',
    'cookie_accept': 'Aceptar',
    'cookie_more': 'Mas informacion',
    'cookie_msg': 'Usamos cookies esenciales para el funcionamiento del sitio.',
    'cookie_reject': 'Rechazar',
    'criterios_elegibilidad': 'Criterios de elegibilidad',
    'cta_b1': 'Presentar candidatura',
    'cta_b2': 'Contactar con ACES',
    'cta_h': 'Empieza tu candidatura hoy',
    'cta_p': 'Unete a la red de ciudades europeas del deporte y transforma tu comunidad.',
    'descargar_factura': 'Descargar factura',
    'docs_drag_drop': 'Arrastra archivos aqui o haz clic para seleccionar',
    'docs_obligatorios': 'Documentos obligatorios',
    'eval_actual': 'Evaluacion actual',
    'eval_comentario_voto_placeholder': 'Comentario sobre tu voto (opcional)...',
    'eval_max_puntos': 'Puntuacion maxima',
    'feats': 'Funcionalidades',
    'footer_contact': 'Contacto',
    'footer_legal': 'Aviso legal',
    'footer_privacy': 'Politica de privacidad',
    'ft_h': 'Todo lo que necesitas',
    'ft_lbl': 'Funcionalidades',
    'general_volver': 'Volver',
    'hero_cta1': 'Presentar candidatura',
    'hero_cta2': 'Conocer el proceso',
    'hero_h1a': 'Tu ciudad merece',
    'hero_h1b': 'ser reconocida',
    'hero_sub': 'ACES Cities Network conecta ciudades, evaluadores y organismos deportivos en una sola plataforma.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Limpiar',
    'login_subtitulo': 'Accede a tu cuenta de ACES Cities Network',
    'marcar_todas_leidas': 'Marcar todas como leidas',
    'nav_acceder': 'Acceder',
    'nav_funciones': 'Funciones',
    'nav_galardones': 'Galardones',
    'nav_proceso': 'Proceso',
    'nav_registro': 'Registro',
    'nav_roles': 'Roles',
    'notif_todas_leidas': 'Todas las notificaciones marcadas como leidas',
    'pago_eliminado': 'Pago eliminado',
    'pendiente': 'Pendiente',
    'pendiente_label': 'Pendiente',
    'pipe_h': 'Proceso transparente',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Sigue cada fase de tu candidatura en tiempo real.',
    'preambulo': 'Preambulo',
    'recursos_aces_desc': 'Galardones, reglamentos y documentacion oficial de ACES.',
    'recursos_aces_titulo': 'Recursos ACES',
    'reglamentos_seed': 'Reglamentos cargados correctamente',
    'regulacion_sin_articulos': 'Esta regulacion no tiene articulos.',
    'roles_h': 'Para cada rol',
    'roles_lbl': 'Roles',
    'roles_p': 'Ciudades, evaluadores y administradores en una sola plataforma.',
    'sancion_incumplimiento': 'Sancion por incumplimiento',
    'sin_articulos': 'Sin articulos',
    'sin_galardones': 'No hay galardones disponibles',
    'sin_reglamentos': 'No hay reglamentos disponibles',
    'sin_recursos': 'No hay recursos disponibles',
    'sin_resultados': 'Sin resultados',
    'stages': 'Fases',
    'tasa_inscripcion': 'Tasa de inscripcion',
    'todas': 'Todas',
    'ver_candidatura': 'Ver candidatura',
    'reserva_sin_evaluador': 'General (sin evaluador asignado)',
    'preview_pdf_hint': 'Los PDF se abren en una nueva pestaña del navegador.',
    'descargar': 'Descargar',
    'con_pago_confirmado': 'con pago confirmado (hito)',
    'pendientes_pago': 'pendientes',
    'sin_datos_pagos': 'Sin datos de pagos registrados',
    'eval_no_asignado': 'No estás asignado a la comisión de evaluación de esta candidatura.',
    'subir_reserva': 'Subir reserva',
    'sin_reservas': 'Sin reservas',
    'sin_reservas_desc': 'Sube los PDFs de las reservas.',
    'reservas_desc_master': 'Sube las reservas de vuelo y hotel confirmadas como PDF. Puedes seleccionar el evaluador al que corresponde.',
    'subir_agenda': 'Subir agenda (PDF)',
    'agenda_visita_titulo': 'Agenda de visita',
    'reservas_titulo': 'Reservas',
    'reserva_subida_ok': 'Reserva subida correctamente',
    'agenda_subida_ok': 'Agenda subida correctamente',
    'doc_eliminado': 'Documento eliminado',
    'agenda_vacia_desc': 'Sube el PDF de la agenda de visita.',
    'revenue_cobrado': 'Cobrado',
    'revenue_pendiente': 'Pendiente',
    'ciudad_hitos_titulo': 'Estado de tu candidatura',
    'hito_factura_recibida': 'Factura recibida',
    'eval_mis_evaluaciones': 'Mis evaluaciones',
    'eval_sin_bid': 'La ciudad aún no ha subido el BID File.',
    'voto_final_desc_motor': 'Emite tu voto final basado en tu evaluación.',
    'chat_comision': 'Chat comisión',
    'tit_comunicacion_ok': 'Comunicación oficial OK',
    'tit_derechos_factura_env': 'Derechos imagen: factura enviada',
    'tit_derechos_pagado': 'Derechos imagen: pagada',
    'tit_q1': 'Informe trimestral Q1',
    'tit_q2': 'Informe trimestral Q2',
    'tit_q3': 'Informe trimestral Q3',
    'tit_q4': 'Informe trimestral Q4',
    'tit_premio_n1': 'Premio N1: ¿Participa?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Nueva sanción',
    'motivo': 'Motivo',
    'si': 'Sí',
    'no': 'No',
    'nueva': 'Nueva',
    'sanciones': 'Sanciones',
    'pagada': 'Pagada',

    'borrar_candidatura': 'Eliminar candidatura',
    'borrar_candidatura_desc': 'Elimina permanentemente la candidatura y todos sus datos asociados.',
    'confirmar_borrar_candidatura': 'Eliminar la candidatura? Esta accion NO se puede deshacer.',
    'confirmar_borrar_candidatura_2': 'SEGURO? Se borraran TODOS los documentos, pagos, evaluaciones y chats.',
    'candidatura_eliminada': 'Candidatura eliminada',
    'zona_peligrosa': 'Zona peligrosa',
    'contacto_ciudad': 'Contacto ciudad',
    'sin_ciudad_vinculada': 'Sin usuario ciudad vinculado',
    'cambiar_ciudad': 'Cambiar',
    'vincular_ciudad': 'Vincular',
    'vincular_ciudad_titulo': 'Vincular usuario ciudad',
    'vinculado_actual': 'Vinculado actual',
    'desvincular': 'Desvincular',
    'buscar_usuario_ciudad': 'Buscar por nombre, email o ciudad...',
    'sin_usuarios_ciudad': 'No hay usuarios con rol ciudad registrados',
    'ciudad_vinculada_ok': 'Ciudad vinculada correctamente',
    'ciudad_desvinculada': 'Ciudad desvinculada',
    'vincular': 'Vincular',
    'codigo_generado': 'Codigo generado',
    'codigo_generado_ok': 'Codigo de ciudad generado',
    'codigo_vinculado_candidatura': 'Pre-vinculado a esta candidatura',
    'idioma_carta': 'Idioma de la carta',
    'carta_copiada': 'Carta copiada al portapapeles',
    'copiar_carta': 'Copiar',
    'enviar_invitacion': 'Abrir email',
    'email_cliente_abierto': 'Cliente de correo abierto',
    'estado_avanza_aceptada': 'Candidatura aceptada automaticamente',
    'estado_avanza_documentacion': 'Avanzando a fase de documentacion',
    'estado_avanza_visita': 'Avanzando a fase de visita',
    'estado_avanza_evaluacion': 'Avanzando a fase de evaluacion',
    'confirmar_avance_estado': 'Avanzar estado a',
    'estado_cambiado': 'Estado cambiado a',
    'eval_ciudades_galardonadas': 'Ciudades galardonadas',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Delegado',
    'delegado_desc': 'El delegado puede ver el estado de la candidatura y qué documentos faltan.',
    'asignar_delegado': 'Asignar',
    'cambiar_delegado': 'Cambiar',
    'sin_delegado': 'Sin delegado asignado',
    'confirmar_quitar_delegado': '¿Quitar delegado de esta candidatura?',
    'delegado_quitado': 'Delegado eliminado',
    'delegado_asignado': 'Delegado asignado',
    'delegado_existente': 'Usuario existente',
    'delegado_invitar': 'Invitar por email',
    'generar_codigo_delegado': 'Generar código de delegado',
    'codigo_delegado_generado': 'Código generado — envía el email',
    'nombre_delegado_hint': 'Nombre del delegado',
    'email_delegado_hint': 'email@ejemplo.com',
    'confirmar_retroceso_estado': '¿Retroceder estado a',
    'accion_gala': 'Invitar a Gala',
    'accion_gala_desc': 'Confirma la gala y añade la ciudad al evento del año.',
    'accion_notificar': 'Marcar como notificada',
    'accion_notificar_desc_simple': 'Cambia el estado a notificada. La comunicacion a la ciudad se realiza fuera de la app.',
    'accion_premio': 'Entregar premio',
    'accion_titularidad': 'Activar titularidad',
    'activar_titularidad': 'Activar titularidad',
    'anos_label': 'Años',
    'aprobar_informe': 'Aprobar',
    'archivo_muy_grande': 'El archivo supera los 50 MB',
    'badge': 'Insignia',
    'cambiar_estado': 'Cambiar estado',
    'candidatura_actualizada': 'Candidatura actualizada',
    'chat_ayer': 'Ayer',
    'chat_hoy': 'Hoy',
    'chat_primer_mensaje': 'Envía el primer mensaje',
    'checklist_obligaciones': 'Obligaciones',
    'ciudad_notificada': 'Ciudad notificada',
    'comentario_rechazo': 'Comentario obligatorio para el rechazo:',
    'comite_label': 'Comité',
    'confirmar_cambio_estado': '¿Confirmar cambio de estado?',
    'confirmar_gala': 'Confirmar gala',
    'confirmar_notificar': '¿Marcar como notificada?',
    'confirmar_pago': 'Confirmar pago recibido',
    'Copiado': 'Copiado',
    'delegado_info_restriccion': 'Como delegado puedes ver el estado del pipeline y la agenda de visita. Para acceder al motor de evaluación o al BID File, solicita asignación como evaluador a ACES.',
    'delegado_mis_candidaturas': 'Como delegado',
    'delegado_vista': 'Vista de delegado',
    'delegado_vista_restringida': 'Vista restringida: solo pipeline, agenda y documentos pendientes. Sin pagos ni evaluaciones.',
    'derechos_imagen': 'Derechos de imagen',
    'editar_candidatura': 'Editar candidatura',
    'Eliminado': 'Eliminado',
    'email': 'Email',
    'emitir_factura': 'Emitir factura (PDF)',
    'entre_miembros': 'Entre',
    'espera_repetir': 'Espera para repetir',
    'estado_actualizado': 'Estado actualizado',
    'estado_gala_confirmada': 'Gala confirmada',
    'estado_notificada': 'Notificada',
    'estado_notificada_rechazo': 'Rechazo notificado',
    'estado_premio_otorgado': 'Premio otorgado',
    'estado_titularidad_activa': 'Titularidad activa',
    'eval_comentario_criterio': 'Comentarios sobre este criterio...',
    'factura': 'Factura',
    'factura_emitida': 'Factura subida',
    'fase_candidatura': 'Candidatura',
    'fase_seguimiento': 'Seguimiento',
    'gala_confirmada_ok': 'Gala confirmada',
    'Guardado': 'Guardado',
    'hito_agenda': 'Agenda de visita aceptada',
    'hito_carta': 'Carta de solicitud aceptada',
    'hito_pago': 'Factura pagada',
    'hito_reglamento_env': 'Reglamento recibido',
    'hito_reglamento_firm': 'Reglamento firmado',
    'hito_viajes': 'Logística de viaje completada',
    'image_rights': 'Derechos de imagen',
    'importe': 'Importe',
    'informe_aprobado': 'Informe aprobado',
    'informe_rechazado': 'Informe rechazado',
    'informe_subido': 'Informe subido',
    'informes_trimestrales': 'Informes trimestrales',
    'marcar_notificada': 'Marcar como notificada',
    'marcar_premio': 'Marcar premio entregado',
    'max_candidatos': 'Máx. candidatos',
    'miembros_label': 'Miembros',
    'notificar_rechazo': 'Notificar rechazo',
    'nueva_version': 'Nueva versión',
    'ocultar': 'Ocultar',
    'permisos_documento': 'Permisos del documento',
    'permisos_guardados': 'Permisos guardados',
    'poblacion_maxima': 'Población máxima',
    'poblacion_minima': 'Población mínima',
    'rechazar_informe': 'Rechazar',
    'region_africa': 'África',
    'region_americas': 'Américas',
    'region_asia': 'Asia',
    'region_europa': 'Europa',
    'region_mundial': 'Mundial',
    'region_oceania': 'Oceanía',
    'reglamentos_pendientes': 'Reglamentos pendientes',
    'seleccionar_tipo': 'Tipo de documento',
    'sin_resultados_busqueda': 'No se encontraron resultados',
    'subir_informe': 'Subir informe',
    'tasa_label': 'Tasa',
    'tipo_anexo': 'Anexo',
    'tipo_especial': 'Especial',
    'tipo_no_permitido': 'Tipo de archivo no permitido. Use PDF, DOC, DOCX, XLS, XLSX, JPG o PNG',
    'tipo_principal': 'Principal',
    'titularidad_activa_label': 'Titularidad activa',
    'titularidad_creada': 'Titularidad creada',
    'titularidad_panel': 'Mi titularidad',
    'tomar_decision_final': 'Tomar decisión final',
    'ver_documento': 'Ver',
    'ver_escala': 'Ver escala',
    'ver_reglamento': 'Ver reglamento completo',
    'ver_seguimiento': 'Ver seguimiento de titularidad',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Ciudad',
    'visible_evaluador': 'Evaluador',
    'visible_master': 'Master',
    'visible_para': 'Visible para',
    'warning_quitar_adjudicada': 'Al retroceder antes de "Adjudicada" se eliminará la marca de adjudicación permanente.',
    'warning_retroceso': '¿Estás seguro de retroceder el estado?',
    'y_label': 'y',
    'Q1_nombre': 'Ene-Mar',
    'Q2_nombre': 'Abr-Jun',
    'Q3_nombre': 'Jul-Sep',
    'Q4_nombre': 'Oct-Dic',
    'informe_pendiente': 'Pendiente',
    'pago_pendiente': 'Pendiente',
    'checklist_logo_aces': 'Uso correcto del logo ACES',
    'checklist_memoria_anual': 'Memoria anual entregada',
    'checklist_congreso': 'Asistencia al congreso ACES',
    'checklist_imagen_corporativa': 'Imagen corporativa actualizada',
    'checklist_calendario_deportivo': 'Calendario deportivo publicado',
    'asignar_evaluadores': 'Asignar evaluadores',
    'notas_internas_opcional': 'Notas internas (opcional)',
    'estado_candidatura': 'Estado de la candidatura',
    'hito_carta_recibida': 'Carta de solicitud recibida',
    'hito_candidatura_aceptada': 'Candidatura aceptada',
    'hito_reglamento_enviado': 'Reglamento enviado',
    'hito_reglamento_firmado': 'Reglamento firmado',
    'hito_datos_facturacion': 'Datos de facturación recibidos',
    'hito_pago_confirmado': 'Pago confirmado',
    'hito_fechas_visita': 'Fechas de visita aceptadas',
    'hito_comision_cerrada': 'Comisión cerrada',
    'hito_reservas_completadas': 'Reservas completadas',
    'hito_agenda_subida': 'Agenda subida',
    'hito_bid_file_recibido': 'BID File recibido',
    'editar_visita': 'Editar visita',
    'programar_visita_btn': 'Programar visita',
    'gestionar_comision': 'Gestionar comisión',
    'pagos_titulo': 'Pagos',
    'sin_pagos': 'Sin pagos registrados',
    'factura_marcada': 'Factura marcada',
    'factura_desmarcada': 'Factura desmarcada',
    'pago_confirmado_label': 'Pago confirmado',
    'pago_desmarcado': 'Pago desmarcado',
    'vence_label': 'Vence',
    'factura_label': 'Factura',
    'pagado_label': 'Pagado',
    'documentos_titulo': 'Documentos',
    'archivos_count': 'archivo',
    'archivos_count_plural': 'archivos',
    'subir_btn': 'Subir',
    'sin_documentos': 'Sin documentos subidos',
    'aprobado_label': 'Aprobado',
    'rechazado_label': 'Rechazado',
    'sin_permisos': 'Sin permisos',
    'ver_label': 'Ver',
    'logistica_titulo': 'Logística',
    'agenda_visita': 'Agenda de visita',
    'subir_pdf': 'Subir PDF',
    'sin_agenda': 'Sin agenda subida',
    'reservas_titulo': 'Reservas',
    'general_sin_eval': 'General (sin evaluador)',
    'subir_reserva': 'Subir reserva',
    'sin_reservas': 'Sin reservas subidas',
    'agenda_subida_ok': 'Agenda subida',
    'reserva_subida_ok': 'Reserva subida',
    'evaluador_actualizado': 'Evaluador actualizado',
    'general_todos_eval': 'General (todos los evaluadores)',
    'cambiar_evaluador': 'Cambiar evaluador',
    'evaluaciones_titulo': 'Evaluaciones',
    'enviada_label': 'enviada',
    'enviadas_label': 'enviadas',
    'en_progreso_label': 'en progreso',
    'comision_asignada': 'Comisión asignada',
    'evaluador_label': 'evaluador',
    'evaluadores_label': 'evaluadores',
    'jefe_label': 'Jefe',
    'sin_empezar': 'Sin empezar',
    'sin_evaluadores': 'Sin evaluadores asignados',
    'enviada_badge': 'Enviada',
    'favorable_label': 'Favorable',
    'desfavorable_label': 'Desfavorable',
    'desbloquear_label': 'Desbloquear',
    'evaluacion_desbloqueada': 'Evaluación desbloqueada',
    'error_desbloquear': 'Error al desbloquear',
    'pdf_generado': 'PDF generado',
    'error_pdf': 'Error al generar PDF',
    'en_progreso_badge': 'En progreso',
    'tomar_decision': 'Tomar decisión final',
    'cerrar_menu': 'Cerrar menú',
    'compartir_tel_ciudad': 'Compartir teléfono con la ciudad candidata',
    'compartir_tel_eval': 'Compartir teléfono con otros evaluadores',
    'notas_internas': 'Notas internas',
    'notas_privadas_placeholder': 'Notas privadas...',
    'guardado_ok': 'Guardado',
    'generar_btn': 'Generar',
    'copiado_ok': 'Copiado',
    'idioma_destinatario': 'Idioma del destinatario',
    'codigo_acceso_modal': 'Código de acceso',
    'gala_activa': 'ACTIVA',
    'gala_inactiva': 'INACTIVA',
    'calendario_carta': 'Carta alcalde: 30 mar',
    'calendario_bid': 'BID file: 30 jun',
    'calendario_preseleccion': 'Pre-selección: 31 jul',
    'calendario_visitas': 'Visitas: oct',
    'calendario_gala': 'Gala: nov',
    'calendario_titularidad': 'Titularidad: 1 ene siguiente',
    'candidatura_singular': 'candidatura',
    'candidaturas_plural': 'candidaturas',
    'doc_tipo_bid_file': 'BID File',
    'doc_tipo_presentacion': 'Presentación',
    'progreso_inicio': 'Inicio',
    'progreso_adjudicada': 'Adjudicada',
    'hab_label': 'hab.',
    'eval_abreviado': 'eval.',
    'min_poblacion_label': 'Población mínima',
    'max_poblacion_label': 'Población máxima',
    'max_candidatos_label': 'Máximo candidatos',
    'espera_label': 'Espera',
    'anos_label': 'años',
    'image_rights': 'Derechos de imagen',
    'comite_label': 'Comité',
    'miembros_label': 'miembros',
    'usado_label': 'USADO',
    'disponibles_count': 'Disponibles',
    'usados_count': 'Usados',
    'codigos_disponibles_count': 'Códigos disponibles',
    'hotel_placeholder': 'Hotel asignado, check-in, reglas...',
    'vuelo_placeholder': 'Aeropuerto, horarios, clase...',
    'parlamento_placeholder': 'Dirección, normas de acceso, protocolo...',
    'dni_pasaporte': 'DNI / Pasaporte',
    'cerrar_menu': 'Cerrar menú',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'sin_fecha_visita': 'Sin fecha de visita',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Comentario de la sección',
    'eval_comentario_seccion_placeholder': 'Comentario general de la sección (opcional)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Error: {0}',
    'pdf_evaluacion': 'Evaluación en PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Informe de evaluación',
    'pdf_ciudad': 'Ciudad',
    'pdf_evaluador': 'Evaluador',
    'pdf_fecha': 'Fecha',
    'pdf_total': 'Puntuación total',
    'pdf_secciones': 'Secciones',
    'pdf_voto_final': 'Voto final',
    'pdf_comentario_voto': 'Comentario del voto',
    'pdf_no_evaluada': 'Sin evaluar',
    'pdf_generado_por': 'Generado por ACES Cities Network · {0}',
    'email_placeholder': 'nombre@ejemplo.com',
    'ej_nombre_persona': 'Ej.: María García',
    'ej_aeropuerto': 'Ej.: Madrid (MAD)',
    'pdf_permitir_popups': 'Permite las ventanas emergentes para exportar el PDF',
    'confirmar': 'Confirmar',
    // Barrido español fijo — 23sep2026
    'aceptar': 'Aceptar',
    'atencion': 'Atención',
    'confirmar_eliminar_doc': '¿Eliminar este documento? Esta acción no se puede deshacer.',
    'confirmar_eliminar_logistica': '¿Eliminar este documento de logística?',
    'confirmar_notificar_titulo': 'Notificar a la ciudad',
    'confirmar_retroceso_titulo': 'Confirmar retroceso',
    'eliminado': 'Eliminado',
    'quitar_delegado_titulo': 'Quitar delegado',
    'warning_quitar_adjudicada_titulo': 'Quitar adjudicación',
    'warning_retroceso_2': '¿CONFIRMAR? Se borrarán datos de forma irreversible (fechas, registros de gala, etc.). Esta acción NO se puede deshacer.',
    'warning_retroceso_titulo': 'Retroceder estado',
    'eval_pts': 'pts',
    // Corrección de acentos — 23sep2026
    'codigo_generado': 'Código generado',
    'accion_notificar_desc_simple': 'Cambia el estado a notificada. La comunicación a la ciudad se realiza fuera de la app.',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Reserva de vuelo',
    'viaje_tipo_reserva_hotel': 'Reserva de hotel',
    'reserva_generica': 'Reserva',
  },
  'en': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'We could not find that code. Check that it is complete, for example: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'This code has already been used. If you already registered, log in. Otherwise, ask ACES for a new code.',
    'codigo_expirado': 'This code has expired. Ask ACES for a new code.',
    'codigo_admin': 'This is an administration code and cannot be used to register here. Please contact ACES.',
    'registro_error_general': 'Registration could not be completed and no account was created. Please try again; if it fails again, contact ACES.',
    'email_ya_registrado_login': 'This email already has an account. Tap "Log in" and, if you do not remember your password, use "Forgot your password?".',
    'nueva_gala_btn': 'Create gala',
    'programar_visita': 'Schedule evaluation visit',
    'guardar_notas': 'Save notes',
    'historial_estados': 'Status history',
    'notas_privadas_hint': 'Private notes about this application (only visible to masters)...',
    'voto_emitido': 'Vote cast:',
    'voto_en_contra': 'Against',
    'voto_a_favor': 'In favour',
    'voto_final_desc': 'The application is in the voting phase. Cast your vote.',
    'voto_final_titulo': 'Final vote required',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titularities — coming soon',
    'email_abierto': 'Your email client opened',
    'cargo_hint': 'E.g.: Sports Councillor',
    'password_repetir_hint': 'Repeat password',
    'password_min': 'Minimum 6 characters',
    'placeholder_apellido_ej': 'Smith',
    'placeholder_nombre_ej': 'Mary',
    'error_guardar': 'Error saving',
    'error_label': 'Error',
    'error_subir': 'Upload error',
    'error_cambiar_password': 'Error changing password',
    'candidatura_no_encontrada': 'Application not found',
    'puntuacion_final': 'Final score',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Destination',
    'origen_label': 'Origin',
    'notif_actividad_desc': 'Your application activity will appear here.',
    'placeholder_ej_espana': 'E.g.: Spain',
    'placeholder_ej_madrid': 'E.g.: Madrid',
    'gala_lugar_hint': 'E.g.: Congress Palace',
    'gala_titulo_hint': 'E.g.: ACES América Gala 2026',
    'gala_descripcion_hint': 'Event description...',
    'gala_pais': 'Event country',
    'gala_ciudad': 'Event city',
    'gala_lugar': 'Ceremony venue',
    'gala_titulo_label': 'Gala title',
    'visible_ciudades': 'Visible to cities',
    'nueva_gala': 'New gala',
    'sin_galas': 'No galas configured',
    'gala_gestion': 'Gala ceremony management',
    'gala_aces_titulo': 'ACES Gala',
    'codigo_copiado': 'Code copied',
    'error_generar_codigo': 'Error generating code',
    'nombre_eval_email': 'Evaluator name (for email)',
    'invitar_evaluador': 'Invite evaluator',
    'sin_evaluadores': 'No evaluators registered',
    'preview': 'Preview',
    'ver_todos': 'View all',
    'total_candidaturas': 'Total applications',
    'titulos_adjudicados': 'Awarded titles',
    'tamano_comite': 'Committee size (evaluators)',
    'sanciones_asistencia': 'Non-attendance penalties (€)',
    'tasas_participacion': 'Participation fees (€)',
    'config_sistema_perfil': 'System & profile',
    'sin_candidaturas_desc2': 'Try changing the filters or create a new one.',
    'placeholder_pais_ej': 'E.g.: Argentina',
    'placeholder_ciudad_ej': 'E.g.: Buenos Aires',
    'buscar_evaluador': 'Search evaluator...',
    'notas_decision_hint': 'Internal notes about the decision...',
    'concepto_placeholder': 'E.g.: Participation fee 2026',
    'sin_jefe_asignado': 'No head assigned',
    'jefe_comision': 'Committee head',
    'ciudad_label': 'City',
    'descargar_app_store': 'Download on App Store',
    'aforo_maximo': 'Max capacity',
    'descripcion_label': 'Description',
    'convocatoria_label': 'Year',
    'abrir_email': 'Open email',
    'crear_gala': 'Create gala',
    'en_evaluacion': 'Under evaluation',
    'emails_institucionales': 'Institutional emails',
    'email_evaluador': 'Evaluator email',
    'codigo_acceso_label': 'Access code',
    'codigos_acceso': 'Access codes',
    'seleccionar_galardon': 'Select award...',
    'todos_galardones': 'All awards',
    'todos_estados': 'All statuses',
    'cargando_dashboard': 'Loading dashboard...',
    'candidaturas_recientes': 'Recent applications',
    'candidaturas_activas': 'Active applications',
    'alertas_sistema': 'System alerts',
    'accesos_rapidos': 'Quick actions',
    'viaje_titulo': 'Travel',
    'nuevo': 'New',
    'estado': 'Status',
    'abrir_votacion': 'Open voting',
    'accion_anadir_evaluador': 'Add evaluator',
    'accion_master': 'Master action',
    'accion_nueva_candidatura': 'New candidature',
    'accion_ver_alertas': 'View alerts',
    'actividad': 'Activity',
    'agenda_notas': 'Internal notes',
    'agenda_notas_hint': 'e.g. Evaluator will be received by the Mayor...',
    'agenda_pdf_listo': 'Agenda PDF attached',
    'agenda_propuesta_enviada': 'Agenda event sent',
    'agenda_subir_pdf': 'Upload full agenda PDF (optional)',
    'agenda_tipo_evento': 'Event type',
    'agenda_titulo_evento': 'Event title',
    'agenda_vacia': 'Empty agenda',
    'alerta_decision_pendiente': 'Decision pending',
    'alerta_docs_pendientes': 'Pending documents',
    'alerta_pago_vencido': 'Overdue payment',
    'alerta_sin_evaluadores': 'No evaluators assigned',
    'alertas_titulo': 'Alerts',
    'anos': 'years',
    'anterior': 'Previous',
    'apellidos': 'Last name',
    'aprobar': 'Approve',
    'asignacion_ciudad_hint': 'E.g.: London',
    'asignacion_ciudad_salida': 'Departure city for the visit',
    'asignacion_ciudad_salida_desc': 'The city from which you will depart for the evaluation visit.',
    'asignacion_compartir_ciudad': 'Share phone with city',
    'asignacion_compartir_ciudad_desc': 'The city will be able to see your phone number and WhatsApp.',
    'asignacion_compartir_eval_desc': 'Other evaluators of this candidature will be able to see your contact.',
    'asignacion_compartir_evaluadores': 'Share with other evaluators',
    'asignacion_confirmar': 'Confirm and start',
    'asignacion_nota': 'Note for the city (optional)',
    'asignacion_nota_desc': 'This note will be visible to the candidate city team.',
    'asignacion_nota_hint': 'E.g.: I will arrive by train on Tuesday morning...',
    'asignacion_privacidad': 'Privacy and contact',
    'asignacion_sub': 'Before starting, configure your contact details for this candidature.',
    'asignacion_titulo': 'New assignment',
    'asignar_ciudad_titulo': 'Assign city',
    'asignar_evaluador': 'Assign evaluator',
    'auth_cargando': 'Signing in...',
    'auth_cerrar_sesion': 'Sign Out',
    'auth_email': 'Email',
    'auth_entrar': 'Sign In',
    'auth_error_credenciales': 'Incorrect email or password.',
    'auth_error_red': 'No internet connection.',
    'auth_password': 'Password',
    'auth_subtitulo': 'ACES sports candidature platform',
    'avanzar_a': 'Advance to',
    'borrar': 'Delete',
    'borrar_todas': 'Delete all',
    'buscar_ciudad_email': 'Search city, email...',
    'buscar_pais': 'Search country...',
    'buscar_placeholder': 'Search city, award...',
    'cambios': 'Changes',
    'campos_obligatorios': 'Please fill in all required fields.',
    'cancelar': 'Cancel',
    'candidatura_asignada_ok': 'Candidature assigned',
    'cargando_candidatura': 'Loading candidature...',
    'cargo': 'Position',
    'cat_carta': 'Letter of intent',
    'cat_eventos': 'Events',
    'cat_galardones': 'Previous awards',
    'cat_infra': 'Infrastructure',
    'cat_otros': 'Other',
    'cat_presupuesto': 'Budget',
    'categoria': 'Category',
    'cerrar': 'Close',
    'cerrar_votacion': 'Close voting',
    'chat_ciudad': 'ACES Chat',
    'chat_ciudad_aces': 'Chat with ACES',
    'chat_ciudad_aces_desc': 'Direct communication with the ACES Europe team.',
    'chat_conversaciones': 'Conversations',
    'chat_elige_conversacion': 'Choose who you want to chat with',
    'chat_escribir': 'Write a message...',
    'chat_interno': 'Commission Chat',
    'chat_interno_desc': 'Private channel between evaluators and ACES. The city has no access.',
    'chat_mis_chats': 'My chats',
    'chat_sin_activos': 'No active chats',
    'chat_sin_activos_desc': 'Chats with candidatures will appear here',
    'chat_sin_mensajes': 'No messages yet',
    'chat_adjuntar': 'Attach file',
    'chat_adjunto_expira': 'File available for 7 days',
    'chat_adjunto_max': 'File too large (max 10MB)',
    'chat_borrar': 'Delete for everyone',
    'chat_buscar_conv': 'Search city or award...',
    'chat_confirmar_borrar': 'Delete this message for everyone?',
    'chat_filtro_no_leidas': 'Unread',
    'chat_filtro_todas': 'All',
    'chat_mensaje_borrado': 'Message deleted',
    'chat_no_leidos': 'unread',
    'chat_activas': 'active chats',
    'chat_recargar': 'Refresh',
    'chat_responder': 'Reply',
    'chat_sin_no_leidos': 'All read',
    'warn_poblacion_min': 'Minimum population required',
    'warn_poblacion_max': 'Maximum population allowed',
    'warn_actual': 'Current',
    'warn_max_candidaturas': 'Maximum candidatures for this award',
    'warn_actuales': 'Current',
    'warn_espera': 'Waiting period',
    'warn_anos': 'years',
    'warn_ultima': 'Last award',
    'warn_elegible_desde': 'Eligible from',
    'warn_elegibilidad': 'Eligibility warnings',
    'warn_override': 'Master override: create candidature anyway',
    'warn_override_required': 'There are eligibility warnings. Check Override to continue.',
    'tasa_auto': 'Automatic payment will be created for',
    'poblacion_label': 'Population',
    'galardon_label': 'Award',
    'calendario_procesal': 'Procedural calendar (Art. 15)',
    'regla_25_titulo': '2.5 points rule (Art. 15)',
    'regla_25_desc': 'The difference between the top two is',
    'regla_25_info': 'The Master may award the second-place candidate if justified.',
    'regla_25_justificacion_hint': 'Justify your decision, especially if the 2.5 rule applies...',
    'resumen_puntuaciones': 'Evaluator scores',
    'candidatura_adjudicada': 'Candidature awarded!',
    'error_campos_obligatorios': 'City, country and award are required.',
    'checklist_aprobado': 'APPROVED',
    'checklist_titulo': 'Documentation requirements',
    'ciudad': 'City',
    'ciudad_asignada': 'Assigned city',
    'ciudad_asignar': 'Assign',
    'ciudad_cambiar': 'Change',
    'ciudad_cargo': 'Position',
    'ciudad_contacto_principal': 'Primary contact',
    'ciudad_desde': 'City from',
    'ciudad_email': 'Email',
    'ciudad_historico': 'History',
    'ciudad_modulos': 'Modules',
    'ciudad_nombre': 'Name',
    'ciudad_recursos': 'ACES Resources',
    'ciudad_rol': 'Role',
    'ciudad_salida': 'Departure city',
    'ciudad_salida_desc': 'The candidate city needs to know where you travel from to book your flight.',
    'ciudad_salida_hint': 'E.g.: London, Manchester...',
    'ciudad_salida_pendiente': 'Departure city pending',
    'ciudad_sin_asignar': 'No city assigned',
    'ciudad_sin_candidatura': 'No active candidature',
    'ciudad_sin_candidatura_desc': 'Contact ACES to start the candidature process.',
    'ciudad_telefono': 'Phone',
    'codigo_activando': 'Activating...',
    'codigo_activar': 'Activate code',
    'codigo_error_invalido': 'Invalid or already used code.',
    'codigo_generado_label': 'GENERATED CODE',
    'codigo_invalido': 'Invalid or already used code.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Enter the ACESCN code provided by ACES.',
    'codigo_titulo': 'Access code',
    'codigo_vacio': 'Please enter your access code.',
    'codigo_validar': 'Validate code',
    'codigos_disponibles': 'Available',
    'codigos_generados': 'Generated codes',
    'codigos_usados': 'Used codes',
    'comision_sin_otros': 'Only you on the commission',
    'comision_sin_otros_desc': 'No other evaluators have been assigned to this candidature yet.',
    'comision_titulo': 'Evaluation commission',
    'completado': 'complete',
    'comprobante_desc': 'Upload the bank transfer receipt in PDF or image format.',
    'comprobante_subido': 'Proof of payment uploaded successfully',
    'comprobante_titulo': 'Payment receipt',
    'config_comite': 'Committee size',
    'config_convocatorias': 'Open calls',
    'config_correos_desc': 'Emails used for official notifications to cities and evaluators.',
    'config_correos_titulo': 'Institutional emails',
    'config_guardada': 'Settings saved',
    'config_sanciones': 'Penalties for gala non-attendance (€)',
    'config_sistema_titulo': 'System configuration',
    'config_tasas': 'Participation fees (€)',
    'confirmada': 'Confirmed',
    'confirmando': 'Confirming...',
    'confirmar_asistencia': 'Confirm attendance',
    'contacto_principal': 'Main contact',
    'continuar': 'Continue',
    'continuar_evaluacion': 'Continue evaluation',
    'convocatoria': 'Year',
    'creando': 'Creating...',
    'crear_candidatura': 'Create candidature',
    'crear_cuenta': 'Create account',
    'dashboard_accesos_rapidos': 'Quick access',
    'dashboard_awos_sub': 'Log your sports activities and access global statistics.',
    'dashboard_awos_titulo': 'AWoS Active',
    'dashboard_documentos': 'Documents',
    'dashboard_estado': 'Application status',
    'dashboard_mensajes': 'Messages',
    'dashboard_pagos_pendientes': 'Pending payments',
    'datos_opcionales': 'These fields are optional and can be updated from your profile.',
    'de': 'of',
    'decision_adjudicar': 'Award',
    'decision_advertencia': 'This decision is final and permanently recorded.',
    'decision_confirmar': 'Confirm decision',
    'decision_nav': 'Final decision',
    'decision_notas': 'Decision notes (required)',
    'decision_rechazar': 'Not award',
    'decision_selecciona': 'Select the decision',
    'decision_titulo': 'Final decision',
    'desbloquear': 'Unlock',
    'desde': 'since',
    'destino': 'Destination',
    'dia': 'Day',
    'dias': 'days',
    'dias_label': 'days',
    'dias_visita_label': 'visit days',
    'doc_subido_ok': 'Document uploaded successfully',
    'docs_pendientes': 'Pending docs',
    'documento_pendiente': 'Document pending receipt',
    'duracion_visita_label': 'VISIT DURATION',
    'editar': 'Edit',
    'eliminar': 'Delete',
    'eliminar_cuenta': 'Delete my account',
    'eliminar_cuenta_desc': 'This action is irreversible. Your data will be anonymised per GDPR.',
    'eliminar_cuenta_password': 'Enter your password to confirm',
    'eliminar_cuenta_titulo': 'Delete account',
    'eliminar_documento': 'Delete document',
    'email_ciudad_label': 'CITY EMAIL',
    'email_contacto': 'Contact email',
    'email_enviado': 'Email sent successfully',
    'email_enviar': 'Send official email',
    'email_idioma': 'Recipient language',
    'email_invalido': 'Invalid email.',
    'email_preview': 'Email preview',
    'email_remitente': 'Send from',
    'email_ya_registrado': 'This email is already registered.',
    'emitir_factura_titulo': 'Issue invoice',
    'emitir_nueva_factura': 'Issue new invoice',
    'enviada': 'Submitted',
    'enviado_por_aces': 'Sent by ACES',
    'enviando': 'Sending...',
    'enviar': 'Submit',
    'enviar_evaluacion': 'Submit evaluation',
    'enviar_propuesta': 'Send proposal',
    'eres_jefe_comision': 'You are commission chief',
    'error_generico': 'An error occurred. Please try again.',
    'escribiendo': 'is typing',
    'estado_aceptada': 'Accepted',
    'estado_adjudicada': 'Awarded',
    'estado_decision': 'Decision pending',
    'estado_documentacion': 'Documentation',
    'estado_evaluacion': 'Under evaluation',
    'estado_pipeline': 'Candidature pipeline',
    'estado_rechazada': 'Not awarded',
    'estado_solicitada': 'Applied',
    'estado_visita': 'Visit scheduled',
    'estado_votacion': 'Under vote',
    'eval_abrev': 'eval.',
    'eval_abrir_motor': 'Open evaluation engine',
    'eval_anterior': 'Previous',
    'eval_asignadas': 'My assigned',
    'eval_asignado_ok': 'Evaluator assigned',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Loading evaluation...',
    'eval_comentario_placeholder': 'Comment your score...',
    'eval_comentario_voto': 'Final vote comment',
    'eval_comision_pendiente': 'Evaluator information available soon.',
    'eval_comision_titulo': 'Assigned evaluators',
    'eval_confirmar_desc': 'Once submitted, it cannot be modified without the Master unlocking it.',
    'eval_confirmar_envio': 'Submit evaluation',
    'eval_conflicto_interes': 'Conflict of interest: you are from the same country as the candidate city.',
    'eval_desfavorable': 'Not favourable',
    'eval_enviada_desc': 'Your evaluation has been successfully recorded.',
    'eval_enviada_ok': 'Evaluation submitted successfully',
    'eval_enviada_titulo': 'Evaluation submitted',
    'eval_enviadas': 'submitted',
    'eval_enviar': 'Submit',
    'eval_enviar_btn': 'Submit',
    'eval_favorable': 'Favourable',
    'eval_habilitada': 'Evaluation enabled',
    'eval_ir_motor': 'Go to evaluation engine',
    'eval_lista': 'Evaluators',
    'eval_mi_evaluacion': 'My evaluation',
    'eval_mis_candidaturas': 'My candidatures',
    'eval_motor_titulo': 'Evaluation engine',
    'eval_no_habilitada': 'The evaluation has not yet been enabled by ACES.',
    'eval_notas_comentario': 'Notes and comments',
    'eval_quitado': 'Evaluator removed',
    'eval_registrados': 'Registered',
    'eval_seccion': 'Section',
    'eval_siguiente': 'Next',
    'eval_sin_activas': 'No active candidatures',
    'eval_sin_asignadas': 'No assigned candidatures',
    'eval_sin_asignadas_desc': 'The Master will assign candidatures to your commission.',
    'eval_sin_documentos': 'No documents',
    'eval_sin_documentos_desc': 'The city has not uploaded any documents yet.',
    'eval_sin_reservas': 'No reservations yet',
    'eval_stat_asignadas': 'Assigned',
    'eval_stat_completadas': 'Completed',
    'eval_stat_pendientes': 'Pending',
    'eval_todas': 'All active',
    'eval_todas_activas': 'Active candidatures',
    'eval_todas_aviso': 'Read-only. Full detail for your assigned candidatures only.',
    'eval_total_seccion': 'Section score',
    'eval_ver_escala': 'View scoring scale',
    'eval_voto_final': 'Final vote',
    'eval_voto_informativo': 'Your vote is advisory. The final decision rests with the ACES Master.',
    'evaluacion_titulo': 'Evaluation',
    'evaluaciones_enviadas': 'evaluations submitted',
    'evaluadores_asignados': 'evaluators assigned',
    'evaluadores_asignados_label': 'ASSIGNED EVALUATORS',
    'evento_almuerzo': 'Lunch',
    'evento_cena': 'Dinner',
    'evento_desayuno': 'Breakfast',
    'evento_descanso': 'Rest',
    'evento_llegada': 'Arrival',
    'evento_otro': 'Other',
    'evento_recepcion': 'Reception',
    'evento_reunion': 'Meeting',
    'evento_rueda_prensa': 'Press conference',
    'evento_salida': 'Departure',
    'evento_traslado': 'Transfer',
    'evento_visita': 'Visit',
    'factura_creada_ok': 'Invoice registered. Now upload the PDF.',
    'factura_detalle': 'Detail / Extended concept',
    'factura_detalle_hint': 'Detailed description of services, payment terms, bank details...',
    'factura_subida_ok': 'Invoice uploaded successfully',
    'facturas_aces': 'From ACES',
    'fecha_llegada_label': 'ARRIVAL DATE',
    'fecha_regreso': 'Return date',
    'fecha_salida': 'Departure date',
    'fecha_vencimiento_label': 'DUE DATE',
    'filtro_estado': 'Status',
    'filtro_tipo': 'Type',
    'filtro_todas': 'All',
    'filtro_todos': 'All',
    'gala_asistencia_confirmada': 'Attendance confirmed',
    'gala_invitacion_titulo': 'Gala Invitation',
    'gala_pendiente_desc': 'ACES will activate your invitation when the time comes.',
    'gala_pendiente_invitacion': 'Invitation pending',
    'gala_representantes': 'Representatives',
    'gala_sin_datos': 'No gala data',
    'gala_sin_datos_desc': 'No ceremony information for this year.',
    'gala_sin_representantes': 'No representatives added',
    'galardon': 'Award',
    'general_error': 'An error occurred',
    'general_reintentar': 'Retry',
    'generar_codigo': 'Generate code',
    'generar_codigo_titulo': 'New access code',
    'gestionar_comision': 'Manage commission',
    'guardado': 'Saved',
    'guardando': 'Saving...',
    'guardar': 'Save',
    'guardar_ciudad_salida': 'Save departure city',
    'guardar_config': 'Save settings',
    'guardar_y_siguiente': 'Save and next',
    'historico_titulo': 'Previous applications',
    'hora': 'Time',
    'hora_fin_opc': 'End time (optional)',
    'hora_inicio': 'Start time',
    'idioma_titulo': 'Interface language',
    'iniciar_evaluacion': 'Start evaluation',
    'invitacion_enviada': 'Invitation sent',
    'invitar_ciudad_titulo': 'Invite city',
    'invitar_codigo_generado': 'Generated code',
    'invitar_copiar': 'Copy',
    'invitar_cuerpo_eval': 'We invite you to join ACES Cities Network as an evaluator.\\n\\nYour access code is:',
    'invitar_email': 'Send via email',
    'invitar_evaluador_sub': 'Generate a code and share it via WhatsApp or email',
    'invitar_evaluador_titulo': 'Invite evaluator',
    'invitar_generar_codigo': 'Generate access code',
    'invitar_nombre': 'Evaluator name',
    'invitar_pie': 'Download the ACES Cities Network app, register and enter your code when prompted.\\n\\n— ACES',
    'invitar_saludo': 'Dear',
    'invitar_whatsapp': 'Send via WhatsApp',
    'jefe_comision_ninguno': 'No chief assigned',
    'jefe_comision_sin_eval': 'Assign evaluators first to designate a chief.',
    'jefe_comision_titulo': 'Commission chief',
    'jefe_designado_ok': 'Commission chief appointed',
    'jefe_eliminado_ok': 'Commission chief removed',
    'llegada': 'Arrival',
    'llegada_label': 'Arrival',
    'login_crear_cuenta': 'First time? Create account →',
    'login_olvide_contrasena': 'Forgot your password?',
    'login_proximamente': 'Coming soon',
    'login_recuperar_desc': 'Enter your email and we will send you a link to reset your password.',
    'login_recuperar_titulo': 'Recover access',
    'login_requiere_codigo': 'Access to Cities Network requires an ACES invitation code.',
    'login_restablecer': 'Reset password',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Venue',
    'marcar_leidas': 'Mark all as read',
    'master_label': 'ACES MASTER',
    'master_panel_desc': 'Full control of candidatures, evaluations and decisions.',
    'master_recientes': 'Recent candidatures',
    'master_saludo': 'ACES Panel',
    'master_sin_candidaturas': 'No candidatures yet',
    'mi_evaluacion': 'My evaluation',
    'mis_pagos': 'My payments',
    'mod_chat': 'ACES Chat',
    'mod_documentos': 'Documents',
    'mod_facturas_pagos': 'Invoices & Payments',
    'mod_gala': 'Gala',
    'mod_pagos': 'Payments',
    'mod_titularidad': 'Titularity',
    'mod_viaje': 'Logistics',
    'modo_evaluador': 'Evaluator',
    'modo_master': 'Master',
    'motor_evaluacion': 'Evaluation engine',
    'no_configurado': 'Not configured — edit your profile',
    'nombre': 'First name',
    'nombre_documento': 'Document name',
    'nombre_hotel': 'Hotel name',
    'notas_hint': 'E.g.: Land at T4, recommended hotel...',
    'notas_internas_label': 'INTERNAL NOTES (optional)',
    'notif_candidatura_actualizada': 'Candidature updated',
    'notif_candidatura_desasignada': 'Candidature unassigned',
    'notif_documento_revisado': 'Document reviewed',
    'notif_estado_actualizado': 'Status updated',
    'notif_evaluacion_completada': 'Evaluation completed',
    'notif_limpiar_desc': 'All notifications will be deleted. This action cannot be undone.',
    'notif_limpiar_todas': 'Clear all',
    'notif_marcar_leida': 'Mark as read',
    'notif_nueva_asignacion': 'New candidature assigned',
    'notif_pago_vencido': 'Payment due soon',
    'notif_sin_leer': 'Unread',
    'notif_sin_notifs': 'No notifications',
    'notif_visita_programada': 'Evaluation visit scheduled',
    'notificar_ciudad': 'Notify city',
    'nueva_candidatura': 'New candidature',
    'nueva_propuesta': 'New proposal',
    'num_habitaciones': 'Number of rooms',
    'origen': 'Origin',
    'pago_enviar_recordatorio': 'Open email',
    'pago_factura': 'Invoice',
    'pago_instrucciones': 'Make the bank transfer and upload proof.',
    'pago_recibido': 'Received',
    'pago_recordatorio': 'Reminder',
    'pago_recordatorio_desc': 'Your email client will open with the message ready.',
    'pago_recordatorio_titulo': 'Send payment reminder',
    'pagos_ciudad': 'My payments',
    'pagos_pendientes': 'Pending payments',
    'pais': 'Country',
    'pais_buscar': 'Search country...',
    'pais_seleccionado': 'Selected country',
    'pais_seleccionar': 'Select country',
    'paso_datos': 'Invoice data',
    'paso_subir_pdf': 'Upload invoice PDF',
    'password_actual': 'Current password',
    'password_cambiada': 'Password changed successfully',
    'password_cambiar': 'Change password',
    'password_corta': 'Password must be at least 6 characters.',
    'password_nueva': 'New password',
    'password_repetir': 'Repeat password',
    'passwords_no_coinciden': 'Passwords do not match.',
    'error_red': 'Network error. Please check your Internet connection.',
    'error_demasiados_intentos': 'Too many attempts. Please wait a moment and try again.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Application letter received',
    'hito_aprobada': 'Candidacy approved',
    'hito_reglamento_enviado': 'Regulations sent for signature',
    'hito_reglamento_firmado': 'Signed regulations received',
    'hito_datos_factura': 'Invoice data received',
    'hito_pago_confirmado': 'Payment confirmed',
    'hito_fechas_visita': 'Visit dates proposed',
    'hito_comision_creada': 'Evaluation committee created',
    'hito_viajes_cerrados': 'Travel arrangements finalized',
    'hito_agenda_enviada': 'Agenda sent',
    'hito_bid_file': 'BID File received',
    'doc_tipo_carta_solicitud': 'Application letter',
    'doc_tipo_agenda_visita': 'Visit agenda',
    // Logistica simplificada
    'mod_logistica': 'Logistics',
    'agenda_vacia_ciudad': 'No agenda uploaded yet. Upload the visit agenda PDF.',
    'agenda_aviso_master': 'The agenda is visible to evaluators and the city. Upload the final PDF.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES will publish the visit agenda when available.',
    'eval_reservas_desc': 'Your confirmed flight and hotel reservations will appear here.',
    'eval_sin_reservas_desc': 'ACES or the city will upload your travel reservations when confirmed.',
    'perfil_actualizado': 'Profile updated',
    'perfil_apellidos': 'Last name',
    'perfil_cambiar_foto': 'Profile photo',
    'perfil_cargo': 'Position',
    'perfil_ciudad': 'City',
    'perfil_compartir_ciudad': 'Share phone with cities',
    'perfil_compartir_ciudad_desc': 'Candidate cities will be able to see your contact number.',
    'perfil_compartir_eval_desc': 'Evaluators on your commission will be able to see your contact.',
    'perfil_compartir_evaluadores': 'Share with other evaluators',
    'perfil_contacto': 'Contact',
    'perfil_cuenta': 'Account',
    'perfil_datos': 'Personal data',
    'perfil_datos_evaluador': 'Commission data',
    'perfil_datos_personales': 'Personal data',
    'perfil_elegir_foto': 'Choose photo',
    'perfil_eval_config': 'Evaluator settings',
    'perfil_evaluador': 'Evaluator settings',
    'perfil_fecha_nac': 'Date of birth',
    'perfil_foto_actualizada': 'Photo updated successfully',
    'perfil_guardado': 'Profile saved successfully',
    'perfil_guardar': 'Save profile',
    'perfil_idioma': 'App language',
    'perfil_nombre': 'First name',
    'perfil_notificaciones': 'Notifications',
    'perfil_pais': 'Country',
    'perfil_provincia': 'Province',
    'perfil_talla': 'Polo size (commission)',
    'perfil_telefono': 'Phone',
    'perfil_titulo': 'My profile',
    'perfil_ubicacion': 'Location',
    'pipeline_aceptada_desc': 'Candidature accepted. Prepare the required documentation.',
    'pipeline_adjudicada_desc': 'Congratulations! Your city has been awarded the ACES title.',
    'pipeline_decision_desc': 'The final decision is being prepared by ACES.',
    'pipeline_documentacion_desc': 'We are reviewing your documentation. Please upload all required files.',
    'pipeline_evaluacion_desc': 'The evaluation committee is analysing your candidature.',
    'pipeline_rechazada_desc': 'Your candidature was not selected in this call.',
    'pipeline_solicitada_desc': 'Your candidature has been received and is being reviewed.',
    'pipeline_visita_desc': 'The evaluation visit to your city is being organised.',
    'pipeline_votacion_desc': 'The committee is deliberating on your candidature.',
    'precio_aprox': 'Approximate price (€)',
    'precio_estimado': 'Estimated price (€)',
    'preview_email_label': 'EMAIL PREVIEW',
    'programar_visita_titulo': 'Schedule visit',
    'proponer_agenda': 'Agenda',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Flight',
    'provincia': 'Province / State',
    'provincia_seleccionar': 'Select province / region',
    'rechazar': 'Reject',
    'recomendaciones_titulo': 'Recommendations',
    'recordatorio_asunto': 'Payment reminder — {ciudad}',
    'recordatorio_cuerpo': 'Dear {ciudad} team,\\n\\nThis is a reminder that the payment for: {concepto} is still pending.\\n\\nPlease complete the transfer at your earliest convenience. If you have any questions, feel free to contact us.\\n\\nBest regards,\\nACES',
    'reg_ciudad': 'City / Municipality *',
    'reg_creando': 'Creating account...',
    'reg_crear_cuenta': 'Create account',
    'reg_pais': 'Country *',
    'reg_provincia': 'Province / Region',
    'reg_resumen_titulo': 'Account summary',
    'reg_telefono': 'Contact phone *',
    'reg_tipo': 'Access type',
    'reg_ubicacion_sub': 'Your organisation\'s information',
    'reg_ubicacion_titulo': 'Your location',
    'registro_cancelar_salir': 'Cancel and exit',
    'registro_codigo_label': 'ACES ACCESS CODE',
    'registro_contrasena_label': 'PASSWORD',
    'registro_crear_cuenta': 'Create your account',
    'registro_datos_personales': 'Personal details',
    'registro_elige_rol': 'Which role do you use to access Cities Network?',
    'registro_email_label': 'EMAIL',
    'registro_paso_1': 'Step 1 of 3',
    'registro_paso_2': 'Step 2 of 3',
    'registro_paso_2_desc': 'This information is used for evaluation visit logistics.',
    'registro_paso_3': 'Step 3 of 3',
    'registro_siguiente': 'Next →',
    'registro_verifica_desc': 'We have sent you a verification email. Open it and click the link before continuing.',
    'registro_verifica_titulo': 'Verify your email',
    'rol_ciudad': 'City',
    'rol_evaluador': 'Evaluator',
    'rol_master': 'ACES Master',
    'salida': 'Departure',
    'salida_label': 'Departure',
    'saludo_buenas_noches': 'Good evening,',
    'saludo_buenas_tardes': 'Good afternoon,',
    'saludo_buenos_dias': 'Good morning,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Section',
    'seleccionar': 'Select',
    'seleccionar_pais': 'Select country',
    'seleccionar_provincia': 'Select province',
    'sin_agenda': 'No schedule',
    'sin_agenda_desc': 'The city has not proposed a visit schedule yet.',
    'sin_candidaturas': 'No candidatures',
    'sin_candidaturas_desc': 'No candidatures match this filter.',
    'sin_ciudad_asignada': 'No city assigned',
    'sin_codigos_disponibles': 'No codes available',
    'sin_documentos': 'No documents',
    'sin_documentos_desc': 'Upload the required documents.',
    'sin_evaluaciones': 'No evaluations',
    'sin_evaluadores_desc': 'Register evaluators with an ACESCN-EVAL-xxx code.',
    'sin_evaluadores_disponibles': 'No evaluators registered',
    'sin_facturas_aces': 'No invoices received',
    'sin_facturas_aces_desc': 'Invoices sent by ACES will appear here.',
    'sin_notificaciones': 'No notifications',
    'sin_notificaciones_desc': 'Activity from your candidatures will appear here.',
    'sin_pagos': 'No payments',
    'sin_pagos_desc': 'Payments will appear here.',
    'stat_activas': 'Active',
    'stat_decision': 'Decision pending',
    'stat_dias_visita': 'Days until visit',
    'stat_docs_pendientes': 'Pending docs',
    'stat_evaluacion': 'In evaluation',
    'stat_mensajes_nuevos': 'New messages',
    'stat_notif': 'Unread',
    'stat_pagos_pendientes': 'Pending payments',
    'stat_sin_visita': 'No visit scheduled',
    'stat_titulos': 'Active titles',
    'stat_total': 'Total',
    'subir_comprobante': 'Upload proof',
    'subir_documento': 'Upload document',
    'subir_factura': 'Upload invoice',
    'subir_factura_desc': 'Upload the invoice PDF. The city will be able to download it from their panel.',
    'subir_factura_titulo': 'Upload invoice PDF',
    'subir_nota': 'Select the file from your device',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidature',
    'tab_candidaturas': 'Candidatures',
    'tab_chat': 'Chat',
    'tab_config': 'Settings',
    'tab_documentos': 'Documents',
    'tab_evaluaciones': 'Evaluations',
    'tab_evaluadores': 'Evaluators',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Home',
    'tab_notif': 'Notifications',
    'tab_pagos': 'Payments',
    'tab_perfil': 'Profile',
    'tab_recursos': 'Resources',
    'tab_resumen': 'Summary',
    'tab_viaje': 'Logistics',
    'talla_polo': 'Polo shirt size',
    'telefono': 'Phone',
    'template_no_disponible': 'The evaluation template is not yet available.',
    'tipo_codigo': 'Code type',
    'tit_ano_titulo': 'Title year',
    'tit_evidencias': 'Uploaded evidence',
    'tit_item_calendario': 'Sports calendar',
    'tit_item_congreso': 'Congress or conference',
    'tit_item_imagen': 'Correct use of title',
    'tit_item_memoria': 'Final report',
    'tit_no_aplica': 'No title year',
    'tit_no_aplica_desc': 'This module activates when your city wins an ACES award.',
    'tit_sanciones': 'Penalties',
    'tit_sin_datos': 'No active titles',
    'tit_titulo': 'Title year',
    'toca_abrir_documento': 'Tap to open the document',
    'toca_copiar': 'Tap code to copy',
    'toca_para_abrir': 'Tap to open',
    'toca_para_copiar': 'Tap to copy',
    'tomar_decision': 'Final decision',
    'tu_ciudad_salida': 'Your departure city',
    'upload_error': 'Upload error',
    'upload_exito': 'Uploaded successfully!',
    'upload_formatos': 'PDF, JPG or PNG · max. 20 MB',
    'upload_no_cierres': 'Do not close the app',
    'upload_reintentar': 'Try again',
    'upload_subiendo': 'Uploading file...',
    'vence': 'Due',
    'ver_comprobante': 'View proof',
    'ver_detalle': 'View detail',
    'ver_documento_adjunto': 'View attached document',
    'ver_factura': 'View invoice',
    'verifica_desc': 'We have sent a verification email. Please check your inbox.',
    'verifica_reenviar': 'Resend verification email',
    'viaje_aviso_privacidad': 'Evaluator identity is confidential. You will only see dates and logistics.',
    'viaje_ciudad_salida': 'Your departure city for flights',
    'viaje_proponer_vuelo': 'Propose flight',
    'viaje_propuesta_enviada': 'Proposal sent successfully',
    'viaje_sin_propuestas': 'No travel proposals',
    'viaje_sin_propuestas_desc': 'Propose flight, hotel and agenda options.',
    'visita_evaluadores': 'Evaluators visit',
    'visita_programada': 'Visit scheduled',
    'visita_sin_programar': 'Visit not yet scheduled',
    'visita_titulo': 'Evaluation visit',
    'volver': 'Back',
    'votacion_abierta': 'Voting open',
    'votacion_cerrada': 'Voting closed',
    'walkthrough_ver_guia': 'View getting started guide',
    'whatsapp': 'WhatsApp (with prefix)',
    'ya_tengo_cuenta': 'Already have an account?',
    'tab_titularidades': 'Titularities',
    'acciones_rapidas': 'Quick actions',
    'evaluadores_titulo': 'Evaluators',
    'evaluadores_registrados': 'Registered evaluators',
    'codigos_disponibles_label': 'Available codes',
    'evaluadores_seccion': 'Evaluators',
    'codigos_acceso_titulo': 'Access codes',
    'config_pais': 'Country',
    'config_telefono': 'Phone',
    'config_correos_inst': 'Institutional emails',
    'config_capital': 'Capital',
    'config_city': 'City',
    'config_town': 'Town',
    'evaluacion_habilitada': 'Evaluation enabled',
    'evaluaciones_titulo_card': 'Evaluations',
    'decision_final_titulo': 'Final decision',
    'gestionar_comision_titulo': 'Manage committee',
    'programar_visita_modal': 'Schedule evaluation visit',
    'fecha_llegada': 'Arrival date',
    'req_documentacion': 'Documentation requirements',
    'todo_leido': 'All read',
    'confirmar_borrar_notifs': 'Delete all notifications?',
    'gala_creada_ok': 'Gala created successfully',
    'gala_error_crear': 'Error creating gala',
    'gala_activada': 'Gala activated for cities',
    'gala_desactivada': 'Gala deactivated',
    'titularidades_titulo': 'Titularities',
    'titularidades_desc': 'Cities with active ACES award and obligation tracking',
    'obligaciones_titulo': 'Title holder obligations',
    'obligacion_imagen': 'Respect ACES image rules',
    'obligacion_calendario': 'Design annual sport calendar',
    'obligacion_congreso': 'Organize international congress or competition',
    'obligacion_memoria': 'Submit year-end report and conclusions',
    'obligacion_awos': 'Actively participate in AWoS/EWoS',
    'cumplidas': 'completed',
    'viaje_confirmar': 'Confirm proposal',
    'viaje_rechazar': 'Reject proposal',
    'viaje_confirmado': 'Proposal confirmed',
    'viaje_rechazado': 'Proposal rejected',
    'nota_respuesta': 'Response note (optional)',
    'voto_favor_confirm': 'Confirm favorable vote?',
    'voto_contra_confirm': 'Confirm vote against?',
    'historial_sin_cambios': 'No status changes recorded',
    'candidatura_buscar': 'Search city, award...',
    'candidatura_ciudad_ph': 'E.g. Buenos Aires',
    'candidatura_pais_ph': 'E.g. Argentina',
    'candidatura_email_ph': 'city@email.com',
    'dias_visita': 'visit days',
    'propuestas_viaje': 'Travel proposals',
    'sin_propuestas_viaje': 'No travel proposals',
    'sin_propuestas_desc': 'Evaluators have not yet proposed an itinerary.',
    'sin_evaluaciones_desc': 'Assign evaluators and enable evaluation.',
    'seleccionar_pdf': 'Select PDF',
    'rechazar_candidatura': 'Reject candidature',
    'motivo_rechazo': 'Rejection reason (required)',
    'tit_sin_datos_desc': 'Awarded cities will appear here automatically.',
    'marcado_cumplido': 'Marked as completed',
    'desmarcado': 'Unmarked',
    'finalizada': 'Completed',
    'finalizadas': 'Completed',
    'notas_label': 'Notes',
    'sin_leer': 'unread',
    'confirmar_cerrar_sesion': 'Sign out?',
    'email_aces_europa': 'ACES Europe email',
    'email_aces_america': 'ACES Americas email',
    'gala_fecha_evento': 'Event date',
    'gala_primera_desc': 'Create the first gala to start managing ceremonies.',
    'evaluadores_gestion': 'ACES evaluation committee management',
    'adjudicar': 'Adjudicate',
    'adjudicada_ok': 'Candidature adjudicated!',
    'candidatura_rechazada': 'Candidature rejected',
    'error_decision': 'Error registering decision',
    'evaluador_asignado': 'Evaluator assigned',
    'evaluador_quitado': 'Evaluator removed',
    'jefe_designado': 'Committee head designated',
    'jefe_eliminado': 'Committee head removed',
    'notas_guardadas': 'Notes saved',
    'notas_visita_hint': 'E.g.: Recommended hotel, airport instructions...',
    'visita_ok': 'Visit scheduled successfully',
    'error_visita': 'Error scheduling visit',
    'evaluacion_hab_ok': 'Evaluation enabled',
    'evaluacion_deshab_ok': 'Evaluation disabled',
    'programar': 'Schedule',
    'confirmar_decision': 'Confirm decision',
    'cambiar_modo': 'Switch mode',
    'de_preposicion': 'of',
    'notas_decision_label': 'Decision notes (optional)',
    'generar': 'Generate',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File received',
    'documentos_firmados': 'Signed documents',
    'pago_confirmado': 'Payment confirmed',
    'subiendo_label': 'Uploading...',
    'pagado_label': 'Paid',
    'factura_label': 'Invoice',
    'marcar_factura': 'Mark invoice as issued',
    'desmarcar_factura': 'Unmark invoice',
    'marcar_pago': 'Mark payment received',
    'desmarcar_pago': 'Unmark payment',
    'evaluacion_enviada': 'Submitted',
    'disponible_label': 'Available',
    'ver_codigos_btn': 'View codes',
    'invitar_eval_btn': 'Invite evaluator',
    'generar_codigo_btn': 'Generate new code',
    'idioma_destinatario': 'Recipient language',
    'candidaturas_count': 'candidatures',
    'sin_alertas_ok': 'All good. No pending alerts.',
    'sin_galas_configuradas': 'No galas configured',
    'gala_activada_ciudades': 'Gala activated for cities',
    'ver_alertas_label': 'View alerts',
    'modo_evaluador_activo': 'Evaluator mode active',
    'modo_master_activo': 'Master ACES view',
    'cambiar_a_eval': 'Evaluator mode',
    'cambiar_a_master': 'Back to Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Regulation',
    'doc_tipo_comprobante': 'Payment proof',
    'doc_tipo_contrato': 'Contract',
    'doc_tipo_memoria': 'Report',
    'doc_tipo_pres': 'Presentation',
    'doc_tipo_otro': 'Other',
    'selecciona_tipo_doc': 'What type of document is this?',
    'todos_label': 'All',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Event',
    'mis_propuestas': 'My proposals',
    'propuestas_label': 'proposals',
    'ciudad_hotel': 'City',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/night',
    'hotel_notas_hint': 'E.g.: Double room, breakfast included...',
    'vuelo_notas_hint': 'E.g.: Direct flight, stopover in Madrid...',
    'fecha_label': 'Date',
    'hora_label': 'Time',
    'lugar_label': 'Venue',
    'tipo_reunion': 'Meeting',
    'tipo_visita_instalacion': 'Facility visit',
    'tipo_acto': 'Official event',
    'tipo_almuerzo': 'Lunch / Dinner',
    'tipo_transporte': 'Transport',
    'tipo_otro': 'Other',
    'galardones_titulo': 'Awards',
    'reglamentos_titulo': 'Regulations',
    'sin_candidatura_titulo': 'No candidature assigned',
    'sin_candidatura_desc': 'Your account has no candidature linked yet.',
    'bienvenida_ciudad_saludo': 'Hi, {nombre}',
    'bienvenida_ciudad_titulo': 'Your account is active',
    'bienvenida_ciudad_desc': 'We\'re preparing your candidacy. As soon as the ACES team assigns one to you, it will appear here with full tracking.',
    'bienvenida_ciudad_chip_activa': 'Active account',
    'bienvenida_ciudad_chip_espera': 'Awaiting assignment',
    'bienvenida_ciudad_contacto': 'Questions? Contact ACES',
    'chat_ciudad_desc': 'Direct communication with the ACES team.',
    'mensajes_label': 'Messages',
    'motor_seccion_de': 'of',
    'gala_confirmar_desc': 'Indicate whether your city will attend the gala ceremony.',
    'eval_completadas': 'Completed',
    'secciones_completadas': 'sections completed',
    'evaluaciones_enviadas_abrev': 'evaluations submitted',
    'awos_activa_desc': 'Track your physical activity and access ACES events',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Your travel details are only visible to ACES — the city cannot see evaluator identities.',
    'eval_docs_solo_lectura': 'You can view documents submitted by the city.',
    'conflicto_titulo': 'Conflict of interest declaration',
    'conflicto_desc': 'Before evaluating, confirm you have no conflict of interest with this candidature.',
    'conflicto_sin_conflicto': 'No conflict — proceed',
    'conflicto_con_conflicto': 'I have a conflict',
    'conflicto_aviso': 'Please notify ACES immediately. You cannot evaluate this candidature.',
    'sin_fecha': 'No date',
    'subir_reserva_hint': 'Upload the confirmed flight or hotel booking PDF.',
    'subir_reserva_hint_eval': 'Upload your flight or hotel booking PDF.',
    'login_sin_cuenta': 'Don\'t have an account?',
    'agenda_oficial_titulo': 'Official visit agenda',
    'agenda_anadir_evento': 'Add event',
    'agenda_editar_evento': 'Edit event',
    'agenda_oficial_aviso': 'This agenda is visible to evaluators. The city sees dates and logistics, but not evaluator names.',
    'agenda_oficial_vacia': 'No events published yet. Add the visit programme so evaluators can see it.',
    'publicar_evento': 'Publish event',
    'evento_publicado': 'Event published to agenda',
    'evento_guardado': 'Event updated',
    'evento_eliminado': 'Event deleted',
    'confirmar_eliminar': 'Delete this event?',
    'guardar_cambios': 'Save changes',
    'pipeline_titulo': 'Candidacy pipeline',
    'revenue_titulo': 'Revenue',
    'revenue_total': 'Total billed',
    'cobrado': 'Collected',
    'visitas_proximas': 'Upcoming visits',
    'paises_titulo': 'By country',
    'awos_banner_desc': 'Track your physical activity and access ACES events',
    'fecha_limite_confirmar': 'Confirmation deadline',
    'info_parlamento': 'European Parliament info',
    'info_venue': 'Venue',
    'norma_hotel': 'Hotel rules',
    'norma_vuelo': 'Flight rules',
    'programa_dia': 'Day program',
    'sin_programa': 'No program defined',
    'actividad_placeholder': 'Activity...',
    'anadir': 'Add',
    'representantes_label': 'Representatives',
    'confirmados_label': 'Confirmed',
    'fecha_limite': 'Deadline',
    'deadline_pasada': 'Deadline passed',
    'restantes': 'remaining',
    'anadir_representante': 'Add representative',
    'sin_representantes': 'No representatives',
    'representante_anadido': 'Representative added',
    'representante_eliminado': 'Representative removed',
    'programa_actualizado': 'Program updated',
    'confirmado': 'CONFIRMED',
    'nombre_label': 'Full name',
    'cargo_label': 'Position',
    'telefono_label': 'Phone',
    'logistica_evaluadores': 'Evaluator logistics',
    'vuelo_short': 'Flight',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Required documents',
    'evidencia_subida': 'Evidence uploaded',
    'sancion_anadida': 'Sanction registered',
    'memoria_subida': 'Final report uploaded',
    'nueva_sancion': 'New sanction',
    'motivo_sancion': 'Reason',
    'motivo_sancion_hint': 'E.g.: Non-attendance at gala without justification',
    'importe_label': 'Amount',
    'divisa_label': 'Currency',
    'registrar_sancion': 'Register sanction',
    'subir_evidencia': 'Upload',
    'memoria_final_titulo': 'Final report',
    'memoria_deadline': 'Before January 31',
    'subir_memoria': 'Upload final report (PDF)',
    'sin_sanciones': 'No sanctions registered',
    'evidencias_short': 'evidences',
    'memoria_ok': 'Report OK',
    'sanciones_short': 'sanctions',
    'dias_en_fase': 'Days in phase',
    'proximo_pago': 'Next payment',
    'vencido': 'Overdue',
    'visita_label': 'Visit',
    // === Paquete 2 — 85 keys faltantes (en) ===
    'abrir_nueva_pestana': 'Open in new tab',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Articles',
    'auth_accediendo': 'Signing in...',
    'auth_email_enviado': 'Email sent. Check your inbox.',
    'auth_enviar_enlace': 'Send link',
    'auth_error_intentos': 'Too many attempts. Please wait.',
    'auth_error_password': 'Incorrect password',
    'auth_error_reset': 'Error sending recovery email',
    'auth_error_usuario': 'User not found',
    'auth_introduce_email': 'Enter your email',
    'auth_olvido_password': 'Forgot my password',
    'auth_recuperar': 'Reset password',
    'auth_recuperar_desc': 'We will send you a link to reset your password.',
    'aw_h': 'American Week of Sport',
    'aw_lbl': 'AWoS',
    'aw_p': 'Celebrate sport and physical activity with your city during the American Week of Sport.',
    'bonus_desc': 'Additional points for outstanding initiatives',
    'buscar_articulo': 'Search article...',
    'buscar_recursos': 'Search resources...',
    'comite_evaluacion': 'Evaluation committee',
    'confirmar_eliminar_pago': 'Are you sure you want to delete this payment?',
    'cookie_accept': 'Accept',
    'cookie_more': 'More information',
    'cookie_msg': 'We use essential cookies for site functionality.',
    'cookie_reject': 'Reject',
    'criterios_elegibilidad': 'Eligibility criteria',
    'cta_b1': 'Submit candidature',
    'cta_b2': 'Contact ACES',
    'cta_h': 'Start your candidature today',
    'cta_p': 'Join the network of European sport cities and transform your community.',
    'descargar_factura': 'Download invoice',
    'docs_drag_drop': 'Drag files here or click to select',
    'docs_obligatorios': 'Required documents',
    'eval_actual': 'Current evaluation',
    'eval_comentario_voto_placeholder': 'Comment on your vote (optional)...',
    'eval_max_puntos': 'Maximum score',
    'feats': 'Features',
    'footer_contact': 'Contact',
    'footer_legal': 'Legal notice',
    'footer_privacy': 'Privacy policy',
    'ft_h': 'Everything you need',
    'ft_lbl': 'Features',
    'general_volver': 'Back',
    'hero_cta1': 'Submit candidature',
    'hero_cta2': 'Learn the process',
    'hero_h1a': 'Your city deserves',
    'hero_h1b': 'to be recognised',
    'hero_sub': 'ACES Cities Network connects cities, evaluators and sport organisations in one platform.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Clear',
    'login_subtitulo': 'Sign in to your ACES Cities Network account',
    'marcar_todas_leidas': 'Mark all as read',
    'nav_acceder': 'Sign in',
    'nav_funciones': 'Features',
    'nav_galardones': 'Awards',
    'nav_proceso': 'Process',
    'nav_registro': 'Register',
    'nav_roles': 'Roles',
    'notif_todas_leidas': 'All notifications marked as read',
    'pago_eliminado': 'Payment deleted',
    'pendiente': 'Pending',
    'pendiente_label': 'Pending',
    'pipe_h': 'Transparent process',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Follow every stage of your candidature in real time.',
    'preambulo': 'Preamble',
    'recursos_aces_desc': 'Awards, regulations and official ACES documentation.',
    'recursos_aces_titulo': 'ACES Resources',
    'reglamentos_seed': 'Regulations loaded successfully',
    'regulacion_sin_articulos': 'This regulation has no articles.',
    'roles_h': 'For every role',
    'roles_lbl': 'Roles',
    'roles_p': 'Cities, evaluators and administrators in one platform.',
    'sancion_incumplimiento': 'Non-compliance penalty',
    'sin_articulos': 'No articles',
    'sin_galardones': 'No awards available',
    'sin_reglamentos': 'No regulations available',
    'sin_recursos': 'No resources available',
    'sin_resultados': 'No results',
    'stages': 'Stages',
    'tasa_inscripcion': 'Registration fee',
    'todas': 'All',
    'ver_candidatura': 'View candidature',
    'reserva_sin_evaluador': 'General (no evaluator assigned)',
    'preview_pdf_hint': 'PDFs open in a new browser tab.',
    'descargar': 'Download',
    'con_pago_confirmado': 'with confirmed payment (milestone)',
    'pendientes_pago': 'pending',
    'sin_datos_pagos': 'No payment data recorded',
    'eval_no_asignado': 'You are not assigned to the evaluation commission for this candidacy.',
    'subir_reserva': 'Upload reservation',
    'sin_reservas': 'No reservations',
    'sin_reservas_desc': 'Upload the reservation PDFs.',
    'reservas_desc_master': 'Upload confirmed flight and hotel reservations as PDF. You can select the corresponding evaluator.',
    'subir_agenda': 'Upload agenda (PDF)',
    'agenda_visita_titulo': 'Visit agenda',
    'reservas_titulo': 'Reservations',
    'reserva_subida_ok': 'Reservation uploaded successfully',
    'agenda_subida_ok': 'Agenda uploaded successfully',
    'doc_eliminado': 'Document deleted',
    'agenda_vacia_desc': 'Upload the visit agenda PDF.',
    'revenue_cobrado': 'Collected',
    'revenue_pendiente': 'Pending',
    'ciudad_hitos_titulo': 'Your candidature status',
    'hito_factura_recibida': 'Invoice received',
    'eval_mis_evaluaciones': 'My evaluations',
    'eval_sin_bid': 'The city has not uploaded the BID File yet.',
    'voto_final_desc_motor': 'Cast your final vote based on your evaluation.',
    'chat_comision': 'Commission chat',
    'tit_comunicacion_ok': 'Official communication OK',
    'tit_derechos_factura_env': 'Image rights: invoice sent',
    'tit_derechos_pagado': 'Image rights: paid',
    'tit_q1': 'Quarterly report Q1',
    'tit_q2': 'Quarterly report Q2',
    'tit_q3': 'Quarterly report Q3',
    'tit_q4': 'Quarterly report Q4',
    'tit_premio_n1': 'N1 Award: Participates?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'New sanction',
    'motivo': 'Reason',
    'si': 'Yes',
    'no': 'No',
    'nueva': 'New',
    'sanciones': 'Sanctions',
    'pagada': 'Paid',

    'borrar_candidatura': 'Delete candidature',
    'borrar_candidatura_desc': 'Permanently deletes the candidature and all associated data.',
    'confirmar_borrar_candidatura': 'Delete this candidature? This action CANNOT be undone.',
    'confirmar_borrar_candidatura_2': 'ARE YOU SURE? ALL documents, payments, evaluations and chats will be deleted.',
    'candidatura_eliminada': 'Candidature deleted',
    'zona_peligrosa': 'Danger zone',
    'contacto_ciudad': 'City contact',
    'sin_ciudad_vinculada': 'No city user linked',
    'cambiar_ciudad': 'Change',
    'vincular_ciudad': 'Link',
    'vincular_ciudad_titulo': 'Link city user',
    'vinculado_actual': 'Currently linked',
    'desvincular': 'Unlink',
    'buscar_usuario_ciudad': 'Search by name, email or city...',
    'sin_usuarios_ciudad': 'No users with city role registered',
    'ciudad_vinculada_ok': 'City linked successfully',
    'ciudad_desvinculada': 'City unlinked',
    'vincular': 'Link',
    'codigo_generado': 'Code generated',
    'codigo_generado_ok': 'City code generated',
    'codigo_vinculado_candidatura': 'Pre-linked to this candidature',
    'idioma_carta': 'Letter language',
    'carta_copiada': 'Letter copied to clipboard',
    'copiar_carta': 'Copy',
    'enviar_invitacion': 'Open email',
    'email_cliente_abierto': 'Email client opened',
    'estado_avanza_aceptada': 'Candidature accepted automatically',
    'estado_avanza_documentacion': 'Advancing to documentation phase',
    'estado_avanza_visita': 'Advancing to visit phase',
    'estado_avanza_evaluacion': 'Advancing to evaluation phase',
    'confirmar_avance_estado': 'Advance status to',
    'estado_cambiado': 'Status changed to',
    'eval_ciudades_galardonadas': 'Awarded cities',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Delegate',
    'delegado_desc': 'The delegate can view the candidature status and pending documents.',
    'asignar_delegado': 'Assign',
    'cambiar_delegado': 'Change',
    'sin_delegado': 'No delegate assigned',
    'confirmar_quitar_delegado': 'Remove delegate from this candidature?',
    'delegado_quitado': 'Delegate removed',
    'delegado_asignado': 'Delegate assigned',
    'delegado_existente': 'Existing user',
    'delegado_invitar': 'Invite by email',
    'generar_codigo_delegado': 'Generate delegate code',
    'codigo_delegado_generado': 'Code generated — send the email',
    'nombre_delegado_hint': 'Delegate name',
    'email_delegado_hint': 'email@example.com',
    'confirmar_retroceso_estado': 'Roll back status to',
    'accion_gala': 'Invite to Gala',
    'accion_gala_desc': 'Confirm the gala and add the city to the yearly event.',
    'accion_notificar': 'Mark as notified',
    'accion_notificar_desc_simple': 'Changes the status to notified. Communication to the city is done outside the app.',
    'accion_premio': 'Award prize',
    'accion_titularidad': 'Activate tenure',
    'activar_titularidad': 'Activate tenure',
    'anos_label': 'Years',
    'aprobar_informe': 'Approve',
    'archivo_muy_grande': 'File exceeds 50 MB',
    'badge': 'Badge',
    'cambiar_estado': 'Change status',
    'candidatura_actualizada': 'Candidacy updated',
    'chat_ayer': 'Yesterday',
    'chat_hoy': 'Today',
    'chat_primer_mensaje': 'Send the first message',
    'checklist_obligaciones': 'Obligations',
    'ciudad_notificada': 'City notified',
    'comentario_rechazo': 'Mandatory comment for rejection:',
    'comite_label': 'Committee',
    'confirmar_cambio_estado': 'Confirm status change?',
    'confirmar_gala': 'Confirm gala',
    'confirmar_notificar': 'Mark as notified?',
    'confirmar_pago': 'Confirm payment received',
    'Copiado': 'Copied',
    'delegado_info_restriccion': 'As a delegate you can see the pipeline status and visit agenda. To access the evaluation engine or BID File, request evaluator assignment from ACES.',
    'delegado_mis_candidaturas': 'As delegate',
    'delegado_vista': 'Delegate view',
    'delegado_vista_restringida': 'Restricted view: pipeline, agenda and pending documents only. No payments or evaluations.',
    'derechos_imagen': 'Image rights',
    'editar_candidatura': 'Edit candidacy',
    'Eliminado': 'Deleted',
    'email': 'Email',
    'emitir_factura': 'Issue invoice (PDF)',
    'entre_miembros': 'Between',
    'espera_repetir': 'Wait to repeat',
    'estado_actualizado': 'Status updated',
    'estado_gala_confirmada': 'Gala confirmed',
    'estado_notificada': 'Notified',
    'estado_notificada_rechazo': 'Rejection notified',
    'estado_premio_otorgado': 'Prize awarded',
    'estado_titularidad_activa': 'Active tenure',
    'eval_comentario_criterio': 'Comments on this criterion...',
    'factura': 'Invoice',
    'factura_emitida': 'Invoice uploaded',
    'fase_candidatura': 'Candidacy',
    'fase_seguimiento': 'Follow-up',
    'gala_confirmada_ok': 'Gala confirmed',
    'Guardado': 'Saved',
    'hito_agenda': 'Visit agenda accepted',
    'hito_carta': 'Application letter accepted',
    'hito_pago': 'Invoice paid',
    'hito_reglamento_env': 'Regulations received',
    'hito_reglamento_firm': 'Regulations signed',
    'hito_viajes': 'Travel logistics completed',
    'image_rights': 'Image Rights',
    'importe': 'Amount',
    'informe_aprobado': 'Report approved',
    'informe_rechazado': 'Report rejected',
    'informe_subido': 'Report uploaded',
    'informes_trimestrales': 'Quarterly reports',
    'marcar_notificada': 'Mark as notified',
    'marcar_premio': 'Mark prize awarded',
    'max_candidatos': 'Max candidates',
    'miembros_label': 'Members',
    'notificar_rechazo': 'Notify rejection',
    'nueva_version': 'New version',
    'ocultar': 'Hide',
    'permisos_documento': 'Document permissions',
    'permisos_guardados': 'Permissions saved',
    'poblacion_maxima': 'Max population',
    'poblacion_minima': 'Min population',
    'rechazar_informe': 'Reject',
    'region_africa': 'Africa',
    'region_americas': 'Americas',
    'region_asia': 'Asia',
    'region_europa': 'Europe',
    'region_mundial': 'Worldwide',
    'region_oceania': 'Oceania',
    'reglamentos_pendientes': 'Pending regulations',
    'seleccionar_tipo': 'Document type',
    'sin_resultados_busqueda': 'No results found',
    'subir_informe': 'Upload report',
    'tasa_label': 'Fee',
    'tipo_anexo': 'Annex',
    'tipo_especial': 'Special',
    'tipo_no_permitido': 'File type not allowed. Use PDF, DOC, DOCX, XLS, XLSX, JPG or PNG',
    'tipo_principal': 'Main',
    'titularidad_activa_label': 'Active tenure',
    'titularidad_creada': 'Tenure created',
    'titularidad_panel': 'My tenure',
    'tomar_decision_final': 'Make final decision',
    'ver_documento': 'View',
    'ver_escala': 'View scale',
    'ver_reglamento': 'View full regulations',
    'ver_seguimiento': 'View tenure follow-up',
    'visible_admin': 'Admin',
    'visible_ciudad': 'City',
    'visible_evaluador': 'Evaluator',
    'visible_master': 'Master',
    'visible_para': 'Visible to',
    'warning_quitar_adjudicada': 'Rolling back before "Awarded" will remove the permanent award flag.',
    'warning_retroceso': 'Are you sure you want to roll back the status?',
    'y_label': 'and',
    'Q1_nombre': 'Jan-Mar',
    'Q2_nombre': 'Apr-Jun',
    'Q3_nombre': 'Jul-Sep',
    'Q4_nombre': 'Oct-Dec',
    'informe_pendiente': 'Pending',
    'pago_pendiente': 'Pending',
    'checklist_logo_aces': 'Correct use of ACES logo',
    'checklist_memoria_anual': 'Annual report submitted',
    'checklist_congreso': 'ACES congress attendance',
    'checklist_imagen_corporativa': 'Corporate image updated',
    'checklist_calendario_deportivo': 'Sports calendar published',
    'asignar_evaluadores': 'Assign evaluators',
    'notas_internas_opcional': 'Internal notes (optional)',
    'estado_candidatura': 'Candidacy status',
    'hito_carta_recibida': 'Application letter received',
    'hito_candidatura_aceptada': 'Candidacy accepted',
    'hito_reglamento_enviado': 'Regulations sent',
    'hito_reglamento_firmado': 'Regulations signed',
    'hito_datos_facturacion': 'Billing data received',
    'hito_pago_confirmado': 'Payment confirmed',
    'hito_fechas_visita': 'Visit dates accepted',
    'hito_comision_cerrada': 'Commission closed',
    'hito_reservas_completadas': 'Reservations completed',
    'hito_agenda_subida': 'Agenda uploaded',
    'hito_bid_file_recibido': 'BID File received',
    'editar_visita': 'Edit visit',
    'programar_visita_btn': 'Schedule visit',
    'gestionar_comision': 'Manage commission',
    'pagos_titulo': 'Payments',
    'sin_pagos': 'No payments recorded',
    'factura_marcada': 'Invoice marked',
    'factura_desmarcada': 'Invoice unmarked',
    'pago_confirmado_label': 'Payment confirmed',
    'pago_desmarcado': 'Payment unmarked',
    'vence_label': 'Due',
    'factura_label': 'Invoice',
    'pagado_label': 'Paid',
    'documentos_titulo': 'Documents',
    'archivos_count': 'file',
    'archivos_count_plural': 'files',
    'subir_btn': 'Upload',
    'sin_documentos': 'No documents uploaded',
    'aprobado_label': 'Approved',
    'rechazado_label': 'Rejected',
    'sin_permisos': 'No permissions',
    'ver_label': 'View',
    'logistica_titulo': 'Logistics',
    'agenda_visita': 'Visit agenda',
    'subir_pdf': 'Upload PDF',
    'sin_agenda': 'No agenda uploaded',
    'reservas_titulo': 'Reservations',
    'general_sin_eval': 'General (no evaluator)',
    'subir_reserva': 'Upload reservation',
    'sin_reservas': 'No reservations uploaded',
    'agenda_subida_ok': 'Agenda uploaded',
    'reserva_subida_ok': 'Reservation uploaded',
    'evaluador_actualizado': 'Evaluator updated',
    'general_todos_eval': 'General (all evaluators)',
    'cambiar_evaluador': 'Change evaluator',
    'evaluaciones_titulo': 'Evaluations',
    'enviada_label': 'submitted',
    'enviadas_label': 'submitted',
    'en_progreso_label': 'in progress',
    'comision_asignada': 'Assigned commission',
    'evaluador_label': 'evaluator',
    'evaluadores_label': 'evaluators',
    'jefe_label': 'Head',
    'sin_empezar': 'Not started',
    'sin_evaluadores': 'No evaluators assigned',
    'enviada_badge': 'Submitted',
    'favorable_label': 'Favorable',
    'desfavorable_label': 'Unfavorable',
    'desbloquear_label': 'Unlock',
    'evaluacion_desbloqueada': 'Evaluation unlocked',
    'error_desbloquear': 'Error unlocking',
    'pdf_generado': 'PDF generated',
    'error_pdf': 'Error generating PDF',
    'en_progreso_badge': 'In progress',
    'tomar_decision': 'Make final decision',
    'cerrar_menu': 'Close menu',
    'compartir_tel_ciudad': 'Share phone with the candidate city',
    'compartir_tel_eval': 'Share phone with other evaluators',
    'notas_internas': 'Internal notes',
    'notas_privadas_placeholder': 'Private notes...',
    'guardado_ok': 'Saved',
    'generar_btn': 'Generate',
    'copiado_ok': 'Copied',
    'idioma_destinatario': 'Recipient language',
    'codigo_acceso_modal': 'Access code',
    'gala_activa': 'ACTIVE',
    'gala_inactiva': 'INACTIVE',
    'calendario_carta': 'Mayor letter: 30 Mar',
    'calendario_bid': 'BID file: 30 Jun',
    'calendario_preseleccion': 'Pre-selection: 31 Jul',
    'calendario_visitas': 'Visits: Oct',
    'calendario_gala': 'Gala: Nov',
    'calendario_titularidad': 'Title holder: 1 Jan following',
    'candidatura_singular': 'candidature',
    'candidaturas_plural': 'candidatures',
    'doc_tipo_bid_file': 'BID File',
    'doc_tipo_presentacion': 'Presentation',
    'progreso_inicio': 'Start',
    'progreso_adjudicada': 'Awarded',
    'hab_label': 'pop.',
    'eval_abreviado': 'eval.',
    'min_poblacion_label': 'Min population',
    'max_poblacion_label': 'Max population',
    'max_candidatos_label': 'Max candidates',
    'espera_label': 'Waiting period',
    'anos_label': 'years',
    'image_rights': 'Image Rights',
    'comite_label': 'Committee',
    'miembros_label': 'members',
    'usado_label': 'USED',
    'disponibles_count': 'Available',
    'usados_count': 'Used',
    'codigos_disponibles_count': 'Available codes',
    'hotel_placeholder': 'Assigned hotel, check-in, rules...',
    'vuelo_placeholder': 'Airport, schedules, class...',
    'parlamento_placeholder': 'Address, access rules, protocol...',
    'dni_pasaporte': 'ID / Passport',
    'cerrar_menu': 'Close menu',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'favorable_label': 'Favourable',
    'sin_fecha_visita': 'No visit date',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Section comment',
    'eval_comentario_seccion_placeholder': 'General comment on this section (optional)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Error: {0}',
    'pdf_evaluacion': 'Evaluation PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Evaluation Report',
    'pdf_ciudad': 'City',
    'pdf_evaluador': 'Evaluator',
    'pdf_fecha': 'Date',
    'pdf_total': 'Total score',
    'pdf_secciones': 'Sections',
    'pdf_voto_final': 'Final vote',
    'pdf_comentario_voto': 'Vote comment',
    'pdf_no_evaluada': 'Not evaluated',
    'pdf_generado_por': 'Generated by ACES Cities Network · {0}',
    'email_placeholder': 'name@example.com',
    'ej_nombre_persona': 'e.g. Jane Smith',
    'ej_aeropuerto': 'e.g. London (LHR)',
    'pdf_permitir_popups': 'Please allow pop-ups to export the PDF',
    'confirmar': 'Confirm',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Warning',
    'confirmar_eliminar_doc': 'Delete this document? This action cannot be undone.',
    'confirmar_eliminar_logistica': 'Delete this logistics document?',
    'confirmar_notificar_titulo': 'Notify city',
    'confirmar_retroceso_titulo': 'Confirm rollback',
    'eliminado': 'Deleted',
    'quitar_delegado_titulo': 'Remove delegate',
    'warning_quitar_adjudicada_titulo': 'Remove award',
    'warning_retroceso_2': 'CONFIRM? Data will be permanently deleted (dates, gala records, etc.). This action CANNOT be undone.',
    'warning_retroceso_titulo': 'Roll back status',
    'eval_pts': 'pts',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Flight booking',
    'viaje_tipo_reserva_hotel': 'Hotel booking',
    'reserva_generica': 'Booking',
  },
  'fr': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'Nous ne trouvons pas ce code. Vérifiez qu\'il est complet, par exemple : ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Ce code a déjà été utilisé. Si vous êtes déjà inscrit, connectez-vous. Sinon, demandez un nouveau code à ACES.',
    'codigo_expirado': 'Ce code a expiré. Demandez un nouveau code à ACES.',
    'codigo_admin': 'Ce code est un code d\'administration et ne permet pas de s\'inscrire ici. Contactez ACES.',
    'registro_error_general': 'L\'inscription n\'a pas pu être finalisée et aucun compte n\'a été créé. Réessayez ; en cas de nouvel échec, contactez ACES.',
    'email_ya_registrado_login': 'Cet email a déjà un compte. Appuyez sur « Se connecter » et, si vous avez oublié votre mot de passe, utilisez « Mot de passe oublié ? ».',
    'nueva_gala_btn': 'Créer gala',
    'programar_visita': 'Planifier la visite d\'évaluation',
    'guardar_notas': 'Enregistrer les notes',
    'historial_estados': 'Historique des statuts',
    'notas_privadas_hint': 'Notes privées sur cette candidature (visible uniquement pour les masters)...',
    'voto_emitido': 'Vote émis:',
    'voto_en_contra': 'Contre',
    'voto_a_favor': 'Pour',
    'voto_final_desc': 'La candidature est en phase de vote. Émettez votre vote.',
    'voto_final_titulo': 'Vote final requis',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titularités — bientôt disponible',
    'email_abierto': 'Votre client email s\'est ouvert',
    'cargo_hint': 'Ex: Conseiller aux sports',
    'password_repetir_hint': 'Répétez le mot de passe',
    'password_min': 'Minimum 6 caractères',
    'placeholder_apellido_ej': 'Dupont',
    'placeholder_nombre_ej': 'Marie',
    'error_guardar': 'Erreur lors de la sauvegarde',
    'error_label': 'Erreur',
    'error_subir': 'Erreur de téléchargement',
    'error_cambiar_password': 'Erreur lors du changement de mot de passe',
    'candidatura_no_encontrada': 'Candidature non trouvée',
    'puntuacion_final': 'Score final',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Destination',
    'origen_label': 'Origine',
    'notif_actividad_desc': 'L\'activité de vos candidatures apparaîtra ici.',
    'placeholder_ej_espana': 'Ex: Espagne',
    'placeholder_ej_madrid': 'Ex: Madrid',
    'gala_lugar_hint': 'Ex: Palais des Congrès',
    'gala_titulo_hint': 'Ex: Gala ACES América 2026',
    'gala_descripcion_hint': 'Description de l\'événement...',
    'gala_pais': 'Pays de l\'événement',
    'gala_ciudad': 'Ville de l\'événement',
    'gala_lugar': 'Lieu de la cérémonie',
    'gala_titulo_label': 'Titre de la gala',
    'visible_ciudades': 'Visible pour les villes',
    'nueva_gala': 'Nouvelle gala',
    'sin_galas': 'Aucune gala configurée',
    'gala_gestion': 'Gestion de la cérémonie de gala',
    'gala_aces_titulo': 'Gala ACES',
    'codigo_copiado': 'Code copié',
    'error_generar_codigo': 'Erreur lors de la génération du code',
    'nombre_eval_email': 'Nom de l\'évaluateur (pour email)',
    'invitar_evaluador': 'Inviter évaluateur',
    'sin_evaluadores': 'Aucun évaluateur enregistré',
    'preview': 'Aperçu',
    'ver_todos': 'Voir tout',
    'total_candidaturas': 'Total candidatures',
    'titulos_adjudicados': 'Titres attribués',
    'tamano_comite': 'Taille du comité (évaluateurs)',
    'sanciones_asistencia': 'Pénalités de non-présence (€)',
    'tasas_participacion': 'Droits de participation (€)',
    'config_sistema_perfil': 'Système et profil',
    'sin_candidaturas_desc2': 'Essayez de changer les filtres ou créez-en une.',
    'placeholder_pais_ej': 'Ex: Argentine',
    'placeholder_ciudad_ej': 'Ex: Buenos Aires',
    'buscar_evaluador': 'Rechercher évaluateur...',
    'notas_decision_hint': 'Notes internes sur la décision...',
    'concepto_placeholder': 'Ex: Droit de participation 2026',
    'sin_jefe_asignado': 'Aucun chef assigné',
    'jefe_comision': 'Chef de commission',
    'ciudad_label': 'Ville',
    'descargar_app_store': 'Télécharger sur App Store',
    'aforo_maximo': 'Capacité maximale',
    'descripcion_label': 'Description',
    'convocatoria_label': 'Convocation',
    'abrir_email': 'Ouvrir email',
    'crear_gala': 'Créer gala',
    'en_evaluacion': 'En évaluation',
    'emails_institucionales': 'Emails institutionnels',
    'email_evaluador': 'Email de l\'évaluateur',
    'codigo_acceso_label': 'Code d\'accès',
    'codigos_acceso': 'Codes d\'accès',
    'seleccionar_galardon': 'Sélectionner distinction...',
    'todos_galardones': 'Toutes les distinctions',
    'todos_estados': 'Tous les statuts',
    'cargando_dashboard': 'Chargement...',
    'candidaturas_recientes': 'Candidatures récentes',
    'candidaturas_activas': 'Candidatures actives',
    'alertas_sistema': 'Alertes système',
    'accesos_rapidos': 'Accès rapides',
    'viaje_titulo': 'Voyage',
    'nuevo': 'Nouveau',
    'estado': 'Statut',
    'abrir_votacion': 'Ouvrir le vote',
    'accion_anadir_evaluador': 'Ajouter évaluateur',
    'accion_master': 'Action master',
    'accion_nueva_candidatura': 'Nouvelle candidature',
    'accion_ver_alertas': 'Voir les alertes',
    'actividad': 'Actividad',
    'agenda_notas': 'Notes internes',
    'agenda_notas_hint': 'Ex: L\'évaluateur sera accueilli par le Maire...',
    'agenda_pdf_listo': 'PDF de l\'agenda joint',
    'agenda_propuesta_enviada': 'Événement agenda envoyé',
    'agenda_subir_pdf': 'Télécharger le PDF de l\'agenda complet (optionnel)',
    'agenda_tipo_evento': 'Type d\'événement',
    'agenda_titulo_evento': 'Titre de l\'événement',
    'agenda_vacia': 'Agenda vide',
    'alerta_decision_pendiente': 'Décision en attente',
    'alerta_docs_pendientes': 'Documents en attente',
    'alerta_pago_vencido': 'Paiement en retard',
    'alerta_sin_evaluadores': 'Aucun évaluateur assigné',
    'alertas_titulo': 'Alertas',
    'anos': 'ans',
    'anterior': 'Précédent',
    'apellidos': 'Nom de famille',
    'aprobar': 'Aprobar',
    'asignacion_ciudad_hint': 'Ex: Paris',
    'asignacion_ciudad_salida': 'Ville de départ pour la visite',
    'asignacion_ciudad_salida_desc': 'La ville depuis laquelle vous partirez pour la visite d\'évaluation.',
    'asignacion_compartir_ciudad': 'Partager le téléphone avec la ville',
    'asignacion_compartir_ciudad_desc': 'La ville pourra voir votre numéro de téléphone et WhatsApp.',
    'asignacion_compartir_eval_desc': 'Les autres évaluateurs de cette candidature pourront voir votre contact.',
    'asignacion_compartir_evaluadores': 'Partager avec d\'autres évaluateurs',
    'asignacion_confirmar': 'Confirmer et commencer',
    'asignacion_nota': 'Note pour la ville (facultatif)',
    'asignacion_nota_desc': 'Cette note sera visible pour l\'équipe de la ville candidate.',
    'asignacion_nota_hint': 'Ex: J\'arriverai en train mardi matin...',
    'asignacion_privacidad': 'Confidentialité et contact',
    'asignacion_sub': 'Avant de commencer, configurez vos coordonnées pour cette candidature.',
    'asignacion_titulo': 'Nouvelle attribution',
    'asignar_ciudad_titulo': 'Attribuer une ville',
    'asignar_evaluador': 'Attribuer évaluateur',
    'auth_cargando': 'Iniciando...',
    'auth_cerrar_sesion': 'Cerrar sesión',
    'auth_email': 'Email',
    'auth_entrar': 'Iniciar sesión',
    'auth_error_credenciales': 'Email o contraseña incorrectos.',
    'auth_error_red': 'Sin conexión a internet.',
    'auth_password': 'Mot de passe',
    'auth_subtitulo': 'Plataforma de candidaturas deportivas ACES',
    'avanzar_a': 'Avanzar a',
    'borrar': 'Supprimer',
    'borrar_todas': 'Tout supprimer',
    'buscar_ciudad_email': 'Rechercher ville, email...',
    'buscar_pais': 'Rechercher un pays...',
    'buscar_placeholder': 'Buscar ciudad, galardón...',
    'cambios': 'Cambios',
    'campos_obligatorios': 'Veuillez remplir tous les champs obligatoires.',
    'cancelar': 'Cancelar',
    'candidatura_asignada_ok': 'Candidature assignée',
    'cargando_candidatura': 'Chargement de la candidature...',
    'cargo': 'Fonction',
    'cat_carta': 'Lettre d\'intention',
    'cat_eventos': 'Eventos',
    'cat_galardones': 'Prix précédents',
    'cat_infra': 'Infraestructura',
    'cat_otros': 'Otros',
    'cat_presupuesto': 'Presupuesto',
    'categoria': 'Categoría',
    'cerrar': 'Cerrar',
    'cerrar_votacion': 'Fermer le vote',
    'chat_ciudad': 'Chat con ACES',
    'chat_ciudad_aces': 'Chat avec ACES',
    'chat_ciudad_aces_desc': 'Communication directe avec l\'équipe ACES Europe.',
    'chat_conversaciones': 'Conversations',
    'chat_elige_conversacion': 'Choisissez avec qui vous voulez discuter',
    'chat_escribir': 'Escribe un mensaje...',
    'chat_interno': 'Chat de comisión',
    'chat_interno_desc': 'Canal privé entre évaluateurs et ACES. La ville n\'y a pas accès.',
    'chat_mis_chats': 'Mes chats',
    'chat_sin_activos': 'Aucun chat actif',
    'chat_sin_activos_desc': 'Les chats avec les candidatures apparaîtront ici',
    'chat_sin_mensajes': 'Aucun message',
    'chat_adjuntar': 'Joindre un fichier',
    'chat_adjunto_expira': 'Fichier disponible 7 jours',
    'chat_adjunto_max': 'Fichier trop volumineux (max 10 Mo)',
    'chat_borrar': 'Supprimer pour tous',
    'chat_buscar_conv': 'Rechercher ville ou prix...',
    'chat_confirmar_borrar': 'Supprimer ce message pour tous?',
    'chat_filtro_no_leidas': 'Non lus',
    'chat_filtro_todas': 'Tous',
    'chat_mensaje_borrado': 'Message supprime',
    'chat_no_leidos': 'non lus',
    'chat_activas': 'chats actifs',
    'chat_recargar': 'Actualiser',
    'chat_responder': 'Repondre',
    'chat_sin_no_leidos': 'Tout lu',
    'warn_poblacion_min': 'Population minimale requise',
    'warn_poblacion_max': 'Population maximale autorisee',
    'warn_actual': 'Actuelle',
    'warn_max_candidaturas': 'Maximum de candidatures pour ce prix',
    'warn_actuales': 'Actuelles',
    'warn_espera': 'Periode d attente',
    'warn_anos': 'ans',
    'warn_ultima': 'Derniere attribution',
    'warn_elegible_desde': 'Eligible a partir de',
    'warn_elegibilidad': 'Avertissements d eligibilite',
    'warn_override': 'Override Master: creer la candidature quand meme',
    'warn_override_required': 'Il y a des avertissements. Cochez Override pour continuer.',
    'tasa_auto': 'Un paiement automatique sera cree de',
    'poblacion_label': 'Population',
    'galardon_label': 'Prix',
    'calendario_procesal': 'Calendrier procedural (Art. 15)',
    'regla_25_titulo': 'Regle 2.5 points (Art. 15)',
    'regla_25_desc': 'La difference entre les deux premiers est',
    'regla_25_info': 'Le Master peut attribuer au deuxieme classe si justifie.',
    'regla_25_justificacion_hint': 'Justifiez la decision, surtout si la regle 2.5 s applique...',
    'resumen_puntuaciones': 'Scores des evaluateurs',
    'candidatura_adjudicada': 'Candidature attribuee!',
    'error_campos_obligatorios': 'Ville, pays et prix sont obligatoires.',
    'checklist_aprobado': 'APPROUVÉE',
    'checklist_titulo': 'Conditions de documentation',
    'ciudad': 'Ciudad',
    'ciudad_asignada': 'Ville assignée',
    'ciudad_asignar': 'Assigner',
    'ciudad_cambiar': 'Changer',
    'ciudad_cargo': 'Poste',
    'ciudad_contacto_principal': 'Contact principal',
    'ciudad_desde': 'Ville de départ',
    'ciudad_email': 'Email',
    'ciudad_historico': 'Historial',
    'ciudad_modulos': 'Modules',
    'ciudad_nombre': 'Nom',
    'ciudad_recursos': 'Recursos ACES',
    'ciudad_rol': 'Rôle',
    'ciudad_salida': 'Ville de départ',
    'ciudad_salida_desc': 'La ville candidate doit savoir d\'où vous voyagez pour réserver votre vol.',
    'ciudad_salida_hint': 'Ex: Paris, Lyon...',
    'ciudad_salida_pendiente': 'Ville de départ en attente',
    'ciudad_sin_asignar': 'Aucune ville assignée',
    'ciudad_sin_candidatura': 'Sin candidatura activa',
    'ciudad_sin_candidatura_desc': 'Contacta con ACES para iniciar el proceso.',
    'ciudad_telefono': 'Téléphone',
    'codigo_activando': 'Activando...',
    'codigo_activar': 'Activar código',
    'codigo_error_invalido': 'Código inválido o ya utilizado.',
    'codigo_generado_label': 'CODE GÉNÉRÉ',
    'codigo_invalido': 'Code invalide ou déjà utilisé.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Introduce el código ACESCN que te proporcionó ACES.',
    'codigo_titulo': 'Código de acceso',
    'codigo_vacio': 'Veuillez entrer votre code d\'accès.',
    'codigo_validar': 'Valider le code',
    'codigos_disponibles': 'Disponibles',
    'codigos_generados': 'Códigos generados',
    'codigos_usados': 'Codes utilisés',
    'comision_sin_otros': 'Seulement vous dans la commission',
    'comision_sin_otros_desc': 'Aucun autre évaluateur n\'a encore été attribué à cette candidature.',
    'comision_titulo': 'Commission d\'évaluation',
    'completado': 'completado',
    'comprobante_desc': 'Téléchargez le justificatif de virement bancaire en PDF ou image.',
    'comprobante_subido': 'Justificatif téléchargé avec succès',
    'comprobante_titulo': 'Justificatif de paiement',
    'config_comite': 'Taille du comité',
    'config_convocatorias': 'Convocatorias abiertas',
    'config_correos_desc': 'E-mails utilisés pour les notifications officielles.',
    'config_correos_titulo': 'E-mails institutionnels',
    'config_guardada': 'Configuración guardada',
    'config_sanciones': 'Sanciones por no asistencia a gala (€)',
    'config_sistema_titulo': 'Configuration du système',
    'config_tasas': 'Tasas de participación (€)',
    'confirmada': 'Confirmada',
    'confirmando': 'Confirmando...',
    'confirmar_asistencia': 'Confirmar asistencia',
    'contacto_principal': 'Contact principal',
    'continuar': 'Continuer',
    'continuar_evaluacion': 'Continuer l\'évaluation',
    'convocatoria': 'Convocatoria',
    'creando': 'Creando...',
    'crear_candidatura': 'Crear candidatura',
    'crear_cuenta': 'Créer un compte',
    'dashboard_accesos_rapidos': 'Accès rapides',
    'dashboard_awos_sub': 'Enregistrez vos activités sportives et accédez aux statistiques.',
    'dashboard_awos_titulo': 'AWoS Actif',
    'dashboard_documentos': 'Documents',
    'dashboard_estado': 'Statut candidature',
    'dashboard_mensajes': 'Messages',
    'dashboard_pagos_pendientes': 'Paiements en attente',
    'datos_opcionales': 'Ces champs sont facultatifs et peuvent être mis à jour depuis votre profil.',
    'de': 'de',
    'decision_adjudicar': 'Adjudicar',
    'decision_advertencia': 'Esta decisión es inapelable y quedará registrada permanentemente.',
    'decision_confirmar': 'Confirmar decisión',
    'decision_nav': 'Decisión final',
    'decision_notas': 'Notas de la decisión (obligatorio)',
    'decision_rechazar': 'No adjudicar',
    'decision_selecciona': 'Selecciona la decisión',
    'decision_titulo': 'Decisión final',
    'desbloquear': 'Desbloquear',
    'desde': 'depuis',
    'destino': 'Destino',
    'dia': 'Día',
    'dias': 'días',
    'dias_label': 'jours',
    'dias_visita_label': 'jours de visite',
    'doc_subido_ok': 'Document téléchargé avec succès',
    'docs_pendientes': 'Docs en attente',
    'documento_pendiente': 'Document en attente de réception',
    'duracion_visita_label': 'DURÉE DE LA VISITE',
    'editar': 'Editar',
    'eliminar': 'Eliminar',
    'eliminar_cuenta': 'Eliminar mi cuenta',
    'eliminar_cuenta_desc': 'Esta acción es irreversible. Tus datos serán anonimizados conforme al RGPD.',
    'eliminar_cuenta_password': 'Introduce tu contraseña para confirmar',
    'eliminar_cuenta_titulo': 'Eliminar cuenta',
    'eliminar_documento': 'Supprimer le document',
    'email_ciudad_label': 'EMAIL DE LA VILLE',
    'email_contacto': 'Email de contacto',
    'email_enviado': 'E-mail envoyé avec succès',
    'email_enviar': 'Envoyer l\'e-mail officiel',
    'email_idioma': 'Langue du destinataire',
    'email_invalido': 'Email invalide.',
    'email_preview': 'Aperçu de l\'e-mail',
    'email_remitente': 'Envoyer depuis',
    'email_ya_registrado': 'Cet email est déjà enregistré.',
    'emitir_factura_titulo': 'Émettre facture',
    'emitir_nueva_factura': 'Émettre une nouvelle facture',
    'enviada': 'Enviada',
    'enviado_por_aces': 'Envoyé par ACES',
    'enviando': 'Envoi en cours...',
    'enviar': 'Enviar',
    'enviar_evaluacion': 'Envoyer l\'évaluation',
    'enviar_propuesta': 'Enviar propuesta',
    'eres_jefe_comision': 'Vous êtes chef de commission',
    'error_generico': 'Une erreur s\'est produite. Veuillez réessayer.',
    'escribiendo': 'está escribiendo',
    'estado_aceptada': 'Acceptée',
    'estado_adjudicada': 'Attribuée',
    'estado_decision': 'Décision en attente',
    'estado_documentacion': 'Documentation',
    'estado_evaluacion': 'En évaluation',
    'estado_pipeline': 'Pipeline de candidatura',
    'estado_rechazada': 'Non attribuée',
    'estado_solicitada': 'Soumise',
    'estado_visita': 'Visite programmée',
    'estado_votacion': 'En vote',
    'eval_abrev': 'éval.',
    'eval_abrir_motor': 'Ouvrir le moteur d\'évaluation',
    'eval_anterior': 'Anterior',
    'eval_asignadas': 'Mis asignadas',
    'eval_asignado_ok': 'Évaluateur assigné',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Cargando evaluación...',
    'eval_comentario_placeholder': 'Comenta tu puntuación...',
    'eval_comentario_voto': 'Comentario al voto final',
    'eval_comision_pendiente': 'Informations sur les évaluateurs disponibles prochainement.',
    'eval_comision_titulo': 'Évaluateurs assignés',
    'eval_confirmar_desc': 'Una vez enviada no podrás modificarla sin que el Master la desbloquee.',
    'eval_confirmar_envio': 'Enviar evaluación',
    'eval_conflicto_interes': 'Conflicto de interés: eres del mismo país que la ciudad candidata a Capital.',
    'eval_desfavorable': 'Desfavorable',
    'eval_enviada_desc': 'Tu evaluación ha sido registrada correctamente.',
    'eval_enviada_ok': 'Évaluation soumise avec succès',
    'eval_enviada_titulo': 'Evaluación enviada',
    'eval_enviadas': 'enviadas',
    'eval_enviar': 'Enviar',
    'eval_enviar_btn': 'Envoyer',
    'eval_favorable': 'Favorable',
    'eval_habilitada': 'Evaluación habilitada',
    'eval_ir_motor': 'Ir al motor de evaluación',
    'eval_lista': 'Evaluadores',
    'eval_mi_evaluacion': 'Mi evaluación',
    'eval_mis_candidaturas': 'Mis candidaturas',
    'eval_motor_titulo': 'Motor de evaluación',
    'eval_no_habilitada': 'L\'évaluation n\'a pas encore été activée par ACES.',
    'eval_notas_comentario': 'Notas y comentarios',
    'eval_quitado': 'Évaluateur retiré',
    'eval_registrados': 'Registrados',
    'eval_seccion': 'Sección',
    'eval_siguiente': 'Siguiente',
    'eval_sin_activas': 'Sin candidaturas activas',
    'eval_sin_asignadas': 'Sin candidaturas asignadas',
    'eval_sin_asignadas_desc': 'El Master asignará candidaturas a tu comisión.',
    'eval_sin_documentos': 'Aucun document',
    'eval_sin_documentos_desc': 'La ville n\'a pas encore téléchargé de documents.',
    'eval_sin_reservas': 'Aucune réservation pour l\'instant',
    'eval_stat_asignadas': 'Asignadas',
    'eval_stat_completadas': 'Completadas',
    'eval_stat_pendientes': 'Pendientes',
    'eval_todas': 'Todas activas',
    'eval_todas_activas': 'Candidaturas activas',
    'eval_todas_aviso': 'Vista de solo lectura. Detalle completo solo para tus candidaturas asignadas.',
    'eval_total_seccion': 'Puntuación de esta sección',
    'eval_ver_escala': 'Ver escala de puntuación',
    'eval_voto_final': 'Voto final',
    'eval_voto_informativo': 'Tu voto es informativo. La decisión final corresponde al Master ACES.',
    'evaluacion_titulo': 'Evaluación',
    'evaluaciones_enviadas': 'evaluaciones enviadas',
    'evaluadores_asignados': 'evaluadores asignados',
    'evaluadores_asignados_label': 'ÉVALUATEURS ASSIGNÉS',
    'evento_almuerzo': 'Déjeuner',
    'evento_cena': 'Dîner',
    'evento_desayuno': 'Petit-déjeuner',
    'evento_descanso': 'Repos',
    'evento_llegada': 'Arrivée',
    'evento_otro': 'Autre',
    'evento_recepcion': 'Réception',
    'evento_reunion': 'Réunion',
    'evento_rueda_prensa': 'Conférence de presse',
    'evento_salida': 'Départ',
    'evento_traslado': 'Transfert',
    'evento_visita': 'Visite',
    'factura_creada_ok': 'Facture enregistrée. Téléchargez maintenant le PDF.',
    'factura_detalle': 'Détail / Concept étendu',
    'factura_detalle_hint': 'Description détaillée des services, conditions de paiement, coordonnées bancaires...',
    'factura_subida_ok': 'Facture téléchargée avec succès',
    'facturas_aces': 'D\'ACES',
    'fecha_llegada_label': 'DATE D\'ARRIVÉE',
    'fecha_regreso': 'Fecha de regreso',
    'fecha_salida': 'Fecha de salida',
    'fecha_vencimiento_label': 'DATE D\'ÉCHÉANCE',
    'filtro_estado': 'Statut',
    'filtro_tipo': 'Type',
    'filtro_todas': 'Todas',
    'filtro_todos': 'Tous',
    'gala_asistencia_confirmada': 'Asistencia confirmada',
    'gala_invitacion_titulo': 'Invitación a la Gala',
    'gala_pendiente_desc': 'ACES activará tu invitación cuando llegue el momento.',
    'gala_pendiente_invitacion': 'Invitación pendiente',
    'gala_representantes': 'Representantes',
    'gala_sin_datos': 'Sin datos de gala',
    'gala_sin_datos_desc': 'No hay información de la ceremonia para este año.',
    'gala_sin_representantes': 'Sin representantes añadidos',
    'galardon': 'Galardón',
    'general_error': 'Ha ocurrido un error',
    'general_reintentar': 'Reintentar',
    'generar_codigo': 'Generar código',
    'generar_codigo_titulo': 'Nuevo código de acceso',
    'gestionar_comision': 'Gérer la commission',
    'guardado': 'Enregistré',
    'guardando': 'Guardando...',
    'guardar': 'Guardar',
    'guardar_ciudad_salida': 'Enregistrer la ville de départ',
    'guardar_config': 'Guardar configuración',
    'guardar_y_siguiente': 'Enregistrer et suivant',
    'historico_titulo': 'Candidatures précédentes',
    'hora': 'Hora',
    'hora_fin_opc': 'Heure de fin (optionnel)',
    'hora_inicio': 'Heure de début',
    'idioma_titulo': 'Langue de l\'interface',
    'iniciar_evaluacion': 'Commencer l\'évaluation',
    'invitacion_enviada': 'Invitation envoyée',
    'invitar_ciudad_titulo': 'Inviter une ville',
    'invitar_codigo_generado': 'Code généré',
    'invitar_copiar': 'Copier',
    'invitar_cuerpo_eval': 'Nous vous invitons à rejoindre ACES Cities Network en tant qu\'évaluateur.\\n\\nVotre code d\'accès est:',
    'invitar_email': 'Envoyer par email',
    'invitar_evaluador_sub': 'Générez un code et partagez-le par WhatsApp ou email',
    'invitar_evaluador_titulo': 'Inviter un évaluateur',
    'invitar_generar_codigo': 'Générer un code d\'accès',
    'invitar_nombre': 'Nom de l\'évaluateur',
    'invitar_pie': 'Téléchargez l\'app, inscrivez-vous et entrez votre code.\\n\\n— ACES',
    'invitar_saludo': 'Cher/Chère',
    'invitar_whatsapp': 'Envoyer par WhatsApp',
    'jefe_comision_ninguno': 'Aucun chef assigné',
    'jefe_comision_sin_eval': 'Assignez d\'abord des évaluateurs pour désigner un chef.',
    'jefe_comision_titulo': 'Chef de commission',
    'jefe_designado_ok': 'Chef de commission désigné',
    'jefe_eliminado_ok': 'Chef de commission retiré',
    'llegada': 'Llegada',
    'llegada_label': 'Arrivée',
    'login_crear_cuenta': 'Première fois? Créer un compte →',
    'login_olvide_contrasena': 'Mot de passe oublié?',
    'login_proximamente': 'Prochainement',
    'login_recuperar_desc': 'Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    'login_recuperar_titulo': 'Récupérer l\'accès',
    'login_requiere_codigo': 'L\'accès à Cities Network nécessite un code d\'invitation ACES.',
    'login_restablecer': 'Réinitialiser le mot de passe',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Lugar',
    'marcar_leidas': 'Marcar todas leídas',
    'master_label': 'MASTER ACES',
    'master_panel_desc': 'Control total de candidaturas, evaluaciones y decisiones.',
    'master_recientes': 'Candidaturas recientes',
    'master_saludo': 'Panel ACES',
    'master_sin_candidaturas': 'Sin candidaturas aún',
    'mi_evaluacion': 'Mon évaluation',
    'mis_pagos': 'Mes paiements',
    'mod_chat': 'Chat ACES',
    'mod_documentos': 'Documentos',
    'mod_facturas_pagos': 'Factures et paiements',
    'mod_gala': 'Gala',
    'mod_pagos': 'Pagos',
    'mod_titularidad': 'Titularidad',
    'mod_viaje': 'Logística',
    'modo_evaluador': 'Évaluateur',
    'modo_master': 'Master',
    'motor_evaluacion': 'Moteur d\'évaluation',
    'no_configurado': 'Non configuré — modifiez votre profil',
    'nombre': 'Prénom',
    'nombre_documento': 'Nombre del documento',
    'nombre_hotel': 'Nombre del hotel',
    'notas_hint': 'Ex: Atterrir au T4, hôtel recommandé...',
    'notas_internas_label': 'NOTES INTERNES (facultatif)',
    'notif_candidatura_actualizada': 'Candidature mise à jour',
    'notif_candidatura_desasignada': 'Candidature désassignée',
    'notif_documento_revisado': 'Document examiné',
    'notif_estado_actualizado': 'Statut mis à jour',
    'notif_evaluacion_completada': 'Évaluation complétée',
    'notif_limpiar_desc': 'Toutes les notifications seront supprimées. Cette action est irréversible.',
    'notif_limpiar_todas': 'Tout effacer',
    'notif_marcar_leida': 'Marquer comme lu',
    'notif_nueva_asignacion': 'Nouvelle candidature assignée',
    'notif_pago_vencido': 'Paiement bientôt expiré',
    'notif_sin_leer': 'Sin leer',
    'notif_sin_notifs': 'Sin notificaciones',
    'notif_visita_programada': 'Visite d\'évaluation programmée',
    'notificar_ciudad': 'Notifier la ville',
    'nueva_candidatura': 'Nueva candidatura',
    'nueva_propuesta': 'Nueva propuesta',
    'num_habitaciones': 'Número de habitaciones',
    'origen': 'Origen',
    'pago_enviar_recordatorio': 'Ouvrir l\'email',
    'pago_factura': 'Facture',
    'pago_instrucciones': 'Realiza la transferencia bancaria y sube el comprobante.',
    'pago_recibido': 'Reçu',
    'pago_recordatorio': 'Rappel',
    'pago_recordatorio_desc': 'Votre client de messagerie s\'ouvrira avec le message.',
    'pago_recordatorio_titulo': 'Envoyer un rappel de paiement',
    'pagos_ciudad': 'Mes paiements',
    'pagos_pendientes': 'Paiements en attente',
    'pais': 'País',
    'pais_buscar': 'Rechercher un pays...',
    'pais_seleccionado': 'Pays sélectionné',
    'pais_seleccionar': 'Sélectionner un pays',
    'paso_datos': 'Données de la facture',
    'paso_subir_pdf': 'Télécharger le PDF de la facture',
    'password_actual': 'Mot de passe actuel',
    'password_cambiada': 'Mot de passe modifié avec succès',
    'password_cambiar': 'Changer le mot de passe',
    'password_corta': 'Le mot de passe doit contenir au moins 6 caractères.',
    'password_nueva': 'Nouveau mot de passe',
    'password_repetir': 'Répéter le mot de passe',
    'passwords_no_coinciden': 'Les mots de passe ne correspondent pas.',
    'error_red': 'Erreur réseau. Vérifiez votre connexion Internet.',
    'error_demasiados_intentos': 'Trop de tentatives. Veuillez patienter et réessayer.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Lettre de candidature reçue',
    'hito_aprobada': 'Candidature approuvée',
    'hito_reglamento_enviado': 'Règlement envoyé pour signature',
    'hito_reglamento_firmado': 'Règlement signé reçu',
    'hito_datos_factura': 'Données de facturation reçues',
    'hito_pago_confirmado': 'Paiement confirmé',
    'hito_fechas_visita': 'Dates de visite proposées',
    'hito_comision_creada': 'Commission d\'évaluation créée',
    'hito_viajes_cerrados': 'Voyages finalisés',
    'hito_agenda_enviada': 'Agenda envoyé',
    'hito_bid_file': 'BID File reçu',
    'doc_tipo_carta_solicitud': 'Lettre de candidature',
    'doc_tipo_agenda_visita': 'Agenda de visite',
    // Logistica simplificada
    'mod_logistica': 'Logistique',
    'agenda_vacia_ciudad': 'Aucune agenda. T\u00e9l\u00e9chargez le PDF de l\u2019agenda de visite.',
    'agenda_aviso_master': 'L\u2019agenda est visible par les \u00e9valuateurs et la ville.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES publiera l\u2019agenda de visite quand elle sera disponible.',
    'eval_reservas_desc': 'Vos r\u00e9servations de vol et h\u00f4tel confirm\u00e9es appara\u00eetront ici.',
    'eval_sin_reservas_desc': 'ACES ou la ville t\u00e9l\u00e9chargera vos r\u00e9servations quand elles seront confirm\u00e9es.',
    'perfil_actualizado': 'Profil mis à jour',
    'perfil_apellidos': 'Apellidos',
    'perfil_cambiar_foto': 'Photo de profil',
    'perfil_cargo': 'Cargo',
    'perfil_ciudad': 'Ville',
    'perfil_compartir_ciudad': 'Partager le téléphone avec les villes',
    'perfil_compartir_ciudad_desc': 'Les villes candidates pourront voir votre numéro de contact.',
    'perfil_compartir_eval_desc': 'Les évaluateurs de votre commission pourront voir votre contact.',
    'perfil_compartir_evaluadores': 'Partager avec d\'autres évaluateurs',
    'perfil_contacto': 'Contact',
    'perfil_cuenta': 'Compte',
    'perfil_datos': 'Données personnelles',
    'perfil_datos_evaluador': 'Données commission',
    'perfil_datos_personales': 'Données personnelles',
    'perfil_elegir_foto': 'Choisir une photo',
    'perfil_eval_config': 'Paramètres évaluateur',
    'perfil_evaluador': 'Paramètres évaluateur',
    'perfil_fecha_nac': 'Date de naissance',
    'perfil_foto_actualizada': 'Photo mise à jour',
    'perfil_guardado': 'Profil sauvegardé avec succès',
    'perfil_guardar': 'Enregistrer le profil',
    'perfil_idioma': 'Idioma de la app',
    'perfil_nombre': 'Nombre',
    'perfil_notificaciones': 'Notificaciones',
    'perfil_pais': 'País',
    'perfil_provincia': 'Province',
    'perfil_talla': 'Taille polo (commission)',
    'perfil_telefono': 'Teléfono',
    'perfil_titulo': 'Mon profil',
    'perfil_ubicacion': 'Localisation',
    'pipeline_aceptada_desc': 'Candidature acceptée. Préparez la documentation requise.',
    'pipeline_adjudicada_desc': 'Félicitations ! Votre ville a reçu le titre ACES.',
    'pipeline_decision_desc': 'La décision finale est en cours de préparation par ACES.',
    'pipeline_documentacion_desc': 'Nous examinons votre documentation.',
    'pipeline_evaluacion_desc': 'La commission d\'évaluation analyse votre candidature.',
    'pipeline_rechazada_desc': 'Votre candidature n\'a pas été sélectionnée lors de cet appel.',
    'pipeline_solicitada_desc': 'Votre candidature a été reçue et est en cours d\'examen.',
    'pipeline_visita_desc': 'La visite d\'évaluation de votre ville est en cours d\'organisation.',
    'pipeline_votacion_desc': 'La commission délibère sur votre candidature.',
    'precio_aprox': 'Precio aproximado (€)',
    'precio_estimado': 'Prix estimé (€)',
    'preview_email_label': 'APERÇU DE L\'EMAIL',
    'programar_visita_titulo': 'Programmer la visite',
    'proponer_agenda': 'Agenda',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Vuelo',
    'provincia': 'Province / État',
    'provincia_seleccionar': 'Sélectionner la province / région',
    'rechazar': 'Rechazar',
    'recomendaciones_titulo': 'Recommandations',
    'recordatorio_asunto': 'Rappel de paiement — {ciudad}',
    'recordatorio_cuerpo': 'Chère équipe de {ciudad},\\n\\nNous vous rappelons que le paiement de: {concepto} est en attente.\\n\\nVeuillez effectuer le virement dès que possible.\\n\\nCordialement,\\nACES',
    'reg_ciudad': 'Ville / Commune *',
    'reg_creando': 'Création en cours...',
    'reg_crear_cuenta': 'Créer un compte',
    'reg_pais': 'Pays *',
    'reg_provincia': 'Province / Région',
    'reg_resumen_titulo': 'Récapitulatif du compte',
    'reg_telefono': 'Téléphone de contact *',
    'reg_tipo': 'Type d\'accès',
    'reg_ubicacion_sub': 'Informations de votre organisation',
    'reg_ubicacion_titulo': 'Votre emplacement',
    'registro_cancelar_salir': 'Annuler et quitter',
    'registro_codigo_label': 'CODE D\'ACCÈS ACES',
    'registro_contrasena_label': 'MOT DE PASSE',
    'registro_crear_cuenta': 'Créez votre compte',
    'registro_datos_personales': 'Données personnelles',
    'registro_elige_rol': 'Avec quel rôle accédez-vous à Cities Network?',
    'registro_email_label': 'EMAIL',
    'registro_paso_1': 'Étape 1 sur 3',
    'registro_paso_2': 'Étape 2 sur 3',
    'registro_paso_2_desc': 'Ces informations sont utilisées pour la logistique des visites d\'évaluation.',
    'registro_paso_3': 'Étape 3 sur 3',
    'registro_siguiente': 'Suivant →',
    'registro_verifica_desc': 'Nous vous avons envoyé un email de vérification. Ouvrez-le et cliquez sur le lien avant de continuer.',
    'registro_verifica_titulo': 'Vérifiez votre email',
    'rol_ciudad': 'Ville',
    'rol_evaluador': 'Évaluateur',
    'rol_master': 'Master ACES',
    'salida': 'Salida',
    'salida_label': 'Départ',
    'saludo_buenas_noches': 'Bonsoir,',
    'saludo_buenas_tardes': 'Bon après-midi,',
    'saludo_buenos_dias': 'Bonjour,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Section',
    'seleccionar': 'Seleccionar',
    'seleccionar_pais': 'Sélectionner le pays',
    'seleccionar_provincia': 'Sélectionner la province',
    'sin_agenda': 'Aucun calendrier',
    'sin_agenda_desc': 'La ville n\'a pas encore proposé de calendrier de visite.',
    'sin_candidaturas': 'Sin candidaturas',
    'sin_candidaturas_desc': 'No hay candidaturas con este filtro.',
    'sin_ciudad_asignada': 'Aucune ville assignée',
    'sin_codigos_disponibles': 'Aucun code disponible',
    'sin_documentos': 'Sin documentos',
    'sin_documentos_desc': 'Sube los documentos requeridos para tu candidatura.',
    'sin_evaluaciones': 'Sin evaluaciones',
    'sin_evaluadores_desc': 'Enregistrez des évaluateurs avec un code ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Aucun évaluateur enregistré',
    'sin_facturas_aces': 'Aucune facture reçue',
    'sin_facturas_aces_desc': 'Les factures envoyées par ACES apparaîtront ici.',
    'sin_notificaciones': 'Aucune notification',
    'sin_notificaciones_desc': 'L\'activité de vos candidatures apparaîtra ici.',
    'sin_pagos': 'Sin pagos',
    'sin_pagos_desc': 'Los pagos de tu candidatura aparecerán aquí.',
    'stat_activas': 'Activas',
    'stat_decision': 'Decisión pendiente',
    'stat_dias_visita': 'Jours avant la visite',
    'stat_docs_pendientes': 'Docs en attente',
    'stat_evaluacion': 'En evaluación',
    'stat_mensajes_nuevos': 'Nouveaux messages',
    'stat_notif': 'Sin leer',
    'stat_pagos_pendientes': 'Paiements en attente',
    'stat_sin_visita': 'Aucune visite prévue',
    'stat_titulos': 'Títulos activos',
    'stat_total': 'Total',
    'subir_comprobante': 'Télécharger le justificatif',
    'subir_documento': 'Subir documento',
    'subir_factura': 'Télécharger la facture',
    'subir_factura_desc': 'Téléchargez le PDF de la facture. La ville pourra le télécharger depuis son panneau.',
    'subir_factura_titulo': 'Télécharger la facture PDF',
    'subir_nota': 'Selecciona el archivo desde tu dispositivo',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidatura',
    'tab_candidaturas': 'Candidaturas',
    'tab_chat': 'Chat',
    'tab_config': 'Configuración',
    'tab_documentos': 'Documentos',
    'tab_evaluaciones': 'Evaluaciones',
    'tab_evaluadores': 'Evaluadores',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Accueil',
    'tab_notif': 'Notificaciones',
    'tab_pagos': 'Pagos',
    'tab_perfil': 'Perfil',
    'tab_recursos': 'Recursos',
    'tab_resumen': 'Resumen',
    'tab_viaje': 'Logística',
    'talla_polo': 'Taille du polo',
    'telefono': 'Téléphone',
    'template_no_disponible': 'Le modèle d\'évaluation n\'est pas encore disponible.',
    'tipo_codigo': 'Tipo de código',
    'tit_ano_titulo': 'Año de titularidad',
    'tit_evidencias': 'Evidencias subidas',
    'tit_item_calendario': 'Calendario deportivo',
    'tit_item_congreso': 'Congreso o conferencia',
    'tit_item_imagen': 'Uso correcto del título',
    'tit_item_memoria': 'Memoria final',
    'tit_no_aplica': 'Sin año de titularidad',
    'tit_no_aplica_desc': 'Este módulo se activa cuando tu ciudad gana un galardón ACES.',
    'tit_sanciones': 'Sanciones',
    'tit_sin_datos': 'Sin titularidades activas',
    'tit_titulo': 'Año de titularidad',
    'toca_abrir_documento': 'Appuyez pour ouvrir le document',
    'toca_copiar': 'Toca el código para copiar',
    'toca_para_abrir': 'Appuyez pour ouvrir',
    'toca_para_copiar': 'Appuyez pour copier',
    'tomar_decision': 'Decisión final',
    'tu_ciudad_salida': 'Votre ville de départ',
    'upload_error': 'Erreur de téléchargement',
    'upload_exito': 'Téléchargé avec succès!',
    'upload_formatos': 'PDF, JPG ou PNG · max. 20 Mo',
    'upload_no_cierres': 'Ne fermez pas l\'application',
    'upload_reintentar': 'Réessayer',
    'upload_subiendo': 'Téléchargement en cours...',
    'vence': 'Vence',
    'ver_comprobante': 'Ver comprobante',
    'ver_detalle': 'Voir le détail',
    'ver_documento_adjunto': 'Voir le document joint',
    'ver_factura': 'Voir la facture',
    'verifica_desc': 'Nous avons envoyé un email de vérification. Vérifiez votre boîte de réception.',
    'verifica_reenviar': 'Renvoyer l\'email de vérification',
    'viaje_aviso_privacidad': 'La identidad de los evaluadores es confidencial. Solo verás fechas y logística.',
    'viaje_ciudad_salida': 'Votre ville de départ pour les vols',
    'viaje_proponer_vuelo': 'Proposer un vol',
    'viaje_propuesta_enviada': 'Proposition envoyée avec succès',
    'viaje_sin_propuestas': 'Sin propuestas de viaje',
    'viaje_sin_propuestas_desc': 'Propón opciones de vuelo, hotel y agenda para la visita.',
    'visita_evaluadores': 'Visita de evaluadores',
    'visita_programada': 'Visita programada',
    'visita_sin_programar': 'Visita aún no programada',
    'visita_titulo': 'Visita de evaluación',
    'volver': 'Retour',
    'votacion_abierta': 'Vote ouvert',
    'votacion_cerrada': 'Vote fermé',
    'walkthrough_ver_guia': 'Voir le guide de démarrage',
    'whatsapp': 'WhatsApp (avec indicatif)',
    'ya_tengo_cuenta': 'Vous avez déjà un compte?',
    'tab_titularidades': 'Titularités',
    'acciones_rapidas': 'Actions rapides',
    'evaluadores_titulo': 'Évaluateurs',
    'evaluadores_registrados': 'Évaluateurs inscrits',
    'codigos_disponibles_label': 'Codes disponibles',
    'evaluadores_seccion': 'Évaluateurs',
    'codigos_acceso_titulo': 'Codes d\'accès',
    'config_pais': 'Pays',
    'config_telefono': 'Téléphone',
    'config_correos_inst': 'E-mails institutionnels',
    'config_capital': 'Capitale',
    'config_city': 'Ville',
    'config_town': 'Commune',
    'evaluacion_habilitada': 'Évaluation activée',
    'evaluaciones_titulo_card': 'Évaluations',
    'decision_final_titulo': 'Décision finale',
    'gestionar_comision_titulo': 'Gérer le comité',
    'programar_visita_modal': 'Planifier la visite d\'évaluation',
    'fecha_llegada': 'Date d\'arrivée',
    'req_documentacion': 'Exigences documentaires',
    'todo_leido': 'Tout lu',
    'confirmar_borrar_notifs': 'Supprimer toutes les notifications ?',
    'gala_creada_ok': 'Gala créé avec succès',
    'gala_error_crear': 'Erreur lors de la création',
    'gala_activada': 'Gala activée pour les villes',
    'gala_desactivada': 'Gala désactivée',
    'titularidades_titulo': 'Titularités',
    'titularidades_desc': 'Villes avec titre ACES actif et suivi des obligations',
    'obligaciones_titulo': 'Obligations du titulaire',
    'obligacion_imagen': 'Respecter les règles d\'image ACES',
    'obligacion_calendario': 'Concevoir le calendrier sportif annuel',
    'obligacion_congreso': 'Organiser un congrès ou une compétition internationale',
    'obligacion_memoria': 'Soumettre le rapport et les conclusions annuels',
    'obligacion_awos': 'Participer activement à AWoS/EWoS',
    'cumplidas': 'accomplies',
    'viaje_confirmar': 'Confirmer la proposition',
    'viaje_rechazar': 'Rejeter la proposition',
    'viaje_confirmado': 'Proposition confirmée',
    'viaje_rechazado': 'Proposition rejetée',
    'nota_respuesta': 'Note de réponse (optionnel)',
    'voto_favor_confirm': 'Confirmer le vote favorable ?',
    'voto_contra_confirm': 'Confirmer le vote contre ?',
    'historial_sin_cambios': 'Aucun changement de statut enregistré',
    'candidatura_buscar': 'Rechercher ville, récompense...',
    'candidatura_ciudad_ph': 'Ex : Buenos Aires',
    'candidatura_pais_ph': 'Ex : Argentine',
    'candidatura_email_ph': 'ville@email.com',
    'dias_visita': 'jours de visite',
    'propuestas_viaje': 'Propositions de voyage',
    'sin_propuestas_viaje': 'Aucune proposition de voyage',
    'sin_propuestas_desc': 'Les évaluateurs n\'ont pas encore proposé d\'itinéraire.',
    'sin_evaluaciones_desc': 'Assignez des évaluateurs et activez l\'évaluation.',
    'seleccionar_pdf': 'Sélectionner PDF',
    'rechazar_candidatura': 'Rejeter la candidature',
    'motivo_rechazo': 'Motif du rejet (obligatoire)',
    'tit_sin_datos_desc': 'Les villes attribuées apparaîtront ici automatiquement.',
    'marcado_cumplido': 'Marqué comme accompli',
    'desmarcado': 'Décoché',
    'finalizada': 'Terminée',
    'finalizadas': 'Terminées',
    'notas_label': 'Notes',
    'sin_leer': 'non lu(s)',
    'confirmar_cerrar_sesion': 'Se déconnecter ?',
    'email_aces_europa': 'E-mail ACES Europe',
    'email_aces_america': 'E-mail ACES Amériques',
    'gala_fecha_evento': 'Date de l\'événement',
    'gala_primera_desc': 'Créez la première gala pour commencer à gérer les cérémonies.',
    'evaluadores_gestion': 'Gestion du comité d\'évaluation ACES',
    'adjudicar': 'Attribuer',
    'adjudicada_ok': 'Candidature attribuée !',
    'candidatura_rechazada': 'Candidature rejetée',
    'error_decision': 'Erreur lors de l\'enregistrement',
    'evaluador_asignado': 'Évaluateur assigné',
    'evaluador_quitado': 'Évaluateur retiré',
    'jefe_designado': 'Chef de comité désigné',
    'jefe_eliminado': 'Chef de comité retiré',
    'notas_guardadas': 'Notes enregistrées',
    'notas_visita_hint': 'Ex : Hôtel recommandé, instructions aéroport...',
    'visita_ok': 'Visite planifiée avec succès',
    'error_visita': 'Erreur lors de la planification',
    'evaluacion_hab_ok': 'Évaluation activée',
    'evaluacion_deshab_ok': 'Évaluation désactivée',
    'programar': 'Planifier',
    'confirmar_decision': 'Confirmer la décision',
    'cambiar_modo': 'Changer de mode',
    'de_preposicion': 'sur',
    'notas_decision_label': 'Notes de décision (optionnel)',
    'generar': 'Générer',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File reçu',
    'documentos_firmados': 'Documents signés',
    'pago_confirmado': 'Paiement confirmé',
    'subiendo_label': 'Téléchargement...',
    'pagado_label': 'Payé',
    'factura_label': 'Facture',
    'marcar_factura': 'Marquer la facture comme émise',
    'desmarcar_factura': 'Décocher la facture',
    'marcar_pago': 'Marquer le paiement reçu',
    'desmarcar_pago': 'Décocher le paiement',
    'evaluacion_enviada': 'Soumise',
    'disponible_label': 'Disponible',
    'ver_codigos_btn': 'Voir les codes',
    'invitar_eval_btn': 'Inviter évaluateur',
    'generar_codigo_btn': 'Générer un nouveau code',
    'idioma_destinatario': 'Langue du destinataire',
    'candidaturas_count': 'candidatures',
    'sin_alertas_ok': 'Tout est en ordre. Aucune alerte en attente.',
    'sin_galas_configuradas': 'Aucune gala configurée',
    'gala_activada_ciudades': 'Gala activée pour les villes',
    'ver_alertas_label': 'Voir les alertes',
    'modo_evaluador_activo': 'Mode evaluateur actif',
    'modo_master_activo': 'Vue Master ACES',
    'cambiar_a_eval': 'Mode evaluateur',
    'cambiar_a_master': 'Retour Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Règlement',
    'doc_tipo_comprobante': 'Justificatif de paiement',
    'doc_tipo_contrato': 'Contrat',
    'doc_tipo_memoria': 'Rapport',
    'doc_tipo_pres': 'Présentation',
    'doc_tipo_otro': 'Autre',
    'selecciona_tipo_doc': 'Quel type de document?',
    'todos_label': 'Tous',
    'hotel_sin_nombre': 'Hôtel',
    'agenda_evento': 'Événement',
    'mis_propuestas': 'Mes propositions',
    'propuestas_label': 'propositions',
    'ciudad_hotel': 'Ville',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/nuit',
    'hotel_notas_hint': 'Ex: Chambre double, petit-déjeuner inclus...',
    'vuelo_notas_hint': 'Ex: Vol direct, escale à Madrid...',
    'fecha_label': 'Date',
    'hora_label': 'Heure',
    'lugar_label': 'Lieu',
    'tipo_reunion': 'Réunion',
    'tipo_visita_instalacion': 'Visite installation',
    'tipo_acto': 'Événement officiel',
    'tipo_almuerzo': 'Déjeuner / Dîner',
    'tipo_transporte': 'Transport',
    'tipo_otro': 'Autre',
    'galardones_titulo': 'Prix',
    'reglamentos_titulo': 'Règlements',
    'sin_candidatura_titulo': 'Aucune candidature assignée',
    'sin_candidatura_desc': 'Votre compte n\'a pas encore de candidature liée.',
    'bienvenida_ciudad_saludo': 'Bonjour, {nombre}',
    'bienvenida_ciudad_titulo': 'Votre compte est actif',
    'bienvenida_ciudad_desc': 'Nous préparons votre candidature. Dès que l\'équipe ACES vous en attribue une, elle apparaîtra ici avec son suivi complet.',
    'bienvenida_ciudad_chip_activa': 'Compte actif',
    'bienvenida_ciudad_chip_espera': 'En attente d\'attribution',
    'bienvenida_ciudad_contacto': 'Des questions ? Contactez ACES',
    'chat_ciudad_desc': 'Communication directe avec l\'équipe ACES.',
    'mensajes_label': 'Messages',
    'motor_seccion_de': 'de',
    'gala_confirmar_desc': 'Indiquez si votre ville assistera à la cérémonie de gala.',
    'eval_completadas': 'Complétées',
    'secciones_completadas': 'sections complétées',
    'evaluaciones_enviadas_abrev': 'évaluations soumises',
    'awos_activa_desc': 'Enregistrez votre activité physique et accédez aux événements ACES',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Vos données de voyage ne sont visibles que par ACES.',
    'eval_docs_solo_lectura': 'Vous pouvez consulter les documents soumis par la ville.',
    'conflicto_titulo': 'Déclaration de conflit d\'intérêts',
    'conflicto_desc': 'Avant d\'évaluer, confirmez que vous n\'avez aucun conflit d\'intérêts.',
    'conflicto_sin_conflicto': 'Aucun conflit — continuer',
    'conflicto_con_conflicto': 'J\'ai un conflit',
    'conflicto_aviso': 'Veuillez notifier ACES immédiatement.',
    'sin_fecha': 'Sans date',
    'subir_reserva_hint': 'Telechargez le PDF de reservation confirmee.',
    'subir_reserva_hint_eval': 'Telechargez votre PDF de reservation.',
    'login_sin_cuenta': 'Pas de compte?',
    'agenda_oficial_titulo': 'Agenda officiel de visite',
    'agenda_anadir_evento': 'Ajouter un evenement',
    'agenda_editar_evento': 'Modifier evenement',
    'agenda_oficial_aviso': 'Cet agenda est visible par les evaluateurs.',
    'agenda_oficial_vacia': 'Aucun evenement publie pour le moment.',
    'publicar_evento': 'Publier evenement',
    'evento_publicado': 'Evenement publie',
    'evento_guardado': 'Evenement mis a jour',
    'evento_eliminado': 'Evenement supprime',
    'confirmar_eliminar': 'Supprimer cet evenement?',
    'guardar_cambios': 'Sauvegarder les modifications',
    'pipeline_titulo': 'Pipeline des candidatures',
    'revenue_titulo': 'Revenus',
    'revenue_total': 'Total facture',
    'cobrado': 'Encaisse',
    'visitas_proximas': 'Visites a venir',
    'paises_titulo': 'Par pays',
    'awos_banner_desc': 'Suivez votre activite physique et accedez aux evenements ACES',
    'fecha_limite_confirmar': 'Date limite de confirmation',
    'info_parlamento': 'Info Parlement Europeen',
    'info_venue': 'Lieu',
    'norma_hotel': 'Regles hotel',
    'norma_vuelo': 'Regles vol',
    'programa_dia': 'Programme du jour',
    'sin_programa': 'Aucun programme',
    'actividad_placeholder': 'Activite...',
    'anadir': 'Ajouter',
    'representantes_label': 'Representants',
    'confirmados_label': 'Confirmes',
    'fecha_limite': 'Date limite',
    'deadline_pasada': 'Delai depasse',
    'restantes': 'restants',
    'anadir_representante': 'Ajouter representant',
    'sin_representantes': 'Aucun representant',
    'representante_anadido': 'Representant ajoute',
    'representante_eliminado': 'Representant supprime',
    'programa_actualizado': 'Programme mis a jour',
    'confirmado': 'CONFIRME',
    'nombre_label': 'Nom complet',
    'cargo_label': 'Poste',
    'telefono_label': 'Telephone',
    'logistica_evaluadores': 'Logistique evaluateurs',
    'vuelo_short': 'Vol',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Documents obligatoires',
    'evidencia_subida': 'Preuve telechargee',
    'sancion_anadida': 'Sanction enregistree',
    'memoria_subida': 'Rapport final telecharge',
    'nueva_sancion': 'Nouvelle sanction',
    'motivo_sancion': 'Motif',
    'motivo_sancion_hint': 'Ex: Non-participation au gala',
    'importe_label': 'Montant',
    'divisa_label': 'Devise',
    'registrar_sancion': 'Enregistrer sanction',
    'subir_evidencia': 'Telecharger',
    'memoria_final_titulo': 'Rapport final',
    'memoria_deadline': 'Avant le 31 janvier',
    'subir_memoria': 'Telecharger rapport final (PDF)',
    'sin_sanciones': 'Aucune sanction',
    'evidencias_short': 'preuves',
    'memoria_ok': 'Rapport OK',
    'sanciones_short': 'sanctions',
    'dias_en_fase': 'Jours en phase',
    'proximo_pago': 'Prochain paiement',
    'vencido': 'En retard',
    'visita_label': 'Visite',
    // === Paquete 2 — 85 keys faltantes (fr) ===
    'abrir_nueva_pestana': 'Ouvrir dans un nouvel onglet',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Articles',
    'auth_accediendo': 'Connexion...',
    'auth_email_enviado': 'Email envoye. Verifiez votre boite de reception.',
    'auth_enviar_enlace': 'Envoyer le lien',
    'auth_error_intentos': 'Trop de tentatives. Veuillez patienter.',
    'auth_error_password': 'Mot de passe incorrect',
    'auth_error_reset': 'Erreur lors de envoi de email de recuperation',
    'auth_error_usuario': 'Utilisateur non trouve',
    'auth_introduce_email': 'Entrez votre email',
    'auth_olvido_password': 'Mot de passe oublie',
    'auth_recuperar': 'Reinitialiser le mot de passe',
    'auth_recuperar_desc': 'Nous vous enverrons un lien pour reinitialiser votre mot de passe.',
    'aw_h': 'Semaine Americaine du Sport',
    'aw_lbl': 'AWoS',
    'aw_p': 'Celebrez le sport et activite physique avec votre ville pendant la Semaine Americaine du Sport.',
    'bonus_desc': 'Points supplementaires pour les initiatives remarquables',
    'buscar_articulo': 'Rechercher un article...',
    'buscar_recursos': 'Rechercher dans les ressources...',
    'comite_evaluacion': 'Comite evaluation',
    'confirmar_eliminar_pago': 'Etes-vous sur de vouloir supprimer ce paiement ?',
    'cookie_accept': 'Accepter',
    'cookie_more': 'Plus informations',
    'cookie_msg': 'Nous utilisons des cookies essentiels pour le fonctionnement du site.',
    'cookie_reject': 'Refuser',
    'criterios_elegibilidad': 'Criteres eligibilite',
    'cta_b1': 'Soumettre une candidature',
    'cta_b2': 'Contacter ACES',
    'cta_h': 'Commencez votre candidature',
    'cta_p': 'Rejoignez le reseau des villes europeennes du sport et transformez votre communaute.',
    'descargar_factura': 'Telecharger la facture',
    'docs_drag_drop': 'Glissez des fichiers ici ou cliquez pour selectionner',
    'docs_obligatorios': 'Documents obligatoires',
    'eval_actual': 'Evaluation actuelle',
    'eval_comentario_voto_placeholder': 'Commentaire sur votre vote (optionnel)...',
    'eval_max_puntos': 'Score maximum',
    'feats': 'Fonctionnalites',
    'footer_contact': 'Contact',
    'footer_legal': 'Mentions legales',
    'footer_privacy': 'Politique de confidentialite',
    'ft_h': 'Tout ce dont vous avez besoin',
    'ft_lbl': 'Fonctionnalites',
    'general_volver': 'Retour',
    'hero_cta1': 'Soumettre une candidature',
    'hero_cta2': 'Decouvrir le processus',
    'hero_h1a': 'Votre ville merite',
    'hero_h1b': 'etre reconnue',
    'hero_sub': 'ACES Cities Network connecte villes, evaluateurs et organismes sportifs en une seule plateforme.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Effacer',
    'login_subtitulo': 'Accedez a votre compte ACES Cities Network',
    'marcar_todas_leidas': 'Tout marquer comme lu',
    'nav_acceder': 'Se connecter',
    'nav_funciones': 'Fonctions',
    'nav_galardones': 'Prix',
    'nav_proceso': 'Processus',
    'nav_registro': 'Inscription',
    'nav_roles': 'Roles',
    'notif_todas_leidas': 'Toutes les notifications marquees comme lues',
    'pago_eliminado': 'Paiement supprime',
    'pendiente': 'En attente',
    'pendiente_label': 'En attente',
    'pipe_h': 'Processus transparent',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Suivez chaque etape de votre candidature en temps reel.',
    'preambulo': 'Preambule',
    'recursos_aces_desc': 'Prix, reglements et documentation officielle ACES.',
    'recursos_aces_titulo': 'Ressources ACES',
    'reglamentos_seed': 'Reglements charges avec succes',
    'regulacion_sin_articulos': 'Ce reglement ne contient pas articles.',
    'roles_h': 'Pour chaque role',
    'roles_lbl': 'Roles',
    'roles_p': 'Villes, evaluateurs et administrateurs en une seule plateforme.',
    'sancion_incumplimiento': 'Sanction pour non-conformite',
    'sin_articulos': 'Pas articles',
    'sin_galardones': 'Aucun prix disponible',
    'sin_reglamentos': 'Aucun reglement disponible',
    'sin_recursos': 'Aucune ressource disponible',
    'sin_resultados': 'Aucun resultat',
    'stages': 'Etapes',
    'tasa_inscripcion': 'Frais inscription',
    'todas': 'Toutes',
    'ver_candidatura': 'Voir la candidature',
    'reserva_sin_evaluador': 'Général (aucun évaluateur assigné)',
    'preview_pdf_hint': 'Les PDF s\'ouvrent dans un nouvel onglet du navigateur.',
    'descargar': 'Télécharger',
    'con_pago_confirmado': 'avec paiement confirmé (jalon)',
    'pendientes_pago': 'en attente',
    'sin_datos_pagos': 'Aucune donnée de paiement enregistrée',
    'eval_no_asignado': 'Vous n\'êtes pas assigné à la commission d\'évaluation de cette candidature.',
    'subir_reserva': 'Télécharger réservation',
    'sin_reservas': 'Aucune réservation',
    'sin_reservas_desc': 'Téléchargez les PDFs des réservations.',
    'reservas_desc_master': 'Téléchargez les réservations de vol et hôtel confirmées en PDF. Vous pouvez sélectionner l\'évaluateur correspondant.',
    'subir_agenda': 'Télécharger agenda (PDF)',
    'agenda_visita_titulo': 'Agenda de la visite',
    'reservas_titulo': 'Réservations',
    'reserva_subida_ok': 'Réservation téléchargée',
    'agenda_subida_ok': 'Agenda téléchargée',
    'doc_eliminado': 'Document supprimé',
    'agenda_vacia_desc': 'Téléchargez le PDF de l\'agenda de visite.',
    'revenue_cobrado': 'Encaissé',
    'revenue_pendiente': 'En attente',
    'ciudad_hitos_titulo': 'État de votre candidature',
    'hito_factura_recibida': 'Facture reçue',
    'eval_mis_evaluaciones': 'Mes évaluations',
    'eval_sin_bid': 'La ville n\'a pas encore envoyé le BID File.',
    'voto_final_desc_motor': 'Émettez votre vote final basé sur votre évaluation.',
    'chat_comision': 'Chat commission',
    'tit_comunicacion_ok': 'Communication officielle OK',
    'tit_derechos_factura_env': 'Droits d\'image : facture envoyée',
    'tit_derechos_pagado': 'Droits d\'image : payée',
    'tit_q1': 'Rapport trimestriel Q1',
    'tit_q2': 'Rapport trimestriel Q2',
    'tit_q3': 'Rapport trimestriel Q3',
    'tit_q4': 'Rapport trimestriel Q4',
    'tit_premio_n1': 'Prix N1 : Participe ?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Nouvelle sanction',
    'motivo': 'Motif',
    'si': 'Oui',
    'no': 'Non',
    'nueva': 'Nouveau',
    'sanciones': 'Sanctions',
    'pagada': 'Payée',

    'borrar_candidatura': 'Supprimer la candidature',
    'borrar_candidatura_desc': 'Supprime definitivement la candidature et toutes les donnees associees.',
    'confirmar_borrar_candidatura': 'Supprimer cette candidature ? Cette action est IRREVERSIBLE.',
    'confirmar_borrar_candidatura_2': 'ETES-VOUS SUR ? TOUS les documents, paiements, evaluations et chats seront supprimes.',
    'candidatura_eliminada': 'Candidature supprimee',
    'zona_peligrosa': 'Zone dangereuse',
    'contacto_ciudad': 'Contact ville',
    'sin_ciudad_vinculada': 'Aucun utilisateur ville lie',
    'cambiar_ciudad': 'Changer',
    'vincular_ciudad': 'Lier',
    'vincular_ciudad_titulo': 'Lier un utilisateur ville',
    'vinculado_actual': 'Lie actuellement',
    'desvincular': 'Delier',
    'buscar_usuario_ciudad': 'Rechercher par nom, email ou ville...',
    'sin_usuarios_ciudad': 'Aucun utilisateur avec role ville enregistre',
    'ciudad_vinculada_ok': 'Ville liee avec succes',
    'ciudad_desvinculada': 'Ville deliee',
    'vincular': 'Lier',
    'codigo_generado': 'Code genere',
    'codigo_generado_ok': 'Code ville genere',
    'codigo_vinculado_candidatura': 'Pre-lie a cette candidature',
    'idioma_carta': 'Langue de la lettre',
    'carta_copiada': 'Lettre copiee dans le presse-papiers',
    'copiar_carta': 'Copier',
    'enviar_invitacion': 'Ouvrir email',
    'email_cliente_abierto': 'Client email ouvert',
    'estado_avanza_aceptada': 'Candidature acceptee automatiquement',
    'estado_avanza_documentacion': 'Passage en phase de documentation',
    'estado_avanza_visita': 'Passage en phase de visite',
    'estado_avanza_evaluacion': 'Passage en phase d\'evaluation',
    'confirmar_avance_estado': 'Avancer le statut a',
    'estado_cambiado': 'Statut change en',
    'eval_ciudades_galardonadas': 'Villes recompensees',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Délégué',
    'delegado_desc': 'Le délégué peut voir le statut de la candidature et les documents en attente.',
    'asignar_delegado': 'Assigner',
    'cambiar_delegado': 'Changer',
    'sin_delegado': 'Aucun délégué assigné',
    'confirmar_quitar_delegado': 'Retirer le délégué de cette candidature ?',
    'delegado_quitado': 'Délégué retiré',
    'delegado_asignado': 'Délégué assigné',
    'delegado_existente': 'Utilisateur existant',
    'delegado_invitar': 'Inviter par email',
    'generar_codigo_delegado': 'Générer un code de délégué',
    'codigo_delegado_generado': 'Code généré — envoyez le mail',
    'nombre_delegado_hint': 'Nom du délégué',
    'email_delegado_hint': 'email@exemple.com',
    'confirmar_retroceso_estado': 'Reculer le statut à',
    'accion_gala': 'Inviter au Gala',
    'accion_gala_desc': 'Confirmer le gala et ajouter la ville à l\'événement annuel.',
    'accion_notificar': 'Marquer comme notifiée',
    'accion_notificar_desc_simple': 'Change le statut en notifiée. La communication à la ville se fait hors de l\'app.',
    'accion_premio': 'Remettre le prix',
    'accion_titularidad': 'Activer la titularité',
    'activar_titularidad': 'Activer la titularité',
    'anos_label': 'Années',
    'aprobar_informe': 'Approuver',
    'archivo_muy_grande': 'Le fichier dépasse 50 Mo',
    'badge': 'Badge',
    'cambiar_estado': 'Changer le statut',
    'candidatura_actualizada': 'Candidature mise à jour',
    'chat_ayer': 'Hier',
    'chat_hoy': 'Aujourd\'hui',
    'chat_primer_mensaje': 'Envoyez le premier message',
    'checklist_obligaciones': 'Obligations',
    'ciudad_notificada': 'Ville notifiée',
    'comentario_rechazo': 'Commentaire obligatoire pour le rejet :',
    'comite_label': 'Comité',
    'confirmar_cambio_estado': 'Confirmer le changement de statut ?',
    'confirmar_gala': 'Confirmer le gala',
    'confirmar_notificar': 'Marquer comme notifiée ?',
    'confirmar_pago': 'Confirmer paiement reçu',
    'Copiado': 'Copié',
    'delegado_info_restriccion': 'En tant que délégué, vous pouvez voir le pipeline et l\'agenda. Pour accéder au moteur d\'évaluation ou au BID File, demandez une affectation comme évaluateur à ACES.',
    'delegado_mis_candidaturas': 'En tant que délégué',
    'delegado_vista': 'Vue délégué',
    'delegado_vista_restringida': 'Vue restreinte : pipeline, agenda et documents en attente uniquement. Pas de paiements ni d\'évaluations.',
    'derechos_imagen': 'Droits à l\'image',
    'editar_candidatura': 'Modifier la candidature',
    'Eliminado': 'Supprimé',
    'email': 'Email',
    'emitir_factura': 'Émettre facture (PDF)',
    'entre_miembros': 'Entre',
    'espera_repetir': 'Attente avant de répéter',
    'estado_actualizado': 'Statut mis à jour',
    'estado_gala_confirmada': 'Gala confirmé',
    'estado_notificada': 'Notifiée',
    'estado_notificada_rechazo': 'Rejet notifié',
    'estado_premio_otorgado': 'Prix décerné',
    'estado_titularidad_activa': 'Titularité active',
    'eval_comentario_criterio': 'Commentaires sur ce critère...',
    'factura': 'Facture',
    'factura_emitida': 'Facture téléversée',
    'fase_candidatura': 'Candidature',
    'fase_seguimiento': 'Suivi',
    'gala_confirmada_ok': 'Gala confirmé',
    'Guardado': 'Enregistré',
    'hito_agenda': 'Agenda de visite accepté',
    'hito_carta': 'Lettre de candidature acceptée',
    'hito_pago': 'Facture payée',
    'hito_reglamento_env': 'Règlement reçu',
    'hito_reglamento_firm': 'Règlement signé',
    'hito_viajes': 'Logistique de voyage terminée',
    'image_rights': 'Droits à l\'image',
    'importe': 'Montant',
    'informe_aprobado': 'Rapport approuvé',
    'informe_rechazado': 'Rapport rejeté',
    'informe_subido': 'Rapport téléversé',
    'informes_trimestrales': 'Rapports trimestriels',
    'marcar_notificada': 'Marquer comme notifiée',
    'marcar_premio': 'Marquer prix décerné',
    'max_candidatos': 'Max candidats',
    'miembros_label': 'Membres',
    'notificar_rechazo': 'Notifier le rejet',
    'nueva_version': 'Nouvelle version',
    'ocultar': 'Masquer',
    'permisos_documento': 'Autorisations du document',
    'permisos_guardados': 'Autorisations enregistrées',
    'poblacion_maxima': 'Population maximale',
    'poblacion_minima': 'Population minimale',
    'rechazar_informe': 'Rejeter',
    'region_africa': 'Afrique',
    'region_americas': 'Amériques',
    'region_asia': 'Asie',
    'region_europa': 'Europe',
    'region_mundial': 'Mondial',
    'region_oceania': 'Océanie',
    'reglamentos_pendientes': 'Règlements en attente',
    'seleccionar_tipo': 'Type de document',
    'sin_resultados_busqueda': 'Aucun résultat trouvé',
    'subir_informe': 'Téléverser le rapport',
    'tasa_label': 'Taxe',
    'tipo_anexo': 'Annexe',
    'tipo_especial': 'Spécial',
    'tipo_no_permitido': 'Type de fichier non autorisé. Utilisez PDF, DOC, DOCX, XLS, XLSX, JPG ou PNG',
    'tipo_principal': 'Principal',
    'titularidad_activa_label': 'Titularité active',
    'titularidad_creada': 'Titularité créée',
    'titularidad_panel': 'Ma titularité',
    'tomar_decision_final': 'Prendre la décision finale',
    'ver_documento': 'Voir',
    'ver_escala': 'Voir l\'échelle',
    'ver_reglamento': 'Voir le règlement complet',
    'ver_seguimiento': 'Voir le suivi de titularité',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Ville',
    'visible_evaluador': 'Évaluateur',
    'visible_master': 'Master',
    'visible_para': 'Visible par',
    'warning_quitar_adjudicada': 'Revenir avant « Attribuée » supprimera le marquage d\'attribution permanent.',
    'warning_retroceso': 'Êtes-vous sûr de vouloir reculer le statut ?',
    'y_label': 'et',
    'Q1_nombre': 'Jan-Mar',
    'Q2_nombre': 'Avr-Jun',
    'Q3_nombre': 'Jul-Sep',
    'Q4_nombre': 'Oct-Déc',
    'informe_pendiente': 'En attente',
    'pago_pendiente': 'En attente',
    'checklist_logo_aces': 'Utilisation correcte du logo ACES',
    'checklist_memoria_anual': 'Rapport annuel soumis',
    'checklist_congreso': 'Participation au congrès ACES',
    'checklist_imagen_corporativa': 'Image corporative mise à jour',
    'checklist_calendario_deportivo': 'Calendrier sportif publié',
    'asignar_evaluadores': 'Assigner des évaluateurs',
    'notas_internas_opcional': 'Notes internes (optionnel)',
    'estado_candidatura': 'Statut de la candidature',
    'hito_carta_recibida': 'Lettre de candidature reçue',
    'hito_candidatura_aceptada': 'Candidature acceptée',
    'hito_reglamento_enviado': 'Règlement envoyé',
    'hito_reglamento_firmado': 'Règlement signé',
    'hito_datos_facturacion': 'Données de facturation reçues',
    'hito_pago_confirmado': 'Paiement confirmé',
    'hito_fechas_visita': 'Dates de visite acceptées',
    'hito_comision_cerrada': 'Commission fermée',
    'hito_reservas_completadas': 'Réservations complétées',
    'hito_agenda_subida': 'Agenda téléchargé',
    'hito_bid_file_recibido': 'BID File reçu',
    'editar_visita': 'Modifier la visite',
    'programar_visita_btn': 'Programmer la visite',
    'gestionar_comision': 'Gérer la commission',
    'pagos_titulo': 'Paiements',
    'sin_pagos': 'Aucun paiement enregistré',
    'factura_marcada': 'Facture marquée',
    'factura_desmarcada': 'Facture non marquée',
    'pago_confirmado_label': 'Paiement confirmé',
    'pago_desmarcado': 'Paiement non marqué',
    'vence_label': 'Échéance',
    'factura_label': 'Facture',
    'pagado_label': 'Payé',
    'documentos_titulo': 'Documents',
    'archivos_count': 'fichier',
    'archivos_count_plural': 'fichiers',
    'subir_btn': 'Télécharger',
    'sin_documentos': 'Aucun document téléchargé',
    'aprobado_label': 'Approuvé',
    'rechazado_label': 'Rejeté',
    'sin_permisos': 'Sans permissions',
    'ver_label': 'Voir',
    'logistica_titulo': 'Logistique',
    'agenda_visita': 'Agenda de visite',
    'subir_pdf': 'Télécharger PDF',
    'sin_agenda': 'Aucune agenda téléchargée',
    'reservas_titulo': 'Réservations',
    'general_sin_eval': 'Général (sans évaluateur)',
    'subir_reserva': 'Télécharger réservation',
    'sin_reservas': 'Aucune réservation téléchargée',
    'agenda_subida_ok': 'Agenda téléchargé',
    'reserva_subida_ok': 'Réservation téléchargée',
    'evaluador_actualizado': 'Évaluateur mis à jour',
    'general_todos_eval': 'Général (tous les évaluateurs)',
    'cambiar_evaluador': 'Changer l\'évaluateur',
    'evaluaciones_titulo': 'Évaluations',
    'enviada_label': 'envoyée',
    'enviadas_label': 'envoyées',
    'en_progreso_label': 'en cours',
    'comision_asignada': 'Commission assignée',
    'evaluador_label': 'évaluateur',
    'evaluadores_label': 'évaluateurs',
    'jefe_label': 'Chef',
    'sin_empezar': 'Non commencé',
    'sin_evaluadores': 'Aucun évaluateur assigné',
    'enviada_badge': 'Envoyée',
    'favorable_label': 'Favorable',
    'desfavorable_label': 'Défavorable',
    'desbloquear_label': 'Débloquer',
    'evaluacion_desbloqueada': 'Évaluation débloquée',
    'error_desbloquear': 'Erreur de déblocage',
    'pdf_generado': 'PDF généré',
    'error_pdf': 'Erreur lors de la génération du PDF',
    'en_progreso_badge': 'En cours',
    'tomar_decision': 'Prendre la décision finale',
    'cerrar_menu': 'Fermer le menu',
    'compartir_tel_ciudad': 'Partager le téléphone avec la ville candidate',
    'compartir_tel_eval': 'Partager le téléphone avec d\'autres évaluateurs',
    'notas_internas': 'Notes internes',
    'notas_privadas_placeholder': 'Notes privées...',
    'guardado_ok': 'Enregistré',
    'generar_btn': 'Générer',
    'copiado_ok': 'Copié',
    'idioma_destinatario': 'Langue du destinataire',
    'codigo_acceso_modal': 'Code d\'accès',
    'gala_activa': 'ACTIVE',
    'gala_inactiva': 'INACTIVE',
    'calendario_carta': 'Lettre du maire: 30 mar',
    'calendario_bid': 'Dossier BID: 30 jun',
    'calendario_preseleccion': 'Pré-sélection: 31 jul',
    'calendario_visitas': 'Visites: oct',
    'calendario_gala': 'Gala: nov',
    'calendario_titularidad': 'Titulariat: 1er jan suivant',
    'candidatura_singular': 'candidature',
    'candidaturas_plural': 'candidatures',
    'doc_tipo_bid_file': 'Dossier BID',
    'doc_tipo_presentacion': 'Présentation',
    'progreso_inicio': 'Début',
    'progreso_adjudicada': 'Attribuée',
    'hab_label': 'hab.',
    'eval_abreviado': 'éval.',
    'min_poblacion_label': 'Population min.',
    'max_poblacion_label': 'Population max.',
    'max_candidatos_label': 'Maximum candidats',
    'espera_label': 'Période d\'attente',
    'anos_label': 'ans',
    'image_rights': 'Droits à l\'image',
    'comite_label': 'Comité',
    'miembros_label': 'membres',
    'usado_label': 'UTILISÉ',
    'disponibles_count': 'Disponibles',
    'usados_count': 'Utilisés',
    'codigos_disponibles_count': 'Codes disponibles',
    'hotel_placeholder': 'Hôtel assigné, enregistrement, règles...',
    'vuelo_placeholder': 'Aéroport, horaires, classe...',
    'parlamento_placeholder': 'Adresse, règles d\'accès, protocole...',
    'dni_pasaporte': 'Pièce d\'identité / Passeport',
    'cerrar_menu': 'Fermer le menu',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'actividad': 'Activité',
    'alertas_titulo': 'Alertes',
    'aprobar': 'Approuver',
    'auth_cargando': 'Connexion...',
    'auth_cerrar_sesion': 'Se déconnecter',
    'auth_email': 'E-mail',
    'auth_entrar': 'Se connecter',
    'auth_error_credenciales': 'E-mail ou mot de passe incorrect.',
    'auth_error_red': 'Pas de connexion Internet.',
    'auth_subtitulo': 'Plateforme de candidatures sportives ACES',
    'avanzar_a': 'Passer à',
    'buscar_placeholder': 'Rechercher une ville, une distinction...',
    'cambios': 'Modifications',
    'cancelar': 'Annuler',
    'cat_eventos': 'Événements',
    'cat_infra': 'Infrastructures',
    'cat_otros': 'Autres',
    'cat_presupuesto': 'Budget',
    'categoria': 'Catégorie',
    'cerrar': 'Fermer',
    'chat_ciudad': 'Chat avec ACES',
    'chat_escribir': 'Écrivez un message...',
    'chat_interno': 'Chat de la commission',
    'ciudad': 'Ville',
    'ciudad_email': 'E-mail',
    'ciudad_historico': 'Historique',
    'ciudad_recursos': 'Ressources ACES',
    'ciudad_sin_candidatura': 'Aucune candidature active',
    'ciudad_sin_candidatura_desc': 'Contactez ACES pour lancer le processus.',
    'codigo_activando': 'Activation...',
    'codigo_activar': 'Activer le code',
    'codigo_error_invalido': 'Code invalide ou déjà utilisé.',
    'codigo_subtitulo': 'Saisissez le code ACESCN fourni par ACES.',
    'codigo_titulo': 'Code d\'accès',
    'codigos_generados': 'Codes générés',
    'completado': 'terminé',
    'config_convocatorias': 'Appels à candidatures ouverts',
    'config_guardada': 'Paramètres enregistrés',
    'config_sanciones': 'Pénalités pour absence au gala (€)',
    'config_tasas': 'Frais de participation (€)',
    'confirmada': 'Confirmée',
    'confirmando': 'Confirmation...',
    'confirmar_asistencia': 'Confirmer la présence',
    'convocatoria': 'Édition',
    'creando': 'Création...',
    'crear_candidatura': 'Créer une candidature',
    'decision_adjudicar': 'Attribuer',
    'decision_advertencia': 'Cette décision est définitive et sera enregistrée de façon permanente.',
    'decision_confirmar': 'Confirmer la décision',
    'decision_nav': 'Décision finale',
    'decision_notas': 'Notes de décision (obligatoire)',
    'decision_rechazar': 'Ne pas attribuer',
    'decision_selecciona': 'Sélectionnez la décision',
    'decision_titulo': 'Décision finale',
    'desbloquear': 'Débloquer',
    'destino': 'Destination',
    'dias': 'jours',
    'editar': 'Modifier',
    'eliminar': 'Supprimer',
    'eliminar_cuenta': 'Supprimer mon compte',
    'eliminar_cuenta_desc': 'Cette action est irréversible. Vos données seront anonymisées conformément au RGPD.',
    'eliminar_cuenta_password': 'Saisissez votre mot de passe pour confirmer',
    'eliminar_cuenta_titulo': 'Supprimer le compte',
    'email_contacto': 'E-mail de contact',
    'enviada': 'Envoyée',
    'enviar': 'Envoyer',
    'enviar_propuesta': 'Envoyer la proposition',
    'escribiendo': 'est en train d\'écrire',
    'estado_pipeline': 'Pipeline de candidature',
    'eval_anterior': 'Précédent',
    'eval_asignadas': 'Mes attributions',
    'eval_cargando': 'Chargement de l\'évaluation...',
    'eval_comentario_placeholder': 'Commentez votre note...',
    'eval_comentario_voto': 'Commentaire sur le vote final',
    'eval_confirmar_desc': 'Une fois envoyée, elle ne pourra plus être modifiée sans déblocage par le Master.',
    'eval_confirmar_envio': 'Envoyer l\'évaluation',
    'eval_conflicto_interes': 'Conflit d\'intérêts : vous êtes du même pays que la ville candidate au titre de Capitale.',
    'eval_desfavorable': 'Défavorable',
    'eval_enviada_desc': 'Votre évaluation a bien été enregistrée.',
    'eval_enviada_titulo': 'Évaluation envoyée',
    'eval_enviadas': 'envoyées',
    'eval_enviar': 'Envoyer',
    'eval_habilitada': 'Évaluation activée',
    'eval_ir_motor': 'Aller au moteur d\'évaluation',
    'eval_lista': 'Évaluateurs',
    'eval_mi_evaluacion': 'Mon évaluation',
    'eval_mis_candidaturas': 'Mes candidatures',
    'eval_motor_titulo': 'Moteur d\'évaluation',
    'eval_notas_comentario': 'Notes et commentaires',
    'eval_registrados': 'Inscrits',
    'eval_seccion': 'Section',
    'eval_siguiente': 'Suivant',
    'eval_sin_activas': 'Aucune candidature active',
    'eval_sin_asignadas': 'Aucune candidature attribuée',
    'eval_sin_asignadas_desc': 'Le Master attribuera des candidatures à votre commission.',
    'eval_stat_asignadas': 'Attribuées',
    'eval_stat_completadas': 'Terminées',
    'eval_stat_pendientes': 'En attente',
    'eval_todas': 'Toutes actives',
    'eval_todas_activas': 'Candidatures actives',
    'eval_todas_aviso': 'Lecture seule. Détail complet uniquement pour vos candidatures attribuées.',
    'eval_total_seccion': 'Note de cette section',
    'eval_ver_escala': 'Voir l\'échelle de notation',
    'eval_voto_final': 'Vote final',
    'eval_voto_informativo': 'Votre vote est consultatif. La décision finale revient au Master ACES.',
    'evaluacion_titulo': 'Évaluation',
    'evaluaciones_enviadas': 'évaluations envoyées',
    'evaluadores_asignados': 'évaluateurs attribués',
    'fecha_regreso': 'Date de retour',
    'fecha_salida': 'Date de départ',
    'filtro_todas': 'Toutes',
    'gala_asistencia_confirmada': 'Présence confirmée',
    'gala_invitacion_titulo': 'Invitation au Gala',
    'gala_pendiente_desc': 'ACES activera votre invitation le moment venu.',
    'gala_pendiente_invitacion': 'Invitation en attente',
    'gala_representantes': 'Représentants',
    'gala_sin_datos': 'Aucune donnée de gala',
    'gala_sin_datos_desc': 'Aucune information sur la cérémonie pour cette année.',
    'gala_sin_representantes': 'Aucun représentant ajouté',
    'galardon': 'Distinction',
    'general_error': 'Une erreur est survenue',
    'general_reintentar': 'Réessayer',
    'generar_codigo': 'Générer un code',
    'generar_codigo_titulo': 'Nouveau code d\'accès',
    'guardando': 'Enregistrement...',
    'guardar': 'Enregistrer',
    'guardar_config': 'Enregistrer les paramètres',
    'hora': 'Heure',
    'llegada': 'Arrivée',
    'lugar': 'Lieu',
    'marcar_leidas': 'Tout marquer comme lu',
    'master_panel_desc': 'Contrôle total des candidatures, évaluations et décisions.',
    'master_recientes': 'Candidatures récentes',
    'master_saludo': 'Tableau de bord ACES',
    'master_sin_candidaturas': 'Aucune candidature pour le moment',
    'mod_documentos': 'Documents',
    'mod_pagos': 'Paiements',
    'mod_titularidad': 'Titre',
    'mod_viaje': 'Logistique',
    'nombre_documento': 'Nom du document',
    'nombre_hotel': 'Nom de l\'hôtel',
    'notif_sin_leer': 'Non lues',
    'notif_sin_notifs': 'Aucune notification',
    'nueva_candidatura': 'Nouvelle candidature',
    'nueva_propuesta': 'Nouvelle proposition',
    'num_habitaciones': 'Nombre de chambres',
    'origen': 'Origine',
    'pago_instrucciones': 'Effectuez le virement bancaire et téléversez le justificatif.',
    'pais': 'Pays',
    'perfil_apellidos': 'Nom',
    'perfil_cargo': 'Fonction',
    'perfil_idioma': 'Langue de l\'application',
    'perfil_nombre': 'Prénom',
    'perfil_notificaciones': 'Notifications',
    'perfil_pais': 'Pays',
    'perfil_telefono': 'Téléphone',
    'precio_aprox': 'Prix approximatif (€)',
    'proponer_hotel': 'Hôtel',
    'proponer_vuelo': 'Vol',
    'rechazar': 'Rejeter',
    'salida': 'Départ',
    'seleccionar': 'Sélectionner',
    'sin_candidaturas': 'Aucune candidature',
    'sin_candidaturas_desc': 'Aucune candidature ne correspond à ce filtre.',
    'sin_documentos_desc': 'Téléversez les documents requis pour votre candidature.',
    'sin_evaluaciones': 'Aucune évaluation',
    'sin_pagos_desc': 'Les paiements de votre candidature apparaîtront ici.',
    'stat_activas': 'Actives',
    'stat_decision': 'Décision en attente',
    'stat_evaluacion': 'En évaluation',
    'stat_notif': 'Non lues',
    'stat_titulos': 'Titres actifs',
    'subir_documento': 'Téléverser un document',
    'subir_nota': 'Sélectionnez le fichier depuis votre appareil',
    'tab_candidatura': 'Candidature',
    'tab_candidaturas': 'Candidatures',
    'tab_config': 'Paramètres',
    'tab_documentos': 'Documents',
    'tab_evaluaciones': 'Évaluations',
    'tab_evaluadores': 'Évaluateurs',
    'tab_notif': 'Notifications',
    'tab_pagos': 'Paiements',
    'tab_perfil': 'Profil',
    'tab_recursos': 'Ressources',
    'tab_resumen': 'Résumé',
    'tab_viaje': 'Logistique',
    'tipo_codigo': 'Type de code',
    'tit_ano_titulo': 'Année du titre',
    'tit_evidencias': 'Justificatifs téléversés',
    'tit_item_calendario': 'Calendrier sportif',
    'tit_item_congreso': 'Congrès ou conférence',
    'tit_item_imagen': 'Bon usage du titre',
    'tit_item_memoria': 'Rapport final',
    'tit_no_aplica': 'Aucune année de titre',
    'tit_no_aplica_desc': 'Ce module s\'active lorsque votre ville obtient une distinction ACES.',
    'tit_sanciones': 'Pénalités',
    'tit_sin_datos': 'Aucun titre actif',
    'tit_titulo': 'Année du titre',
    'toca_copiar': 'Touchez le code pour le copier',
    'vence': 'Échéance',
    'ver_comprobante': 'Voir le justificatif',
    'viaje_aviso_privacidad': 'L\'identité des évaluateurs est confidentielle. Vous ne verrez que les dates et la logistique.',
    'viaje_sin_propuestas': 'Aucune proposition de voyage',
    'viaje_sin_propuestas_desc': 'Proposez des options de vol, d\'hôtel et d\'agenda pour la visite.',
    'visita_evaluadores': 'Visite des évaluateurs',
    'visita_programada': 'Visite programmée',
    'visita_sin_programar': 'Visite non encore programmée',
    'visita_titulo': 'Visite d\'évaluation',
    'hotel_short': 'Hôtel',
    'nav_roles': 'Rôles',
    'roles_lbl': 'Rôles',
    'email': 'E-mail',
    'Q3_nombre': 'juil.-sept.',
    'calendario_gala': 'Gala : nov.',
    'sin_fecha_visita': 'Pas de date de visite',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Commentaire de la section',
    'eval_comentario_seccion_placeholder': 'Commentaire général sur la section (facultatif)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Erreur : {0}',
    'pdf_evaluacion': 'Évaluation en PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Rapport d’évaluation',
    'pdf_ciudad': 'Ville',
    'pdf_evaluador': 'Évaluateur',
    'pdf_fecha': 'Date',
    'pdf_total': 'Note totale',
    'pdf_secciones': 'Sections',
    'pdf_voto_final': 'Vote final',
    'pdf_comentario_voto': 'Commentaire du vote',
    'pdf_no_evaluada': 'Non évaluée',
    'pdf_generado_por': 'Généré par ACES Cities Network · {0}',
    'email_placeholder': 'nom@exemple.com',
    'ej_nombre_persona': 'Ex. : Marie Dupont',
    'ej_aeropuerto': 'Ex. : Paris (CDG)',
    'pdf_permitir_popups': 'Autorisez les fenêtres contextuelles pour exporter le PDF',
    'confirmar': 'Confirmer',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Attention',
    'confirmar_eliminar_doc': 'Supprimer ce document ? Cette action est irréversible.',
    'confirmar_eliminar_logistica': 'Supprimer ce document de logistique ?',
    'confirmar_notificar_titulo': 'Notifier la ville',
    'confirmar_retroceso_titulo': 'Confirmer le retour en arrière',
    'eliminado': 'Supprimé',
    'quitar_delegado_titulo': 'Retirer le délégué',
    'warning_quitar_adjudicada_titulo': 'Retirer l’attribution',
    'warning_retroceso_2': 'CONFIRMER ? Des données seront supprimées définitivement (dates, inscriptions à la cérémonie, etc.). Cette action est IRRÉVERSIBLE.',
    'warning_retroceso_titulo': 'Revenir au statut précédent',
    'eval_pts': 'pts',
    // Corrección de acentos — 23sep2026
    'codigo_generado': 'Code généré',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Réservation de vol',
    'viaje_tipo_reserva_hotel': 'Réservation d’hôtel',
    'reserva_generica': 'Réservation',
  },
  'de': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'Wir konnten diesen Code nicht finden. Prüfen Sie, ob er vollständig ist, zum Beispiel: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Dieser Code wurde bereits verwendet. Wenn Sie schon registriert sind, melden Sie sich an. Andernfalls fordern Sie bei ACES einen neuen Code an.',
    'codigo_expirado': 'Dieser Code ist abgelaufen. Fordern Sie bei ACES einen neuen Code an.',
    'codigo_admin': 'Dies ist ein Verwaltungscode und kann hier nicht zur Registrierung verwendet werden. Kontaktieren Sie ACES.',
    'registro_error_general': 'Die Registrierung konnte nicht abgeschlossen werden, es wurde kein Konto erstellt. Versuchen Sie es erneut; falls es wieder fehlschlägt, kontaktieren Sie ACES.',
    'email_ya_registrado_login': 'Für diese E-Mail gibt es bereits ein Konto. Tippen Sie auf „Anmelden“ und nutzen Sie „Passwort vergessen?“, falls Sie Ihr Passwort nicht mehr wissen.',
    'nueva_gala_btn': 'Gala erstellen',
    'programar_visita': 'Bewertungsbesuch planen',
    'guardar_notas': 'Notizen speichern',
    'historial_estados': 'Statusverlauf',
    'notas_privadas_hint': 'Private Notizen zu dieser Kandidatur (nur für Master sichtbar)...',
    'voto_emitido': 'Stimme abgegeben:',
    'voto_en_contra': 'Dagegen',
    'voto_a_favor': 'Dafür',
    'voto_final_desc': 'Die Kandidatur befindet sich in der Abstimmungsphase. Geben Sie Ihre Stimme ab.',
    'voto_final_titulo': 'Endabstimmung erforderlich',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Inhaberschaften — demnächst',
    'email_abierto': 'Ihr E-Mail-Client wurde geöffnet',
    'cargo_hint': 'Z.B.: Sportstadtrat',
    'password_repetir_hint': 'Passwort wiederholen',
    'password_min': 'Mindestens 6 Zeichen',
    'placeholder_apellido_ej': 'Müller',
    'placeholder_nombre_ej': 'Maria',
    'error_guardar': 'Fehler beim Speichern',
    'error_label': 'Fehler',
    'error_subir': 'Fehler beim Hochladen',
    'error_cambiar_password': 'Fehler beim Ändern des Passworts',
    'candidatura_no_encontrada': 'Kandidatur nicht gefunden',
    'puntuacion_final': 'Endpunktzahl',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Ziel',
    'origen_label': 'Abflugort',
    'notif_actividad_desc': 'Die Aktivität Ihrer Kandidaturen erscheint hier.',
    'placeholder_ej_espana': 'Z.B.: Spanien',
    'placeholder_ej_madrid': 'Z.B.: Madrid',
    'gala_lugar_hint': 'Z.B.: Kongresspalast',
    'gala_titulo_hint': 'Z.B.: ACES América Gala 2026',
    'gala_descripcion_hint': 'Veranstaltungsbeschreibung...',
    'gala_pais': 'Veranstaltungsland',
    'gala_ciudad': 'Veranstaltungsstadt',
    'gala_lugar': 'Zeremonie-Ort',
    'gala_titulo_label': 'Gala-Titel',
    'visible_ciudades': 'Für Städte sichtbar',
    'nueva_gala': 'Neue Gala',
    'sin_galas': 'Keine Galas konfiguriert',
    'gala_gestion': 'Gala-Zeremonie-Verwaltung',
    'gala_aces_titulo': 'ACES Gala',
    'codigo_copiado': 'Code kopiert',
    'error_generar_codigo': 'Fehler beim Generieren des Codes',
    'nombre_eval_email': 'Name des Gutachters (für E-Mail)',
    'invitar_evaluador': 'Gutachter einladen',
    'sin_evaluadores': 'Keine Gutachter registriert',
    'preview': 'Vorschau',
    'ver_todos': 'Alle anzeigen',
    'total_candidaturas': 'Gesamte Kandidaturen',
    'titulos_adjudicados': 'Zuerkannte Titel',
    'tamano_comite': 'Komiteegröße (Gutachter)',
    'sanciones_asistencia': 'Nichterscheinensstrafen (€)',
    'tasas_participacion': 'Teilnahmegebühren (€)',
    'config_sistema_perfil': 'System & Profil',
    'sin_candidaturas_desc2': 'Versuchen Sie die Filter zu ändern oder erstellen Sie eine neue.',
    'placeholder_pais_ej': 'Z.B.: Argentinien',
    'placeholder_ciudad_ej': 'Z.B.: Buenos Aires',
    'buscar_evaluador': 'Gutachter suchen...',
    'notas_decision_hint': 'Interne Hinweise zur Entscheidung...',
    'concepto_placeholder': 'Z.B.: Teilnahmegebühr 2026',
    'sin_jefe_asignado': 'Kein Leiter zugewiesen',
    'jefe_comision': 'Kommissionsleiter',
    'ciudad_label': 'Stadt',
    'descargar_app_store': 'Im App Store laden',
    'aforo_maximo': 'Maximale Kapazität',
    'descripcion_label': 'Beschreibung',
    'convocatoria_label': 'Ausschreibung',
    'abrir_email': 'E-Mail öffnen',
    'crear_gala': 'Gala erstellen',
    'en_evaluacion': 'In Bewertung',
    'emails_institucionales': 'Institutionelle E-Mails',
    'email_evaluador': 'E-Mail des Gutachters',
    'codigo_acceso_label': 'Zugangscode',
    'codigos_acceso': 'Zugangscodes',
    'seleccionar_galardon': 'Auszeichnung wählen...',
    'todos_galardones': 'Alle Auszeichnungen',
    'todos_estados': 'Alle Status',
    'cargando_dashboard': 'Laden...',
    'candidaturas_recientes': 'Aktuelle Kandidaturen',
    'candidaturas_activas': 'Aktive Kandidaturen',
    'alertas_sistema': 'Systemwarnungen',
    'accesos_rapidos': 'Schnellzugriff',
    'viaje_titulo': 'Reise',
    'nuevo': 'Neu',
    'estado': 'Status',
    'abrir_votacion': 'Abstimmung öffnen',
    'accion_anadir_evaluador': 'Gutachter hinzufügen',
    'accion_master': 'Master-Aktion',
    'accion_nueva_candidatura': 'Neue Bewerbung',
    'accion_ver_alertas': 'Warnungen anzeigen',
    'actividad': 'Aktivität',
    'agenda_notas': 'Interne Notizen',
    'agenda_notas_hint': 'Bsp.: Der Bewerter wird vom Bürgermeister empfangen...',
    'agenda_pdf_listo': 'PDF des Programms angehängt',
    'agenda_propuesta_enviada': 'Programmereignis gesendet',
    'agenda_subir_pdf': 'PDF des kompletten Programms hochladen (optional)',
    'agenda_tipo_evento': 'Veranstaltungstyp',
    'agenda_titulo_evento': 'Titel der Veranstaltung',
    'agenda_vacia': 'Leere Agenda',
    'alerta_decision_pendiente': 'Entscheidung ausstehend',
    'alerta_docs_pendientes': 'Ausstehende Dokumente',
    'alerta_pago_vencido': 'Überfälliger Zahlung',
    'alerta_sin_evaluadores': 'Keine Gutachter zugewiesen',
    'alertas_titulo': 'Warnungen',
    'anos': 'Jahre',
    'anterior': 'Zurück',
    'apellidos': 'Nachname',
    'aprobar': 'Genehmigen',
    'asignacion_ciudad_hint': 'Bsp.: Berlin',
    'asignacion_ciudad_salida': 'Abflugstadt für den Besuch',
    'asignacion_ciudad_salida_desc': 'Die Stadt, von der Sie zur Bewertungsreise abreisen werden.',
    'asignacion_compartir_ciudad': 'Telefon mit der Stadt teilen',
    'asignacion_compartir_ciudad_desc': 'Die Stadt kann Ihre Telefonnummer und WhatsApp sehen.',
    'asignacion_compartir_eval_desc': 'Die anderen Gutachter dieser Bewerbung können Ihren Kontakt sehen.',
    'asignacion_compartir_evaluadores': 'Mit anderen Gutachtern teilen',
    'asignacion_confirmar': 'Bestätigen und beginnen',
    'asignacion_nota': 'Hinweis für die Stadt (optional)',
    'asignacion_nota_desc': 'Diese Notiz ist für das Team der Bewerberstadt sichtbar.',
    'asignacion_nota_hint': 'Bsp.: Ich komme am Dienstagmorgen mit dem Zug an...',
    'asignacion_privacidad': 'Datenschutz und Kontakt',
    'asignacion_sub': 'Bevor Sie beginnen, konfigurieren Sie Ihre Kontaktdaten für diese Bewerbung.',
    'asignacion_titulo': 'Neue Zuweisung',
    'asignar_ciudad_titulo': 'Stadt zuweisen',
    'asignar_evaluador': 'Bewerter zuweisen',
    'auth_cargando': 'Wird angemeldet...',
    'auth_cerrar_sesion': 'Abmelden',
    'auth_email': 'E-Mail',
    'auth_entrar': 'Anmelden',
    'auth_error_credenciales': 'E-Mail oder Passwort falsch.',
    'auth_error_red': 'Keine Internetverbindung.',
    'auth_password': 'Passwort',
    'auth_subtitulo': 'Plattform für ACES-Sportkandidaturen',
    'avanzar_a': 'Weiter zu',
    'borrar': 'Löschen',
    'borrar_todas': 'Alle löschen',
    'buscar_ciudad_email': 'Stadt, E-Mail suchen...',
    'buscar_pais': 'Land suchen...',
    'buscar_placeholder': 'Stadt, Auszeichnung suchen...',
    'cambios': 'Änderungen',
    'campos_obligatorios': 'Bitte alle Pflichtfelder ausfüllen.',
    'cancelar': 'Abbrechen',
    'candidatura_asignada_ok': 'Bewerbung zugewiesen',
    'cargando_candidatura': 'Bewerbung wird geladen...',
    'cargo': 'Position',
    'cat_carta': 'Absichtserklärung',
    'cat_eventos': 'Veranstaltungen',
    'cat_galardones': 'Frühere Auszeichnungen',
    'cat_infra': 'Infrastruktur',
    'cat_otros': 'Sonstiges',
    'cat_presupuesto': 'Budget',
    'categoria': 'Kategorie',
    'cerrar': 'Schließen',
    'cerrar_votacion': 'Abstimmung schließen',
    'chat_ciudad': 'Chat mit ACES',
    'chat_ciudad_aces': 'Chat mit ACES',
    'chat_ciudad_aces_desc': 'Direkte Kommunikation mit dem ACES Europa-Team.',
    'chat_conversaciones': 'Gespräche',
    'chat_elige_conversacion': 'Wählen Sie, mit wem Sie chatten möchten',
    'chat_escribir': 'Schreibe eine Nachricht...',
    'chat_interno': 'Kommissions-Chat',
    'chat_interno_desc': 'Privater Kanal zwischen Gutachtern und ACES. Die Stadt hat keinen Zugang.',
    'chat_mis_chats': 'Meine Chats',
    'chat_sin_activos': 'Keine aktiven Chats',
    'chat_sin_activos_desc': 'Chats mit Kandidaturen werden hier angezeigt',
    'chat_sin_mensajes': 'Noch keine Nachrichten',
    'chat_adjuntar': 'Datei anhangen',
    'chat_adjunto_expira': 'Datei 7 Tage verfugbar',
    'chat_adjunto_max': 'Datei zu gross (max 10MB)',
    'chat_borrar': 'Fur alle loschen',
    'chat_buscar_conv': 'Stadt oder Auszeichnung suchen...',
    'chat_confirmar_borrar': 'Diese Nachricht fur alle loschen?',
    'chat_filtro_no_leidas': 'Ungelesen',
    'chat_filtro_todas': 'Alle',
    'chat_mensaje_borrado': 'Nachricht geloscht',
    'chat_no_leidos': 'ungelesen',
    'chat_activas': 'aktive Chats',
    'chat_recargar': 'Aktualisieren',
    'chat_responder': 'Antworten',
    'chat_sin_no_leidos': 'Alles gelesen',
    'warn_poblacion_min': 'Mindestbevolkerung erforderlich',
    'warn_poblacion_max': 'Maximale Bevolkerung erlaubt',
    'warn_actual': 'Aktuell',
    'warn_max_candidaturas': 'Maximale Bewerbungen fur diese Auszeichnung',
    'warn_actuales': 'Aktuelle',
    'warn_espera': 'Wartezeit',
    'warn_anos': 'Jahre',
    'warn_ultima': 'Letzte Vergabe',
    'warn_elegible_desde': 'Berechtigt ab',
    'warn_elegibilidad': 'Zulassigkeitswarnungen',
    'warn_override': 'Master-Override: Bewerbung trotzdem erstellen',
    'warn_override_required': 'Es gibt Warnungen. Override aktivieren um fortzufahren.',
    'tasa_auto': 'Automatische Zahlung wird erstellt fur',
    'poblacion_label': 'Bevolkerung',
    'galardon_label': 'Auszeichnung',
    'calendario_procesal': 'Verfahrenskalender (Art. 15)',
    'regla_25_titulo': '2.5-Punkte-Regel (Art. 15)',
    'regla_25_desc': 'Der Unterschied zwischen den ersten beiden betragt',
    'regla_25_info': 'Der Master kann den Zweitplatzierten auszeichnen wenn begrundet.',
    'regla_25_justificacion_hint': 'Begrunden Sie die Entscheidung, besonders bei der 2.5-Regel...',
    'resumen_puntuaciones': 'Bewerterpunkte',
    'candidatura_adjudicada': 'Bewerbung vergeben!',
    'error_campos_obligatorios': 'Stadt, Land und Auszeichnung sind erforderlich.',
    'checklist_aprobado': 'GENEHMIGT',
    'checklist_titulo': 'Dokumentationsanforderungen',
    'ciudad': 'Stadt',
    'ciudad_asignada': 'Zugewiesene Stadt',
    'ciudad_asignar': 'Zuweisen',
    'ciudad_cambiar': 'Ändern',
    'ciudad_cargo': 'Position',
    'ciudad_contacto_principal': 'Hauptkontakt',
    'ciudad_desde': 'Stadt seit',
    'ciudad_email': 'E-Mail',
    'ciudad_historico': 'Verlauf',
    'ciudad_modulos': 'Module',
    'ciudad_nombre': 'Name',
    'ciudad_recursos': 'ACES-Ressourcen',
    'ciudad_rol': 'Rolle',
    'ciudad_salida': 'Abflugstadt',
    'ciudad_salida_desc': 'Die Bewerberstadt muss wissen, von wo Sie reisen, um Ihren Flug zu buchen.',
    'ciudad_salida_hint': 'Bsp.: Berlin, München...',
    'ciudad_salida_pendiente': 'Abflugstadt ausstehend',
    'ciudad_sin_asignar': 'Keine Stadt zugewiesen',
    'ciudad_sin_candidatura': 'Keine aktive Kandidatur',
    'ciudad_sin_candidatura_desc': 'Kontaktiere ACES, um den Prozess zu starten.',
    'ciudad_telefono': 'Telefon',
    'codigo_activando': 'Wird aktiviert...',
    'codigo_activar': 'Code aktivieren',
    'codigo_error_invalido': 'Ungültiger oder bereits verwendeter Code.',
    'codigo_generado_label': 'GENERIERTER CODE',
    'codigo_invalido': 'Ungültiger oder bereits verwendeter Code.',
    'codigo_placeholder': 'ACESCN-TYP-XXXXXX',
    'codigo_subtitulo': 'Gib den von ACES bereitgestellten ACESCN-Code ein.',
    'codigo_titulo': 'Zugangscode',
    'codigo_vacio': 'Bitte geben Sie Ihren Zugangscode ein.',
    'codigo_validar': 'Code validieren',
    'codigos_disponibles': 'Verfügbar',
    'codigos_generados': 'Generierte Codes',
    'codigos_usados': 'Verwendete Codes',
    'comision_sin_otros': 'Nur Sie in der Kommission',
    'comision_sin_otros_desc': 'Es wurden noch keine anderen Gutachter für diese Bewerbung zugewiesen.',
    'comision_titulo': 'Bewertungskommission',
    'completado': 'abgeschlossen',
    'comprobante_desc': 'Laden Sie den Banküberweisungsbeleg als PDF oder Bild hoch.',
    'comprobante_subido': 'Zahlungsnachweis erfolgreich hochgeladen',
    'comprobante_titulo': 'Zahlungsbeleg',
    'config_comite': 'Ausschussgröße',
    'config_convocatorias': 'Offene Ausschreibungen',
    'config_correos_desc': 'E-Mails für offizielle Benachrichtigungen.',
    'config_correos_titulo': 'Institutionelle E-Mails',
    'config_guardada': 'Einstellungen gespeichert',
    'config_sanciones': 'Strafen für Nichtteilnahme an der Gala (€)',
    'config_sistema_titulo': 'Systemkonfiguration',
    'config_tasas': 'Teilnahmegebühren (€)',
    'confirmada': 'Bestätigt',
    'confirmando': 'Wird bestätigt...',
    'confirmar_asistencia': 'Teilnahme bestätigen',
    'contacto_principal': 'Hauptkontakt',
    'continuar': 'Weiter',
    'continuar_evaluacion': 'Bewertung fortsetzen',
    'convocatoria': 'Ausschreibung',
    'creando': 'Wird erstellt...',
    'crear_candidatura': 'Kandidatur erstellen',
    'crear_cuenta': 'Konto erstellen',
    'dashboard_accesos_rapidos': 'Schnellzugriffe',
    'dashboard_awos_sub': 'Erfasse deine sportlichen Aktivitäten und greife auf globale Statistiken zu.',
    'dashboard_awos_titulo': 'Aktives AWoS',
    'dashboard_documentos': 'Dokumente',
    'dashboard_estado': 'Status der Kandidatur',
    'dashboard_mensajes': 'Nachrichten',
    'dashboard_pagos_pendientes': 'Ausstehende Zahlungen',
    'datos_opcionales': 'Diese Felder sind optional und können in Ihrem Profil aktualisiert werden.',
    'de': 'von',
    'decision_adjudicar': 'Zuerkennen',
    'decision_advertencia': 'Diese Entscheidung ist unanfechtbar und wird dauerhaft gespeichert.',
    'decision_confirmar': 'Entscheidung bestätigen',
    'decision_nav': 'Endgültige Entscheidung',
    'decision_notas': 'Entscheidungsnotizen (erforderlich)',
    'decision_rechazar': 'Nicht zuerkennen',
    'decision_selecciona': 'Entscheidung auswählen',
    'decision_titulo': 'Endgültige Entscheidung',
    'desbloquear': 'Entsperren',
    'desde': 'seit',
    'destino': 'Zielort',
    'dia': 'Tag',
    'dias': 'Tage',
    'dias_label': 'Tage',
    'dias_visita_label': 'Besuchstage',
    'doc_subido_ok': 'Dokument erfolgreich hochgeladen',
    'docs_pendientes': 'Ausstehende Dokumente',
    'documento_pendiente': 'Dokument ausstehend',
    'duracion_visita_label': 'BESUCHSDAUER',
    'editar': 'Bearbeiten',
    'eliminar': 'Löschen',
    'eliminar_cuenta': 'Mein Konto löschen',
    'eliminar_cuenta_desc': 'Diese Aktion ist unwiderruflich. Deine Daten werden gemäß der DSGVO anonymisiert.',
    'eliminar_cuenta_password': 'Gib zur Bestätigung dein Passwort ein',
    'eliminar_cuenta_titulo': 'Konto löschen',
    'eliminar_documento': 'Dokument löschen',
    'email_ciudad_label': 'STADT-E-MAIL',
    'email_contacto': 'Kontakt-E-Mail',
    'email_enviado': 'E-Mail erfolgreich gesendet',
    'email_enviar': 'Offizielle E-Mail senden',
    'email_idioma': 'Empfängersprache',
    'email_invalido': 'Ungültige E-Mail.',
    'email_preview': 'E-Mail-Vorschau',
    'email_remitente': 'Senden von',
    'email_ya_registrado': 'Diese E-Mail ist bereits registriert.',
    'emitir_factura_titulo': 'Rechnung ausstellen',
    'emitir_nueva_factura': 'Neue Rechnung ausstellen',
    'enviada': 'Gesendet',
    'enviado_por_aces': 'Von ACES gesendet',
    'enviando': 'Wird gesendet...',
    'enviar': 'Senden',
    'enviar_evaluacion': 'Bewertung einreichen',
    'enviar_propuesta': 'Vorschlag senden',
    'eres_jefe_comision': 'Sie sind Kommissionsleiter',
    'error_generico': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    'escribiendo': 'schreibt...',
    'estado_aceptada': 'Akzeptiert',
    'estado_adjudicada': 'Vergeben',
    'estado_decision': 'Entscheidung ausstehend',
    'estado_documentacion': 'Dokumentation',
    'estado_evaluacion': 'In Bewertung',
    'estado_pipeline': 'Kandidatur-Pipeline',
    'estado_rechazada': 'Nicht vergeben',
    'estado_solicitada': 'Eingereicht',
    'estado_visita': 'Besuch geplant',
    'estado_votacion': 'In Abstimmung',
    'eval_abrev': 'Gut.',
    'eval_abrir_motor': 'Bewertungsmotor öffnen',
    'eval_anterior': 'Zurück',
    'eval_asignadas': 'Meine zugewiesenen',
    'eval_asignado_ok': 'Gutachter zugewiesen',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Bewertung wird geladen...',
    'eval_comentario_placeholder': 'Kommentiere deine Punktzahl...',
    'eval_comentario_voto': 'Kommentar zur endgültigen Stimme',
    'eval_comision_pendiente': 'Informationen zu den Gutachtern in Kürze verfügbar.',
    'eval_comision_titulo': 'Zugewiesene Gutachter',
    'eval_confirmar_desc': 'Nach dem Senden kannst du sie nicht mehr ändern, es sei denn, der Master entsperrt sie.',
    'eval_confirmar_envio': 'Bewertung senden',
    'eval_conflicto_interes': 'Interessenkonflikt: Du kommst aus demselben Land wie die Kandidatenstadt für die Hauptstadt.',
    'eval_desfavorable': 'Negativ',
    'eval_enviada_desc': 'Deine Bewertung wurde erfolgreich registriert.',
    'eval_enviada_ok': 'Bewertung erfolgreich eingereicht',
    'eval_enviada_titulo': 'Bewertung gesendet',
    'eval_enviadas': 'gesendet',
    'eval_enviar': 'Senden',
    'eval_enviar_btn': 'Einreichen',
    'eval_favorable': 'Positiv',
    'eval_habilitada': 'Bewertung aktiviert',
    'eval_ir_motor': 'Zur Bewertungs-Engine gehen',
    'eval_lista': 'Bewerter',
    'eval_mi_evaluacion': 'Meine Bewertung',
    'eval_mis_candidaturas': 'Meine Kandidaturen',
    'eval_motor_titulo': 'Bewertungs-Engine',
    'eval_no_habilitada': 'Die Bewertung wurde von ACES noch nicht freigegeben.',
    'eval_notas_comentario': 'Notizen und Kommentare',
    'eval_quitado': 'Gutachter entfernt',
    'eval_registrados': 'Registriert',
    'eval_seccion': 'Abschnitt',
    'eval_siguiente': 'Weiter',
    'eval_sin_activas': 'Keine aktiven Kandidaturen',
    'eval_sin_asignadas': 'Keine zugewiesenen Kandidaturen',
    'eval_sin_asignadas_desc': 'Der Master wird deiner Kommission Kandidaturen zuweisen.',
    'eval_sin_documentos': 'Keine Dokumente',
    'eval_sin_documentos_desc': 'Die Stadt hat noch keine Dokumente hochgeladen.',
    'eval_sin_reservas': 'Noch keine Reservierungen',
    'eval_stat_asignadas': 'Zugewiesen',
    'eval_stat_completadas': 'Abgeschlossen',
    'eval_stat_pendientes': 'Ausstehend',
    'eval_todas': 'Alle aktiven',
    'eval_todas_activas': 'Aktive Kandidaturen',
    'eval_todas_aviso': 'Schreibgeschützte Ansicht. Vollständige Details nur für deine zugewiesenen Kandidaturen.',
    'eval_total_seccion': 'Punktzahl für diesen Abschnitt',
    'eval_ver_escala': 'Punkteskala ansehen',
    'eval_voto_final': 'Endgültige Stimme',
    'eval_voto_informativo': 'Deine Stimme ist informativ. Die endgültige Entscheidung obliegt dem ACES-Master.',
    'evaluacion_titulo': 'Bewertung',
    'evaluaciones_enviadas': 'Bewertungen gesendet',
    'evaluadores_asignados': 'Bewerter zugewiesen',
    'evaluadores_asignados_label': 'ZUGEWIESENE GUTACHTER',
    'evento_almuerzo': 'Mittagessen',
    'evento_cena': 'Abendessen',
    'evento_desayuno': 'Frühstück',
    'evento_descanso': 'Pause',
    'evento_llegada': 'Ankunft',
    'evento_otro': 'Sonstiges',
    'evento_recepcion': 'Empfang',
    'evento_reunion': 'Meeting',
    'evento_rueda_prensa': 'Pressekonferenz',
    'evento_salida': 'Abreise',
    'evento_traslado': 'Transfer',
    'evento_visita': 'Besuch',
    'factura_creada_ok': 'Rechnung registriert. Laden Sie jetzt das PDF hoch.',
    'factura_detalle': 'Detail / Erweitertes Konzept',
    'factura_detalle_hint': 'Detaillierte Beschreibung der Leistungen, Zahlungsbedingungen, Bankdaten...',
    'factura_subida_ok': 'Rechnung erfolgreich hochgeladen',
    'facturas_aces': 'Von ACES',
    'fecha_llegada_label': 'ANKUNFTSDATUM',
    'fecha_regreso': 'Rückreisedatum',
    'fecha_salida': 'Abreisedatum',
    'fecha_vencimiento_label': 'FÄLLIGKEITSDATUM',
    'filtro_estado': 'Status',
    'filtro_tipo': 'Typ',
    'filtro_todas': 'Alle',
    'filtro_todos': 'Alle',
    'gala_asistencia_confirmada': 'Teilnahme bestätigt',
    'gala_invitacion_titulo': 'Einladung zur Gala',
    'gala_pendiente_desc': 'ACES wird deine Einladung zur gegebenen Zeit aktivieren.',
    'gala_pendiente_invitacion': 'Einladung ausstehend',
    'gala_representantes': 'Vertreter',
    'gala_sin_datos': 'Keine Gala-Daten',
    'gala_sin_datos_desc': 'Es gibt keine Informationen zur Zeremonie für dieses Jahr.',
    'gala_sin_representantes': 'Keine Vertreter hinzugefügt',
    'galardon': 'Auszeichnung',
    'general_error': 'Ein Fehler ist aufgetreten',
    'general_reintentar': 'Erneut versuchen',
    'generar_codigo': 'Code generieren',
    'generar_codigo_titulo': 'Neuer Zugangscode',
    'gestionar_comision': 'Kommission verwalten',
    'guardado': 'Gespeichert',
    'guardando': 'Wird gespeichert...',
    'guardar': 'Speichern',
    'guardar_ciudad_salida': 'Abflugstadt speichern',
    'guardar_config': 'Einstellungen speichern',
    'guardar_y_siguiente': 'Speichern und weiter',
    'historico_titulo': 'Frühere Kandidaturen',
    'hora': 'Uhrzeit',
    'hora_fin_opc': 'Endzeit (optional)',
    'hora_inicio': 'Startzeit',
    'idioma_titulo': 'Oberflächensprache',
    'iniciar_evaluacion': 'Bewertung starten',
    'invitacion_enviada': 'Einladung gesendet',
    'invitar_ciudad_titulo': 'Stadt einladen',
    'invitar_codigo_generado': 'Generierter Code',
    'invitar_copiar': 'Kopieren',
    'invitar_cuerpo_eval': 'Wir laden Sie ein, ACES Cities Network als Gutachter beizutreten.\\n\\nIhr Zugangscode lautet:',
    'invitar_email': 'Per E-Mail senden',
    'invitar_evaluador_sub': 'Generiere einen Code und teile ihn per WhatsApp oder E-Mail',
    'invitar_evaluador_titulo': 'Bewerter einladen',
    'invitar_generar_codigo': 'Zugangscode generieren',
    'invitar_nombre': 'Name des Bewerters',
    'invitar_pie': 'Laden Sie die App herunter, registrieren Sie sich und geben Sie Ihren Code ein.\\n\\n— ACES',
    'invitar_saludo': 'Sehr geehrte/r',
    'invitar_whatsapp': 'Per WhatsApp senden',
    'jefe_comision_ninguno': 'Kein Leiter zugewiesen',
    'jefe_comision_sin_eval': 'Weisen Sie zuerst Gutachter zu, um einen Leiter zu bestimmen.',
    'jefe_comision_titulo': 'Kommissionsleiter',
    'jefe_designado_ok': 'Kommissionsleiter ernannt',
    'jefe_eliminado_ok': 'Kommissionsleiter entfernt',
    'llegada': 'Ankunft',
    'llegada_label': 'Ankunft',
    'login_crear_cuenta': 'Erstes Mal? Konto erstellen →',
    'login_olvide_contrasena': 'Passwort vergessen?',
    'login_proximamente': 'Demnächst',
    'login_recuperar_desc': 'Geben Sie Ihre E-Mail ein und wir senden einen Link zum Zurücksetzen.',
    'login_recuperar_titulo': 'Zugang wiederherstellen',
    'login_requiere_codigo': 'Der Zugang zu Cities Network erfordert einen ACES-Einladungscode.',
    'login_restablecer': 'Passwort zurücksetzen',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Ort',
    'marcar_leidas': 'Alle als gelesen markieren',
    'master_label': 'ACES MASTER',
    'master_panel_desc': 'Volle Kontrolle über Kandidaturen, Bewertungen und Entscheidungen.',
    'master_recientes': 'Aktuelle Kandidaturen',
    'master_saludo': 'ACES-Panel',
    'master_sin_candidaturas': 'Noch keine Kandidaturen',
    'mi_evaluacion': 'Meine Bewertung',
    'mis_pagos': 'Meine Zahlungen',
    'mod_chat': 'ACES-Chat',
    'mod_documentos': 'Dokumente',
    'mod_facturas_pagos': 'Rechnungen und Zahlungen',
    'mod_gala': 'Gala',
    'mod_pagos': 'Zahlungen',
    'mod_titularidad': 'Titelträgerschaft',
    'mod_viaje': 'Logistik',
    'modo_evaluador': 'Bewerter',
    'modo_master': 'Master',
    'motor_evaluacion': 'Bewertungsmotor',
    'no_configurado': 'Nicht konfiguriert — Profil bearbeiten',
    'nombre': 'Vorname',
    'nombre_documento': 'Dokumentenname',
    'nombre_hotel': 'Hotelname',
    'notas_hint': 'Bsp.: Landung in T4, empfohlenes Hotel...',
    'notas_internas_label': 'INTERNE NOTIZEN (optional)',
    'notif_candidatura_actualizada': 'Bewerbung aktualisiert',
    'notif_candidatura_desasignada': 'Bewerbung nicht zugewiesen',
    'notif_documento_revisado': 'Dokument geprüft',
    'notif_estado_actualizado': 'Status aktualisiert',
    'notif_evaluacion_completada': 'Bewertung abgeschlossen',
    'notif_limpiar_desc': 'Alle Benachrichtigungen werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    'notif_limpiar_todas': 'Alle löschen',
    'notif_marcar_leida': 'Als gelesen markieren',
    'notif_nueva_asignacion': 'Neue Bewerbung zugewiesen',
    'notif_pago_vencido': 'Zahlung bald fällig',
    'notif_sin_leer': 'Ungelesen',
    'notif_sin_notifs': 'Keine Benachrichtigungen',
    'notif_visita_programada': 'Bewertungsbesuch geplant',
    'notificar_ciudad': 'Stadt benachrichtigen',
    'nueva_candidatura': 'Neue Kandidatur',
    'nueva_propuesta': 'Neuer Vorschlag',
    'num_habitaciones': 'Anzahl der Zimmer',
    'origen': 'Abflugort',
    'pago_enviar_recordatorio': 'E-Mail öffnen',
    'pago_factura': 'Rechnung',
    'pago_instrucciones': 'Überweise den Betrag und lade den Beleg hoch.',
    'pago_recibido': 'Erhalten',
    'pago_recordatorio': 'Erinnerung',
    'pago_recordatorio_desc': 'Ihr E-Mail-Client öffnet sich mit der Nachricht.',
    'pago_recordatorio_titulo': 'Zahlungserinnerung senden',
    'pagos_ciudad': 'Meine Zahlungen',
    'pagos_pendientes': 'Ausstehende Zahlungen',
    'pais': 'Land',
    'pais_buscar': 'Land suchen...',
    'pais_seleccionado': 'Ausgewähltes Land',
    'pais_seleccionar': 'Land auswählen',
    'paso_datos': 'Rechnungsdaten',
    'paso_subir_pdf': 'Rechnungs-PDF hochladen',
    'password_actual': 'Aktuelles Passwort',
    'password_cambiada': 'Passwort erfolgreich geändert',
    'password_cambiar': 'Passwort ändern',
    'password_corta': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
    'password_nueva': 'Neues Passwort',
    'password_repetir': 'Passwort wiederholen',
    'passwords_no_coinciden': 'Passwörter stimmen nicht überein.',
    'error_red': 'Netzwerkfehler. Überprüfen Sie Ihre Internetverbindung.',
    'error_demasiados_intentos': 'Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Bewerbungsschreiben eingegangen',
    'hito_aprobada': 'Bewerbung genehmigt',
    'hito_reglamento_enviado': 'Regelwerk zur Unterschrift gesendet',
    'hito_reglamento_firmado': 'Unterschriebenes Regelwerk eingegangen',
    'hito_datos_factura': 'Rechnungsdaten eingegangen',
    'hito_pago_confirmado': 'Zahlung bestätigt',
    'hito_fechas_visita': 'Besuchstermine vorgeschlagen',
    'hito_comision_creada': 'Evaluierungskommission erstellt',
    'hito_viajes_cerrados': 'Reisen abgeschlossen',
    'hito_agenda_enviada': 'Agenda gesendet',
    'hito_bid_file': 'BID File eingegangen',
    'doc_tipo_carta_solicitud': 'Bewerbungsschreiben',
    'doc_tipo_agenda_visita': 'Besuchsagenda',
    // Logistica simplificada
    'mod_logistica': 'Logistik',
    'agenda_vacia_ciudad': 'Noch keine Agenda hochgeladen. Laden Sie das PDF hoch.',
    'agenda_aviso_master': 'Die Agenda ist sichtbar. Laden Sie das PDF hoch.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES wird die Besuchsagenda ver\u00f6ffentlichen, wenn sie verf\u00fcgbar ist.',
    'eval_reservas_desc': 'Ihre best\u00e4tigten Flug- und Hotelreservierungen erscheinen hier.',
    'eval_sin_reservas_desc': 'ACES oder die Stadt laden Ihre Reisereservierungen hoch, wenn sie best\u00e4tigt sind.',
    'perfil_actualizado': 'Profil aktualisiert',
    'perfil_apellidos': 'Nachname',
    'perfil_cambiar_foto': 'Profilbild',
    'perfil_cargo': 'Position',
    'perfil_ciudad': 'Stadt',
    'perfil_compartir_ciudad': 'Telefon mit Städten teilen',
    'perfil_compartir_ciudad_desc': 'Die Beweberstädte können Ihre Kontaktnummer sehen.',
    'perfil_compartir_eval_desc': 'Die Gutachter Ihrer Kommission können Ihren Kontakt sehen.',
    'perfil_compartir_evaluadores': 'Mit anderen Gutachtern teilen',
    'perfil_contacto': 'Kontakt',
    'perfil_cuenta': 'Konto',
    'perfil_datos': 'Persönliche Daten',
    'perfil_datos_evaluador': 'Kommissionsdaten',
    'perfil_datos_personales': 'Persönliche Daten',
    'perfil_elegir_foto': 'Foto auswählen',
    'perfil_eval_config': 'Gutachter-Einstellungen',
    'perfil_evaluador': 'Einstellungen Gutachter',
    'perfil_fecha_nac': 'Geburtsdatum',
    'perfil_foto_actualizada': 'Foto erfolgreich aktualisiert',
    'perfil_guardado': 'Profil erfolgreich gespeichert',
    'perfil_guardar': 'Profil speichern',
    'perfil_idioma': 'App-Sprache',
    'perfil_nombre': 'Vorname',
    'perfil_notificaciones': 'Benachrichtigungen',
    'perfil_pais': 'Land',
    'perfil_provincia': 'Provinz',
    'perfil_talla': 'Polo-Größe (Kommission)',
    'perfil_telefono': 'Telefon',
    'perfil_titulo': 'Mein Profil',
    'perfil_ubicacion': 'Standort',
    'pipeline_aceptada_desc': 'Bewerbung angenommen. Bereiten Sie die erforderliche Dokumentation vor.',
    'pipeline_adjudicada_desc': 'Herzlichen Glückwunsch! Ihrer Stadt wurde der ACES-Titel verliehen.',
    'pipeline_decision_desc': 'Die endgültige Entscheidung wird von ACES vorbereitet.',
    'pipeline_documentacion_desc': 'Wir überprüfen Ihre Unterlagen.',
    'pipeline_evaluacion_desc': 'Der Bewertungsausschuss analysiert Ihre Bewerbung.',
    'pipeline_rechazada_desc': 'Ihre Bewerbung wurde in dieser Ausschreibung nicht ausgewählt.',
    'pipeline_solicitada_desc': 'Ihre Bewerbung wurde erhalten und wird geprüft.',
    'pipeline_visita_desc': 'Der Evaluationsbesuch in Ihrer Stadt wird organisiert.',
    'pipeline_votacion_desc': 'Der Ausschuss berät über Ihre Bewerbung.',
    'precio_aprox': 'Ungefährer Preis (€)',
    'precio_estimado': 'Geschätzter Preis (€)',
    'preview_email_label': 'E-MAIL-VORSCHAU',
    'programar_visita_titulo': 'Besuch planen',
    'proponer_agenda': 'Programm',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Flug',
    'provincia': 'Provinz / Bundesland',
    'provincia_seleccionar': 'Provinz / Region auswählen',
    'rechazar': 'Ablehnen',
    'recomendaciones_titulo': 'Empfehlungen',
    'recordatorio_asunto': 'Zahlungserinnerung — {ciudad}',
    'recordatorio_cuerpo': 'Liebes {ciudad}-Team,\\n\\nwir erinnern Sie an die ausstehende Zahlung für: {concepto}.\\n\\nBitte überweisen Sie so bald wie möglich.\\n\\nMit freundlichen Grüßen,\\nACES',
    'reg_ciudad': 'Stadt / Gemeinde *',
    'reg_creando': 'Konto wird erstellt...',
    'reg_crear_cuenta': 'Konto erstellen',
    'reg_pais': 'Land *',
    'reg_provincia': 'Provinz / Region',
    'reg_resumen_titulo': 'Zusammenfassung deines Kontos',
    'reg_telefono': 'Kontakttelefon *',
    'reg_tipo': 'Zugangsart',
    'reg_ubicacion_sub': 'Informationen zu deiner Organisation',
    'reg_ubicacion_titulo': 'Dein Standort',
    'registro_cancelar_salir': 'Abbrechen und beenden',
    'registro_codigo_label': 'ACES-ZUGANGSCODE',
    'registro_contrasena_label': 'PASSWORT',
    'registro_crear_cuenta': 'Erstellen Sie Ihr Konto',
    'registro_datos_personales': 'Persönliche Daten',
    'registro_elige_rol': 'Mit welcher Rolle greifen Sie auf Cities Network zu?',
    'registro_email_label': 'E-MAIL',
    'registro_paso_1': 'Schritt 1 von 3',
    'registro_paso_2': 'Schritt 2 von 3',
    'registro_paso_2_desc': 'Diese Informationen werden für die Logistik der Bewertungsbesuche verwendet.',
    'registro_paso_3': 'Schritt 3 von 3',
    'registro_siguiente': 'Weiter →',
    'registro_verifica_desc': 'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Öffnen Sie sie und klicken Sie auf den Link.',
    'registro_verifica_titulo': 'E-Mail bestätigen',
    'rol_ciudad': 'Stadt',
    'rol_evaluador': 'Gutachter',
    'rol_master': 'ACES Master',
    'salida': 'Abreise',
    'salida_label': 'Abfahrt',
    'saludo_buenas_noches': 'Guten Abend,',
    'saludo_buenas_tardes': 'Guten Tag,',
    'saludo_buenos_dias': 'Guten Morgen,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Abschnitt',
    'seleccionar': 'Auswählen',
    'seleccionar_pais': 'Land auswählen',
    'seleccionar_provincia': 'Provinz auswählen',
    'sin_agenda': 'Kein Terminplan',
    'sin_agenda_desc': 'Die Stadt hat noch keinen Besuchsplan vorgeschlagen.',
    'sin_candidaturas': 'Keine Kandidaturen',
    'sin_candidaturas_desc': 'Es gibt keine Kandidaturen mit diesem Filter.',
    'sin_ciudad_asignada': 'Keine Stadt zugewiesen',
    'sin_codigos_disponibles': 'Keine Codes verfügbar',
    'sin_documentos': 'Keine Dokumente',
    'sin_documentos_desc': 'Lade die erforderlichen Dokumente für deine Kandidatur hoch.',
    'sin_evaluaciones': 'Keine Bewertungen',
    'sin_evaluadores_desc': 'Registriere Bewerter mit einem Code ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Keine Bewerter registriert',
    'sin_facturas_aces': 'Keine Rechnungen',
    'sin_facturas_aces_desc': 'Von ACES gesendete Rechnungen erscheinen hier.',
    'sin_notificaciones': 'Keine Benachrichtigungen',
    'sin_notificaciones_desc': 'Aktivitäten Ihrer Bewerbungen erscheinen hier.',
    'sin_pagos': 'Keine Zahlungen',
    'sin_pagos_desc': 'Die Zahlungen für deine Kandidatur werden hier angezeigt.',
    'stat_activas': 'Aktiv',
    'stat_decision': 'Entscheidung ausstehend',
    'stat_dias_visita': 'Tage bis zum Besuch',
    'stat_docs_pendientes': 'Ausstehende Dokumente',
    'stat_evaluacion': 'In Bewertung',
    'stat_mensajes_nuevos': 'Neue Nachrichten',
    'stat_notif': 'Ungelesen',
    'stat_pagos_pendientes': 'Ausstehende Zahlungen',
    'stat_sin_visita': 'Kein Besuch geplant',
    'stat_titulos': 'Aktive Titel',
    'stat_total': 'Gesamt',
    'subir_comprobante': 'Nachweis hochladen',
    'subir_documento': 'Dokument hochladen',
    'subir_factura': 'Rechnung hochladen',
    'subir_factura_desc': 'Laden Sie die Rechnung hoch. Die Stadt kann sie von ihrem Panel herunterladen.',
    'subir_factura_titulo': 'Rechnung als PDF hochladen',
    'subir_nota': 'Wähle die Datei von deinem Gerät aus',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Kandidatur',
    'tab_candidaturas': 'Kandidaturen',
    'tab_chat': 'Chat',
    'tab_config': 'Einstellungen',
    'tab_documentos': 'Dokumente',
    'tab_evaluaciones': 'Bewertungen',
    'tab_evaluadores': 'Bewerter',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Startseite',
    'tab_notif': 'Benachrichtigungen',
    'tab_pagos': 'Zahlungen',
    'tab_perfil': 'Profil',
    'tab_recursos': 'Ressourcen',
    'tab_resumen': 'Zusammenfassung',
    'tab_viaje': 'Logistik',
    'talla_polo': 'Polohemd-Größe',
    'telefono': 'Telefon',
    'template_no_disponible': 'Die Bewertungsvorlage ist noch nicht verfügbar.',
    'tipo_codigo': 'Codetyp',
    'tit_ano_titulo': 'Jahr der Titelträgerschaft',
    'tit_evidencias': 'Hochgeladene Nachweise',
    'tit_item_calendario': 'Sportkalender',
    'tit_item_congreso': 'Kongress oder Konferenz',
    'tit_item_imagen': 'Korrekte Verwendung des Titels',
    'tit_item_memoria': 'Abschlussbericht',
    'tit_no_aplica': 'Kein Jahr der Titelträgerschaft',
    'tit_no_aplica_desc': 'Dieses Modul wird aktiviert, wenn deine Stadt eine ACES-Auszeichnung gewinnt.',
    'tit_sanciones': 'Strafen',
    'tit_sin_datos': 'Keine aktiven Titelträgerschaften',
    'tit_titulo': 'Jahr der Titelträgerschaft',
    'toca_abrir_documento': 'Tippen zum Öffnen des Dokuments',
    'toca_copiar': 'Zum Kopieren auf den Code tippen',
    'toca_para_abrir': 'Tippen zum Öffnen',
    'toca_para_copiar': 'Tippen zum Kopieren',
    'tomar_decision': 'Endgültige Entscheidung',
    'tu_ciudad_salida': 'Ihre Abflugstadt',
    'upload_error': 'Hochladefehler',
    'upload_exito': 'Erfolgreich hochgeladen!',
    'upload_formatos': 'PDF, JPG oder PNG · max. 20 MB',
    'upload_no_cierres': 'App nicht schließen',
    'upload_reintentar': 'Erneut versuchen',
    'upload_subiendo': 'Datei wird hochgeladen...',
    'vence': 'Läuft ab',
    'ver_comprobante': 'Beleg ansehen',
    'ver_detalle': 'Details anzeigen',
    'ver_documento_adjunto': 'Angehängtes Dokument ansehen',
    'ver_factura': 'Rechnung anzeigen',
    'verifica_desc': 'Wir haben eine Bestätigungs-E-Mail gesendet. Überprüfen Sie Ihren Posteingang.',
    'verifica_reenviar': 'Bestätigungs-E-Mail erneut senden',
    'viaje_aviso_privacidad': 'Die Identität der Bewerter ist vertraulich. Du siehst nur Daten und Logistik.',
    'viaje_ciudad_salida': 'Ihre Abflugstadt für Flüge',
    'viaje_proponer_vuelo': 'Flug vorschlagen',
    'viaje_propuesta_enviada': 'Vorschlag erfolgreich gesendet',
    'viaje_sin_propuestas': 'Keine Reisevorschläge',
    'viaje_sin_propuestas_desc': 'Schlage Flug-, Hotel- und Programmoptionen für den Besuch vor.',
    'visita_evaluadores': 'Besuch der Bewerter',
    'visita_programada': 'Geplanter Besuch',
    'visita_sin_programar': 'Besuch noch nicht geplant',
    'visita_titulo': 'Bewertungsbesuch',
    'volver': 'Zurück',
    'votacion_abierta': 'Abstimmung offen',
    'votacion_cerrada': 'Abstimmung geschlossen',
    'walkthrough_ver_guia': 'Startanleitung ansehen',
    'whatsapp': 'WhatsApp (mit Vorwahl)',
    'ya_tengo_cuenta': 'Haben Sie bereits ein Konto?',
    'tab_titularidades': 'Inhaberschaften',
    'acciones_rapidas': 'Schnellaktionen',
    'evaluadores_titulo': 'Evaluatoren',
    'evaluadores_registrados': 'Registrierte Evaluatoren',
    'codigos_disponibles_label': 'Verfügbare Codes',
    'evaluadores_seccion': 'Evaluatoren',
    'codigos_acceso_titulo': 'Zugangscodes',
    'config_pais': 'Land',
    'config_telefono': 'Telefon',
    'config_correos_inst': 'Institutionelle E-Mails',
    'config_capital': 'Hauptstadt',
    'config_city': 'Stadt',
    'config_town': 'Gemeinde',
    'evaluacion_habilitada': 'Bewertung aktiviert',
    'evaluaciones_titulo_card': 'Bewertungen',
    'decision_final_titulo': 'Endentscheidung',
    'gestionar_comision_titulo': 'Ausschuss verwalten',
    'programar_visita_modal': 'Bewertungsbesuch planen',
    'fecha_llegada': 'Ankunftsdatum',
    'req_documentacion': 'Dokumentationsanforderungen',
    'todo_leido': 'Alles gelesen',
    'confirmar_borrar_notifs': 'Alle Benachrichtigungen löschen?',
    'gala_creada_ok': 'Gala erfolgreich erstellt',
    'gala_error_crear': 'Fehler beim Erstellen der Gala',
    'gala_activada': 'Gala für Städte aktiviert',
    'gala_desactivada': 'Gala deaktiviert',
    'titularidades_titulo': 'Inhaberschaften',
    'titularidades_desc': 'Städte mit aktivem ACES-Titel und Verpflichtungsverfolgung',
    'obligaciones_titulo': 'Pflichten des Titelträgers',
    'obligacion_imagen': 'ACES-Bildregeln einhalten',
    'obligacion_calendario': 'Jährlichen Sportkalender erstellen',
    'obligacion_congreso': 'Internationalen Kongress oder Wettbewerb organisieren',
    'obligacion_memoria': 'Jahresbericht und Schlussfolgerungen einreichen',
    'obligacion_awos': 'Aktiv an AWoS/EWoS teilnehmen',
    'cumplidas': 'erfüllt',
    'viaje_confirmar': 'Vorschlag bestätigen',
    'viaje_rechazar': 'Vorschlag ablehnen',
    'viaje_confirmado': 'Vorschlag bestätigt',
    'viaje_rechazado': 'Vorschlag abgelehnt',
    'nota_respuesta': 'Antwortnotiz (optional)',
    'voto_favor_confirm': 'Zustimmung bestätigen?',
    'voto_contra_confirm': 'Ablehnung bestätigen?',
    'historial_sin_cambios': 'Keine Statusänderungen aufgezeichnet',
    'candidatura_buscar': 'Stadt, Auszeichnung suchen...',
    'candidatura_ciudad_ph': 'Z.B. Buenos Aires',
    'candidatura_pais_ph': 'Z.B. Argentinien',
    'candidatura_email_ph': 'stadt@email.com',
    'dias_visita': 'Besuchstage',
    'propuestas_viaje': 'Reisevorschläge',
    'sin_propuestas_viaje': 'Keine Reisevorschläge',
    'sin_propuestas_desc': 'Die Evaluatoren haben noch keinen Reiseplan vorgeschlagen.',
    'sin_evaluaciones_desc': 'Evaluatoren zuweisen und Bewertung aktivieren.',
    'seleccionar_pdf': 'PDF auswählen',
    'rechazar_candidatura': 'Bewerbung ablehnen',
    'motivo_rechazo': 'Ablehnungsgrund (erforderlich)',
    'tit_sin_datos_desc': 'Zugewiesene Städte werden hier automatisch angezeigt.',
    'marcado_cumplido': 'Als erfüllt markiert',
    'desmarcado': 'Abgehakt',
    'finalizada': 'Abgeschlossen',
    'finalizadas': 'Abgeschlossen',
    'notas_label': 'Notizen',
    'sin_leer': 'ungelesen',
    'confirmar_cerrar_sesion': 'Abmelden?',
    'email_aces_europa': 'ACES Europa E-Mail',
    'email_aces_america': 'ACES Amerika E-Mail',
    'gala_fecha_evento': 'Veranstaltungsdatum',
    'gala_primera_desc': 'Erstellen Sie die erste Gala, um die Zeremonien zu verwalten.',
    'evaluadores_gestion': 'Verwaltung des ACES-Bewertungsausschusses',
    'adjudicar': 'Vergeben',
    'adjudicada_ok': 'Bewerbung vergeben!',
    'candidatura_rechazada': 'Bewerbung abgelehnt',
    'error_decision': 'Fehler beim Speichern der Entscheidung',
    'evaluador_asignado': 'Evaluator zugewiesen',
    'evaluador_quitado': 'Evaluator entfernt',
    'jefe_designado': 'Ausschussleiter bestimmt',
    'jefe_eliminado': 'Ausschussleiter entfernt',
    'notas_guardadas': 'Notizen gespeichert',
    'notas_visita_hint': 'Z.B.: Empfohlenes Hotel, Flughafenanweisungen...',
    'visita_ok': 'Besuch erfolgreich geplant',
    'error_visita': 'Fehler beim Planen des Besuchs',
    'evaluacion_hab_ok': 'Bewertung aktiviert',
    'evaluacion_deshab_ok': 'Bewertung deaktiviert',
    'programar': 'Planen',
    'confirmar_decision': 'Entscheidung bestätigen',
    'cambiar_modo': 'Modus wechseln',
    'de_preposicion': 'von',
    'notas_decision_label': 'Entscheidungsnotizen (optional)',
    'generar': 'Generieren',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File erhalten',
    'documentos_firmados': 'Unterzeichnete Dokumente',
    'pago_confirmado': 'Zahlung bestätigt',
    'subiendo_label': 'Hochladen...',
    'pagado_label': 'Bezahlt',
    'factura_label': 'Rechnung',
    'marcar_factura': 'Rechnung als ausgestellt markieren',
    'desmarcar_factura': 'Rechnung abwählen',
    'marcar_pago': 'Zahlung als erhalten markieren',
    'desmarcar_pago': 'Zahlung abwählen',
    'evaluacion_enviada': 'Eingereicht',
    'disponible_label': 'Verfügbar',
    'ver_codigos_btn': 'Codes anzeigen',
    'invitar_eval_btn': 'Evaluator einladen',
    'generar_codigo_btn': 'Neuen Code generieren',
    'idioma_destinatario': 'Sprache des Empfängers',
    'candidaturas_count': 'Bewerbungen',
    'sin_alertas_ok': 'Alles in Ordnung. Keine ausstehenden Warnungen.',
    'sin_galas_configuradas': 'Keine Galas konfiguriert',
    'gala_activada_ciudades': 'Gala für Städte aktiviert',
    'ver_alertas_label': 'Warnungen anzeigen',
    'modo_evaluador_activo': 'Evaluatormodus aktiv',
    'modo_master_activo': 'Master ACES Ansicht',
    'cambiar_a_eval': 'Evaluatormodus',
    'cambiar_a_master': 'Zuruck zu Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Satzung',
    'doc_tipo_comprobante': 'Zahlungsnachweis',
    'doc_tipo_contrato': 'Vertrag',
    'doc_tipo_memoria': 'Bericht',
    'doc_tipo_pres': 'Präsentation',
    'doc_tipo_otro': 'Andere',
    'selecciona_tipo_doc': 'Welcher Dokumenttyp?',
    'todos_label': 'Alle',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Veranstaltung',
    'mis_propuestas': 'Meine Vorschläge',
    'propuestas_label': 'Vorschläge',
    'ciudad_hotel': 'Stadt',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/Nacht',
    'hotel_notas_hint': 'Z.B.: Doppelzimmer, Frühstück inbegriffen...',
    'vuelo_notas_hint': 'Z.B.: Direktflug, Zwischenstopp in Madrid...',
    'fecha_label': 'Datum',
    'hora_label': 'Uhrzeit',
    'lugar_label': 'Ort',
    'tipo_reunion': 'Treffen',
    'tipo_visita_instalacion': 'Anlagebesichtigung',
    'tipo_acto': 'Offizieller Akt',
    'tipo_almuerzo': 'Mittagessen / Abendessen',
    'tipo_transporte': 'Transport',
    'tipo_otro': 'Andere',
    'galardones_titulo': 'Auszeichnungen',
    'reglamentos_titulo': 'Regelwerke',
    'sin_candidatura_titulo': 'Keine Bewerbung zugewiesen',
    'sin_candidatura_desc': 'Ihr Konto hat noch keine verknüpfte Bewerbung.',
    'bienvenida_ciudad_saludo': 'Hallo, {nombre}',
    'bienvenida_ciudad_titulo': 'Dein Konto ist aktiv',
    'bienvenida_ciudad_desc': 'Wir bereiten deine Kandidatur vor. Sobald das ACES-Team dir eine zuweist, erscheint sie hier mit vollständiger Nachverfolgung.',
    'bienvenida_ciudad_chip_activa': 'Konto aktiv',
    'bienvenida_ciudad_chip_espera': 'Warten auf Zuweisung',
    'bienvenida_ciudad_contacto': 'Fragen? Kontaktiere ACES',
    'chat_ciudad_desc': 'Direkte Kommunikation mit dem ACES-Team.',
    'mensajes_label': 'Nachrichten',
    'motor_seccion_de': 'von',
    'gala_confirmar_desc': 'Geben Sie an, ob Ihre Stadt an der Galaveranstaltung teilnimmt.',
    'eval_completadas': 'Abgeschlossen',
    'secciones_completadas': 'Abschnitte abgeschlossen',
    'evaluaciones_enviadas_abrev': 'Bewertungen eingereicht',
    'awos_activa_desc': 'Verfolgen Sie Ihre körperliche Aktivität und greifen Sie auf ACES-Veranstaltungen zu',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Ihre Reisedaten sind nur für ACES sichtbar.',
    'eval_docs_solo_lectura': 'Sie können die von der Stadt eingereichten Dokumente einsehen.',
    'conflicto_titulo': 'Interessenkonflikt-Erklärung',
    'conflicto_desc': 'Bestätigen Sie vor der Bewertung, dass kein Interessenkonflikt besteht.',
    'conflicto_sin_conflicto': 'Kein Konflikt — fortfahren',
    'conflicto_con_conflicto': 'Ich habe einen Konflikt',
    'conflicto_aviso': 'Bitte benachrichtigen Sie ACES sofort.',
    'sin_fecha': 'Kein Datum',
    'subir_reserva_hint': 'Laden Sie die bestaettigte Buchungs-PDF hoch.',
    'subir_reserva_hint_eval': 'Laden Sie Ihre Buchungs-PDF hoch.',
    'login_sin_cuenta': 'Kein Konto?',
    'agenda_oficial_titulo': 'Offizielle Besuchsagenda',
    'agenda_anadir_evento': 'Veranstaltung hinzufugen',
    'agenda_editar_evento': 'Veranstaltung bearbeiten',
    'agenda_oficial_aviso': 'Diese Agenda ist fur Evaluatoren sichtbar.',
    'agenda_oficial_vacia': 'Noch keine Veranstaltungen veroffentlicht.',
    'publicar_evento': 'Veranstaltung veroffentlichen',
    'evento_publicado': 'Veranstaltung veroffentlicht',
    'evento_guardado': 'Veranstaltung aktualisiert',
    'evento_eliminado': 'Veranstaltung geloscht',
    'confirmar_eliminar': 'Diese Veranstaltung loschen?',
    'guardar_cambios': 'Anderungen speichern',
    'pipeline_titulo': 'Bewerbungs-Pipeline',
    'revenue_titulo': 'Einnahmen',
    'revenue_total': 'Gesamt abgerechnet',
    'cobrado': 'Eingezogen',
    'visitas_proximas': 'Bevorstehende Besuche',
    'paises_titulo': 'Nach Land',
    'awos_banner_desc': 'Erfassen Sie Ihre koerperliche Aktivitaet und greifen Sie auf ACES-Events zu',
    'fecha_limite_confirmar': 'Bestatigungsfrist',
    'info_parlamento': 'Europaeisches Parlament Info',
    'info_venue': 'Veranstaltungsort',
    'norma_hotel': 'Hotelregeln',
    'norma_vuelo': 'Flugregeln',
    'programa_dia': 'Tagesprogramm',
    'sin_programa': 'Kein Programm',
    'actividad_placeholder': 'Aktivitaet...',
    'anadir': 'Hinzufuegen',
    'representantes_label': 'Vertreter',
    'confirmados_label': 'Bestaetigt',
    'fecha_limite': 'Frist',
    'deadline_pasada': 'Frist abgelaufen',
    'restantes': 'verbleibend',
    'anadir_representante': 'Vertreter hinzufuegen',
    'sin_representantes': 'Keine Vertreter',
    'representante_anadido': 'Vertreter hinzugefuegt',
    'representante_eliminado': 'Vertreter entfernt',
    'programa_actualizado': 'Programm aktualisiert',
    'confirmado': 'BESTAETIGT',
    'nombre_label': 'Vollstaendiger Name',
    'cargo_label': 'Position',
    'telefono_label': 'Telefon',
    'logistica_evaluadores': 'Evaluator-Logistik',
    'vuelo_short': 'Flug',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Pflichtdokumente',
    'evidencia_subida': 'Nachweis hochgeladen',
    'sancion_anadida': 'Sanktion registriert',
    'memoria_subida': 'Abschlussbericht hochgeladen',
    'nueva_sancion': 'Neue Sanktion',
    'motivo_sancion': 'Grund',
    'motivo_sancion_hint': 'Z.B.: Nichterscheinen bei Gala',
    'importe_label': 'Betrag',
    'divisa_label': 'Waehrung',
    'registrar_sancion': 'Sanktion registrieren',
    'subir_evidencia': 'Hochladen',
    'memoria_final_titulo': 'Abschlussbericht',
    'memoria_deadline': 'Vor dem 31. Januar',
    'subir_memoria': 'Abschlussbericht hochladen (PDF)',
    'sin_sanciones': 'Keine Sanktionen',
    'evidencias_short': 'Nachweise',
    'memoria_ok': 'Bericht OK',
    'sanciones_short': 'Sanktionen',
    'dias_en_fase': 'Tage in Phase',
    'proximo_pago': 'Naechste Zahlung',
    'vencido': 'Ueberfaellig',
    'visita_label': 'Besuch',
    // === Paquete 2 — 85 keys faltantes (de) ===
    'abrir_nueva_pestana': 'In neuem Tab oeffnen',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Artikel',
    'auth_accediendo': 'Anmeldung...',
    'auth_email_enviado': 'E-Mail gesendet. Pruefen Sie Ihren Posteingang.',
    'auth_enviar_enlace': 'Link senden',
    'auth_error_intentos': 'Zu viele Versuche. Bitte warten.',
    'auth_error_password': 'Falsches Passwort',
    'auth_error_reset': 'Fehler beim Senden der Wiederherstellungs-E-Mail',
    'auth_error_usuario': 'Benutzer nicht gefunden',
    'auth_introduce_email': 'Geben Sie Ihre E-Mail ein',
    'auth_olvido_password': 'Passwort vergessen',
    'auth_recuperar': 'Passwort zuruecksetzen',
    'auth_recuperar_desc': 'Wir senden Ihnen einen Link zum Zuruecksetzen Ihres Passworts.',
    'aw_h': 'Amerikanische Sportwoche',
    'aw_lbl': 'AWoS',
    'aw_p': 'Feiern Sie Sport und koerperliche Aktivitaet mit Ihrer Stadt waehrend der Amerikanischen Sportwoche.',
    'bonus_desc': 'Zusatzpunkte fuer herausragende Initiativen',
    'buscar_articulo': 'Artikel suchen...',
    'buscar_recursos': 'In Ressourcen suchen...',
    'comite_evaluacion': 'Bewertungskomitee',
    'confirmar_eliminar_pago': 'Moechten Sie diese Zahlung wirklich loeschen?',
    'cookie_accept': 'Akzeptieren',
    'cookie_more': 'Mehr Informationen',
    'cookie_msg': 'Wir verwenden wesentliche Cookies fuer die Website-Funktionalitaet.',
    'cookie_reject': 'Ablehnen',
    'criterios_elegibilidad': 'Zulassungskriterien',
    'cta_b1': 'Bewerbung einreichen',
    'cta_b2': 'ACES kontaktieren',
    'cta_h': 'Starten Sie Ihre Bewerbung heute',
    'cta_p': 'Treten Sie dem Netzwerk europaeischer Sportstaedte bei und veraendern Sie Ihre Gemeinschaft.',
    'descargar_factura': 'Rechnung herunterladen',
    'docs_drag_drop': 'Dateien hierher ziehen oder klicken zum Auswaehlen',
    'docs_obligatorios': 'Pflichtdokumente',
    'eval_actual': 'Aktuelle Bewertung',
    'eval_comentario_voto_placeholder': 'Kommentar zu Ihrer Abstimmung (optional)...',
    'eval_max_puntos': 'Maximale Punktzahl',
    'feats': 'Funktionen',
    'footer_contact': 'Kontakt',
    'footer_legal': 'Impressum',
    'footer_privacy': 'Datenschutz',
    'ft_h': 'Alles was Sie brauchen',
    'ft_lbl': 'Funktionen',
    'general_volver': 'Zurueck',
    'hero_cta1': 'Bewerbung einreichen',
    'hero_cta2': 'Prozess kennenlernen',
    'hero_h1a': 'Ihre Stadt verdient',
    'hero_h1b': 'Anerkennung',
    'hero_sub': 'ACES Cities Network verbindet Staedte, Bewerter und Sportorganisationen auf einer Plattform.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Loeschen',
    'login_subtitulo': 'Melden Sie sich bei Ihrem ACES Cities Network Konto an',
    'marcar_todas_leidas': 'Alle als gelesen markieren',
    'nav_acceder': 'Anmelden',
    'nav_funciones': 'Funktionen',
    'nav_galardones': 'Auszeichnungen',
    'nav_proceso': 'Prozess',
    'nav_registro': 'Registrierung',
    'nav_roles': 'Rollen',
    'notif_todas_leidas': 'Alle Benachrichtigungen als gelesen markiert',
    'pago_eliminado': 'Zahlung geloescht',
    'pendiente': 'Ausstehend',
    'pendiente_label': 'Ausstehend',
    'pipe_h': 'Transparenter Prozess',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Verfolgen Sie jede Phase Ihrer Bewerbung in Echtzeit.',
    'preambulo': 'Praeambel',
    'recursos_aces_desc': 'Auszeichnungen, Vorschriften und offizielle ACES-Dokumentation.',
    'recursos_aces_titulo': 'ACES Ressourcen',
    'reglamentos_seed': 'Vorschriften erfolgreich geladen',
    'regulacion_sin_articulos': 'Diese Vorschrift hat keine Artikel.',
    'roles_h': 'Fuer jede Rolle',
    'roles_lbl': 'Rollen',
    'roles_p': 'Staedte, Bewerter und Administratoren auf einer Plattform.',
    'sancion_incumplimiento': 'Sanktion bei Nichteinhaltung',
    'sin_articulos': 'Keine Artikel',
    'sin_galardones': 'Keine Auszeichnungen verfuegbar',
    'sin_reglamentos': 'Keine Vorschriften verfuegbar',
    'sin_recursos': 'Keine Ressourcen verfuegbar',
    'sin_resultados': 'Keine Ergebnisse',
    'stages': 'Phasen',
    'tasa_inscripcion': 'Anmeldegebuehr',
    'todas': 'Alle',
    'ver_candidatura': 'Bewerbung ansehen',
    'reserva_sin_evaluador': 'Allgemein (kein Evaluator zugewiesen)',
    'preview_pdf_hint': 'PDFs werden in einem neuen Browser-Tab geöffnet.',
    'descargar': 'Herunterladen',
    'con_pago_confirmado': 'mit bestätigter Zahlung (Meilenstein)',
    'pendientes_pago': 'ausstehend',
    'sin_datos_pagos': 'Keine Zahlungsdaten erfasst',
    'eval_no_asignado': 'Sie sind nicht der Evaluierungskommission dieser Kandidatur zugewiesen.',
    'subir_reserva': 'Reservierung hochladen',
    'sin_reservas': 'Keine Reservierungen',
    'sin_reservas_desc': 'Laden Sie die Reservierungs-PDFs hoch.',
    'reservas_desc_master': 'Laden Sie die bestätigten Flug- und Hotelreservierungen als PDF hoch. Sie können den entsprechenden Bewerter auswählen.',
    'subir_agenda': 'Agenda hochladen (PDF)',
    'agenda_visita_titulo': 'Besuchsagenda',
    'reservas_titulo': 'Reservierungen',
    'reserva_subida_ok': 'Reservierung erfolgreich hochgeladen',
    'agenda_subida_ok': 'Agenda erfolgreich hochgeladen',
    'doc_eliminado': 'Dokument gelöscht',
    'agenda_vacia_desc': 'Laden Sie das PDF der Besuchsagenda hoch.',
    'revenue_cobrado': 'Eingezogen',
    'revenue_pendiente': 'Ausstehend',
    'ciudad_hitos_titulo': 'Status Ihrer Bewerbung',
    'hito_factura_recibida': 'Rechnung erhalten',
    'eval_mis_evaluaciones': 'Meine Bewertungen',
    'eval_sin_bid': 'Die Stadt hat die BID-Datei noch nicht hochgeladen.',
    'voto_final_desc_motor': 'Geben Sie Ihre Schlussbewertung ab.',
    'chat_comision': 'Kommissions-Chat',
    'tit_comunicacion_ok': 'Offizielle Kommunikation OK',
    'tit_derechos_factura_env': 'Bildrechte: Rechnung gesendet',
    'tit_derechos_pagado': 'Bildrechte: bezahlt',
    'tit_q1': 'Quartalsbericht Q1',
    'tit_q2': 'Quartalsbericht Q2',
    'tit_q3': 'Quartalsbericht Q3',
    'tit_q4': 'Quartalsbericht Q4',
    'tit_premio_n1': 'N1-Preis: Nimmt teil?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Neue Sanktion',
    'motivo': 'Grund',
    'si': 'Ja',
    'no': 'Nein',
    'nueva': 'Neu',
    'sanciones': 'Sanktionen',
    'pagada': 'Bezahlt',

    'borrar_candidatura': 'Kandidatur loschen',
    'borrar_candidatura_desc': 'Loscht die Kandidatur und alle zugehorigen Daten dauerhaft.',
    'confirmar_borrar_candidatura': 'Diese Kandidatur loschen? Diese Aktion kann NICHT ruckgangig gemacht werden.',
    'confirmar_borrar_candidatura_2': 'SIND SIE SICHER? ALLE Dokumente, Zahlungen, Bewertungen und Chats werden geloscht.',
    'candidatura_eliminada': 'Kandidatur geloscht',
    'zona_peligrosa': 'Gefahrenzone',
    'contacto_ciudad': 'Stadtkontakt',
    'sin_ciudad_vinculada': 'Kein Stadtbenutzer verknupft',
    'cambiar_ciudad': 'Andern',
    'vincular_ciudad': 'Verknupfen',
    'vincular_ciudad_titulo': 'Stadtbenutzer verknupfen',
    'vinculado_actual': 'Aktuell verknupft',
    'desvincular': 'Trennen',
    'buscar_usuario_ciudad': 'Suche nach Name, E-Mail oder Stadt...',
    'sin_usuarios_ciudad': 'Keine Benutzer mit Stadtrolle registriert',
    'ciudad_vinculada_ok': 'Stadt erfolgreich verknupft',
    'ciudad_desvinculada': 'Stadt getrennt',
    'vincular': 'Verknupfen',
    'codigo_generado': 'Code generiert',
    'codigo_generado_ok': 'Stadtcode generiert',
    'codigo_vinculado_candidatura': 'Vorverknupft mit dieser Kandidatur',
    'idioma_carta': 'Briefsprache',
    'carta_copiada': 'Brief in die Zwischenablage kopiert',
    'copiar_carta': 'Kopieren',
    'enviar_invitacion': 'E-Mail offnen',
    'email_cliente_abierto': 'E-Mail-Client geoffnet',
    'estado_avanza_aceptada': 'Kandidatur automatisch akzeptiert',
    'estado_avanza_documentacion': 'Weiter zur Dokumentationsphase',
    'estado_avanza_visita': 'Weiter zur Besuchsphase',
    'estado_avanza_evaluacion': 'Weiter zur Bewertungsphase',
    'confirmar_avance_estado': 'Status vorrucken auf',
    'estado_cambiado': 'Status geandert zu',
    'eval_ciudades_galardonadas': 'Ausgezeichnete Stadte',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Delegierter',
    'delegado_desc': 'Der Delegierte kann den Status der Bewerbung und ausstehende Dokumente einsehen.',
    'asignar_delegado': 'Zuweisen',
    'cambiar_delegado': 'Ändern',
    'sin_delegado': 'Kein Delegierter zugewiesen',
    'confirmar_quitar_delegado': 'Delegierten von dieser Bewerbung entfernen?',
    'delegado_quitado': 'Delegierter entfernt',
    'delegado_asignado': 'Delegierter zugewiesen',
    'delegado_existente': 'Vorhandener Benutzer',
    'delegado_invitar': 'Per E-Mail einladen',
    'generar_codigo_delegado': 'Delegierten-Code generieren',
    'codigo_delegado_generado': 'Code generiert — senden Sie die E-Mail',
    'nombre_delegado_hint': 'Name des Delegierten',
    'email_delegado_hint': 'email@beispiel.com',
    'confirmar_retroceso_estado': 'Status zurücksetzen auf',
    'accion_gala': 'Zur Gala einladen',
    'accion_gala_desc': 'Gala bestätigen und Stadt zum Jahresevent hinzufügen.',
    'accion_notificar': 'Als benachrichtigt markieren',
    'accion_notificar_desc_simple': 'Ändert den Status auf benachrichtigt. Die Kommunikation an die Stadt erfolgt außerhalb der App.',
    'accion_premio': 'Preis vergeben',
    'accion_titularidad': 'Amtszeit aktivieren',
    'activar_titularidad': 'Amtszeit aktivieren',
    'anos_label': 'Jahre',
    'aprobar_informe': 'Genehmigen',
    'archivo_muy_grande': 'Datei überschreitet 50 MB',
    'badge': 'Abzeichen',
    'cambiar_estado': 'Status ändern',
    'candidatura_actualizada': 'Kandidatur aktualisiert',
    'chat_ayer': 'Gestern',
    'chat_hoy': 'Heute',
    'chat_primer_mensaje': 'Sende die erste Nachricht',
    'checklist_obligaciones': 'Pflichten',
    'ciudad_notificada': 'Stadt benachrichtigt',
    'comentario_rechazo': 'Pflichtkommentar für die Ablehnung:',
    'comite_label': 'Komitee',
    'confirmar_cambio_estado': 'Statusänderung bestätigen?',
    'confirmar_gala': 'Gala bestätigen',
    'confirmar_notificar': 'Als benachrichtigt markieren?',
    'confirmar_pago': 'Zahlungseingang bestätigen',
    'Copiado': 'Kopiert',
    'delegado_info_restriccion': 'Als Delegierter können Sie den Pipeline-Status und die Besuchsagenda sehen. Für Zugang zum Bewertungsmotor oder BID File, fordern Sie eine Evaluator-Zuweisung bei ACES an.',
    'delegado_mis_candidaturas': 'Als Delegierter',
    'delegado_vista': 'Delegiertenansicht',
    'delegado_vista_restringida': 'Eingeschränkte Ansicht: nur Pipeline, Agenda und ausstehende Dokumente. Keine Zahlungen oder Bewertungen.',
    'derechos_imagen': 'Bildrechte',
    'editar_candidatura': 'Kandidatur bearbeiten',
    'Eliminado': 'Gelöscht',
    'email': 'E-Mail',
    'emitir_factura': 'Rechnung ausstellen (PDF)',
    'entre_miembros': 'Zwischen',
    'espera_repetir': 'Wartezeit zum Wiederholen',
    'estado_actualizado': 'Status aktualisiert',
    'estado_gala_confirmada': 'Gala bestätigt',
    'estado_notificada': 'Benachrichtigt',
    'estado_notificada_rechazo': 'Ablehnung mitgeteilt',
    'estado_premio_otorgado': 'Preis verliehen',
    'estado_titularidad_activa': 'Aktive Amtszeit',
    'eval_comentario_criterio': 'Kommentare zu diesem Kriterium...',
    'factura': 'Rechnung',
    'factura_emitida': 'Rechnung hochgeladen',
    'fase_candidatura': 'Kandidatur',
    'fase_seguimiento': 'Nachverfolgung',
    'gala_confirmada_ok': 'Gala bestätigt',
    'Guardado': 'Gespeichert',
    'hito_agenda': 'Besuchsagenda akzeptiert',
    'hito_carta': 'Bewerbungsschreiben akzeptiert',
    'hito_pago': 'Rechnung bezahlt',
    'hito_reglamento_env': 'Reglement erhalten',
    'hito_reglamento_firm': 'Reglement unterzeichnet',
    'hito_viajes': 'Reiselogistik abgeschlossen',
    'image_rights': 'Bildrechte',
    'importe': 'Betrag',
    'informe_aprobado': 'Bericht genehmigt',
    'informe_rechazado': 'Bericht abgelehnt',
    'informe_subido': 'Bericht hochgeladen',
    'informes_trimestrales': 'Quartalsberichte',
    'marcar_notificada': 'Als benachrichtigt markieren',
    'marcar_premio': 'Preis als verliehen markieren',
    'max_candidatos': 'Max. Kandidaten',
    'miembros_label': 'Mitglieder',
    'notificar_rechazo': 'Ablehnung mitteilen',
    'nueva_version': 'Neue Version',
    'ocultar': 'Ausblenden',
    'permisos_documento': 'Dokumentberechtigungen',
    'permisos_guardados': 'Berechtigungen gespeichert',
    'poblacion_maxima': 'Max. Bevölkerung',
    'poblacion_minima': 'Min. Bevölkerung',
    'rechazar_informe': 'Ablehnen',
    'region_africa': 'Afrika',
    'region_americas': 'Amerika',
    'region_asia': 'Asien',
    'region_europa': 'Europa',
    'region_mundial': 'Weltweit',
    'region_oceania': 'Ozeanien',
    'reglamentos_pendientes': 'Ausstehende Reglements',
    'seleccionar_tipo': 'Dokumenttyp',
    'sin_resultados_busqueda': 'Keine Ergebnisse gefunden',
    'subir_informe': 'Bericht hochladen',
    'tasa_label': 'Gebühr',
    'tipo_anexo': 'Anhang',
    'tipo_especial': 'Spezial',
    'tipo_no_permitido': 'Dateityp nicht erlaubt. Verwenden Sie PDF, DOC, DOCX, XLS, XLSX, JPG oder PNG',
    'tipo_principal': 'Haupt',
    'titularidad_activa_label': 'Aktive Amtszeit',
    'titularidad_creada': 'Amtszeit erstellt',
    'titularidad_panel': 'Meine Amtszeit',
    'tomar_decision_final': 'Endgültige Entscheidung treffen',
    'ver_documento': 'Ansehen',
    'ver_escala': 'Skala anzeigen',
    'ver_reglamento': 'Vollständiges Reglement ansehen',
    'ver_seguimiento': 'Amtszeit-Nachverfolgung ansehen',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Stadt',
    'visible_evaluador': 'Bewerter',
    'visible_master': 'Master',
    'visible_para': 'Sichtbar für',
    'warning_quitar_adjudicada': 'Ein Zurücksetzen vor „Zuerkannt" entfernt die permanente Zuerkennungsmarkierung.',
    'warning_retroceso': 'Sind Sie sicher, dass Sie den Status zurücksetzen möchten?',
    'y_label': 'und',
    'Q1_nombre': 'Jan-Mär',
    'Q2_nombre': 'Apr-Jun',
    'Q3_nombre': 'Jul-Sep',
    'Q4_nombre': 'Okt-Dez',
    'informe_pendiente': 'Ausstehend',
    'pago_pendiente': 'Ausstehend',
    'checklist_logo_aces': 'Korrekte Verwendung des ACES-Logos',
    'checklist_memoria_anual': 'Jahresbericht eingereicht',
    'checklist_congreso': 'Teilnahme am ACES-Kongress',
    'checklist_imagen_corporativa': 'Unternehmensimage aktualisiert',
    'checklist_calendario_deportivo': 'Sportkalender veröffentlicht',
    'asignar_evaluadores': 'Evaluatoren zuweisen',
    'notas_internas_opcional': 'Interne Notizen (optional)',
    'estado_candidatura': 'Bewerbungsstatus',
    'hito_carta_recibida': 'Bewerbungsschreiben erhalten',
    'hito_candidatura_aceptada': 'Bewerbung angenommen',
    'hito_reglamento_enviado': 'Regelwerk gesendet',
    'hito_reglamento_firmado': 'Regelwerk unterzeichnet',
    'hito_datos_facturacion': 'Rechnungsdaten erhalten',
    'hito_pago_confirmado': 'Zahlung bestätigt',
    'hito_fechas_visita': 'Besuchstermine akzeptiert',
    'hito_comision_cerrada': 'Kommission geschlossen',
    'hito_reservas_completadas': 'Reservierungen abgeschlossen',
    'hito_agenda_subida': 'Agenda hochgeladen',
    'hito_bid_file_recibido': 'BID-Datei erhalten',
    'editar_visita': 'Besuch bearbeiten',
    'programar_visita_btn': 'Besuch planen',
    'gestionar_comision': 'Kommission verwalten',
    'pagos_titulo': 'Zahlungen',
    'sin_pagos': 'Keine Zahlungen registriert',
    'factura_marcada': 'Rechnung markiert',
    'factura_desmarcada': 'Rechnung unmarkiert',
    'pago_confirmado_label': 'Zahlung bestätigt',
    'pago_desmarcado': 'Zahlung unmarkiert',
    'vence_label': 'Fällig',
    'factura_label': 'Rechnung',
    'pagado_label': 'Bezahlt',
    'documentos_titulo': 'Dokumente',
    'archivos_count': 'Datei',
    'archivos_count_plural': 'Dateien',
    'subir_btn': 'Hochladen',
    'sin_documentos': 'Keine Dokumente hochgeladen',
    'aprobado_label': 'Genehmigt',
    'rechazado_label': 'Abgelehnt',
    'sin_permisos': 'Keine Berechtigungen',
    'ver_label': 'Ansehen',
    'logistica_titulo': 'Logistik',
    'agenda_visita': 'Besuchsagenda',
    'subir_pdf': 'PDF hochladen',
    'sin_agenda': 'Keine Agenda hochgeladen',
    'reservas_titulo': 'Reservierungen',
    'general_sin_eval': 'Allgemein (kein Evaluator)',
    'subir_reserva': 'Reservierung hochladen',
    'sin_reservas': 'Keine Reservierungen hochgeladen',
    'agenda_subida_ok': 'Agenda hochgeladen',
    'reserva_subida_ok': 'Reservierung hochgeladen',
    'evaluador_actualizado': 'Evaluator aktualisiert',
    'general_todos_eval': 'Allgemein (alle Evaluatoren)',
    'cambiar_evaluador': 'Evaluator ändern',
    'evaluaciones_titulo': 'Bewertungen',
    'enviada_label': 'gesendet',
    'enviadas_label': 'gesendet',
    'en_progreso_label': 'in Bearbeitung',
    'comision_asignada': 'Zugewiesene Kommission',
    'evaluador_label': 'Evaluator',
    'evaluadores_label': 'Evaluatoren',
    'jefe_label': 'Leiter',
    'sin_empezar': 'Nicht begonnen',
    'sin_evaluadores': 'Keine Evaluatoren zugewiesen',
    'enviada_badge': 'Gesendet',
    'favorable_label': 'Günstig',
    'desfavorable_label': 'Ungünstig',
    'desbloquear_label': 'Entsperren',
    'evaluacion_desbloqueada': 'Bewertung entsperrt',
    'error_desbloquear': 'Fehler beim Entsperren',
    'pdf_generado': 'PDF generiert',
    'error_pdf': 'Fehler beim Generieren des PDF',
    'en_progreso_badge': 'In Bearbeitung',
    'tomar_decision': 'Endgültige Entscheidung treffen',
    'cerrar_menu': 'Menü schließen',
    'compartir_tel_ciudad': 'Telefon mit der Kandidatenstadt teilen',
    'compartir_tel_eval': 'Telefon mit anderen Evaluatoren teilen',
    'notas_internas': 'Interne Notizen',
    'notas_privadas_placeholder': 'Private Notizen...',
    'guardado_ok': 'Gespeichert',
    'generar_btn': 'Generieren',
    'copiado_ok': 'Kopiert',
    'idioma_destinatario': 'Sprache des Empfängers',
    'codigo_acceso_modal': 'Zugangscode',
    'gala_activa': 'AKTIV',
    'gala_inactiva': 'INAKTIV',
    'calendario_carta': 'Bürgermeisterbrief: 30. Mär',
    'calendario_bid': 'BID-Datei: 30. Jun',
    'calendario_preseleccion': 'Vorauswahl: 31. Jul',
    'calendario_visitas': 'Besuche: Okt',
    'calendario_gala': 'Gala: Nov',
    'calendario_titularidad': 'Titelträger: 1. Jan folgend',
    'candidatura_singular': 'Kandidatur',
    'candidaturas_plural': 'Kandidaturen',
    'doc_tipo_bid_file': 'BID-Datei',
    'doc_tipo_presentacion': 'Präsentation',
    'progreso_inicio': 'Start',
    'progreso_adjudicada': 'Vergeben',
    'hab_label': 'Einw.',
    'eval_abreviado': 'Bew.',
    'min_poblacion_label': 'Min. Bevölkerung',
    'max_poblacion_label': 'Max. Bevölkerung',
    'max_candidatos_label': 'Max. Kandidaten',
    'espera_label': 'Wartezeit',
    'anos_label': 'Jahre',
    'image_rights': 'Bildrechte',
    'comite_label': 'Ausschuss',
    'miembros_label': 'Mitglieder',
    'usado_label': 'VERWENDET',
    'disponibles_count': 'Verfügbar',
    'usados_count': 'Verwendet',
    'codigos_disponibles_count': 'Verfügbare Codes',
    'hotel_placeholder': 'Zugewiesenes Hotel, Check-in, Regeln...',
    'vuelo_placeholder': 'Flughafen, Zeiten, Klasse...',
    'parlamento_placeholder': 'Adresse, Zugangsregeln, Protokoll...',
    'dni_pasaporte': 'Ausweis / Reisepass',
    'cerrar_menu': 'Menü schließen',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'sin_fecha_visita': 'Kein Besuchstermin',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Kommentar zum Abschnitt',
    'eval_comentario_seccion_placeholder': 'Allgemeiner Kommentar zum Abschnitt (optional)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Fehler: {0}',
    'pdf_evaluacion': 'Bewertung als PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Bewertungsbericht',
    'pdf_ciudad': 'Stadt',
    'pdf_evaluador': 'Gutachter',
    'pdf_fecha': 'Datum',
    'pdf_total': 'Gesamtpunktzahl',
    'pdf_secciones': 'Abschnitte',
    'pdf_voto_final': 'Endgültige Stimme',
    'pdf_comentario_voto': 'Kommentar zur Stimme',
    'pdf_no_evaluada': 'Nicht bewertet',
    'pdf_generado_por': 'Erstellt von ACES Cities Network · {0}',
    'email_placeholder': 'name@beispiel.de',
    'ej_nombre_persona': 'z. B. Anna Schmidt',
    'ej_aeropuerto': 'z. B. Frankfurt (FRA)',
    'pdf_permitir_popups': 'Bitte erlauben Sie Pop-ups, um das PDF zu exportieren',
    'confirmar': 'Bestätigen',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Achtung',
    'confirmar_eliminar_doc': 'Dieses Dokument löschen? Dies kann nicht rückgängig gemacht werden.',
    'confirmar_eliminar_logistica': 'Dieses Logistikdokument löschen?',
    'confirmar_notificar_titulo': 'Stadt benachrichtigen',
    'confirmar_retroceso_titulo': 'Zurücksetzen bestätigen',
    'eliminado': 'Gelöscht',
    'quitar_delegado_titulo': 'Delegierten entfernen',
    'warning_quitar_adjudicada_titulo': 'Auszeichnung entfernen',
    'warning_retroceso_2': 'BESTÄTIGEN? Daten werden unwiderruflich gelöscht (Termine, Gala-Einträge usw.). Dies kann NICHT rückgängig gemacht werden.',
    'warning_retroceso_titulo': 'Status zurücksetzen',
    'eval_pts': 'Pkt.',
    // Corrección de acentos — 23sep2026
    'chat_adjuntar': 'Datei anhängen',
    'vincular': 'Verknüpfen',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Flugbuchung',
    'viaje_tipo_reserva_hotel': 'Hotelbuchung',
    'reserva_generica': 'Buchung',
  },
  'it': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'Non troviamo questo codice. Verifica che sia completo, per esempio: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Questo codice è già stato utilizzato. Se ti sei già registrato, accedi. Altrimenti chiedi un nuovo codice ad ACES.',
    'codigo_expirado': 'Questo codice è scaduto. Chiedi un nuovo codice ad ACES.',
    'codigo_admin': 'Questo è un codice di amministrazione e non serve per registrarsi qui. Contatta ACES.',
    'registro_error_general': 'Non è stato possibile completare la registrazione e nessun account è stato creato. Riprova; se non funziona ancora, contatta ACES.',
    'email_ya_registrado_login': 'Questa email ha già un account. Tocca "Accedi" e, se non ricordi la password, usa "Password dimenticata?".',
    'nueva_gala_btn': 'Crea gala',
    'programar_visita': 'Pianifica visita di valutazione',
    'guardar_notas': 'Salva note',
    'historial_estados': 'Cronologia degli stati',
    'notas_privadas_hint': 'Note private su questa candidatura (visibili solo per master)...',
    'voto_emitido': 'Voto espresso:',
    'voto_en_contra': 'Contro',
    'voto_a_favor': 'A favore',
    'voto_final_desc': 'La candidatura è in fase di votazione. Esprimi il tuo voto.',
    'voto_final_titulo': 'Voto finale richiesto',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titolarità — prossimamente',
    'email_abierto': 'Il tuo client email si è aperto',
    'cargo_hint': 'Es.: Assessore allo Sport',
    'password_repetir_hint': 'Ripeti la password',
    'password_min': 'Minimo 6 caratteri',
    'placeholder_apellido_ej': 'Rossi',
    'placeholder_nombre_ej': 'Maria',
    'error_guardar': 'Errore nel salvataggio',
    'error_label': 'Errore',
    'error_subir': 'Errore di caricamento',
    'error_cambiar_password': 'Errore nel cambio password',
    'candidatura_no_encontrada': 'Candidatura non trovata',
    'puntuacion_final': 'Punteggio finale',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Destinazione',
    'origen_label': 'Origine',
    'notif_actividad_desc': 'L\'attività delle tue candidature apparirà qui.',
    'placeholder_ej_espana': 'Es.: Spagna',
    'placeholder_ej_madrid': 'Es.: Madrid',
    'gala_lugar_hint': 'Es.: Palazzo dei Congressi',
    'gala_titulo_hint': 'Es.: Gala ACES América 2026',
    'gala_descripcion_hint': 'Descrizione dell\'evento...',
    'gala_pais': 'Paese dell\'evento',
    'gala_ciudad': 'Città dell\'evento',
    'gala_lugar': 'Luogo della cerimonia',
    'gala_titulo_label': 'Titolo della gala',
    'visible_ciudades': 'Visibile alle città',
    'nueva_gala': 'Nuova gala',
    'sin_galas': 'Nessuna gala configurata',
    'gala_gestion': 'Gestione cerimonia di gala',
    'gala_aces_titulo': 'Gala ACES',
    'codigo_copiado': 'Codice copiato',
    'error_generar_codigo': 'Errore nella generazione del codice',
    'nombre_eval_email': 'Nome valutatore (per email)',
    'invitar_evaluador': 'Invita valutatore',
    'sin_evaluadores': 'Nessun valutatore registrato',
    'preview': 'Anteprima',
    'ver_todos': 'Vedi tutti',
    'total_candidaturas': 'Totale candidature',
    'titulos_adjudicados': 'Titoli aggiudicati',
    'tamano_comite': 'Dimensione comitato (valutatori)',
    'sanciones_asistencia': 'Sanzioni per assenza (€)',
    'tasas_participacion': 'Quote di partecipazione (€)',
    'config_sistema_perfil': 'Sistema e profilo',
    'sin_candidaturas_desc2': 'Prova a cambiare i filtri o crea una nuova.',
    'placeholder_pais_ej': 'Es.: Argentina',
    'placeholder_ciudad_ej': 'Es.: Buenos Aires',
    'buscar_evaluador': 'Cerca valutatore...',
    'notas_decision_hint': 'Note interne sulla decisione...',
    'concepto_placeholder': 'Es.: Quota partecipazione 2026',
    'sin_jefe_asignado': 'Nessun capo assegnato',
    'jefe_comision': 'Capo commissione',
    'ciudad_label': 'Città',
    'descargar_app_store': 'Scarica su App Store',
    'aforo_maximo': 'Capacità massima',
    'descripcion_label': 'Descrizione',
    'convocatoria_label': 'Convocazione',
    'abrir_email': 'Apri email',
    'crear_gala': 'Crea gala',
    'en_evaluacion': 'In valutazione',
    'emails_institucionales': 'Email istituzionali',
    'email_evaluador': 'Email del valutatore',
    'codigo_acceso_label': 'Codice di accesso',
    'codigos_acceso': 'Codici di accesso',
    'seleccionar_galardon': 'Seleziona premio...',
    'todos_galardones': 'Tutti i premi',
    'todos_estados': 'Tutti gli stati',
    'cargando_dashboard': 'Caricamento...',
    'candidaturas_recientes': 'Candidature recenti',
    'candidaturas_activas': 'Candidature attive',
    'alertas_sistema': 'Avvisi di sistema',
    'accesos_rapidos': 'Accessi rapidi',
    'viaje_titulo': 'Viaggio',
    'nuevo': 'Nuovo',
    'estado': 'Stato',
    'abrir_votacion': 'Apri votazione',
    'accion_anadir_evaluador': 'Aggiungi valutatore',
    'accion_master': 'Azione master',
    'accion_nueva_candidatura': 'Nuova candidatura',
    'accion_ver_alertas': 'Vedi avvisi',
    'actividad': 'Attività',
    'agenda_notas': 'Note interne',
    'agenda_notas_hint': 'Es: Il valutatore sarà ricevuto dal Sindaco...',
    'agenda_pdf_listo': 'PDF del programma allegato',
    'agenda_propuesta_enviada': 'Evento del programma inviato',
    'agenda_subir_pdf': 'Carica PDF del programma completo (opzionale)',
    'agenda_tipo_evento': 'Tipo di evento',
    'agenda_titulo_evento': 'Titolo dell\'evento',
    'agenda_vacia': 'Agenda vuota',
    'alerta_decision_pendiente': 'Decisione in attesa',
    'alerta_docs_pendientes': 'Documenti in attesa',
    'alerta_pago_vencido': 'Pagamento scaduto',
    'alerta_sin_evaluadores': 'Nessun valutatore assegnato',
    'alertas_titulo': 'Avvisi',
    'anos': 'anni',
    'anterior': 'Precedente',
    'apellidos': 'Cognome',
    'aprobar': 'Approva',
    'asignacion_ciudad_hint': 'Es: Roma',
    'asignacion_ciudad_salida': 'Città di partenza per la visita',
    'asignacion_ciudad_salida_desc': 'La città dalla quale partirete per la visita di valutazione.',
    'asignacion_compartir_ciudad': 'Condividi telefono con la città',
    'asignacion_compartir_ciudad_desc': 'La città potrà vedere il tuo numero di telefono e WhatsApp.',
    'asignacion_compartir_eval_desc': 'Gli altri valutatori di questa candidatura potranno vedere il tuo contatto.',
    'asignacion_compartir_evaluadores': 'Condividi con altri valutatori',
    'asignacion_confirmar': 'Conferma e inizia',
    'asignacion_nota': 'Nota per la città (opzionale)',
    'asignacion_nota_desc': 'Questa nota sarà visibile al team della città candidata.',
    'asignacion_nota_hint': 'Es: Arriverò in treno martedì mattina...',
    'asignacion_privacidad': 'Privacy e contatto',
    'asignacion_sub': 'Prima di iniziare, configura i tuoi dati di contatto per questa candidatura.',
    'asignacion_titulo': 'Nuova assegnazione',
    'asignar_ciudad_titulo': 'Assegna città',
    'asignar_evaluador': 'Assegna valutatore',
    'auth_cargando': 'Accesso in corso...',
    'auth_cerrar_sesion': 'Esci',
    'auth_email': 'Email',
    'auth_entrar': 'Accedi',
    'auth_error_credenciales': 'Email o password errati.',
    'auth_error_red': 'Nessuna connessione internet.',
    'auth_password': 'Password',
    'auth_subtitulo': 'Piattaforma di candidature sportive ACES',
    'avanzar_a': 'Avanza a',
    'borrar': 'Elimina',
    'borrar_todas': 'Elimina tutto',
    'buscar_ciudad_email': 'Cerca città, email...',
    'buscar_pais': 'Cerca paese...',
    'buscar_placeholder': 'Cerca città, premio...',
    'cambios': 'Modifiche',
    'campos_obligatorios': 'Compila tutti i campi obbligatori.',
    'cancelar': 'Annulla',
    'candidatura_asignada_ok': 'Candidatura assegnata',
    'cargando_candidatura': 'Caricamento candidatura...',
    'cargo': 'Ruolo',
    'cat_carta': 'Lettera di intenti',
    'cat_eventos': 'Eventi',
    'cat_galardones': 'Premi precedenti',
    'cat_infra': 'Infrastrutture',
    'cat_otros': 'Altro',
    'cat_presupuesto': 'Budget',
    'categoria': 'Categoria',
    'cerrar': 'Chiudi',
    'cerrar_votacion': 'Chiudi votazione',
    'chat_ciudad': 'Chat con ACES',
    'chat_ciudad_aces': 'Chat con ACES',
    'chat_ciudad_aces_desc': 'Comunicazione diretta con il team ACES Europa.',
    'chat_conversaciones': 'Conversazioni',
    'chat_elige_conversacion': 'Scegli con chi vuoi chattare',
    'chat_escribir': 'Scrivi un messaggio...',
    'chat_interno': 'Chat della commissione',
    'chat_interno_desc': 'Canale privato tra valutatori e ACES. La città non ha accesso.',
    'chat_mis_chats': 'Le mie chat',
    'chat_sin_activos': 'Nessuna chat attiva',
    'chat_sin_activos_desc': 'Le chat con le candidature appariranno qui',
    'chat_sin_mensajes': 'Ancora nessun messaggio',
    'chat_adjuntar': 'Allega file',
    'chat_adjunto_expira': 'File disponibile per 7 giorni',
    'chat_adjunto_max': 'File troppo grande (max 10MB)',
    'chat_borrar': 'Elimina per tutti',
    'chat_buscar_conv': 'Cerca citta o premio...',
    'chat_confirmar_borrar': 'Eliminare questo messaggio per tutti?',
    'chat_filtro_no_leidas': 'Non letti',
    'chat_filtro_todas': 'Tutti',
    'chat_mensaje_borrado': 'Messaggio eliminato',
    'chat_no_leidos': 'non letti',
    'chat_activas': 'chat attive',
    'chat_recargar': 'Aggiorna',
    'chat_responder': 'Rispondi',
    'chat_sin_no_leidos': 'Tutto letto',
    'warn_poblacion_min': 'Popolazione minima richiesta',
    'warn_poblacion_max': 'Popolazione massima consentita',
    'warn_actual': 'Attuale',
    'warn_max_candidaturas': 'Massimo candidature per questo premio',
    'warn_actuales': 'Attuali',
    'warn_espera': 'Periodo di attesa',
    'warn_anos': 'anni',
    'warn_ultima': 'Ultima assegnazione',
    'warn_elegible_desde': 'Ammissibile dal',
    'warn_elegibilidad': 'Avvisi di ammissibilita',
    'warn_override': 'Override Master: crea la candidatura comunque',
    'warn_override_required': 'Ci sono avvisi. Spunta Override per continuare.',
    'tasa_auto': 'Verra creato un pagamento automatico di',
    'poblacion_label': 'Popolazione',
    'galardon_label': 'Premio',
    'calendario_procesal': 'Calendario procedurale (Art. 15)',
    'regla_25_titulo': 'Regola 2.5 punti (Art. 15)',
    'regla_25_desc': 'La differenza tra i primi due e',
    'regla_25_info': 'Il Master puo assegnare al secondo classificato se giustificato.',
    'regla_25_justificacion_hint': 'Giustifica la decisione, specialmente se si applica la regola 2.5...',
    'resumen_puntuaciones': 'Punteggi valutatori',
    'candidatura_adjudicada': 'Candidatura assegnata!',
    'error_campos_obligatorios': 'Citta, paese e premio sono obbligatori.',
    'checklist_aprobado': 'APPROVATA',
    'checklist_titulo': 'Requisiti documentazione',
    'ciudad': 'Città',
    'ciudad_asignada': 'Città assegnata',
    'ciudad_asignar': 'Assegna',
    'ciudad_cambiar': 'Cambia',
    'ciudad_cargo': 'Ruolo',
    'ciudad_contacto_principal': 'Contatto principale',
    'ciudad_desde': 'Città dal',
    'ciudad_email': 'Email',
    'ciudad_historico': 'Storico',
    'ciudad_modulos': 'Moduli',
    'ciudad_nombre': 'Nome',
    'ciudad_recursos': 'Risorse ACES',
    'ciudad_rol': 'Ruolo',
    'ciudad_salida': 'Città di partenza',
    'ciudad_salida_desc': 'La città candidata ha bisogno di sapere da dove viaggi per prenotare il volo.',
    'ciudad_salida_hint': 'Es: Roma, Milano...',
    'ciudad_salida_pendiente': 'Città di partenza in attesa',
    'ciudad_sin_asignar': 'Nessuna città assegnata',
    'ciudad_sin_candidatura': 'Nessuna candidatura attiva',
    'ciudad_sin_candidatura_desc': 'Contatta ACES per avviare la procedura.',
    'ciudad_telefono': 'Telefono',
    'codigo_activando': 'Attivazione...',
    'codigo_activar': 'Attiva codice',
    'codigo_error_invalido': 'Codice non valido o già utilizzato.',
    'codigo_generado_label': 'CODICE GENERATO',
    'codigo_invalido': 'Codice non valido o già utilizzato.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Inserisci il codice ACESCN fornito da ACES.',
    'codigo_titulo': 'Codice di accesso',
    'codigo_vacio': 'Inserisci il tuo codice di accesso.',
    'codigo_validar': 'Valida codice',
    'codigos_disponibles': 'Disponibili',
    'codigos_generados': 'Codici generati',
    'codigos_usados': 'Codici usati',
    'comision_sin_otros': 'Solo tu nella commissione',
    'comision_sin_otros_desc': 'Nessun altro valutatore è ancora stato assegnato a questa candidatura.',
    'comision_titulo': 'Commissione di valutazione',
    'completado': 'completato',
    'comprobante_desc': 'Carica la ricevuta del bonifico bancario in PDF o immagine.',
    'comprobante_subido': 'Ricevuta caricata con successo',
    'comprobante_titulo': 'Ricevuta di pagamento',
    'config_comite': 'Dimensione del comitato',
    'config_convocatorias': 'Bandi aperti',
    'config_correos_desc': 'Email usate per le notifiche ufficiali.',
    'config_correos_titulo': 'Email istituzionali',
    'config_guardada': 'Configurazione salvata',
    'config_sanciones': 'Sanzioni per mancata partecipazione al Gala (€)',
    'config_sistema_titulo': 'Configurazione del sistema',
    'config_tasas': 'Quote di partecipazione (€)',
    'confirmada': 'Confermata',
    'confirmando': 'Conferma in corso...',
    'confirmar_asistencia': 'Conferma partecipazione',
    'contacto_principal': 'Contatto principale',
    'continuar': 'Continua',
    'continuar_evaluacion': 'Continua valutazione',
    'convocatoria': 'Bando',
    'creando': 'Creazione...',
    'crear_candidatura': 'Crea candidatura',
    'crear_cuenta': 'Crea account',
    'dashboard_accesos_rapidos': 'Accessi rapidi',
    'dashboard_awos_sub': 'Registra le tue attività sportive e accedi alle statistiche globali.',
    'dashboard_awos_titulo': 'AWoS Attiva',
    'dashboard_documentos': 'Documenti',
    'dashboard_estado': 'Stato candidatura',
    'dashboard_mensajes': 'Messaggi',
    'dashboard_pagos_pendientes': 'Pagamenti in sospeso',
    'datos_opcionales': 'Questi campi sono facoltativi e possono essere aggiornati dal tuo profilo.',
    'de': 'di',
    'decision_adjudicar': 'Assegna',
    'decision_advertencia': 'Questa decisione è inappellabile e verrà registrata in modo permanente.',
    'decision_confirmar': 'Conferma decisione',
    'decision_nav': 'Decisione finale',
    'decision_notas': 'Note sulla decisione (obbligatorio)',
    'decision_rechazar': 'Non assegnare',
    'decision_selecciona': 'Seleziona la decisione',
    'decision_titulo': 'Decisione finale',
    'desbloquear': 'Sblocca',
    'desde': 'da',
    'destino': 'Destinazione',
    'dia': 'Giorno',
    'dias': 'giorni',
    'dias_label': 'giorni',
    'dias_visita_label': 'giorni di visita',
    'doc_subido_ok': 'Documento caricato con successo',
    'docs_pendientes': 'Documenti in attesa',
    'documento_pendiente': 'Documento in attesa di ricezione',
    'duracion_visita_label': 'DURATA DELLA VISITA',
    'editar': 'Modifica',
    'eliminar': 'Elimina',
    'eliminar_cuenta': 'Elimina il mio account',
    'eliminar_cuenta_desc': 'Questa azione è irreversibile. I tuoi dati verranno resi anonimi in conformità al GDPR.',
    'eliminar_cuenta_password': 'Inserisci la tua password per confermare',
    'eliminar_cuenta_titulo': 'Elimina account',
    'eliminar_documento': 'Elimina documento',
    'email_ciudad_label': 'EMAIL DELLA CITTÀ',
    'email_contacto': 'Email di contatto',
    'email_enviado': 'Email inviata con successo',
    'email_enviar': 'Invia email ufficiale',
    'email_idioma': 'Lingua del destinatario',
    'email_invalido': 'Email non valida.',
    'email_preview': 'Anteprima email',
    'email_remitente': 'Invia da',
    'email_ya_registrado': 'Questa email è già registrata.',
    'emitir_factura_titulo': 'Emetti fattura',
    'emitir_nueva_factura': 'Emetti nuova fattura',
    'enviada': 'Inviata',
    'enviado_por_aces': 'Inviato da ACES',
    'enviando': 'Invio in corso...',
    'enviar': 'Invia',
    'enviar_evaluacion': 'Invia valutazione',
    'enviar_propuesta': 'Invia proposta',
    'eres_jefe_comision': 'Sei capo della commissione',
    'error_generico': 'Si è verificato un errore. Riprova.',
    'escribiendo': 'sta scrivendo',
    'estado_aceptada': 'Accettata',
    'estado_adjudicada': 'Aggiudicata',
    'estado_decision': 'Decisione in attesa',
    'estado_documentacion': 'Documentazione',
    'estado_evaluacion': 'In valutazione',
    'estado_pipeline': 'Pipeline di candidatura',
    'estado_rechazada': 'Non aggiudicata',
    'estado_solicitada': 'Inviata',
    'estado_visita': 'Visita programmata',
    'estado_votacion': 'In votazione',
    'eval_abrev': 'val.',
    'eval_abrir_motor': 'Apri motore di valutazione',
    'eval_anterior': 'Precedente',
    'eval_asignadas': 'Le mie assegnate',
    'eval_asignado_ok': 'Valutatore assegnato',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Caricamento valutazione...',
    'eval_comentario_placeholder': 'Commenta il tuo punteggio...',
    'eval_comentario_voto': 'Commento al voto finale',
    'eval_comision_pendiente': 'Informazioni sugli valutatori disponibili a breve.',
    'eval_comision_titulo': 'Valutatori assegnati',
    'eval_confirmar_desc': 'Una volta inviata non potrai modificarla a meno che il Master non la sblocchi.',
    'eval_confirmar_envio': 'Invia valutazione',
    'eval_conflicto_interes': 'Conflitto di interessi: sei dello stesso Paese della città candidata a Capitale.',
    'eval_desfavorable': 'Sfavorevole',
    'eval_enviada_desc': 'La tua valutazione è stata registrata correttamente.',
    'eval_enviada_ok': 'Valutazione inviata con successo',
    'eval_enviada_titulo': 'Valutazione inviata',
    'eval_enviadas': 'inviate',
    'eval_enviar': 'Invia',
    'eval_enviar_btn': 'Invia',
    'eval_favorable': 'Favorevole',
    'eval_habilitada': 'Valutazione abilitata',
    'eval_ir_motor': 'Vai al motore di valutazione',
    'eval_lista': 'Valutatori',
    'eval_mi_evaluacion': 'La mia valutazione',
    'eval_mis_candidaturas': 'Le mie candidature',
    'eval_motor_titulo': 'Motore di valutazione',
    'eval_no_habilitada': 'La valutazione non è ancora stata abilitata da ACES.',
    'eval_notas_comentario': 'Note e commenti',
    'eval_quitado': 'Valutatore rimosso',
    'eval_registrados': 'Registrati',
    'eval_seccion': 'Sezione',
    'eval_siguiente': 'Successivo',
    'eval_sin_activas': 'Nessuna candidatura attiva',
    'eval_sin_asignadas': 'Nessuna candidatura assegnata',
    'eval_sin_asignadas_desc': 'Il Master assegnerà le candidature alla tua commissione.',
    'eval_sin_documentos': 'Nessun documento',
    'eval_sin_documentos_desc': 'La città non ha ancora caricato documenti.',
    'eval_sin_reservas': 'Nessuna prenotazione ancora',
    'eval_stat_asignadas': 'Assegnate',
    'eval_stat_completadas': 'Completate',
    'eval_stat_pendientes': 'In sospeso',
    'eval_todas': 'Tutte le attive',
    'eval_todas_activas': 'Candidature attive',
    'eval_todas_aviso': 'Visualizzazione in sola lettura. Dettaglio completo solo per le candidature assegnate.',
    'eval_total_seccion': 'Punteggio di questa sezione',
    'eval_ver_escala': 'Vedi scala di punteggio',
    'eval_voto_final': 'Voto finale',
    'eval_voto_informativo': 'Il tuo voto è indicativo. La decisione finale spetta al Master ACES.',
    'evaluacion_titulo': 'Valutazione',
    'evaluaciones_enviadas': 'valutazioni inviate',
    'evaluadores_asignados': 'valutatori assegnati',
    'evaluadores_asignados_label': 'VALUTATORI ASSEGNATI',
    'evento_almuerzo': 'Pranzo',
    'evento_cena': 'Cena',
    'evento_desayuno': 'Colazione',
    'evento_descanso': 'Pausa',
    'evento_llegada': 'Arrivo',
    'evento_otro': 'Altro',
    'evento_recepcion': 'Ricevimento',
    'evento_reunion': 'Riunione',
    'evento_rueda_prensa': 'Conferenza stampa',
    'evento_salida': 'Partenza',
    'evento_traslado': 'Trasferimento',
    'evento_visita': 'Visita',
    'factura_creada_ok': 'Fattura registrata. Ora carica il PDF.',
    'factura_detalle': 'Dettaglio / Concetto esteso',
    'factura_detalle_hint': 'Descrizione dettagliata dei servizi, termini di pagamento, dati bancari...',
    'factura_subida_ok': 'Fattura caricata con successo',
    'facturas_aces': 'Da ACES',
    'fecha_llegada_label': 'DATA DI ARRIVO',
    'fecha_regreso': 'Data di ritorno',
    'fecha_salida': 'Data di partenza',
    'fecha_vencimiento_label': 'DATA DI SCADENZA',
    'filtro_estado': 'Stato',
    'filtro_tipo': 'Tipo',
    'filtro_todas': 'Tutte',
    'filtro_todos': 'Tutti',
    'gala_asistencia_confirmada': 'Partecipazione confermata',
    'gala_invitacion_titulo': 'Invito al Gala',
    'gala_pendiente_desc': 'ACES attiverà il tuo invito al momento opportuno.',
    'gala_pendiente_invitacion': 'Invito in sospeso',
    'gala_representantes': 'Rappresentanti',
    'gala_sin_datos': 'Nessun dato sul Gala',
    'gala_sin_datos_desc': 'Non ci sono informazioni sulla cerimonia per quest\'anno.',
    'gala_sin_representantes': 'Nessun rappresentante aggiunto',
    'galardon': 'Premio',
    'general_error': 'Si è verificato un errore',
    'general_reintentar': 'Riprova',
    'generar_codigo': 'Genera codice',
    'generar_codigo_titulo': 'Nuovo codice di accesso',
    'gestionar_comision': 'Gestisci commissione',
    'guardado': 'Salvato',
    'guardando': 'Salvataggio...',
    'guardar': 'Salva',
    'guardar_ciudad_salida': 'Salva città di partenza',
    'guardar_config': 'Salva configurazione',
    'guardar_y_siguiente': 'Salva e avanti',
    'historico_titulo': 'Candidature precedenti',
    'hora': 'Ora',
    'hora_fin_opc': 'Ora di fine (opzionale)',
    'hora_inicio': 'Ora di inizio',
    'idioma_titulo': 'Lingua dell\'interfaccia',
    'iniciar_evaluacion': 'Avvia valutazione',
    'invitacion_enviada': 'Invito inviato',
    'invitar_ciudad_titulo': 'Invita città',
    'invitar_codigo_generado': 'Codice generato',
    'invitar_copiar': 'Copia',
    'invitar_cuerpo_eval': 'La invitiamo a unirsi ad ACES Cities Network come valutatore.\\n\\nIl suo codice è:',
    'invitar_email': 'Invia tramite email',
    'invitar_evaluador_sub': 'Genera un codice e condividilo tramite WhatsApp o email',
    'invitar_evaluador_titulo': 'Invita valutatore',
    'invitar_generar_codigo': 'Genera codice di accesso',
    'invitar_nombre': 'Nome del valutatore',
    'invitar_pie': 'Scarichi l\'app, si registri e inserisca il codice.\\n\\n— ACES',
    'invitar_saludo': 'Gentile',
    'invitar_whatsapp': 'Invia tramite WhatsApp',
    'jefe_comision_ninguno': 'Nessun capo assegnato',
    'jefe_comision_sin_eval': 'Assegna prima i valutatori per designare un capo.',
    'jefe_comision_titulo': 'Capo commissione',
    'jefe_designado_ok': 'Capo commissione designato',
    'jefe_eliminado_ok': 'Capo commissione rimosso',
    'llegada': 'Arrivo',
    'llegada_label': 'Arrivo',
    'login_crear_cuenta': 'Prima volta? Crea account →',
    'login_olvide_contrasena': 'Password dimenticata?',
    'login_proximamente': 'Prossimamente',
    'login_recuperar_desc': 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
    'login_recuperar_titulo': 'Recupera accesso',
    'login_requiere_codigo': 'L\'accesso a Cities Network richiede un codice di invito ACES.',
    'login_restablecer': 'Reimposta password',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Luogo',
    'marcar_leidas': 'Segna tutte come lette',
    'master_label': 'MASTER ACES',
    'master_panel_desc': 'Controllo totale di candidature, valutazioni e decisioni.',
    'master_recientes': 'Candidature recenti',
    'master_saludo': 'Pannello ACES',
    'master_sin_candidaturas': 'Ancora nessuna candidatura',
    'mi_evaluacion': 'La mia valutazione',
    'mis_pagos': 'I miei pagamenti',
    'mod_chat': 'Chat ACES',
    'mod_documentos': 'Documenti',
    'mod_facturas_pagos': 'Fatture e pagamenti',
    'mod_gala': 'Gala',
    'mod_pagos': 'Pagamenti',
    'mod_titularidad': 'Titolarità',
    'mod_viaje': 'Logistica',
    'modo_evaluador': 'Valutatore',
    'modo_master': 'Master',
    'motor_evaluacion': 'Motore di valutazione',
    'no_configurado': 'Non configurato — modifica il tuo profilo',
    'nombre': 'Nome',
    'nombre_documento': 'Nome del documento',
    'nombre_hotel': 'Nome dell\'hotel',
    'notas_hint': 'Es: Atterrare al T4, hotel consigliato...',
    'notas_internas_label': 'NOTE INTERNE (opzionale)',
    'notif_candidatura_actualizada': 'Candidatura aggiornata',
    'notif_candidatura_desasignada': 'Candidatura rimossa',
    'notif_documento_revisado': 'Documento revisionato',
    'notif_estado_actualizado': 'Stato aggiornato',
    'notif_evaluacion_completada': 'Valutazione completata',
    'notif_limpiar_desc': 'Tutte le notifiche verranno eliminate. Questa azione non può essere annullata.',
    'notif_limpiar_todas': 'Cancella tutte',
    'notif_marcar_leida': 'Segna come letta',
    'notif_nueva_asignacion': 'Nuova candidatura assegnata',
    'notif_pago_vencido': 'Pagamento in scadenza',
    'notif_sin_leer': 'Non lette',
    'notif_sin_notifs': 'Nessuna notifica',
    'notif_visita_programada': 'Visita di valutazione programmata',
    'notificar_ciudad': 'Notifica città',
    'nueva_candidatura': 'Nuova candidatura',
    'nueva_propuesta': 'Nuova proposta',
    'num_habitaciones': 'Numero di camere',
    'origen': 'Origine',
    'pago_enviar_recordatorio': 'Apri email',
    'pago_factura': 'Fattura',
    'pago_instrucciones': 'Effettua il bonifico bancario e carica la ricevuta.',
    'pago_recibido': 'Ricevuto',
    'pago_recordatorio': 'Promemoria',
    'pago_recordatorio_desc': 'Il client email si aprirà con il messaggio.',
    'pago_recordatorio_titulo': 'Invia promemoria pagamento',
    'pagos_ciudad': 'I miei pagamenti',
    'pagos_pendientes': 'Pagamenti in attesa',
    'pais': 'Paese',
    'pais_buscar': 'Cerca paese...',
    'pais_seleccionado': 'Paese selezionato',
    'pais_seleccionar': 'Seleziona paese',
    'paso_datos': 'Dati fattura',
    'paso_subir_pdf': 'Carica PDF fattura',
    'password_actual': 'Password attuale',
    'password_cambiada': 'Password modificata con successo',
    'password_cambiar': 'Cambia password',
    'password_corta': 'La password deve contenere almeno 6 caratteri.',
    'password_nueva': 'Nuova password',
    'password_repetir': 'Ripeti password',
    'passwords_no_coinciden': 'Le password non corrispondono.',
    'error_red': 'Errore di rete. Verifica la tua connessione Internet.',
    'error_demasiados_intentos': 'Troppi tentativi. Attendi un momento e riprova.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Lettera di candidatura ricevuta',
    'hito_aprobada': 'Candidatura approvata',
    'hito_reglamento_enviado': 'Regolamento inviato per la firma',
    'hito_reglamento_firmado': 'Regolamento firmato ricevuto',
    'hito_datos_factura': 'Dati di fatturazione ricevuti',
    'hito_pago_confirmado': 'Pagamento confermato',
    'hito_fechas_visita': 'Date di visita proposte',
    'hito_comision_creada': 'Commissione di valutazione creata',
    'hito_viajes_cerrados': 'Viaggi finalizzati',
    'hito_agenda_enviada': 'Agenda inviata',
    'hito_bid_file': 'BID File ricevuto',
    'doc_tipo_carta_solicitud': 'Lettera di candidatura',
    'doc_tipo_agenda_visita': 'Agenda della visita',
    // Logistica simplificada
    'mod_logistica': 'Logistica',
    'agenda_vacia_ciudad': 'Nessuna agenda caricata. Carica il PDF.',
    'agenda_aviso_master': 'Agenda visibile per valutatori e la citt\u00e0. Carica il PDF definitivo.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES pubblicher\u00e0 l\u2019agenda della visita quando sar\u00e0 disponibile.',
    'eval_reservas_desc': 'Le tue prenotazioni di volo e hotel confermate appariranno qui.',
    'eval_sin_reservas_desc': 'ACES o la citt\u00e0 caricheranno le tue prenotazioni quando confermate.',
    'perfil_actualizado': 'Profilo aggiornato',
    'perfil_apellidos': 'Cognome',
    'perfil_cambiar_foto': 'Foto profilo',
    'perfil_cargo': 'Ruolo',
    'perfil_ciudad': 'Città',
    'perfil_compartir_ciudad': 'Condividi telefono con le città',
    'perfil_compartir_ciudad_desc': 'Le città candidate potranno vedere il tuo numero di contatto.',
    'perfil_compartir_eval_desc': 'I valutatori della tua commissione potranno vedere il tuo contatto.',
    'perfil_compartir_evaluadores': 'Condividi con altri valutatori',
    'perfil_contacto': 'Contatto',
    'perfil_cuenta': 'Account',
    'perfil_datos': 'Dati personali',
    'perfil_datos_evaluador': 'Dati della commissione',
    'perfil_datos_personales': 'Dati personali',
    'perfil_elegir_foto': 'Seleziona foto',
    'perfil_eval_config': 'Impostazioni valutatore',
    'perfil_evaluador': 'Impostazioni valutatore',
    'perfil_fecha_nac': 'Data di nascita',
    'perfil_foto_actualizada': 'Foto aggiornata correttamente',
    'perfil_guardado': 'Profilo salvato con successo',
    'perfil_guardar': 'Salva profilo',
    'perfil_idioma': 'Lingua dell\'app',
    'perfil_nombre': 'Nome',
    'perfil_notificaciones': 'Notifiche',
    'perfil_pais': 'Paese',
    'perfil_provincia': 'Provincia',
    'perfil_talla': 'Taglia polo (commissione)',
    'perfil_telefono': 'Telefono',
    'perfil_titulo': 'Il mio profilo',
    'perfil_ubicacion': 'Posizione',
    'pipeline_aceptada_desc': 'Candidatura accettata. Prepara la documentazione richiesta.',
    'pipeline_adjudicada_desc': 'Congratulazioni! La tua città ha ricevuto il titolo ACES.',
    'pipeline_decision_desc': 'La decisione finale è in preparazione da parte di ACES.',
    'pipeline_documentacion_desc': 'Stiamo esaminando la tua documentazione.',
    'pipeline_evaluacion_desc': 'La commissione di valutazione sta analizzando la tua candidatura.',
    'pipeline_rechazada_desc': 'La tua candidatura non è stata selezionata in questo bando.',
    'pipeline_solicitada_desc': 'La tua candidatura è stata ricevuta ed è in fase di revisione.',
    'pipeline_visita_desc': 'La visita di valutazione nella tua città è in fase di organizzazione.',
    'pipeline_votacion_desc': 'La commissione sta deliberando sulla tua candidatura.',
    'precio_aprox': 'Prezzo indicativo (€)',
    'precio_estimado': 'Prezzo stimato (€)',
    'preview_email_label': 'ANTEPRIMA EMAIL',
    'programar_visita_titulo': 'Pianifica visita',
    'proponer_agenda': 'Programma',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Volo',
    'provincia': 'Provincia / Stato',
    'provincia_seleccionar': 'Seleziona provincia / regione',
    'rechazar': 'Rifiuta',
    'recomendaciones_titulo': 'Raccomandazioni',
    'recordatorio_asunto': 'Promemoria pagamento — {ciudad}',
    'recordatorio_cuerpo': 'Gentile team di {ciudad},\\n\\nLa informiamo che il pagamento per: {concepto} è in sospeso.\\n\\nLa preghiamo di effettuare il bonifico.\\n\\nCordialmente,\\nACES',
    'reg_ciudad': 'Città / Comune *',
    'reg_creando': 'Creazione account...',
    'reg_crear_cuenta': 'Crea account',
    'reg_pais': 'Paese *',
    'reg_provincia': 'Provincia / Regione',
    'reg_resumen_titulo': 'Riepilogo del tuo account',
    'reg_telefono': 'Telefono di contatto *',
    'reg_tipo': 'Tipo di accesso',
    'reg_ubicacion_sub': 'Informazioni sulla tua organizzazione',
    'reg_ubicacion_titulo': 'La tua posizione',
    'registro_cancelar_salir': 'Annulla ed esci',
    'registro_codigo_label': 'CODICE DI ACCESSO ACES',
    'registro_contrasena_label': 'PASSWORD',
    'registro_crear_cuenta': 'Crea il tuo account',
    'registro_datos_personales': 'Dati personali',
    'registro_elige_rol': 'Con quale ruolo accedi a Cities Network?',
    'registro_email_label': 'EMAIL',
    'registro_paso_1': 'Passaggio 1 di 3',
    'registro_paso_2': 'Passaggio 2 di 3',
    'registro_paso_2_desc': 'Queste informazioni vengono utilizzate per la logistica delle visite di valutazione.',
    'registro_paso_3': 'Passaggio 3 di 3',
    'registro_siguiente': 'Avanti →',
    'registro_verifica_desc': 'Ti abbiamo inviato un\'email di verifica. Aprila e clicca sul link prima di continuare.',
    'registro_verifica_titulo': 'Verifica la tua email',
    'rol_ciudad': 'Città',
    'rol_evaluador': 'Valutatore',
    'rol_master': 'Master ACES',
    'salida': 'Partenza',
    'salida_label': 'Partenza',
    'saludo_buenas_noches': 'Buonasera,',
    'saludo_buenas_tardes': 'Buon pomeriggio,',
    'saludo_buenos_dias': 'Buongiorno,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Sezione',
    'seleccionar': 'Seleziona',
    'seleccionar_pais': 'Seleziona paese',
    'seleccionar_provincia': 'Seleziona provincia',
    'sin_agenda': 'Nessun programma',
    'sin_agenda_desc': 'La città non ha ancora proposto un calendario di visita.',
    'sin_candidaturas': 'Nessuna candidatura',
    'sin_candidaturas_desc': 'Nessuna candidatura con questo filtro.',
    'sin_ciudad_asignada': 'Nessuna città assegnata',
    'sin_codigos_disponibles': 'Nessun codice disponibile',
    'sin_documentos': 'Nessun documento',
    'sin_documentos_desc': 'Carica i documenti richiesti per la tua candidatura.',
    'sin_evaluaciones': 'Nessuna valutazione',
    'sin_evaluadores_desc': 'Registra valutatori con un codice ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Nessun valutatore registrato',
    'sin_facturas_aces': 'Nessuna fattura ricevuta',
    'sin_facturas_aces_desc': 'Le fatture inviate da ACES appariranno qui.',
    'sin_notificaciones': 'Nessuna notifica',
    'sin_notificaciones_desc': 'L\'attività delle candidature apparirà qui.',
    'sin_pagos': 'Nessun pagamento',
    'sin_pagos_desc': 'I pagamenti della tua candidatura appariranno qui.',
    'stat_activas': 'Attive',
    'stat_decision': 'Decisione in sospeso',
    'stat_dias_visita': 'Giorni alla visita',
    'stat_docs_pendientes': 'Documenti in attesa',
    'stat_evaluacion': 'In valutazione',
    'stat_mensajes_nuevos': 'Nuovi messaggi',
    'stat_notif': 'Non lette',
    'stat_pagos_pendientes': 'Pagamenti in sospeso',
    'stat_sin_visita': 'Nessuna visita fissata',
    'stat_titulos': 'Titoli attivi',
    'stat_total': 'Totale',
    'subir_comprobante': 'Carica ricevuta',
    'subir_documento': 'Carica documento',
    'subir_factura': 'Carica fattura',
    'subir_factura_desc': 'Carica il PDF della fattura. La città potrà scaricarlo dal suo pannello.',
    'subir_factura_titulo': 'Carica fattura PDF',
    'subir_nota': 'Seleziona il file dal tuo dispositivo',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidatura',
    'tab_candidaturas': 'Candidature',
    'tab_chat': 'Chat',
    'tab_config': 'Configurazione',
    'tab_documentos': 'Documenti',
    'tab_evaluaciones': 'Valutazioni',
    'tab_evaluadores': 'Valutatori',
    'tab_gala': 'Gala',
    'tab_global': 'Globale',
    'tab_inicio': 'Home',
    'tab_notif': 'Notifiche',
    'tab_pagos': 'Pagamenti',
    'tab_perfil': 'Profilo',
    'tab_recursos': 'Risorse',
    'tab_resumen': 'Riepilogo',
    'tab_viaje': 'Logistica',
    'talla_polo': 'Taglia polo',
    'telefono': 'Telefono',
    'template_no_disponible': 'Il template di valutazione non è ancora disponibile.',
    'tipo_codigo': 'Tipo di codice',
    'tit_ano_titulo': 'Anno di titolarità',
    'tit_evidencias': 'Prove caricate',
    'tit_item_calendario': 'Calendario sportivo',
    'tit_item_congreso': 'Congresso o conferenza',
    'tit_item_imagen': 'Uso corretto del titolo',
    'tit_item_memoria': 'Relazione finale',
    'tit_no_aplica': 'Nessun anno di titolarità',
    'tit_no_aplica_desc': 'Questo modulo si attiva quando la tua città vince un premio ACES.',
    'tit_sanciones': 'Sanzioni',
    'tit_sin_datos': 'Nessuna titolarità attiva',
    'tit_titulo': 'Anno di titolarità',
    'toca_abrir_documento': 'Tocca per aprire il documento',
    'toca_copiar': 'Tocca il codice per copiare',
    'toca_para_abrir': 'Tocca per aprire',
    'toca_para_copiar': 'Tocca per copiare',
    'tomar_decision': 'Decisione finale',
    'tu_ciudad_salida': 'La tua città di partenza',
    'upload_error': 'Errore di caricamento',
    'upload_exito': 'Caricato con successo!',
    'upload_formatos': 'PDF, JPG o PNG · max. 20 MB',
    'upload_no_cierres': 'Non chiudere l\'app',
    'upload_reintentar': 'Riprova',
    'upload_subiendo': 'Caricamento in corso...',
    'vence': 'Scade',
    'ver_comprobante': 'Vedi ricevuta',
    'ver_detalle': 'Vedi dettaglio',
    'ver_documento_adjunto': 'Visualizza documento allegato',
    'ver_factura': 'Vedi fattura',
    'verifica_desc': 'Abbiamo inviato un\'email di verifica. Controlla la tua casella di posta.',
    'verifica_reenviar': 'Reinvia email di verifica',
    'viaje_aviso_privacidad': 'L\'identità dei valutatori è riservata. Vedrai solo date e logistica.',
    'viaje_ciudad_salida': 'La tua città di partenza per i voli',
    'viaje_proponer_vuelo': 'Proponi volo',
    'viaje_propuesta_enviada': 'Proposta inviata con successo',
    'viaje_sin_propuestas': 'Nessuna proposta di viaggio',
    'viaje_sin_propuestas_desc': 'Proponi opzioni di volo, hotel e programma per la visita.',
    'visita_evaluadores': 'Visita dei valutatori',
    'visita_programada': 'Visita programmata',
    'visita_sin_programar': 'Visita non ancora programmata',
    'visita_titulo': 'Visita di valutazione',
    'volver': 'Indietro',
    'votacion_abierta': 'Votazione aperta',
    'votacion_cerrada': 'Votazione chiusa',
    'walkthrough_ver_guia': 'Vedi guida introduttiva',
    'whatsapp': 'WhatsApp (con prefisso)',
    'ya_tengo_cuenta': 'Hai già un account?',
    'tab_titularidades': 'Titolarità',
    'acciones_rapidas': 'Azioni rapide',
    'evaluadores_titulo': 'Valutatori',
    'evaluadores_registrados': 'Valutatori registrati',
    'codigos_disponibles_label': 'Codici disponibili',
    'evaluadores_seccion': 'Valutatori',
    'codigos_acceso_titulo': 'Codici di accesso',
    'config_pais': 'Paese',
    'config_telefono': 'Telefono',
    'config_correos_inst': 'Email istituzionali',
    'config_capital': 'Capitale',
    'config_city': 'Città',
    'config_town': 'Comune',
    'evaluacion_habilitada': 'Valutazione abilitata',
    'evaluaciones_titulo_card': 'Valutazioni',
    'decision_final_titulo': 'Decisione finale',
    'gestionar_comision_titulo': 'Gestisci commissione',
    'programar_visita_modal': 'Programma visita di valutazione',
    'fecha_llegada': 'Data di arrivo',
    'req_documentacion': 'Requisiti documentali',
    'todo_leido': 'Tutto letto',
    'confirmar_borrar_notifs': 'Eliminare tutte le notifiche?',
    'gala_creada_ok': 'Gala creata con successo',
    'gala_error_crear': 'Errore nella creazione della gala',
    'gala_activada': 'Gala attivata per le città',
    'gala_desactivada': 'Gala disattivata',
    'titularidades_titulo': 'Titolarità',
    'titularidades_desc': 'Città con titolo ACES attivo e monitoraggio degli obblighi',
    'obligaciones_titulo': 'Obblighi del titolare',
    'obligacion_imagen': 'Rispettare le regole immagine ACES',
    'obligacion_calendario': 'Progettare calendario sportivo annuale',
    'obligacion_congreso': 'Organizzare congresso o competizione internazionale',
    'obligacion_memoria': 'Presentare relazione e conclusioni annuali',
    'obligacion_awos': 'Partecipare attivamente ad AWoS/EWoS',
    'cumplidas': 'completate',
    'viaje_confirmar': 'Conferma proposta',
    'viaje_rechazar': 'Rifiuta proposta',
    'viaje_confirmado': 'Proposta confermata',
    'viaje_rechazado': 'Proposta rifiutata',
    'nota_respuesta': 'Nota di risposta (opzionale)',
    'voto_favor_confirm': 'Confermare voto favorevole?',
    'voto_contra_confirm': 'Confermare voto contrario?',
    'historial_sin_cambios': 'Nessuna variazione di stato registrata',
    'candidatura_buscar': 'Cerca città, premio...',
    'candidatura_ciudad_ph': 'Es: Buenos Aires',
    'candidatura_pais_ph': 'Es: Argentina',
    'candidatura_email_ph': 'citta@email.com',
    'dias_visita': 'giorni di visita',
    'propuestas_viaje': 'Proposte di viaggio',
    'sin_propuestas_viaje': 'Nessuna proposta di viaggio',
    'sin_propuestas_desc': 'I valutatori non hanno ancora proposto un itinerario.',
    'sin_evaluaciones_desc': 'Assegna valutatori e abilita la valutazione.',
    'seleccionar_pdf': 'Seleziona PDF',
    'rechazar_candidatura': 'Rifiuta candidatura',
    'motivo_rechazo': 'Motivo del rifiuto (obbligatorio)',
    'tit_sin_datos_desc': 'Le città assegnate appariranno qui automaticamente.',
    'marcado_cumplido': 'Segnato come completato',
    'desmarcado': 'Deselezionato',
    'finalizada': 'Completata',
    'finalizadas': 'Completate',
    'notas_label': 'Note',
    'sin_leer': 'non letti',
    'confirmar_cerrar_sesion': 'Disconnettersi?',
    'email_aces_europa': 'Email ACES Europa',
    'email_aces_america': 'Email ACES America',
    'gala_fecha_evento': 'Data dell\'evento',
    'gala_primera_desc': 'Crea la prima gala per iniziare a gestire le cerimonie.',
    'evaluadores_gestion': 'Gestione della commissione di valutazione ACES',
    'adjudicar': 'Aggiudicare',
    'adjudicada_ok': 'Candidatura aggiudicata!',
    'candidatura_rechazada': 'Candidatura rifiutata',
    'error_decision': 'Errore nel registrare la decisione',
    'evaluador_asignado': 'Valutatore assegnato',
    'evaluador_quitado': 'Valutatore rimosso',
    'jefe_designado': 'Capo commissione designato',
    'jefe_eliminado': 'Capo commissione rimosso',
    'notas_guardadas': 'Note salvate',
    'notas_visita_hint': 'Es.: Hotel consigliato, istruzioni aeroporto...',
    'visita_ok': 'Visita programmata con successo',
    'error_visita': 'Errore nella pianificazione',
    'evaluacion_hab_ok': 'Valutazione abilitata',
    'evaluacion_deshab_ok': 'Valutazione disabilitata',
    'programar': 'Programma',
    'confirmar_decision': 'Conferma decisione',
    'cambiar_modo': 'Cambia modalità',
    'de_preposicion': 'di',
    'notas_decision_label': 'Note decisione (opzionale)',
    'generar': 'Genera',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File ricevuto',
    'documentos_firmados': 'Documenti firmati',
    'pago_confirmado': 'Pagamento confermato',
    'subiendo_label': 'Caricamento...',
    'pagado_label': 'Pagato',
    'factura_label': 'Fattura',
    'marcar_factura': 'Segna fattura come emessa',
    'desmarcar_factura': 'Deseleziona fattura',
    'marcar_pago': 'Segna pagamento ricevuto',
    'desmarcar_pago': 'Deseleziona pagamento',
    'evaluacion_enviada': 'Inviata',
    'disponible_label': 'Disponibile',
    'ver_codigos_btn': 'Vedi codici',
    'invitar_eval_btn': 'Invita valutatore',
    'generar_codigo_btn': 'Genera nuovo codice',
    'idioma_destinatario': 'Lingua del destinatario',
    'candidaturas_count': 'candidature',
    'sin_alertas_ok': 'Tutto a posto. Nessun avviso in sospeso.',
    'sin_galas_configuradas': 'Nessuna gala configurata',
    'gala_activada_ciudades': 'Gala attivata per le città',
    'ver_alertas_label': 'Vedi avvisi',
    'modo_evaluador_activo': 'Modalita valutatore attiva',
    'modo_master_activo': 'Vista Master ACES',
    'cambiar_a_eval': 'Modalita valutatore',
    'cambiar_a_master': 'Torna a Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Regolamento',
    'doc_tipo_comprobante': 'Ricevuta di pagamento',
    'doc_tipo_contrato': 'Contratto',
    'doc_tipo_memoria': 'Rapporto',
    'doc_tipo_pres': 'Presentazione',
    'doc_tipo_otro': 'Altro',
    'selecciona_tipo_doc': 'Che tipo di documento?',
    'todos_label': 'Tutti',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Evento',
    'mis_propuestas': 'Le mie proposte',
    'propuestas_label': 'proposte',
    'ciudad_hotel': 'Città',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/notte',
    'hotel_notas_hint': 'Es.: Camera doppia, colazione inclusa...',
    'vuelo_notas_hint': 'Es.: Volo diretto, scalo a Madrid...',
    'fecha_label': 'Data',
    'hora_label': 'Ora',
    'lugar_label': 'Luogo',
    'tipo_reunion': 'Riunione',
    'tipo_visita_instalacion': 'Visita impianto',
    'tipo_acto': 'Atto ufficiale',
    'tipo_almuerzo': 'Pranzo / Cena',
    'tipo_transporte': 'Trasporto',
    'tipo_otro': 'Altro',
    'galardones_titulo': 'Premi',
    'reglamentos_titulo': 'Regolamenti',
    'sin_candidatura_titulo': 'Nessuna candidatura assegnata',
    'sin_candidatura_desc': 'Il tuo account non ha ancora una candidatura collegata.',
    'bienvenida_ciudad_saludo': 'Ciao, {nombre}',
    'bienvenida_ciudad_titulo': 'Il tuo account è attivo',
    'bienvenida_ciudad_desc': 'Stiamo preparando la tua candidatura. Non appena il team ACES te ne assegnerà una, apparirà qui con il monitoraggio completo.',
    'bienvenida_ciudad_chip_activa': 'Account attivo',
    'bienvenida_ciudad_chip_espera': 'In attesa di assegnazione',
    'bienvenida_ciudad_contacto': 'Hai dubbi? Contatta ACES',
    'chat_ciudad_desc': 'Comunicazione diretta con il team ACES.',
    'mensajes_label': 'Messaggi',
    'motor_seccion_de': 'di',
    'gala_confirmar_desc': 'Indica se la tua città parteciperà alla cerimonia di gala.',
    'eval_completadas': 'Completate',
    'secciones_completadas': 'sezioni completate',
    'evaluaciones_enviadas_abrev': 'valutazioni inviate',
    'awos_activa_desc': 'Registra la tua attività fisica e accedi agli eventi ACES',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'I tuoi dati di viaggio sono visibili solo ad ACES.',
    'eval_docs_solo_lectura': 'Puoi visualizzare i documenti inviati dalla città.',
    'conflicto_titulo': 'Dichiarazione di conflitto di interessi',
    'conflicto_desc': 'Prima di valutare, conferma di non avere conflitti di interessi.',
    'conflicto_sin_conflicto': 'Nessun conflitto — procedi',
    'conflicto_con_conflicto': 'Ho un conflitto',
    'conflicto_aviso': 'Notifica immediatamente ACES.',
    'sin_fecha': 'Senza data',
    'subir_reserva_hint': 'Carica il PDF di prenotazione confermata.',
    'subir_reserva_hint_eval': 'Carica il PDF della tua prenotazione.',
    'login_sin_cuenta': 'Non hai un account?',
    'agenda_oficial_titulo': 'Agenda ufficiale della visita',
    'agenda_anadir_evento': 'Aggiungi evento',
    'agenda_editar_evento': 'Modifica evento',
    'agenda_oficial_aviso': 'Questa agenda e visibile ai valutatori.',
    'agenda_oficial_vacia': 'Nessun evento pubblicato ancora.',
    'publicar_evento': 'Pubblica evento',
    'evento_publicado': 'Evento pubblicato',
    'evento_guardado': 'Evento aggiornato',
    'evento_eliminado': 'Evento eliminato',
    'confirmar_eliminar': 'Eliminare questo evento?',
    'guardar_cambios': 'Salva modifiche',
    'pipeline_titulo': 'Pipeline candidature',
    'revenue_titulo': 'Entrate',
    'revenue_total': 'Totale fatturato',
    'cobrado': 'Incassato',
    'visitas_proximas': 'Visite imminenti',
    'paises_titulo': 'Per paese',
    'awos_banner_desc': 'Registra la tua attivita fisica e accedi agli eventi ACES',
    'fecha_limite_confirmar': 'Scadenza conferma',
    'info_parlamento': 'Info Parlamento Europeo',
    'info_venue': 'Sede',
    'norma_hotel': 'Regole hotel',
    'norma_vuelo': 'Regole volo',
    'programa_dia': 'Programma del giorno',
    'sin_programa': 'Nessun programma',
    'actividad_placeholder': 'Attivita...',
    'anadir': 'Aggiungi',
    'representantes_label': 'Rappresentanti',
    'confirmados_label': 'Confermati',
    'fecha_limite': 'Scadenza',
    'deadline_pasada': 'Scadenza passata',
    'restantes': 'rimanenti',
    'anadir_representante': 'Aggiungi rappresentante',
    'sin_representantes': 'Nessun rappresentante',
    'representante_anadido': 'Rappresentante aggiunto',
    'representante_eliminado': 'Rappresentante rimosso',
    'programa_actualizado': 'Programma aggiornato',
    'confirmado': 'CONFERMATO',
    'nombre_label': 'Nome completo',
    'cargo_label': 'Carica',
    'telefono_label': 'Telefono',
    'logistica_evaluadores': 'Logistica valutatori',
    'vuelo_short': 'Volo',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Documenti obbligatori',
    'evidencia_subida': 'Evidenza caricata',
    'sancion_anadida': 'Sanzione registrata',
    'memoria_subida': 'Relazione finale caricata',
    'nueva_sancion': 'Nuova sanzione',
    'motivo_sancion': 'Motivo',
    'motivo_sancion_hint': 'Es: Mancata partecipazione al gala',
    'importe_label': 'Importo',
    'divisa_label': 'Valuta',
    'registrar_sancion': 'Registrare sanzione',
    'subir_evidencia': 'Caricare',
    'memoria_final_titulo': 'Relazione finale',
    'memoria_deadline': 'Entro il 31 gennaio',
    'subir_memoria': 'Caricare relazione finale (PDF)',
    'sin_sanciones': 'Nessuna sanzione',
    'evidencias_short': 'evidenze',
    'memoria_ok': 'Relazione OK',
    'sanciones_short': 'sanzioni',
    'dias_en_fase': 'Giorni in fase',
    'proximo_pago': 'Prossimo pagamento',
    'vencido': 'Scaduto',
    'visita_label': 'Visita',
    // === Paquete 2 — 85 keys faltantes (it) ===
    'abrir_nueva_pestana': 'Apri in una nuova scheda',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Articoli',
    'auth_accediendo': 'Accesso in corso...',
    'auth_email_enviado': 'Email inviata. Controlla la posta in arrivo.',
    'auth_enviar_enlace': 'Invia link',
    'auth_error_intentos': 'Troppi tentativi. Attendere.',
    'auth_error_password': 'Password errata',
    'auth_error_reset': 'Errore invio email di recupero',
    'auth_error_usuario': 'Utente non trovato',
    'auth_introduce_email': 'Inserisci la tua email',
    'auth_olvido_password': 'Password dimenticata',
    'auth_recuperar': 'Reimposta password',
    'auth_recuperar_desc': 'Ti invieremo un link per reimpostare la tua password.',
    'aw_h': 'Settimana Americana dello Sport',
    'aw_lbl': 'AWoS',
    'aw_p': 'Celebra lo sport e attivita fisica con la tua citta durante la Settimana Americana dello Sport.',
    'bonus_desc': 'Punti aggiuntivi per iniziative eccezionali',
    'buscar_articulo': 'Cerca articolo...',
    'buscar_recursos': 'Cerca nelle risorse...',
    'comite_evaluacion': 'Comitato di valutazione',
    'confirmar_eliminar_pago': 'Sei sicuro di voler eliminare questo pagamento?',
    'cookie_accept': 'Accetta',
    'cookie_more': 'Maggiori informazioni',
    'cookie_msg': 'Utilizziamo cookie essenziali per il funzionamento del sito.',
    'cookie_reject': 'Rifiuta',
    'criterios_elegibilidad': 'Criteri di ammissibilita',
    'cta_b1': 'Presenta candidatura',
    'cta_b2': 'Contatta ACES',
    'cta_h': 'Inizia la tua candidatura oggi',
    'cta_p': 'Unisciti alla rete delle citta europee dello sport e trasforma la tua comunita.',
    'descargar_factura': 'Scarica fattura',
    'docs_drag_drop': 'Trascina i file qui o clicca per selezionare',
    'docs_obligatorios': 'Documenti obbligatori',
    'eval_actual': 'Valutazione attuale',
    'eval_comentario_voto_placeholder': 'Commento sul tuo voto (opzionale)...',
    'eval_max_puntos': 'Punteggio massimo',
    'feats': 'Funzionalita',
    'footer_contact': 'Contatto',
    'footer_legal': 'Note legali',
    'footer_privacy': 'Politica sulla privacy',
    'ft_h': 'Tutto cio di cui hai bisogno',
    'ft_lbl': 'Funzionalita',
    'general_volver': 'Indietro',
    'hero_cta1': 'Presenta candidatura',
    'hero_cta2': 'Scopri il processo',
    'hero_h1a': 'La tua citta merita',
    'hero_h1b': 'di essere riconosciuta',
    'hero_sub': 'ACES Cities Network collega citta, valutatori e organizzazioni sportive in una piattaforma.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Cancella',
    'login_subtitulo': 'Accedi al tuo account ACES Cities Network',
    'marcar_todas_leidas': 'Segna tutto come letto',
    'nav_acceder': 'Accedi',
    'nav_funciones': 'Funzioni',
    'nav_galardones': 'Premi',
    'nav_proceso': 'Processo',
    'nav_registro': 'Registrazione',
    'nav_roles': 'Ruoli',
    'notif_todas_leidas': 'Tutte le notifiche segnate come lette',
    'pago_eliminado': 'Pagamento eliminato',
    'pendiente': 'In sospeso',
    'pendiente_label': 'In sospeso',
    'pipe_h': 'Processo trasparente',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Segui ogni fase della tua candidatura in tempo reale.',
    'preambulo': 'Preambolo',
    'recursos_aces_desc': 'Premi, regolamenti e documentazione ufficiale ACES.',
    'recursos_aces_titulo': 'Risorse ACES',
    'reglamentos_seed': 'Regolamenti caricati con successo',
    'regulacion_sin_articulos': 'Questo regolamento non ha articoli.',
    'roles_h': 'Per ogni ruolo',
    'roles_lbl': 'Ruoli',
    'roles_p': 'Citta, valutatori e amministratori in una piattaforma.',
    'sancion_incumplimiento': 'Sanzione per inadempienza',
    'sin_articulos': 'Nessun articolo',
    'sin_galardones': 'Nessun premio disponibile',
    'sin_reglamentos': 'Nessun regolamento disponibile',
    'sin_recursos': 'Nessuna risorsa disponibile',
    'sin_resultados': 'Nessun risultato',
    'stages': 'Fasi',
    'tasa_inscripcion': 'Tassa di iscrizione',
    'todas': 'Tutte',
    'ver_candidatura': 'Vedi candidatura',
    'reserva_sin_evaluador': 'Generale (nessun valutatore assegnato)',
    'preview_pdf_hint': 'I PDF si aprono in una nuova scheda del browser.',
    'descargar': 'Scarica',
    'con_pago_confirmado': 'con pagamento confermato (traguardo)',
    'pendientes_pago': 'in sospeso',
    'sin_datos_pagos': 'Nessun dato di pagamento registrato',
    'eval_no_asignado': 'Non sei assegnato alla commissione di valutazione di questa candidatura.',
    'subir_reserva': 'Carica prenotazione',
    'sin_reservas': 'Nessuna prenotazione',
    'sin_reservas_desc': 'Carica i PDF delle prenotazioni.',
    'reservas_desc_master': 'Carica le prenotazioni di volo e hotel confermate in PDF. Puoi selezionare il valutatore corrispondente.',
    'subir_agenda': 'Carica agenda (PDF)',
    'agenda_visita_titulo': 'Agenda della visita',
    'reservas_titulo': 'Prenotazioni',
    'reserva_subida_ok': 'Prenotazione caricata',
    'agenda_subida_ok': 'Agenda caricata',
    'doc_eliminado': 'Documento eliminato',
    'agenda_vacia_desc': 'Carica il PDF dell\'agenda della visita.',
    'revenue_cobrado': 'Riscosso',
    'revenue_pendiente': 'In sospeso',
    'ciudad_hitos_titulo': 'Stato della tua candidatura',
    'hito_factura_recibida': 'Fattura ricevuta',
    'eval_mis_evaluaciones': 'Le mie valutazioni',
    'eval_sin_bid': 'La città non ha ancora caricato il BID File.',
    'voto_final_desc_motor': 'Esprimi il tuo voto finale basato sulla valutazione.',
    'chat_comision': 'Chat commissione',
    'tit_comunicacion_ok': 'Comunicazione ufficiale OK',
    'tit_derechos_factura_env': 'Diritti immagine: fattura inviata',
    'tit_derechos_pagado': 'Diritti immagine: pagata',
    'tit_q1': 'Report trimestrale Q1',
    'tit_q2': 'Report trimestrale Q2',
    'tit_q3': 'Report trimestrale Q3',
    'tit_q4': 'Report trimestrale Q4',
    'tit_premio_n1': 'Premio N1: Partecipa?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Nuova sanzione',
    'motivo': 'Motivo',
    'si': 'Sì',
    'no': 'No',
    'nueva': 'Nuovo',
    'sanciones': 'Sanzioni',
    'pagada': 'Pagata',

    'borrar_candidatura': 'Elimina candidatura',
    'borrar_candidatura_desc': 'Elimina permanentemente la candidatura e tutti i dati associati.',
    'confirmar_borrar_candidatura': 'Eliminare questa candidatura? Questa azione NON puo essere annullata.',
    'confirmar_borrar_candidatura_2': 'SEI SICURO? TUTTI i documenti, pagamenti, valutazioni e chat saranno eliminati.',
    'candidatura_eliminada': 'Candidatura eliminata',
    'zona_peligrosa': 'Zona pericolosa',
    'contacto_ciudad': 'Contatto citta',
    'sin_ciudad_vinculada': 'Nessun utente citta collegato',
    'cambiar_ciudad': 'Cambiare',
    'vincular_ciudad': 'Collegare',
    'vincular_ciudad_titulo': 'Collega utente citta',
    'vinculado_actual': 'Attualmente collegato',
    'desvincular': 'Scollegare',
    'buscar_usuario_ciudad': 'Cerca per nome, email o citta...',
    'sin_usuarios_ciudad': 'Nessun utente con ruolo citta registrato',
    'ciudad_vinculada_ok': 'Citta collegata con successo',
    'ciudad_desvinculada': 'Citta scollegata',
    'vincular': 'Collegare',
    'codigo_generado': 'Codice generato',
    'codigo_generado_ok': 'Codice citta generato',
    'codigo_vinculado_candidatura': 'Pre-collegato a questa candidatura',
    'idioma_carta': 'Lingua della lettera',
    'carta_copiada': 'Lettera copiata negli appunti',
    'copiar_carta': 'Copia',
    'enviar_invitacion': 'Apri email',
    'email_cliente_abierto': 'Client email aperto',
    'estado_avanza_aceptada': 'Candidatura accettata automaticamente',
    'estado_avanza_documentacion': 'Passaggio alla fase documentazione',
    'estado_avanza_visita': 'Passaggio alla fase visita',
    'estado_avanza_evaluacion': 'Passaggio alla fase valutazione',
    'confirmar_avance_estado': 'Avanzare stato a',
    'estado_cambiado': 'Stato cambiato in',
    'eval_ciudades_galardonadas': 'Citta premiate',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Delegato',
    'delegado_desc': 'Il delegato può vedere lo stato della candidatura e i documenti in sospeso.',
    'asignar_delegado': 'Assegnare',
    'cambiar_delegado': 'Cambiare',
    'sin_delegado': 'Nessun delegato assegnato',
    'confirmar_quitar_delegado': 'Rimuovere il delegato da questa candidatura?',
    'delegado_quitado': 'Delegato rimosso',
    'delegado_asignado': 'Delegato assegnato',
    'delegado_existente': 'Utente esistente',
    'delegado_invitar': 'Invita per email',
    'generar_codigo_delegado': 'Genera codice delegato',
    'codigo_delegado_generado': 'Codice generato — invia il mail',
    'nombre_delegado_hint': 'Nome del delegato',
    'email_delegado_hint': 'email@esempio.com',
    'confirmar_retroceso_estado': 'Retrocedere lo stato a',
    'accion_gala': 'Invita al Gala',
    'accion_gala_desc': 'Conferma il gala e aggiungi la città all\'evento annuale.',
    'accion_notificar': 'Segna come notificata',
    'accion_notificar_desc_simple': 'Cambia lo stato a notificata. La comunicazione alla città avviene fuori dall\'app.',
    'accion_premio': 'Consegna premio',
    'accion_titularidad': 'Attiva titolarità',
    'activar_titularidad': 'Attiva titolarità',
    'anos_label': 'Anni',
    'aprobar_informe': 'Approva',
    'archivo_muy_grande': 'Il file supera i 50 MB',
    'badge': 'Badge',
    'cambiar_estado': 'Cambia stato',
    'candidatura_actualizada': 'Candidatura aggiornata',
    'chat_ayer': 'Ieri',
    'chat_hoy': 'Oggi',
    'chat_primer_mensaje': 'Invia il primo messaggio',
    'checklist_obligaciones': 'Obblighi',
    'ciudad_notificada': 'Città notificata',
    'comentario_rechazo': 'Commento obbligatorio per il rifiuto:',
    'comite_label': 'Comitato',
    'confirmar_cambio_estado': 'Confermare il cambio di stato?',
    'confirmar_gala': 'Conferma gala',
    'confirmar_notificar': 'Segnare come notificata?',
    'confirmar_pago': 'Conferma pagamento ricevuto',
    'Copiado': 'Copiato',
    'delegado_info_restriccion': 'Come delegato puoi vedere lo stato della pipeline e l\'agenda delle visite. Per accedere al motore di valutazione o al BID File, richiedi l\'assegnazione come valutatore ad ACES.',
    'delegado_mis_candidaturas': 'Come delegato',
    'delegado_vista': 'Vista delegato',
    'delegado_vista_restringida': 'Vista limitata: solo pipeline, agenda e documenti in sospeso. Nessun pagamento o valutazione.',
    'derechos_imagen': 'Diritti d\'immagine',
    'editar_candidatura': 'Modifica candidatura',
    'Eliminado': 'Eliminato',
    'email': 'Email',
    'emitir_factura': 'Emetti fattura (PDF)',
    'entre_miembros': 'Tra',
    'espera_repetir': 'Attesa per ripetere',
    'estado_actualizado': 'Stato aggiornato',
    'estado_gala_confirmada': 'Gala confermato',
    'estado_notificada': 'Notificata',
    'estado_notificada_rechazo': 'Rifiuto notificato',
    'estado_premio_otorgado': 'Premio assegnato',
    'estado_titularidad_activa': 'Titolarità attiva',
    'eval_comentario_criterio': 'Commenti su questo criterio...',
    'factura': 'Fattura',
    'factura_emitida': 'Fattura caricata',
    'fase_candidatura': 'Candidatura',
    'fase_seguimiento': 'Monitoraggio',
    'gala_confirmada_ok': 'Gala confermato',
    'Guardado': 'Salvato',
    'hito_agenda': 'Agenda di visita accettata',
    'hito_carta': 'Lettera di candidatura accettata',
    'hito_pago': 'Fattura pagata',
    'hito_reglamento_env': 'Regolamento ricevuto',
    'hito_reglamento_firm': 'Regolamento firmato',
    'hito_viajes': 'Logistica di viaggio completata',
    'image_rights': 'Diritti d\'immagine',
    'importe': 'Importo',
    'informe_aprobado': 'Report approvato',
    'informe_rechazado': 'Report rifiutato',
    'informe_subido': 'Report caricato',
    'informes_trimestrales': 'Report trimestrali',
    'marcar_notificada': 'Segna come notificata',
    'marcar_premio': 'Segna premio assegnato',
    'max_candidatos': 'Max candidati',
    'miembros_label': 'Membri',
    'notificar_rechazo': 'Notifica rifiuto',
    'nueva_version': 'Nuova versione',
    'ocultar': 'Nascondi',
    'permisos_documento': 'Permessi del documento',
    'permisos_guardados': 'Permessi salvati',
    'poblacion_maxima': 'Popolazione massima',
    'poblacion_minima': 'Popolazione minima',
    'rechazar_informe': 'Rifiuta',
    'region_africa': 'Africa',
    'region_americas': 'Americhe',
    'region_asia': 'Asia',
    'region_europa': 'Europa',
    'region_mundial': 'Mondiale',
    'region_oceania': 'Oceania',
    'reglamentos_pendientes': 'Regolamenti in sospeso',
    'seleccionar_tipo': 'Tipo di documento',
    'sin_resultados_busqueda': 'Nessun risultato trovato',
    'subir_informe': 'Carica report',
    'tasa_label': 'Tassa',
    'tipo_anexo': 'Allegato',
    'tipo_especial': 'Speciale',
    'tipo_no_permitido': 'Tipo di file non consentito. Usare PDF, DOC, DOCX, XLS, XLSX, JPG o PNG',
    'tipo_principal': 'Principale',
    'titularidad_activa_label': 'Titolarità attiva',
    'titularidad_creada': 'Titolarità creata',
    'titularidad_panel': 'La mia titolarità',
    'tomar_decision_final': 'Prendere decisione finale',
    'ver_documento': 'Vedi',
    'ver_escala': 'Vedi scala',
    'ver_reglamento': 'Vedi regolamento completo',
    'ver_seguimiento': 'Vedi monitoraggio titolarità',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Città',
    'visible_evaluador': 'Valutatore',
    'visible_master': 'Master',
    'visible_para': 'Visibile a',
    'warning_quitar_adjudicada': 'Tornando indietro prima di "Aggiudicata" si rimuoverà il contrassegno permanente.',
    'warning_retroceso': 'Sei sicuro di voler retrocedere lo stato?',
    'y_label': 'e',
    'Q1_nombre': 'Gen-Mar',
    'Q2_nombre': 'Apr-Giu',
    'Q3_nombre': 'Lug-Set',
    'Q4_nombre': 'Ott-Dic',
    'informe_pendiente': 'In attesa',
    'pago_pendiente': 'In attesa',
    'checklist_logo_aces': 'Uso corretto del logo ACES',
    'checklist_memoria_anual': 'Relazione annuale consegnata',
    'checklist_congreso': 'Partecipazione al congresso ACES',
    'checklist_imagen_corporativa': 'Immagine aziendale aggiornata',
    'checklist_calendario_deportivo': 'Calendario sportivo pubblicato',
    'asignar_evaluadores': 'Assegnare valutatori',
    'notas_internas_opcional': 'Note interne (opzionale)',
    'estado_candidatura': 'Stato della candidatura',
    'hito_carta_recibida': 'Lettera di candidatura ricevuta',
    'hito_candidatura_aceptada': 'Candidatura accettata',
    'hito_reglamento_enviado': 'Regolamento inviato',
    'hito_reglamento_firmado': 'Regolamento firmato',
    'hito_datos_facturacion': 'Dati di fatturazione ricevuti',
    'hito_pago_confirmado': 'Pagamento confermato',
    'hito_fechas_visita': 'Date di visita accettate',
    'hito_comision_cerrada': 'Commissione chiusa',
    'hito_reservas_completadas': 'Prenotazioni completate',
    'hito_agenda_subida': 'Agenda caricata',
    'hito_bid_file_recibido': 'BID File ricevuto',
    'editar_visita': 'Modifica visita',
    'programar_visita_btn': 'Programmare visita',
    'gestionar_comision': 'Gestire commissione',
    'pagos_titulo': 'Pagamenti',
    'sin_pagos': 'Nessun pagamento registrato',
    'factura_marcada': 'Fattura contrassegnata',
    'factura_desmarcada': 'Fattura non contrassegnata',
    'pago_confirmado_label': 'Pagamento confermato',
    'pago_desmarcado': 'Pagamento non contrassegnato',
    'vence_label': 'Scadenza',
    'factura_label': 'Fattura',
    'pagado_label': 'Pagato',
    'documentos_titulo': 'Documenti',
    'archivos_count': 'file',
    'archivos_count_plural': 'file',
    'subir_btn': 'Carica',
    'sin_documentos': 'Nessun documento caricato',
    'aprobado_label': 'Approvato',
    'rechazado_label': 'Rifiutato',
    'sin_permisos': 'Senza permessi',
    'ver_label': 'Vedi',
    'logistica_titulo': 'Logistica',
    'agenda_visita': 'Agenda della visita',
    'subir_pdf': 'Carica PDF',
    'sin_agenda': 'Nessuna agenda caricata',
    'reservas_titulo': 'Prenotazioni',
    'general_sin_eval': 'Generale (senza valutatore)',
    'subir_reserva': 'Carica prenotazione',
    'sin_reservas': 'Nessuna prenotazione caricata',
    'agenda_subida_ok': 'Agenda caricata',
    'reserva_subida_ok': 'Prenotazione caricata',
    'evaluador_actualizado': 'Valutatore aggiornato',
    'general_todos_eval': 'Generale (tutti i valutatori)',
    'cambiar_evaluador': 'Cambia valutatore',
    'evaluaciones_titulo': 'Valutazioni',
    'enviada_label': 'inviata',
    'enviadas_label': 'inviate',
    'en_progreso_label': 'in corso',
    'comision_asignada': 'Commissione assegnata',
    'evaluador_label': 'valutatore',
    'evaluadores_label': 'valutatori',
    'jefe_label': 'Capo',
    'sin_empezar': 'Non iniziato',
    'sin_evaluadores': 'Nessun valutatore assegnato',
    'enviada_badge': 'Inviata',
    'favorable_label': 'Favorevole',
    'desfavorable_label': 'Sfavorevole',
    'desbloquear_label': 'Sbloccare',
    'evaluacion_desbloqueada': 'Valutazione sbloccata',
    'error_desbloquear': 'Errore nello sblocco',
    'pdf_generado': 'PDF generato',
    'error_pdf': 'Errore nella generazione del PDF',
    'en_progreso_badge': 'In corso',
    'tomar_decision': 'Prendere la decisione finale',
    'cerrar_menu': 'Chiudi menu',
    'compartir_tel_ciudad': 'Condividere il telefono con la città candidata',
    'compartir_tel_eval': 'Condividere il telefono con altri valutatori',
    'notas_internas': 'Note interne',
    'notas_privadas_placeholder': 'Note private...',
    'guardado_ok': 'Salvato',
    'generar_btn': 'Genera',
    'copiado_ok': 'Copiato',
    'idioma_destinatario': 'Lingua del destinatario',
    'codigo_acceso_modal': 'Codice di accesso',
    'gala_activa': 'ATTIVA',
    'gala_inactiva': 'INATTIVA',
    'calendario_carta': 'Lettera sindaco: 30 mar',
    'calendario_bid': 'File BID: 30 giu',
    'calendario_preseleccion': 'Pre-selezione: 31 lug',
    'calendario_visitas': 'Visite: ott',
    'calendario_gala': 'Gala: nov',
    'calendario_titularidad': 'Titolarità: 1 gen successivo',
    'candidatura_singular': 'candidatura',
    'candidaturas_plural': 'candidature',
    'doc_tipo_bid_file': 'File BID',
    'doc_tipo_presentacion': 'Presentazione',
    'progreso_inicio': 'Inizio',
    'progreso_adjudicada': 'Assegnata',
    'hab_label': 'ab.',
    'eval_abreviado': 'val.',
    'min_poblacion_label': 'Popolazione min.',
    'max_poblacion_label': 'Popolazione max.',
    'max_candidatos_label': 'Massimo candidati',
    'espera_label': 'Periodo di attesa',
    'anos_label': 'anni',
    'image_rights': 'Diritti d\'immagine',
    'comite_label': 'Comitato',
    'miembros_label': 'membri',
    'usado_label': 'USATO',
    'disponibles_count': 'Disponibili',
    'usados_count': 'Usati',
    'codigos_disponibles_count': 'Codici disponibili',
    'hotel_placeholder': 'Hotel assegnato, check-in, regole...',
    'vuelo_placeholder': 'Aeroporto, orari, classe...',
    'parlamento_placeholder': 'Indirizzo, norme di accesso, protocollo...',
    'dni_pasaporte': 'Documento / Passaporto',
    'cerrar_menu': 'Chiudi menu',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'email_aces_europa': 'Email ACES Europe',
    'info_parlamento': 'Info Parlamento europeo',
    'sin_fecha_visita': 'Nessuna data di visita',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Commento sulla sezione',
    'eval_comentario_seccion_placeholder': 'Commento generale sulla sezione (facoltativo)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Errore: {0}',
    'pdf_evaluacion': 'Valutazione in PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Rapporto di valutazione',
    'pdf_ciudad': 'Città',
    'pdf_evaluador': 'Valutatore',
    'pdf_fecha': 'Data',
    'pdf_total': 'Punteggio totale',
    'pdf_secciones': 'Sezioni',
    'pdf_voto_final': 'Voto finale',
    'pdf_comentario_voto': 'Commento al voto',
    'pdf_no_evaluada': 'Non valutata',
    'pdf_generado_por': 'Generato da ACES Cities Network · {0}',
    'email_placeholder': 'nome@esempio.it',
    'ej_nombre_persona': 'Es.: Maria Rossi',
    'ej_aeropuerto': 'Es.: Roma (FCO)',
    'pdf_permitir_popups': 'Consenti i pop-up per esportare il PDF',
    'confirmar': 'Conferma',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Attenzione',
    'confirmar_eliminar_doc': 'Eliminare questo documento? L’azione non può essere annullata.',
    'confirmar_eliminar_logistica': 'Eliminare questo documento di logistica?',
    'confirmar_notificar_titulo': 'Notifica la città',
    'confirmar_retroceso_titulo': 'Conferma il ritorno allo stato precedente',
    'eliminado': 'Eliminato',
    'quitar_delegado_titulo': 'Rimuovi delegato',
    'warning_quitar_adjudicada_titulo': 'Rimuovi aggiudicazione',
    'warning_retroceso_2': 'CONFERMARE? I dati verranno eliminati in modo irreversibile (date, registrazioni della cerimonia, ecc.). L’azione NON può essere annullata.',
    'warning_retroceso_titulo': 'Torna allo stato precedente',
    'eval_pts': 'pti',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Prenotazione volo',
    'viaje_tipo_reserva_hotel': 'Prenotazione hotel',
    'reserva_generica': 'Prenotazione',
  },
  'nl': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'We kunnen deze code niet vinden. Controleer of hij volledig is, bijvoorbeeld: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Deze code is al gebruikt. Bent u al geregistreerd, log dan in. Vraag anders een nieuwe code aan ACES.',
    'codigo_expirado': 'Deze code is verlopen. Vraag een nieuwe code aan ACES.',
    'codigo_admin': 'Dit is een beheercode en kan hier niet worden gebruikt om te registreren. Neem contact op met ACES.',
    'registro_error_general': 'De registratie kon niet worden voltooid en er is geen account aangemaakt. Probeer het opnieuw; lukt het weer niet, neem dan contact op met ACES.',
    'email_ya_registrado_login': 'Dit e-mailadres heeft al een account. Tik op "Inloggen" en gebruik "Wachtwoord vergeten?" als u uw wachtwoord niet meer weet.',
    'nueva_gala_btn': 'Gala aanmaken',
    'programar_visita': 'Evaluatiebezoek plannen',
    'guardar_notas': 'Notities opslaan',
    'historial_estados': 'Statusgeschiedenis',
    'notas_privadas_hint': 'Privénotities over deze kandidatuur (alleen zichtbaar voor masters)...',
    'voto_emitido': 'Stem uitgebracht:',
    'voto_en_contra': 'Tegen',
    'voto_a_favor': 'Voor',
    'voto_final_desc': 'De kandidatuur bevindt zich in de stemfase. Breng uw stem uit.',
    'voto_final_titulo': 'Eindstem vereist',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titelhouders — binnenkort',
    'email_abierto': 'Uw e-mailclient is geopend',
    'cargo_hint': 'Bijv.: Wethouder Sport',
    'password_repetir_hint': 'Herhaal wachtwoord',
    'password_min': 'Minimaal 6 tekens',
    'placeholder_apellido_ej': 'Jansen',
    'placeholder_nombre_ej': 'Maria',
    'error_guardar': 'Fout bij opslaan',
    'error_label': 'Fout',
    'error_subir': 'Uploadfout',
    'error_cambiar_password': 'Fout bij wijzigen wachtwoord',
    'candidatura_no_encontrada': 'Kandidatuur niet gevonden',
    'puntuacion_final': 'Eindscore',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Bestemming',
    'origen_label': 'Vertrekpunt',
    'notif_actividad_desc': 'De activiteit van uw kandidaturen verschijnt hier.',
    'placeholder_ej_espana': 'Bijv.: Spanje',
    'placeholder_ej_madrid': 'Bijv.: Madrid',
    'gala_lugar_hint': 'Bijv.: Congrespaleis',
    'gala_titulo_hint': 'Bijv.: ACES América Gala 2026',
    'gala_descripcion_hint': 'Evenementomschrijving...',
    'gala_pais': 'Evenementenland',
    'gala_ciudad': 'Evenementenstad',
    'gala_lugar': 'Ceremonieplek',
    'gala_titulo_label': 'Gala-titel',
    'visible_ciudades': 'Zichtbaar voor steden',
    'nueva_gala': 'Nieuwe gala',
    'sin_galas': 'Geen gala\'s geconfigureerd',
    'gala_gestion': 'Beheer galaceremonie',
    'gala_aces_titulo': 'ACES Gala',
    'codigo_copiado': 'Code gekopieerd',
    'error_generar_codigo': 'Fout bij genereren code',
    'nombre_eval_email': 'Naam evaluator (voor e-mail)',
    'invitar_evaluador': 'Evaluator uitnodigen',
    'sin_evaluadores': 'Geen evaluatoren geregistreerd',
    'preview': 'Voorbeeld',
    'ver_todos': 'Alles bekijken',
    'total_candidaturas': 'Totale kandidaturen',
    'titulos_adjudicados': 'Toegewezen titels',
    'tamano_comite': 'Commissiegrootte (evaluatoren)',
    'sanciones_asistencia': 'Sancties voor afwezigheid (€)',
    'tasas_participacion': 'Deelnamekosten (€)',
    'config_sistema_perfil': 'Systeem en profiel',
    'sin_candidaturas_desc2': 'Probeer de filters te wijzigen of maak een nieuwe aan.',
    'placeholder_pais_ej': 'Bijv.: Argentinië',
    'placeholder_ciudad_ej': 'Bijv.: Buenos Aires',
    'buscar_evaluador': 'Evaluator zoeken...',
    'notas_decision_hint': 'Interne notities over de beslissing...',
    'concepto_placeholder': 'Bijv.: Deelnamekosten 2026',
    'sin_jefe_asignado': 'Geen hoofd toegewezen',
    'jefe_comision': 'Commissiehoofd',
    'ciudad_label': 'Stad',
    'descargar_app_store': 'Download in App Store',
    'aforo_maximo': 'Maximale capaciteit',
    'descripcion_label': 'Beschrijving',
    'convocatoria_label': 'Oproep',
    'abrir_email': 'E-mail openen',
    'crear_gala': 'Gala aanmaken',
    'en_evaluacion': 'In evaluatie',
    'emails_institucionales': 'Institutionele e-mails',
    'email_evaluador': 'E-mail evaluator',
    'codigo_acceso_label': 'Toegangscode',
    'codigos_acceso': 'Toegangscodes',
    'seleccionar_galardon': 'Onderscheiding selecteren...',
    'todos_galardones': 'Alle onderscheidingen',
    'todos_estados': 'Alle statussen',
    'cargando_dashboard': 'Laden...',
    'candidaturas_recientes': 'Recente kandidaturen',
    'candidaturas_activas': 'Actieve kandidaturen',
    'alertas_sistema': 'Systeemwaarschuwingen',
    'accesos_rapidos': 'Snelle acties',
    'viaje_titulo': 'Reis',
    'nuevo': 'Nieuw',
    'estado': 'Status',
    'abrir_votacion': 'Stemming openen',
    'accion_anadir_evaluador': 'Evaluator toevoegen',
    'accion_master': 'Masteractie',
    'accion_nueva_candidatura': 'Nieuwe kandidatuur',
    'accion_ver_alertas': 'Waarschuwingen bekijken',
    'actividad': 'Actividad',
    'agenda_notas': 'Interne notities',
    'agenda_notas_hint': 'Bijv. De evaluator wordt ontvangen door de Burgemeester...',
    'agenda_pdf_listo': 'Agenda PDF bijgevoegd',
    'agenda_propuesta_enviada': 'Agenda-evenement verzonden',
    'agenda_subir_pdf': 'PDF agenda uploaden (optioneel)',
    'agenda_tipo_evento': 'Type evenement',
    'agenda_titulo_evento': 'Evenementtitel',
    'agenda_vacia': 'Lege agenda',
    'alerta_decision_pendiente': 'Beslissing in behandeling',
    'alerta_docs_pendientes': 'Openstaande documenten',
    'alerta_pago_vencido': 'Achterstallige betaling',
    'alerta_sin_evaluadores': 'Geen evaluatoren toegewezen',
    'alertas_titulo': 'Alertas',
    'anos': 'jaar',
    'anterior': 'Vorige',
    'apellidos': 'Achternaam',
    'aprobar': 'Aprobar',
    'asignacion_ciudad_hint': 'Bijv.: Amsterdam',
    'asignacion_ciudad_salida': 'Vertrekstad voor het bezoek',
    'asignacion_ciudad_salida_desc': 'De stad van waaruit u vertrekt voor het evaluatiebezoek.',
    'asignacion_compartir_ciudad': 'Telefoon delen met de stad',
    'asignacion_compartir_ciudad_desc': 'De stad kan uw telefoonnummer en WhatsApp zien.',
    'asignacion_compartir_eval_desc': 'De andere evaluatoren van deze kandidatuur kunnen uw contact zien.',
    'asignacion_compartir_evaluadores': 'Delen met andere evaluatoren',
    'asignacion_confirmar': 'Bevestigen en starten',
    'asignacion_nota': 'Opmerking voor de stad (optioneel)',
    'asignacion_nota_desc': 'Deze opmerking is zichtbaar voor het team van de kandidaatstad.',
    'asignacion_nota_hint': 'Bijv.: Ik kom dinsdag ochtend met de trein...',
    'asignacion_privacidad': 'Privacy en contact',
    'asignacion_sub': 'Configureer uw contactgegevens voor deze kandidatuur voordat u begint.',
    'asignacion_titulo': 'Nieuwe toewijzing',
    'asignar_ciudad_titulo': 'Stad toewijzen',
    'asignar_evaluador': 'Evaluator toewijzen',
    'auth_cargando': 'Iniciando...',
    'auth_cerrar_sesion': 'Cerrar sesión',
    'auth_email': 'Email',
    'auth_entrar': 'Iniciar sesión',
    'auth_error_credenciales': 'Email o contraseña incorrectos.',
    'auth_error_red': 'Sin conexión a internet.',
    'auth_password': 'Wachtwoord',
    'auth_subtitulo': 'Plataforma de candidaturas deportivas ACES',
    'avanzar_a': 'Avanzar a',
    'borrar': 'Verwijderen',
    'borrar_todas': 'Alles verwijderen',
    'buscar_ciudad_email': 'Zoek stad, e-mail...',
    'buscar_pais': 'Land zoeken...',
    'buscar_placeholder': 'Buscar ciudad, galardón...',
    'cambios': 'Cambios',
    'campos_obligatorios': 'Vul alle verplichte velden in.',
    'cancelar': 'Cancelar',
    'candidatura_asignada_ok': 'Kandidatuur toegewezen',
    'cargando_candidatura': 'Kandidatuur laden...',
    'cargo': 'Functie',
    'cat_carta': 'Intentieverklaring',
    'cat_eventos': 'Eventos',
    'cat_galardones': 'Eerdere prijzen',
    'cat_infra': 'Infraestructura',
    'cat_otros': 'Otros',
    'cat_presupuesto': 'Presupuesto',
    'categoria': 'Categoría',
    'cerrar': 'Cerrar',
    'cerrar_votacion': 'Stemming sluiten',
    'chat_ciudad': 'Chat con ACES',
    'chat_ciudad_aces': 'Chat met ACES',
    'chat_ciudad_aces_desc': 'Directe communicatie met het ACES Europa-team.',
    'chat_conversaciones': 'Gesprekken',
    'chat_elige_conversacion': 'Kies met wie u wilt chatten',
    'chat_escribir': 'Escribe un mensaje...',
    'chat_interno': 'Chat de comisión',
    'chat_interno_desc': 'Privékanaal tussen evaluatoren en ACES. De stad heeft geen toegang.',
    'chat_mis_chats': 'Mijn chats',
    'chat_sin_activos': 'Geen actieve chats',
    'chat_sin_activos_desc': 'Chats met kandidaturen verschijnen hier',
    'chat_sin_mensajes': 'Nog geen berichten',
    'chat_adjuntar': 'Bestand bijvoegen',
    'chat_adjunto_expira': 'Bestand 7 dagen beschikbaar',
    'chat_adjunto_max': 'Bestand te groot (max 10MB)',
    'chat_borrar': 'Verwijder voor iedereen',
    'chat_buscar_conv': 'Zoek stad of prijs...',
    'chat_confirmar_borrar': 'Dit bericht voor iedereen verwijderen?',
    'chat_filtro_no_leidas': 'Ongelezen',
    'chat_filtro_todas': 'Alle',
    'chat_mensaje_borrado': 'Bericht verwijderd',
    'chat_no_leidos': 'ongelezen',
    'chat_activas': 'actieve chats',
    'chat_recargar': 'Vernieuwen',
    'chat_responder': 'Beantwoorden',
    'chat_sin_no_leidos': 'Alles gelezen',
    'warn_poblacion_min': 'Minimale bevolking vereist',
    'warn_poblacion_max': 'Maximale bevolking toegestaan',
    'warn_actual': 'Huidig',
    'warn_max_candidaturas': 'Maximale kandidaturen voor deze prijs',
    'warn_actuales': 'Huidige',
    'warn_espera': 'Wachtperiode',
    'warn_anos': 'jaar',
    'warn_ultima': 'Laatste toekenning',
    'warn_elegible_desde': 'In aanmerking komend vanaf',
    'warn_elegibilidad': 'Toelatingswaarschuwingen',
    'warn_override': 'Master override: toch kandidatuur maken',
    'warn_override_required': 'Er zijn waarschuwingen. Vink Override aan om door te gaan.',
    'tasa_auto': 'Automatische betaling wordt aangemaakt voor',
    'poblacion_label': 'Bevolking',
    'galardon_label': 'Prijs',
    'calendario_procesal': 'Procedurekalender (Art. 15)',
    'regla_25_titulo': '2.5 punten regel (Art. 15)',
    'regla_25_desc': 'Het verschil tussen de eerste twee is',
    'regla_25_info': 'De Master kan de tweede toekennen indien gerechtvaardigd.',
    'regla_25_justificacion_hint': 'Motiveer de beslissing, vooral als de 2.5-regel van toepassing is...',
    'resumen_puntuaciones': 'Beoordelaarscores',
    'candidatura_adjudicada': 'Kandidatuur toegekend!',
    'error_campos_obligatorios': 'Stad, land en prijs zijn verplicht.',
    'checklist_aprobado': 'GOEDGEKEURD',
    'checklist_titulo': 'Documentatievereisten',
    'ciudad': 'Ciudad',
    'ciudad_asignada': 'Toegewezen stad',
    'ciudad_asignar': 'Toewijzen',
    'ciudad_cambiar': 'Wijzigen',
    'ciudad_cargo': 'Functie',
    'ciudad_contacto_principal': 'Primaire contactpersoon',
    'ciudad_desde': 'Vertrekstad',
    'ciudad_email': 'E-mail',
    'ciudad_historico': 'Historial',
    'ciudad_modulos': 'Modules',
    'ciudad_nombre': 'Naam',
    'ciudad_recursos': 'Recursos ACES',
    'ciudad_rol': 'Rol',
    'ciudad_salida': 'Vertrekstad',
    'ciudad_salida_desc': 'De kandidaatstad moet weten vanwaar u reist om uw vlucht te boeken.',
    'ciudad_salida_hint': 'Bijv.: Amsterdam, Rotterdam...',
    'ciudad_salida_pendiente': 'Vertrekstad in behandeling',
    'ciudad_sin_asignar': 'Geen stad toegewezen',
    'ciudad_sin_candidatura': 'Sin candidatura activa',
    'ciudad_sin_candidatura_desc': 'Contacta con ACES para iniciar el proceso.',
    'ciudad_telefono': 'Telefoon',
    'codigo_activando': 'Activando...',
    'codigo_activar': 'Activar código',
    'codigo_error_invalido': 'Código inválido o ya utilizado.',
    'codigo_generado_label': 'GEGENEREERDE CODE',
    'codigo_invalido': 'Ongeldige of al gebruikte code.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Introduce el código ACESCN que te proporcionó ACES.',
    'codigo_titulo': 'Código de acceso',
    'codigo_vacio': 'Voer uw toegangscode in.',
    'codigo_validar': 'Code valideren',
    'codigos_disponibles': 'Disponibles',
    'codigos_generados': 'Códigos generados',
    'codigos_usados': 'Gebruikte codes',
    'comision_sin_otros': 'Alleen u in de commissie',
    'comision_sin_otros_desc': 'Er zijn nog geen andere evaluatoren toegewezen aan deze kandidatuur.',
    'comision_titulo': 'Evaluatiecommissie',
    'completado': 'completado',
    'comprobante_desc': 'Upload het bankoverboekingsbewijs in PDF of afbeeldingsformaat.',
    'comprobante_subido': 'Betaalbewijs succesvol geüpload',
    'comprobante_titulo': 'Betaalbewijs',
    'config_comite': 'Commissiegrootte',
    'config_convocatorias': 'Convocatorias abiertas',
    'config_correos_desc': 'E-mails voor officiële meldingen.',
    'config_correos_titulo': 'Institutionele e-mails',
    'config_guardada': 'Configuración guardada',
    'config_sanciones': 'Sanciones por no asistencia a gala (€)',
    'config_sistema_titulo': 'Systeemconfiguratie',
    'config_tasas': 'Tasas de participación (€)',
    'confirmada': 'Confirmada',
    'confirmando': 'Confirmando...',
    'confirmar_asistencia': 'Confirmar asistencia',
    'contacto_principal': 'Hoofdcontact',
    'continuar': 'Doorgaan',
    'continuar_evaluacion': 'Evaluatie voortzetten',
    'convocatoria': 'Convocatoria',
    'creando': 'Creando...',
    'crear_candidatura': 'Crear candidatura',
    'crear_cuenta': 'Account aanmaken',
    'dashboard_accesos_rapidos': 'Snelle toegang',
    'dashboard_awos_sub': 'Registreer uw sportactiviteiten.',
    'dashboard_awos_titulo': 'AWoS Actief',
    'dashboard_documentos': 'Documenten',
    'dashboard_estado': 'Status kandidatuur',
    'dashboard_mensajes': 'Berichten',
    'dashboard_pagos_pendientes': 'Openstaande betalingen',
    'datos_opcionales': 'Deze velden zijn optioneel en kunnen worden bijgewerkt vanuit uw profiel.',
    'de': 'van',
    'decision_adjudicar': 'Adjudicar',
    'decision_advertencia': 'Esta decisión es inapelable y quedará registrada permanentemente.',
    'decision_confirmar': 'Confirmar decisión',
    'decision_nav': 'Decisión final',
    'decision_notas': 'Notas de la decisión (obligatorio)',
    'decision_rechazar': 'No adjudicar',
    'decision_selecciona': 'Selecciona la decisión',
    'decision_titulo': 'Decisión final',
    'desbloquear': 'Desbloquear',
    'desde': 'sinds',
    'destino': 'Destino',
    'dia': 'Día',
    'dias': 'días',
    'dias_label': 'dagen',
    'dias_visita_label': 'bezoekdagen',
    'doc_subido_ok': 'Document succesvol geüpload',
    'docs_pendientes': 'Openstaande documenten',
    'documento_pendiente': 'Document in afwachting van ontvangst',
    'duracion_visita_label': 'BEZOEKDUUR',
    'editar': 'Editar',
    'eliminar': 'Eliminar',
    'eliminar_cuenta': 'Eliminar mi cuenta',
    'eliminar_cuenta_desc': 'Esta acción es irreversible. Tus datos serán anonimizados conforme al RGPD.',
    'eliminar_cuenta_password': 'Introduce tu contraseña para confirmar',
    'eliminar_cuenta_titulo': 'Eliminar cuenta',
    'eliminar_documento': 'Document verwijderen',
    'email_ciudad_label': 'STADS-E-MAIL',
    'email_contacto': 'Email de contacto',
    'email_enviado': 'E-mail succesvol verzonden',
    'email_enviar': 'Officiële e-mail sturen',
    'email_idioma': 'Taal ontvanger',
    'email_invalido': 'Ongeldig e-mailadres.',
    'email_preview': 'E-mailvoorbeeld',
    'email_remitente': 'Verzenden van',
    'email_ya_registrado': 'Dit e-mailadres is al geregistreerd.',
    'emitir_factura_titulo': 'Factuur uitstellen',
    'emitir_nueva_factura': 'Nieuwe factuur uitstellen',
    'enviada': 'Enviada',
    'enviado_por_aces': 'Verzonden door ACES',
    'enviando': 'Bezig met verzenden...',
    'enviar': 'Enviar',
    'enviar_evaluacion': 'Evaluatie indienen',
    'enviar_propuesta': 'Enviar propuesta',
    'eres_jefe_comision': 'U bent commissiehoofd',
    'error_generico': 'Er is een fout opgetreden. Probeer opnieuw.',
    'escribiendo': 'está escribiendo',
    'estado_aceptada': 'Geaccepteerd',
    'estado_adjudicada': 'Toegewezen',
    'estado_decision': 'Beslissing in behandeling',
    'estado_documentacion': 'Documentatie',
    'estado_evaluacion': 'In beoordeling',
    'estado_pipeline': 'Pipeline de candidatura',
    'estado_rechazada': 'Niet toegewezen',
    'estado_solicitada': 'Ingediend',
    'estado_visita': 'Bezoek gepland',
    'estado_votacion': 'In stemming',
    'eval_abrev': 'eval.',
    'eval_abrir_motor': 'Evaluatiemotor openen',
    'eval_anterior': 'Anterior',
    'eval_asignadas': 'Mis asignadas',
    'eval_asignado_ok': 'Evaluator toegewezen',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Cargando evaluación...',
    'eval_comentario_placeholder': 'Comenta tu puntuación...',
    'eval_comentario_voto': 'Comentario al voto final',
    'eval_comision_pendiente': 'Informatie over evaluatoren binnenkort beschikbaar.',
    'eval_comision_titulo': 'Toegewezen evaluatoren',
    'eval_confirmar_desc': 'Una vez enviada no podrás modificarla sin que el Master la desbloquee.',
    'eval_confirmar_envio': 'Enviar evaluación',
    'eval_conflicto_interes': 'Conflicto de interés: eres del mismo país que la ciudad candidata a Capital.',
    'eval_desfavorable': 'Desfavorable',
    'eval_enviada_desc': 'Tu evaluación ha sido registrada correctamente.',
    'eval_enviada_ok': 'Evaluatie succesvol ingediend',
    'eval_enviada_titulo': 'Evaluación enviada',
    'eval_enviadas': 'enviadas',
    'eval_enviar': 'Enviar',
    'eval_enviar_btn': 'Indienen',
    'eval_favorable': 'Favorable',
    'eval_habilitada': 'Evaluación habilitada',
    'eval_ir_motor': 'Ir al motor de evaluación',
    'eval_lista': 'Evaluadores',
    'eval_mi_evaluacion': 'Mi evaluación',
    'eval_mis_candidaturas': 'Mis candidaturas',
    'eval_motor_titulo': 'Motor de evaluación',
    'eval_no_habilitada': 'De evaluatie is nog niet ingeschakeld door ACES.',
    'eval_notas_comentario': 'Notas y comentarios',
    'eval_quitado': 'Evaluator verwijderd',
    'eval_registrados': 'Registrados',
    'eval_seccion': 'Sección',
    'eval_siguiente': 'Siguiente',
    'eval_sin_activas': 'Sin candidaturas activas',
    'eval_sin_asignadas': 'Sin candidaturas asignadas',
    'eval_sin_asignadas_desc': 'El Master asignará candidaturas a tu comisión.',
    'eval_sin_documentos': 'Geen documenten',
    'eval_sin_documentos_desc': 'De stad heeft nog geen documenten geüpload.',
    'eval_sin_reservas': 'Nog geen reserveringen',
    'eval_stat_asignadas': 'Asignadas',
    'eval_stat_completadas': 'Completadas',
    'eval_stat_pendientes': 'Pendientes',
    'eval_todas': 'Todas activas',
    'eval_todas_activas': 'Candidaturas activas',
    'eval_todas_aviso': 'Vista de solo lectura. Detalle completo solo para tus candidaturas asignadas.',
    'eval_total_seccion': 'Puntuación de esta sección',
    'eval_ver_escala': 'Ver escala de puntuación',
    'eval_voto_final': 'Voto final',
    'eval_voto_informativo': 'Tu voto es informativo. La decisión final corresponde al Master ACES.',
    'evaluacion_titulo': 'Evaluación',
    'evaluaciones_enviadas': 'evaluaciones enviadas',
    'evaluadores_asignados': 'evaluadores asignados',
    'evaluadores_asignados_label': 'TOEGEWEZEN EVALUATOREN',
    'evento_almuerzo': 'Lunch',
    'evento_cena': 'Diner',
    'evento_desayuno': 'Ontbijt',
    'evento_descanso': 'Rust',
    'evento_llegada': 'Aankomst',
    'evento_otro': 'Anders',
    'evento_recepcion': 'Ontvangst',
    'evento_reunion': 'Vergadering',
    'evento_rueda_prensa': 'Persconferentie',
    'evento_salida': 'Vertrek',
    'evento_traslado': 'Transfer',
    'evento_visita': 'Bezoek',
    'factura_creada_ok': 'Factuur geregistreerd. Upload nu de PDF.',
    'factura_detalle': 'Detail / Uitgebreid concept',
    'factura_detalle_hint': 'Gedetailleerde omschrijving van diensten, betalingsvoorwaarden, bankgegevens...',
    'factura_subida_ok': 'Factuur succesvol geüpload',
    'facturas_aces': 'Van ACES',
    'fecha_llegada_label': 'AANKOMSTDATUM',
    'fecha_regreso': 'Fecha de regreso',
    'fecha_salida': 'Fecha de salida',
    'fecha_vencimiento_label': 'VERVALDATUM',
    'filtro_estado': 'Status',
    'filtro_tipo': 'Type',
    'filtro_todas': 'Todas',
    'filtro_todos': 'Alle',
    'gala_asistencia_confirmada': 'Asistencia confirmada',
    'gala_invitacion_titulo': 'Invitación a la Gala',
    'gala_pendiente_desc': 'ACES activará tu invitación cuando llegue el momento.',
    'gala_pendiente_invitacion': 'Invitación pendiente',
    'gala_representantes': 'Representantes',
    'gala_sin_datos': 'Sin datos de gala',
    'gala_sin_datos_desc': 'No hay información de la ceremonia para este año.',
    'gala_sin_representantes': 'Sin representantes añadidos',
    'galardon': 'Galardón',
    'general_error': 'Ha ocurrido un error',
    'general_reintentar': 'Reintentar',
    'generar_codigo': 'Generar código',
    'generar_codigo_titulo': 'Nuevo código de acceso',
    'gestionar_comision': 'Commissie beheren',
    'guardado': 'Opgeslagen',
    'guardando': 'Guardando...',
    'guardar': 'Guardar',
    'guardar_ciudad_salida': 'Vertrekstad opslaan',
    'guardar_config': 'Guardar configuración',
    'guardar_y_siguiente': 'Opslaan en volgende',
    'historico_titulo': 'Eerdere kandidaturen',
    'hora': 'Hora',
    'hora_fin_opc': 'Eindtijd (optioneel)',
    'hora_inicio': 'Begintijd',
    'idioma_titulo': 'Interfacetaal',
    'iniciar_evaluacion': 'Evaluatie starten',
    'invitacion_enviada': 'Uitnodiging verzonden',
    'invitar_ciudad_titulo': 'Stad uitnodigen',
    'invitar_codigo_generado': 'Gegenereerde code',
    'invitar_copiar': 'Kopiëren',
    'invitar_cuerpo_eval': 'Wij nodigen u uit ACES Cities Network te joinen als evaluator.\\n\\nUw toegangscode is:',
    'invitar_email': 'Stuur via email',
    'invitar_evaluador_sub': 'Genereer een code en deel via WhatsApp of email',
    'invitar_evaluador_titulo': 'Evaluator uitnodigen',
    'invitar_generar_codigo': 'Toegangscode genereren',
    'invitar_nombre': 'Naam evaluator',
    'invitar_pie': 'Download de app, registreer u en voer uw code in.\\n\\n— ACES',
    'invitar_saludo': 'Beste',
    'invitar_whatsapp': 'Stuur via WhatsApp',
    'jefe_comision_ninguno': 'Geen hoofd toegewezen',
    'jefe_comision_sin_eval': 'Wijs eerst evaluatoren toe om een hoofd aan te stellen.',
    'jefe_comision_titulo': 'Commissiehoofd',
    'jefe_designado_ok': 'Commissiehoofd aangesteld',
    'jefe_eliminado_ok': 'Commissiehoofd verwijderd',
    'llegada': 'Llegada',
    'llegada_label': 'Aankomst',
    'login_crear_cuenta': 'Eerste keer? Account aanmaken →',
    'login_olvide_contrasena': 'Wachtwoord vergeten?',
    'login_proximamente': 'Binnenkort',
    'login_recuperar_desc': 'Voer uw e-mail in en we sturen een link om uw wachtwoord opnieuw in te stellen.',
    'login_recuperar_titulo': 'Toegang herstellen',
    'login_requiere_codigo': 'Toegang tot Cities Network vereist een ACES-uitnodigingscode.',
    'login_restablecer': 'Wachtwoord opnieuw instellen',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Lugar',
    'marcar_leidas': 'Marcar todas leídas',
    'master_label': 'ACES MASTER',
    'master_panel_desc': 'Control total de candidaturas, evaluaciones y decisiones.',
    'master_recientes': 'Candidaturas recientes',
    'master_saludo': 'Panel ACES',
    'master_sin_candidaturas': 'Sin candidaturas aún',
    'mi_evaluacion': 'Mijn evaluatie',
    'mis_pagos': 'Mijn betalingen',
    'mod_chat': 'Chat ACES',
    'mod_documentos': 'Documentos',
    'mod_facturas_pagos': 'Facturen en betalingen',
    'mod_gala': 'Gala',
    'mod_pagos': 'Pagos',
    'mod_titularidad': 'Titularidad',
    'mod_viaje': 'Logística',
    'modo_evaluador': 'Evaluator',
    'modo_master': 'Master',
    'motor_evaluacion': 'Evaluatiemotor',
    'no_configurado': 'Niet geconfigureerd — bewerk uw profiel',
    'nombre': 'Voornaam',
    'nombre_documento': 'Nombre del documento',
    'nombre_hotel': 'Nombre del hotel',
    'notas_hint': 'Bijv.: Landen op T4, aanbevolen hotel...',
    'notas_internas_label': 'INTERNE NOTITIES (optioneel)',
    'notif_candidatura_actualizada': 'Kandidatuur bijgewerkt',
    'notif_candidatura_desasignada': 'Kandidatuur verwijderd',
    'notif_documento_revisado': 'Document beoordeeld',
    'notif_estado_actualizado': 'Status bijgewerkt',
    'notif_evaluacion_completada': 'Evaluatie voltooid',
    'notif_limpiar_desc': 'Alle meldingen worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
    'notif_limpiar_todas': 'Alles wissen',
    'notif_marcar_leida': 'Markeren als gelezen',
    'notif_nueva_asignacion': 'Nieuwe kandidatuur toegewezen',
    'notif_pago_vencido': 'Betaling vervalt binnenkort',
    'notif_sin_leer': 'Sin leer',
    'notif_sin_notifs': 'Sin notificaciones',
    'notif_visita_programada': 'Evaluatiebezoek gepland',
    'notificar_ciudad': 'Stad melden',
    'nueva_candidatura': 'Nueva candidatura',
    'nueva_propuesta': 'Nueva propuesta',
    'num_habitaciones': 'Número de habitaciones',
    'origen': 'Origen',
    'pago_enviar_recordatorio': 'E-mail openen',
    'pago_factura': 'Factuur',
    'pago_instrucciones': 'Realiza la transferencia bancaria y sube el comprobante.',
    'pago_recibido': 'Ontvangen',
    'pago_recordatorio': 'Herinnering',
    'pago_recordatorio_desc': 'Uw e-mailclient opent met het bericht.',
    'pago_recordatorio_titulo': 'Betalingsherinnering sturen',
    'pagos_ciudad': 'Mijn betalingen',
    'pagos_pendientes': 'Openstaande betalingen',
    'pais': 'País',
    'pais_buscar': 'Land zoeken...',
    'pais_seleccionado': 'Geselecteerd land',
    'pais_seleccionar': 'Land selecteren',
    'paso_datos': 'Factuurgegevens',
    'paso_subir_pdf': 'Factuur-PDF uploaden',
    'password_actual': 'Huidig wachtwoord',
    'password_cambiada': 'Wachtwoord succesvol gewijzigd',
    'password_cambiar': 'Wachtwoord wijzigen',
    'password_corta': 'Wachtwoord moet minimaal 6 tekens bevatten.',
    'password_nueva': 'Nieuw wachtwoord',
    'password_repetir': 'Wachtwoord herhalen',
    'passwords_no_coinciden': 'Wachtwoorden komen niet overeen.',
    'error_red': 'Netwerkfout. Controleer je internetverbinding.',
    'error_demasiados_intentos': 'Te veel pogingen. Wacht even en probeer het opnieuw.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Sollicitatiebrief ontvangen',
    'hito_aprobada': 'Kandidatuur goedgekeurd',
    'hito_reglamento_enviado': 'Reglement verzonden ter ondertekening',
    'hito_reglamento_firmado': 'Ondertekend reglement ontvangen',
    'hito_datos_factura': 'Factuurgegevens ontvangen',
    'hito_pago_confirmado': 'Betaling bevestigd',
    'hito_fechas_visita': 'Bezoekdata voorgesteld',
    'hito_comision_creada': 'Evaluatiecommissie aangemaakt',
    'hito_viajes_cerrados': 'Reizen afgerond',
    'hito_agenda_enviada': 'Agenda verzonden',
    'hito_bid_file': 'BID File ontvangen',
    'doc_tipo_carta_solicitud': 'Sollicitatiebrief',
    'doc_tipo_agenda_visita': 'Bezoekagenda',
    // Logistica simplificada
    'mod_logistica': 'Logistiek',
    'agenda_vacia_ciudad': 'Nog geen agenda. Upload de PDF van de bezoekagenda.',
    'agenda_aviso_master': 'De agenda is zichtbaar. Upload de definitieve PDF.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES publiceert de bezoekagenda wanneer beschikbaar.',
    'eval_reservas_desc': 'Je bevestigde vlucht- en hotelreserveringen verschijnen hier.',
    'eval_sin_reservas_desc': 'ACES of de stad uploadt je reisreserveringen wanneer bevestigd.',
    'perfil_actualizado': 'Profiel bijgewerkt',
    'perfil_apellidos': 'Apellidos',
    'perfil_cambiar_foto': 'Profielfoto',
    'perfil_cargo': 'Cargo',
    'perfil_ciudad': 'Stad',
    'perfil_compartir_ciudad': 'Telefoon delen met steden',
    'perfil_compartir_ciudad_desc': 'Kandidaatsteden kunnen uw contactnummer zien.',
    'perfil_compartir_eval_desc': 'Evaluatoren in uw commissie kunnen uw contact zien.',
    'perfil_compartir_evaluadores': 'Delen met andere evaluatoren',
    'perfil_contacto': 'Contact',
    'perfil_cuenta': 'Account',
    'perfil_datos': 'Persoonlijke gegevens',
    'perfil_datos_evaluador': 'Commissiegegevens',
    'perfil_datos_personales': 'Persoonlijke gegevens',
    'perfil_elegir_foto': 'Foto kiezen',
    'perfil_eval_config': 'Evaluator-instellingen',
    'perfil_evaluador': 'Evaluatorinstellingen',
    'perfil_fecha_nac': 'Geboortedatum',
    'perfil_foto_actualizada': 'Foto bijgewerkt',
    'perfil_guardado': 'Profiel succesvol opgeslagen',
    'perfil_guardar': 'Profiel opslaan',
    'perfil_idioma': 'Idioma de la app',
    'perfil_nombre': 'Nombre',
    'perfil_notificaciones': 'Notificaciones',
    'perfil_pais': 'País',
    'perfil_provincia': 'Provincie',
    'perfil_talla': 'Polo maat',
    'perfil_telefono': 'Teléfono',
    'perfil_titulo': 'Mijn profiel',
    'perfil_ubicacion': 'Locatie',
    'pipeline_aceptada_desc': 'Kandidatuur geaccepteerd. Bereid de vereiste documentatie voor.',
    'pipeline_adjudicada_desc': 'Gefeliciteerd! Uw stad heeft de ACES-titel ontvangen.',
    'pipeline_decision_desc': 'De definitieve beslissing wordt voorbereid door ACES.',
    'pipeline_documentacion_desc': 'We beoordelen uw documentatie.',
    'pipeline_evaluacion_desc': 'De evaluatiecommissie analyseert uw kandidatuur.',
    'pipeline_rechazada_desc': 'Uw kandidatuur is niet geselecteerd in deze oproep.',
    'pipeline_solicitada_desc': 'Uw kandidatuur is ontvangen en wordt beoordeeld.',
    'pipeline_visita_desc': 'Het evaluatiebezoek aan uw stad wordt georganiseerd.',
    'pipeline_votacion_desc': 'De commissie delibereert over uw kandidatuur.',
    'precio_aprox': 'Precio aproximado (€)',
    'precio_estimado': 'Geschatte prijs (€)',
    'preview_email_label': 'E-MAILVOORBEELD',
    'programar_visita_titulo': 'Bezoek plannen',
    'proponer_agenda': 'Agenda',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Vuelo',
    'provincia': 'Provincie / Staat',
    'provincia_seleccionar': 'Provincie / regio selecteren',
    'rechazar': 'Rechazar',
    'recomendaciones_titulo': 'Aanbevelingen',
    'recordatorio_asunto': 'Betalingsherinnering — {ciudad}',
    'recordatorio_cuerpo': 'Beste {ciudad}-team,\\n\\nWij herinneren u aan de openstaande betaling voor: {concepto}.\\n\\nGelieve zo spoedig mogelijk over te maken.\\n\\nMet vriendelijke groet,\\nACES',
    'reg_ciudad': 'Stad / Gemeente *',
    'reg_creando': 'Aanmaken...',
    'reg_crear_cuenta': 'Account aanmaken',
    'reg_pais': 'Land *',
    'reg_provincia': 'Provincie / Regio',
    'reg_resumen_titulo': 'Accountoverzicht',
    'reg_telefono': 'Contacttelefoon *',
    'reg_tipo': 'Toegangstype',
    'reg_ubicacion_sub': 'Gegevens van uw organisatie',
    'reg_ubicacion_titulo': 'Uw locatie',
    'registro_cancelar_salir': 'Annuleren en afsluiten',
    'registro_codigo_label': 'ACES TOEGANGSCODE',
    'registro_contrasena_label': 'WACHTWOORD',
    'registro_crear_cuenta': 'Maak uw account aan',
    'registro_datos_personales': 'Persoonlijke gegevens',
    'registro_elige_rol': 'Met welke rol heeft u toegang tot Cities Network?',
    'registro_email_label': 'E-MAIL',
    'registro_paso_1': 'Stap 1 van 3',
    'registro_paso_2': 'Stap 2 van 3',
    'registro_paso_2_desc': 'Deze informatie wordt gebruikt voor de logistiek van evaluatiebezoeken.',
    'registro_paso_3': 'Stap 3 van 3',
    'registro_siguiente': 'Volgende →',
    'registro_verifica_desc': 'We hebben u een verificatie-e-mail gestuurd. Open deze en klik op de link.',
    'registro_verifica_titulo': 'Verifieer uw e-mail',
    'rol_ciudad': 'Stad',
    'rol_evaluador': 'Evaluator',
    'rol_master': 'ACES Master',
    'salida': 'Salida',
    'salida_label': 'Vertrek',
    'saludo_buenas_noches': 'Goedenavond,',
    'saludo_buenas_tardes': 'Goedemiddag,',
    'saludo_buenos_dias': 'Goedemorgen,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Sectie',
    'seleccionar': 'Seleccionar',
    'seleccionar_pais': 'Land selecteren',
    'seleccionar_provincia': 'Provincie selecteren',
    'sin_agenda': 'Geen agenda',
    'sin_agenda_desc': 'De stad heeft nog geen bezoekschema voorgesteld.',
    'sin_candidaturas': 'Sin candidaturas',
    'sin_candidaturas_desc': 'No hay candidaturas con este filtro.',
    'sin_ciudad_asignada': 'Geen stad toegewezen',
    'sin_codigos_disponibles': 'Geen codes beschikbaar',
    'sin_documentos': 'Sin documentos',
    'sin_documentos_desc': 'Sube los documentos requeridos para tu candidatura.',
    'sin_evaluaciones': 'Sin evaluaciones',
    'sin_evaluadores_desc': 'Registreer evaluatoren met een code ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Geen geregistreerde evaluatoren',
    'sin_facturas_aces': 'Geen facturen ontvangen',
    'sin_facturas_aces_desc': 'Door ACES verzonden facturen verschijnen hier.',
    'sin_notificaciones': 'Geen meldingen',
    'sin_notificaciones_desc': 'Activiteit van uw kandidaturen verschijnt hier.',
    'sin_pagos': 'Sin pagos',
    'sin_pagos_desc': 'Los pagos de tu candidatura aparecerán aquí.',
    'stat_activas': 'Activas',
    'stat_decision': 'Decisión pendiente',
    'stat_dias_visita': 'Dagen tot bezoek',
    'stat_docs_pendientes': 'Openstaande docs',
    'stat_evaluacion': 'En evaluación',
    'stat_mensajes_nuevos': 'Nieuwe berichten',
    'stat_notif': 'Sin leer',
    'stat_pagos_pendientes': 'Openstaande betalingen',
    'stat_sin_visita': 'Geen bezoek gepland',
    'stat_titulos': 'Títulos activos',
    'stat_total': 'Total',
    'subir_comprobante': 'Bewijs uploaden',
    'subir_documento': 'Subir documento',
    'subir_factura': 'Factuur uploaden',
    'subir_factura_desc': 'Upload de factuur als PDF. De stad kan deze downloaden vanuit hun paneel.',
    'subir_factura_titulo': 'Factuur PDF uploaden',
    'subir_nota': 'Selecciona el archivo desde tu dispositivo',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidatura',
    'tab_candidaturas': 'Candidaturas',
    'tab_chat': 'Chat',
    'tab_config': 'Configuración',
    'tab_documentos': 'Documentos',
    'tab_evaluaciones': 'Evaluaciones',
    'tab_evaluadores': 'Evaluadores',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Home',
    'tab_notif': 'Notificaciones',
    'tab_pagos': 'Pagos',
    'tab_perfil': 'Perfil',
    'tab_recursos': 'Recursos',
    'tab_resumen': 'Resumen',
    'tab_viaje': 'Logística',
    'talla_polo': 'Poloshirt maat',
    'telefono': 'Telefoon',
    'template_no_disponible': 'De evaluatietemplate is nog niet beschikbaar.',
    'tipo_codigo': 'Tipo de código',
    'tit_ano_titulo': 'Año de titularidad',
    'tit_evidencias': 'Evidencias subidas',
    'tit_item_calendario': 'Calendario deportivo',
    'tit_item_congreso': 'Congreso o conferencia',
    'tit_item_imagen': 'Uso correcto del título',
    'tit_item_memoria': 'Memoria final',
    'tit_no_aplica': 'Sin año de titularidad',
    'tit_no_aplica_desc': 'Este módulo se activa cuando tu ciudad gana un galardón ACES.',
    'tit_sanciones': 'Sanciones',
    'tit_sin_datos': 'Sin titularidades activas',
    'tit_titulo': 'Año de titularidad',
    'toca_abrir_documento': 'Tik om het document te openen',
    'toca_copiar': 'Toca el código para copiar',
    'toca_para_abrir': 'Tik om te openen',
    'toca_para_copiar': 'Tik om te kopiëren',
    'tomar_decision': 'Decisión final',
    'tu_ciudad_salida': 'Uw vertrekstad',
    'upload_error': 'Uploadfout',
    'upload_exito': 'Succesvol geüpload!',
    'upload_formatos': 'PDF, JPG of PNG · max. 20 MB',
    'upload_no_cierres': 'Sluit de app niet',
    'upload_reintentar': 'Opnieuw proberen',
    'upload_subiendo': 'Bestand uploaden...',
    'vence': 'Vence',
    'ver_comprobante': 'Ver comprobante',
    'ver_detalle': 'Detail bekijken',
    'ver_documento_adjunto': 'Bijgevoegd document bekijken',
    'ver_factura': 'Factuur bekijken',
    'verifica_desc': 'We hebben een verificatie-e-mail gestuurd. Controleer uw inbox.',
    'verifica_reenviar': 'Verificatie-e-mail opnieuw sturen',
    'viaje_aviso_privacidad': 'La identidad de los evaluadores es confidencial. Solo verás fechas y logística.',
    'viaje_ciudad_salida': 'Uw vertrekstad voor vluchten',
    'viaje_proponer_vuelo': 'Vlucht voorstellen',
    'viaje_propuesta_enviada': 'Voorstel succesvol verzonden',
    'viaje_sin_propuestas': 'Sin propuestas de viaje',
    'viaje_sin_propuestas_desc': 'Propón opciones de vuelo, hotel y agenda para la visita.',
    'visita_evaluadores': 'Visita de evaluadores',
    'visita_programada': 'Visita programada',
    'visita_sin_programar': 'Visita aún no programada',
    'visita_titulo': 'Visita de evaluación',
    'volver': 'Terug',
    'votacion_abierta': 'Stemming open',
    'votacion_cerrada': 'Stemming gesloten',
    'walkthrough_ver_guia': 'Introductiegids bekijken',
    'whatsapp': 'WhatsApp (met voorvoegsel)',
    'ya_tengo_cuenta': 'Heeft u al een account?',
    'tab_titularidades': 'Titelhouders',
    'acciones_rapidas': 'Snelle acties',
    'evaluadores_titulo': 'Evaluatoren',
    'evaluadores_registrados': 'Geregistreerde evaluatoren',
    'codigos_disponibles_label': 'Beschikbare codes',
    'evaluadores_seccion': 'Evaluatoren',
    'codigos_acceso_titulo': 'Toegangscodes',
    'config_pais': 'Land',
    'config_telefono': 'Telefoon',
    'config_correos_inst': 'Institutionele e-mails',
    'config_capital': 'Hoofdstad',
    'config_city': 'Stad',
    'config_town': 'Gemeente',
    'evaluacion_habilitada': 'Evaluatie ingeschakeld',
    'evaluaciones_titulo_card': 'Evaluaties',
    'decision_final_titulo': 'Definitieve beslissing',
    'gestionar_comision_titulo': 'Commissie beheren',
    'programar_visita_modal': 'Evaluatiebezoek plannen',
    'fecha_llegada': 'Aankomstdatum',
    'req_documentacion': 'Documentatievereisten',
    'todo_leido': 'Alles gelezen',
    'confirmar_borrar_notifs': 'Alle meldingen verwijderen?',
    'gala_creada_ok': 'Gala succesvol aangemaakt',
    'gala_error_crear': 'Fout bij aanmaken gala',
    'gala_activada': 'Gala geactiveerd voor steden',
    'gala_desactivada': 'Gala gedeactiveerd',
    'titularidades_titulo': 'Titelhouders',
    'titularidades_desc': 'Steden met actieve ACES-titel en verplichtingsopvolging',
    'obligaciones_titulo': 'Verplichtingen titelhouder',
    'obligacion_imagen': 'ACES-beeldregels respecteren',
    'obligacion_calendario': 'Jaarlijkse sportkalender ontwerpen',
    'obligacion_congreso': 'Internationaal congres of wedstrijd organiseren',
    'obligacion_memoria': 'Jaarverslag en conclusies indienen',
    'obligacion_awos': 'Actief deelnemen aan AWoS/EWoS',
    'cumplidas': 'voltooid',
    'viaje_confirmar': 'Voorstel bevestigen',
    'viaje_rechazar': 'Voorstel afwijzen',
    'viaje_confirmado': 'Voorstel bevestigd',
    'viaje_rechazado': 'Voorstel afgewezen',
    'nota_respuesta': 'Antwoordnoot (optioneel)',
    'voto_favor_confirm': 'Gunstige stem bevestigen?',
    'voto_contra_confirm': 'Tegenstem bevestigen?',
    'historial_sin_cambios': 'Geen statuswijzigingen geregistreerd',
    'candidatura_buscar': 'Zoek stad, prijs...',
    'candidatura_ciudad_ph': 'Bijv. Buenos Aires',
    'candidatura_pais_ph': 'Bijv. Argentinië',
    'candidatura_email_ph': 'stad@email.com',
    'dias_visita': 'bezoekdagen',
    'propuestas_viaje': 'Reisvoorstellen',
    'sin_propuestas_viaje': 'Geen reisvoorstellen',
    'sin_propuestas_desc': 'Evaluatoren hebben nog geen reisroute voorgesteld.',
    'sin_evaluaciones_desc': 'Wijs evaluatoren toe en schakel evaluatie in.',
    'seleccionar_pdf': 'PDF selecteren',
    'rechazar_candidatura': 'Kandidatuur afwijzen',
    'motivo_rechazo': 'Reden van afwijzing (verplicht)',
    'tit_sin_datos_desc': 'Toegewezen steden verschijnen hier automatisch.',
    'marcado_cumplido': 'Gemarkeerd als voltooid',
    'desmarcado': 'Uitgevinkt',
    'finalizada': 'Afgerond',
    'finalizadas': 'Afgerond',
    'notas_label': 'Notities',
    'sin_leer': 'ongelezen',
    'confirmar_cerrar_sesion': 'Uitloggen?',
    'email_aces_europa': 'ACES Europa e-mail',
    'email_aces_america': 'ACES Amerika e-mail',
    'gala_fecha_evento': 'Evenementdatum',
    'gala_primera_desc': 'Maak de eerste gala aan om ceremonies te beheren.',
    'evaluadores_gestion': 'Beheer van de ACES-evaluatiecommissie',
    'adjudicar': 'Toewijzen',
    'adjudicada_ok': 'Kandidatuur toegewezen!',
    'candidatura_rechazada': 'Kandidatuur afgewezen',
    'error_decision': 'Fout bij opslaan beslissing',
    'evaluador_asignado': 'Evaluator toegewezen',
    'evaluador_quitado': 'Evaluator verwijderd',
    'jefe_designado': 'Commissiehoofd aangesteld',
    'jefe_eliminado': 'Commissiehoofd verwijderd',
    'notas_guardadas': 'Notities opgeslagen',
    'notas_visita_hint': 'Bijv.: Aanbevolen hotel, luchthavenrichtlijnen...',
    'visita_ok': 'Bezoek succesvol gepland',
    'error_visita': 'Fout bij plannen bezoek',
    'evaluacion_hab_ok': 'Evaluatie ingeschakeld',
    'evaluacion_deshab_ok': 'Evaluatie uitgeschakeld',
    'programar': 'Plannen',
    'confirmar_decision': 'Beslissing bevestigen',
    'cambiar_modo': 'Modus wisselen',
    'de_preposicion': 'van',
    'notas_decision_label': 'Beslissingsnotities (optioneel)',
    'generar': 'Genereren',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File ontvangen',
    'documentos_firmados': 'Ondertekende documenten',
    'pago_confirmado': 'Betaling bevestigd',
    'subiendo_label': 'Uploaden...',
    'pagado_label': 'Betaald',
    'factura_label': 'Factuur',
    'marcar_factura': 'Factuur als uitgegeven markeren',
    'desmarcar_factura': 'Factuur deselecteren',
    'marcar_pago': 'Betaling als ontvangen markeren',
    'desmarcar_pago': 'Betaling deselecteren',
    'evaluacion_enviada': 'Ingediend',
    'disponible_label': 'Beschikbaar',
    'ver_codigos_btn': 'Codes bekijken',
    'invitar_eval_btn': 'Evaluator uitnodigen',
    'generar_codigo_btn': 'Nieuwe code genereren',
    'idioma_destinatario': 'Taal van de ontvanger',
    'candidaturas_count': 'kandidaturen',
    'sin_alertas_ok': 'Alles in orde. Geen openstaande waarschuwingen.',
    'sin_galas_configuradas': 'Geen galas geconfigureerd',
    'gala_activada_ciudades': 'Gala geactiveerd voor steden',
    'ver_alertas_label': 'Waarschuwingen bekijken',
    'modo_evaluador_activo': 'Evaluatormodus actief',
    'modo_master_activo': 'Master ACES weergave',
    'cambiar_a_eval': 'Evaluatormodus',
    'cambiar_a_master': 'Terug naar Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Reglement',
    'doc_tipo_comprobante': 'Betalingsbewijs',
    'doc_tipo_contrato': 'Contract',
    'doc_tipo_memoria': 'Rapport',
    'doc_tipo_pres': 'Presentatie',
    'doc_tipo_otro': 'Anders',
    'selecciona_tipo_doc': 'Welk documenttype?',
    'todos_label': 'Alle',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Evenement',
    'mis_propuestas': 'Mijn voorstellen',
    'propuestas_label': 'voorstellen',
    'ciudad_hotel': 'Stad',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/nacht',
    'hotel_notas_hint': 'Bijv.: Tweepersoonskamer, ontbijt inbegrepen...',
    'vuelo_notas_hint': 'Bijv.: Directe vlucht, tussenstop in Madrid...',
    'fecha_label': 'Datum',
    'hora_label': 'Tijd',
    'lugar_label': 'Locatie',
    'tipo_reunion': 'Vergadering',
    'tipo_visita_instalacion': 'Faciliteitsbezoek',
    'tipo_acto': 'Officieel evenement',
    'tipo_almuerzo': 'Lunch / Diner',
    'tipo_transporte': 'Vervoer',
    'tipo_otro': 'Anders',
    'galardones_titulo': 'Prijzen',
    'reglamentos_titulo': 'Reglementen',
    'sin_candidatura_titulo': 'Geen kandidatuur toegewezen',
    'sin_candidatura_desc': 'Uw account heeft nog geen gekoppelde kandidatuur.',
    'bienvenida_ciudad_saludo': 'Hallo, {nombre}',
    'bienvenida_ciudad_titulo': 'Je account is actief',
    'bienvenida_ciudad_desc': 'We bereiden je kandidatuur voor. Zodra het ACES-team er een aan je toewijst, verschijnt deze hier met volledige opvolging.',
    'bienvenida_ciudad_chip_activa': 'Account actief',
    'bienvenida_ciudad_chip_espera': 'Wacht op toewijzing',
    'bienvenida_ciudad_contacto': 'Vragen? Neem contact op met ACES',
    'chat_ciudad_desc': 'Directe communicatie met het ACES-team.',
    'mensajes_label': 'Berichten',
    'motor_seccion_de': 'van',
    'gala_confirmar_desc': 'Geef aan of uw stad de galabijeenkomst bijwoont.',
    'eval_completadas': 'Voltooid',
    'secciones_completadas': 'secties voltooid',
    'evaluaciones_enviadas_abrev': 'evaluaties ingediend',
    'awos_activa_desc': 'Registreer uw fysieke activiteit en toegang tot ACES-evenementen',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Uw reisgegevens zijn alleen zichtbaar voor ACES.',
    'eval_docs_solo_lectura': 'U kunt de door de stad ingediende documenten bekijken.',
    'conflicto_titulo': 'Verklaring van belangenconflict',
    'conflicto_desc': 'Bevestig vóór de evaluatie dat u geen belangenconflict heeft.',
    'conflicto_sin_conflicto': 'Geen conflict — doorgaan',
    'conflicto_con_conflicto': 'Ik heb een conflict',
    'conflicto_aviso': 'Informeer ACES onmiddellijk.',
    'sin_fecha': 'Geen datum',
    'subir_reserva_hint': 'Upload de bevestigde boekings-PDF.',
    'subir_reserva_hint_eval': 'Upload uw boekings-PDF.',
    'login_sin_cuenta': 'Geen account?',
    'agenda_oficial_titulo': 'Officieel bezoekprogramma',
    'agenda_anadir_evento': 'Evenement toevoegen',
    'agenda_editar_evento': 'Evenement bewerken',
    'agenda_oficial_aviso': 'Deze agenda is zichtbaar voor evaluatoren.',
    'agenda_oficial_vacia': 'Nog geen evenementen gepubliceerd.',
    'publicar_evento': 'Evenement publiceren',
    'evento_publicado': 'Evenement gepubliceerd',
    'evento_guardado': 'Evenement bijgewerkt',
    'evento_eliminado': 'Evenement verwijderd',
    'confirmar_eliminar': 'Dit evenement verwijderen?',
    'guardar_cambios': 'Wijzigingen opslaan',
    'pipeline_titulo': 'Kandidatuur-pipeline',
    'revenue_titulo': 'Inkomsten',
    'revenue_total': 'Totaal gefactureerd',
    'cobrado': 'Geind',
    'visitas_proximas': 'Komende bezoeken',
    'paises_titulo': 'Per land',
    'awos_banner_desc': 'Registreer je fysieke activiteit en krijg toegang tot ACES-evenementen',
    'fecha_limite_confirmar': 'Bevestigingsdeadline',
    'info_parlamento': 'Europees Parlement info',
    'info_venue': 'Locatie',
    'norma_hotel': 'Hotelregels',
    'norma_vuelo': 'Vluchtregels',
    'programa_dia': 'Dagprogramma',
    'sin_programa': 'Geen programma',
    'actividad_placeholder': 'Activiteit...',
    'anadir': 'Toevoegen',
    'representantes_label': 'Vertegenwoordigers',
    'confirmados_label': 'Bevestigd',
    'fecha_limite': 'Deadline',
    'deadline_pasada': 'Deadline verstreken',
    'restantes': 'resterend',
    'anadir_representante': 'Vertegenwoordiger toevoegen',
    'sin_representantes': 'Geen vertegenwoordigers',
    'representante_anadido': 'Vertegenwoordiger toegevoegd',
    'representante_eliminado': 'Vertegenwoordiger verwijderd',
    'programa_actualizado': 'Programma bijgewerkt',
    'confirmado': 'BEVESTIGD',
    'nombre_label': 'Volledige naam',
    'cargo_label': 'Functie',
    'telefono_label': 'Telefoon',
    'logistica_evaluadores': 'Evaluator-logistiek',
    'vuelo_short': 'Vlucht',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Verplichte documenten',
    'evidencia_subida': 'Bewijs geupload',
    'sancion_anadida': 'Sanctie geregistreerd',
    'memoria_subida': 'Eindrapport geupload',
    'nueva_sancion': 'Nieuwe sanctie',
    'motivo_sancion': 'Reden',
    'motivo_sancion_hint': 'Bijv.: Niet-deelname aan gala',
    'importe_label': 'Bedrag',
    'divisa_label': 'Valuta',
    'registrar_sancion': 'Sanctie registreren',
    'subir_evidencia': 'Uploaden',
    'memoria_final_titulo': 'Eindrapport',
    'memoria_deadline': 'Voor 31 januari',
    'subir_memoria': 'Eindrapport uploaden (PDF)',
    'sin_sanciones': 'Geen sancties',
    'evidencias_short': 'bewijzen',
    'memoria_ok': 'Rapport OK',
    'sanciones_short': 'sancties',
    'dias_en_fase': 'Dagen in fase',
    'proximo_pago': 'Volgende betaling',
    'vencido': 'Verlopen',
    'visita_label': 'Bezoek',
    // === Paquete 2 — 85 keys faltantes (nl) ===
    'abrir_nueva_pestana': 'Openen in nieuw tabblad',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Artikelen',
    'auth_accediendo': 'Inloggen...',
    'auth_email_enviado': 'E-mail verzonden. Controleer je inbox.',
    'auth_enviar_enlace': 'Link verzenden',
    'auth_error_intentos': 'Te veel pogingen. Even wachten.',
    'auth_error_password': 'Onjuist wachtwoord',
    'auth_error_reset': 'Fout bij het verzenden van de herstel-e-mail',
    'auth_error_usuario': 'Gebruiker niet gevonden',
    'auth_introduce_email': 'Voer je e-mail in',
    'auth_olvido_password': 'Wachtwoord vergeten',
    'auth_recuperar': 'Wachtwoord herstellen',
    'auth_recuperar_desc': 'We sturen je een link om je wachtwoord te herstellen.',
    'aw_h': 'Amerikaanse Sportweek',
    'aw_lbl': 'AWoS',
    'aw_p': 'Vier sport en lichaamsbeweging met je stad tijdens de Amerikaanse Sportweek.',
    'bonus_desc': 'Extra punten voor uitstekende initiatieven',
    'buscar_articulo': 'Artikel zoeken...',
    'buscar_recursos': 'Zoeken in bronnen...',
    'comite_evaluacion': 'Beoordelingscomite',
    'confirmar_eliminar_pago': 'Weet je zeker dat je deze betaling wilt verwijderen?',
    'cookie_accept': 'Accepteren',
    'cookie_more': 'Meer informatie',
    'cookie_msg': 'We gebruiken essentiele cookies voor de werking van de site.',
    'cookie_reject': 'Weigeren',
    'criterios_elegibilidad': 'Geschiktheidscriteria',
    'cta_b1': 'Kandidatuur indienen',
    'cta_b2': 'Contact ACES',
    'cta_h': 'Begin vandaag je kandidatuur',
    'cta_p': 'Word lid van het netwerk van Europese sportsteden en transformeer je gemeenschap.',
    'descargar_factura': 'Factuur downloaden',
    'docs_drag_drop': 'Sleep bestanden hierheen of klik om te selecteren',
    'docs_obligatorios': 'Verplichte documenten',
    'eval_actual': 'Huidige beoordeling',
    'eval_comentario_voto_placeholder': 'Opmerking bij je stem (optioneel)...',
    'eval_max_puntos': 'Maximale score',
    'feats': 'Functies',
    'footer_contact': 'Contact',
    'footer_legal': 'Juridische kennisgeving',
    'footer_privacy': 'Privacybeleid',
    'ft_h': 'Alles wat je nodig hebt',
    'ft_lbl': 'Functies',
    'general_volver': 'Terug',
    'hero_cta1': 'Kandidatuur indienen',
    'hero_cta2': 'Het proces ontdekken',
    'hero_h1a': 'Jouw stad verdient',
    'hero_h1b': 'erkenning',
    'hero_sub': 'ACES Cities Network verbindt steden, beoordelaars en sportorganisaties in een platform.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Wissen',
    'login_subtitulo': 'Log in op je ACES Cities Network account',
    'marcar_todas_leidas': 'Alles als gelezen markeren',
    'nav_acceder': 'Inloggen',
    'nav_funciones': 'Functies',
    'nav_galardones': 'Onderscheidingen',
    'nav_proceso': 'Proces',
    'nav_registro': 'Registratie',
    'nav_roles': 'Rollen',
    'notif_todas_leidas': 'Alle meldingen als gelezen gemarkeerd',
    'pago_eliminado': 'Betaling verwijderd',
    'pendiente': 'In afwachting',
    'pendiente_label': 'In afwachting',
    'pipe_h': 'Transparant proces',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Volg elke fase van je kandidatuur in realtime.',
    'preambulo': 'Preambule',
    'recursos_aces_desc': 'Onderscheidingen, reglementen en officiele ACES-documentatie.',
    'recursos_aces_titulo': 'ACES Bronnen',
    'reglamentos_seed': 'Reglementen succesvol geladen',
    'regulacion_sin_articulos': 'Dit reglement heeft geen artikelen.',
    'roles_h': 'Voor elke rol',
    'roles_lbl': 'Rollen',
    'roles_p': 'Steden, beoordelaars en beheerders in een platform.',
    'sancion_incumplimiento': 'Sanctie wegens niet-naleving',
    'sin_articulos': 'Geen artikelen',
    'sin_galardones': 'Geen onderscheidingen beschikbaar',
    'sin_reglamentos': 'Geen reglementen beschikbaar',
    'sin_recursos': 'Geen bronnen beschikbaar',
    'sin_resultados': 'Geen resultaten',
    'stages': 'Fases',
    'tasa_inscripcion': 'Inschrijvingskosten',
    'todas': 'Alle',
    'ver_candidatura': 'Kandidatuur bekijken',
    'reserva_sin_evaluador': 'Algemeen (geen evaluator toegewezen)',
    'preview_pdf_hint': 'PDFs worden geopend in een nieuw browsertabblad.',
    'descargar': 'Downloaden',
    'con_pago_confirmado': 'met bevestigde betaling (mijlpaal)',
    'pendientes_pago': 'in afwachting',
    'sin_datos_pagos': 'Geen betalingsgegevens geregistreerd',
    'eval_no_asignado': 'U bent niet toegewezen aan de evaluatiecommissie van deze kandidatuur.',
    'subir_reserva': 'Reservering uploaden',
    'sin_reservas': 'Geen reserveringen',
    'sin_reservas_desc': 'Upload de reserverings-PDFs.',
    'reservas_desc_master': 'Upload de bevestigde vlucht- en hotelreserveringen als PDF. U kunt de bijbehorende beoordelaar selecteren.',
    'subir_agenda': 'Agenda uploaden (PDF)',
    'agenda_visita_titulo': 'Bezoekagenda',
    'reservas_titulo': 'Reserveringen',
    'reserva_subida_ok': 'Reservering succesvol geüpload',
    'agenda_subida_ok': 'Agenda succesvol geüpload',
    'doc_eliminado': 'Document verwijderd',
    'agenda_vacia_desc': 'Upload de PDF van de bezoekagenda.',
    'revenue_cobrado': 'Geïnd',
    'revenue_pendiente': 'Openstaand',
    'ciudad_hitos_titulo': 'Status van je kandidatuur',
    'hito_factura_recibida': 'Factuur ontvangen',
    'eval_mis_evaluaciones': 'Mijn evaluaties',
    'eval_sin_bid': 'De stad heeft het BID-bestand nog niet geüpload.',
    'voto_final_desc_motor': 'Breng je definitieve stem uit op basis van je evaluatie.',
    'chat_comision': 'Commissie-chat',
    'tit_comunicacion_ok': 'Officiële communicatie OK',
    'tit_derechos_factura_env': 'Beeldrechten: factuur verzonden',
    'tit_derechos_pagado': 'Beeldrechten: betaald',
    'tit_q1': 'Kwartaalrapport Q1',
    'tit_q2': 'Kwartaalrapport Q2',
    'tit_q3': 'Kwartaalrapport Q3',
    'tit_q4': 'Kwartaalrapport Q4',
    'tit_premio_n1': 'N1-prijs: Neemt deel?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Nieuwe sanctie',
    'motivo': 'Reden',
    'si': 'Ja',
    'no': 'Nee',
    'nueva': 'Nieuw',
    'sanciones': 'Sancties',
    'pagada': 'Betaald',

    'borrar_candidatura': 'Kandidatuur verwijderen',
    'borrar_candidatura_desc': 'Verwijdert de kandidatuur en alle bijbehorende gegevens permanent.',
    'confirmar_borrar_candidatura': 'Deze kandidatuur verwijderen? Deze actie kan NIET ongedaan worden gemaakt.',
    'confirmar_borrar_candidatura_2': 'WEET U HET ZEKER? ALLE documenten, betalingen, evaluaties en chats worden verwijderd.',
    'candidatura_eliminada': 'Kandidatuur verwijderd',
    'zona_peligrosa': 'Gevarenzone',
    'contacto_ciudad': 'Stadscontact',
    'sin_ciudad_vinculada': 'Geen stadsgebruiker gekoppeld',
    'cambiar_ciudad': 'Wijzigen',
    'vincular_ciudad': 'Koppelen',
    'vincular_ciudad_titulo': 'Stadsgebruiker koppelen',
    'vinculado_actual': 'Momenteel gekoppeld',
    'desvincular': 'Ontkoppelen',
    'buscar_usuario_ciudad': 'Zoek op naam, e-mail of stad...',
    'sin_usuarios_ciudad': 'Geen gebruikers met stadsrol geregistreerd',
    'ciudad_vinculada_ok': 'Stad succesvol gekoppeld',
    'ciudad_desvinculada': 'Stad ontkoppeld',
    'vincular': 'Koppelen',
    'codigo_generado': 'Code gegenereerd',
    'codigo_generado_ok': 'Stadscode gegenereerd',
    'codigo_vinculado_candidatura': 'Voorgekoppeld aan deze kandidatuur',
    'idioma_carta': 'Taal van de brief',
    'carta_copiada': 'Brief gekopieerd naar klembord',
    'copiar_carta': 'Kopieren',
    'enviar_invitacion': 'E-mail openen',
    'email_cliente_abierto': 'E-mailclient geopend',
    'estado_avanza_aceptada': 'Kandidatuur automatisch geaccepteerd',
    'estado_avanza_documentacion': 'Doorgaan naar documentatiefase',
    'estado_avanza_visita': 'Doorgaan naar bezoekfase',
    'estado_avanza_evaluacion': 'Doorgaan naar evaluatiefase',
    'confirmar_avance_estado': 'Status doorschuiven naar',
    'estado_cambiado': 'Status gewijzigd naar',
    'eval_ciudades_galardonadas': 'Bekroonde steden',

    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Afgevaardigde',
    'delegado_desc': 'De afgevaardigde kan de status en openstaande documenten bekijken.',
    'asignar_delegado': 'Toewijzen',
    'cambiar_delegado': 'Wijzigen',
    'sin_delegado': 'Geen afgevaardigde toegewezen',
    'confirmar_quitar_delegado': 'Afgevaardigde verwijderen?',
    'delegado_quitado': 'Afgevaardigde verwijderd',
    'delegado_asignado': 'Afgevaardigde toegewezen',
    'delegado_existente': 'Bestaande gebruiker',
    'delegado_invitar': 'Uitnodigen per email',
    'generar_codigo_delegado': 'Afgevaardigde code genereren',
    'codigo_delegado_generado': 'Code gegenereerd — stuur de email',
    'nombre_delegado_hint': 'Naam van de afgevaardigde',
    'email_delegado_hint': 'email@voorbeeld.com',
    'confirmar_retroceso_estado': 'Status terugzetten naar',
    'accion_gala': 'Uitnodigen voor Gala',
    'accion_gala_desc': 'Bevestig het gala en voeg de stad toe aan het jaarlijkse evenement.',
    'accion_notificar': 'Markeren als gemeld',
    'accion_notificar_desc_simple': 'Wijzigt de status naar gemeld. Communicatie met de stad gebeurt buiten de app.',
    'accion_premio': 'Prijs uitreiken',
    'accion_titularidad': 'Mandaat activeren',
    'activar_titularidad': 'Mandaat activeren',
    'anos_label': 'Jaren',
    'aprobar_informe': 'Goedkeuren',
    'archivo_muy_grande': 'Bestand groter dan 50 MB',
    'badge': 'Badge',
    'cambiar_estado': 'Status wijzigen',
    'candidatura_actualizada': 'Kandidatuur bijgewerkt',
    'chat_ayer': 'Gisteren',
    'chat_hoy': 'Vandaag',
    'chat_primer_mensaje': 'Stuur het eerste bericht',
    'checklist_obligaciones': 'Verplichtingen',
    'ciudad_notificada': 'Stad gemeld',
    'comentario_rechazo': 'Verplicht commentaar bij afwijzing:',
    'comite_label': 'Comité',
    'confirmar_cambio_estado': 'Statuswijziging bevestigen?',
    'confirmar_gala': 'Gala bevestigen',
    'confirmar_notificar': 'Markeren als gemeld?',
    'confirmar_pago': 'Betaling ontvangen bevestigen',
    'Copiado': 'Gekopieerd',
    'delegado_info_restriccion': 'Als gedelegeerde kunt u de pipelinestatus en bezoekagenda zien. Voor toegang tot de beoordelingsmotor of het BID File, vraag een evaluatortoewijzing aan bij ACES.',
    'delegado_mis_candidaturas': 'Als gedelegeerde',
    'delegado_vista': 'Gedelegeerdenweergave',
    'delegado_vista_restringida': 'Beperkte weergave: alleen pipeline, agenda en openstaande documenten. Geen betalingen of beoordelingen.',
    'derechos_imagen': 'Beeldrechten',
    'editar_candidatura': 'Kandidatuur bewerken',
    'Eliminado': 'Verwijderd',
    'email': 'E-mail',
    'emitir_factura': 'Factuur uitgeven (PDF)',
    'entre_miembros': 'Tussen',
    'espera_repetir': 'Wachttijd om te herhalen',
    'estado_actualizado': 'Status bijgewerkt',
    'estado_gala_confirmada': 'Gala bevestigd',
    'estado_notificada': 'Gemeld',
    'estado_notificada_rechazo': 'Afwijzing gemeld',
    'estado_premio_otorgado': 'Prijs toegekend',
    'estado_titularidad_activa': 'Actief mandaat',
    'eval_comentario_criterio': 'Opmerkingen over dit criterium...',
    'factura': 'Factuur',
    'factura_emitida': 'Factuur geüpload',
    'fase_candidatura': 'Kandidatuur',
    'fase_seguimiento': 'Opvolging',
    'gala_confirmada_ok': 'Gala bevestigd',
    'Guardado': 'Opgeslagen',
    'hito_agenda': 'Bezoekagenda geaccepteerd',
    'hito_carta': 'Sollicitatiebrief geaccepteerd',
    'hito_pago': 'Factuur betaald',
    'hito_reglamento_env': 'Reglement ontvangen',
    'hito_reglamento_firm': 'Reglement ondertekend',
    'hito_viajes': 'Reislogistiek voltooid',
    'image_rights': 'Beeldrechten',
    'importe': 'Bedrag',
    'informe_aprobado': 'Rapport goedgekeurd',
    'informe_rechazado': 'Rapport afgekeurd',
    'informe_subido': 'Rapport geüpload',
    'informes_trimestrales': 'Kwartaalrapporten',
    'marcar_notificada': 'Markeren als gemeld',
    'marcar_premio': 'Prijs als toegekend markeren',
    'max_candidatos': 'Max. kandidaten',
    'miembros_label': 'Leden',
    'notificar_rechazo': 'Afwijzing melden',
    'nueva_version': 'Nieuwe versie',
    'ocultar': 'Verbergen',
    'permisos_documento': 'Documentrechten',
    'permisos_guardados': 'Rechten opgeslagen',
    'poblacion_maxima': 'Max. bevolking',
    'poblacion_minima': 'Min. bevolking',
    'rechazar_informe': 'Afwijzen',
    'region_africa': 'Afrika',
    'region_americas': 'Amerika',
    'region_asia': 'Azië',
    'region_europa': 'Europa',
    'region_mundial': 'Wereldwijd',
    'region_oceania': 'Oceanië',
    'reglamentos_pendientes': 'Openstaande reglementen',
    'seleccionar_tipo': 'Documenttype',
    'sin_resultados_busqueda': 'Geen resultaten gevonden',
    'subir_informe': 'Rapport uploaden',
    'tasa_label': 'Tarief',
    'tipo_anexo': 'Bijlage',
    'tipo_especial': 'Speciaal',
    'tipo_no_permitido': 'Bestandstype niet toegestaan. Gebruik PDF, DOC, DOCX, XLS, XLSX, JPG of PNG',
    'tipo_principal': 'Hoofd',
    'titularidad_activa_label': 'Actief mandaat',
    'titularidad_creada': 'Mandaat aangemaakt',
    'titularidad_panel': 'Mijn mandaat',
    'tomar_decision_final': 'Definitieve beslissing nemen',
    'ver_documento': 'Bekijken',
    'ver_escala': 'Schaal bekijken',
    'ver_reglamento': 'Volledig reglement bekijken',
    'ver_seguimiento': 'Mandaat opvolging bekijken',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Stad',
    'visible_evaluador': 'Evaluator',
    'visible_master': 'Master',
    'visible_para': 'Zichtbaar voor',
    'warning_quitar_adjudicada': 'Terugdraaien voor "Toegekend" verwijdert de permanente toekenningsmarkering.',
    'warning_retroceso': 'Weet u zeker dat u de status wilt terugdraaien?',
    'y_label': 'en',
    'Q1_nombre': 'Jan-Mrt',
    'Q2_nombre': 'Apr-Jun',
    'Q3_nombre': 'Jul-Sep',
    'Q4_nombre': 'Okt-Dec',
    'informe_pendiente': 'In afwachting',
    'pago_pendiente': 'In afwachting',
    'checklist_logo_aces': 'Correct gebruik van het ACES-logo',
    'checklist_memoria_anual': 'Jaarverslag ingediend',
    'checklist_congreso': 'Deelname aan het ACES-congres',
    'checklist_imagen_corporativa': 'Bedrijfsimago bijgewerkt',
    'checklist_calendario_deportivo': 'Sportkalender gepubliceerd',
    'asignar_evaluadores': 'Evaluatoren toewijzen',
    'notas_internas_opcional': 'Interne notities (optioneel)',
    'estado_candidatura': 'Status van de kandidatuur',
    'hito_carta_recibida': 'Sollicitatiebrief ontvangen',
    'hito_candidatura_aceptada': 'Kandidatuur geaccepteerd',
    'hito_reglamento_enviado': 'Reglement verzonden',
    'hito_reglamento_firmado': 'Reglement ondertekend',
    'hito_datos_facturacion': 'Facturatiegegevens ontvangen',
    'hito_pago_confirmado': 'Betaling bevestigd',
    'hito_fechas_visita': 'Bezoekdata geaccepteerd',
    'hito_comision_cerrada': 'Commissie gesloten',
    'hito_reservas_completadas': 'Reserveringen voltooid',
    'hito_agenda_subida': 'Agenda geüpload',
    'hito_bid_file_recibido': 'BID-bestand ontvangen',
    'editar_visita': 'Bezoek bewerken',
    'programar_visita_btn': 'Bezoek plannen',
    'gestionar_comision': 'Commissie beheren',
    'pagos_titulo': 'Betalingen',
    'sin_pagos': 'Geen betalingen geregistreerd',
    'factura_marcada': 'Factuur gemarkeerd',
    'factura_desmarcada': 'Factuur niet gemarkeerd',
    'pago_confirmado_label': 'Betaling bevestigd',
    'pago_desmarcado': 'Betaling niet gemarkeerd',
    'vence_label': 'Vervaldatum',
    'factura_label': 'Factuur',
    'pagado_label': 'Betaald',
    'documentos_titulo': 'Documenten',
    'archivos_count': 'bestand',
    'archivos_count_plural': 'bestanden',
    'subir_btn': 'Uploaden',
    'sin_documentos': 'Geen documenten geüpload',
    'aprobado_label': 'Goedgekeurd',
    'rechazado_label': 'Afgewezen',
    'sin_permisos': 'Geen rechten',
    'ver_label': 'Bekijken',
    'logistica_titulo': 'Logistiek',
    'agenda_visita': 'Bezoekagenda',
    'subir_pdf': 'PDF uploaden',
    'sin_agenda': 'Geen agenda geüpload',
    'reservas_titulo': 'Reserveringen',
    'general_sin_eval': 'Algemeen (geen evaluator)',
    'subir_reserva': 'Reservering uploaden',
    'sin_reservas': 'Geen reserveringen geüpload',
    'agenda_subida_ok': 'Agenda geüpload',
    'reserva_subida_ok': 'Reservering geüpload',
    'evaluador_actualizado': 'Evaluator bijgewerkt',
    'general_todos_eval': 'Algemeen (alle evaluatoren)',
    'cambiar_evaluador': 'Evaluator wijzigen',
    'evaluaciones_titulo': 'Evaluaties',
    'enviada_label': 'verzonden',
    'enviadas_label': 'verzonden',
    'en_progreso_label': 'in voortgang',
    'comision_asignada': 'Toegewezen commissie',
    'evaluador_label': 'evaluator',
    'evaluadores_label': 'evaluatoren',
    'jefe_label': 'Hoofd',
    'sin_empezar': 'Niet gestart',
    'sin_evaluadores': 'Geen evaluatoren toegewezen',
    'enviada_badge': 'Verzonden',
    'favorable_label': 'Gunstig',
    'desfavorable_label': 'Ongunstig',
    'desbloquear_label': 'Ontgrendelen',
    'evaluacion_desbloqueada': 'Evaluatie ontgrendeld',
    'error_desbloquear': 'Fout bij ontgrendelen',
    'pdf_generado': 'PDF gegenereerd',
    'error_pdf': 'Fout bij het genereren van PDF',
    'en_progreso_badge': 'In voortgang',
    'tomar_decision': 'Definitieve beslissing nemen',
    'cerrar_menu': 'Menu sluiten',
    'compartir_tel_ciudad': 'Telefoon delen met de kandidaatstad',
    'compartir_tel_eval': 'Telefoon delen met andere evaluatoren',
    'notas_internas': 'Interne notities',
    'notas_privadas_placeholder': 'Privénotities...',
    'guardado_ok': 'Opgeslagen',
    'generar_btn': 'Genereren',
    'copiado_ok': 'Gekopieerd',
    'idioma_destinatario': 'Taal van de ontvanger',
    'codigo_acceso_modal': 'Toegangscode',
    'gala_activa': 'ACTIEF',
    'gala_inactiva': 'INACTIEF',
    'calendario_carta': 'Brief burgemeester: 30 mrt',
    'calendario_bid': 'BID-bestand: 30 jun',
    'calendario_preseleccion': 'Voorselectie: 31 jul',
    'calendario_visitas': 'Bezoeken: okt',
    'calendario_gala': 'Gala: nov',
    'calendario_titularidad': 'Titelhouder: 1 jan volgend',
    'candidatura_singular': 'kandidatuur',
    'candidaturas_plural': 'kandidaturen',
    'doc_tipo_bid_file': 'BID-bestand',
    'doc_tipo_presentacion': 'Presentatie',
    'progreso_inicio': 'Start',
    'progreso_adjudicada': 'Toegekend',
    'hab_label': 'inw.',
    'eval_abreviado': 'eval.',
    'min_poblacion_label': 'Min. bevolking',
    'max_poblacion_label': 'Max. bevolking',
    'max_candidatos_label': 'Max. kandidaten',
    'espera_label': 'Wachttijd',
    'anos_label': 'jaar',
    'image_rights': 'Beeldrechten',
    'comite_label': 'Commissie',
    'miembros_label': 'leden',
    'usado_label': 'GEBRUIKT',
    'disponibles_count': 'Beschikbaar',
    'usados_count': 'Gebruikt',
    'codigos_disponibles_count': 'Beschikbare codes',
    'hotel_placeholder': 'Toegewezen hotel, inchecken, regels...',
    'vuelo_placeholder': 'Luchthaven, tijden, klasse...',
    'parlamento_placeholder': 'Adres, toegangsregels, protocol...',
    'dni_pasaporte': 'ID / Paspoort',
    'cerrar_menu': 'Menu sluiten',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'actividad': 'Activiteit',
    'alertas_titulo': 'Waarschuwingen',
    'aprobar': 'Goedkeuren',
    'auth_cargando': 'Inloggen...',
    'auth_cerrar_sesion': 'Uitloggen',
    'auth_email': 'E-mail',
    'auth_entrar': 'Inloggen',
    'auth_error_credenciales': 'Onjuist e-mailadres of wachtwoord.',
    'auth_error_red': 'Geen internetverbinding.',
    'auth_subtitulo': 'ACES-platform voor sportkandidaturen',
    'avanzar_a': 'Doorzetten naar',
    'buscar_placeholder': 'Zoek stad, onderscheiding...',
    'cambios': 'Wijzigingen',
    'cancelar': 'Annuleren',
    'cat_eventos': 'Evenementen',
    'cat_infra': 'Infrastructuur',
    'cat_otros': 'Overige',
    'cat_presupuesto': 'Begroting',
    'categoria': 'Categorie',
    'cerrar': 'Sluiten',
    'chat_ciudad': 'Chat met ACES',
    'chat_escribir': 'Schrijf een bericht...',
    'chat_interno': 'Commissiechat',
    'ciudad': 'Stad',
    'ciudad_historico': 'Geschiedenis',
    'ciudad_recursos': 'ACES-bronnen',
    'ciudad_sin_candidatura': 'Geen actieve kandidatuur',
    'ciudad_sin_candidatura_desc': 'Neem contact op met ACES om het proces te starten.',
    'codigo_activando': 'Activeren...',
    'codigo_activar': 'Code activeren',
    'codigo_error_invalido': 'Ongeldige of reeds gebruikte code.',
    'codigo_subtitulo': 'Voer de ACESCN-code in die u van ACES hebt ontvangen.',
    'codigo_titulo': 'Toegangscode',
    'codigos_disponibles': 'Beschikbaar',
    'codigos_generados': 'Gegenereerde codes',
    'completado': 'voltooid',
    'config_convocatorias': 'Open oproepen',
    'config_guardada': 'Instellingen opgeslagen',
    'config_sanciones': 'Sancties bij afwezigheid op het gala (€)',
    'config_tasas': 'Deelnamekosten (€)',
    'confirmada': 'Bevestigd',
    'confirmando': 'Bevestigen...',
    'confirmar_asistencia': 'Aanwezigheid bevestigen',
    'convocatoria': 'Editie',
    'creando': 'Aanmaken...',
    'crear_candidatura': 'Kandidatuur aanmaken',
    'decision_adjudicar': 'Toekennen',
    'decision_advertencia': 'Deze beslissing is definitief en wordt permanent vastgelegd.',
    'decision_confirmar': 'Beslissing bevestigen',
    'decision_nav': 'Eindbeslissing',
    'decision_notas': 'Toelichting beslissing (verplicht)',
    'decision_rechazar': 'Niet toekennen',
    'decision_selecciona': 'Selecteer de beslissing',
    'decision_titulo': 'Eindbeslissing',
    'desbloquear': 'Ontgrendelen',
    'destino': 'Bestemming',
    'dias': 'dagen',
    'editar': 'Bewerken',
    'eliminar': 'Verwijderen',
    'eliminar_cuenta': 'Mijn account verwijderen',
    'eliminar_cuenta_desc': 'Deze actie is onomkeerbaar. Uw gegevens worden geanonimiseerd conform de AVG.',
    'eliminar_cuenta_password': 'Voer uw wachtwoord in om te bevestigen',
    'eliminar_cuenta_titulo': 'Account verwijderen',
    'email_contacto': 'Contact-e-mail',
    'enviada': 'Verzonden',
    'enviar': 'Verzenden',
    'enviar_propuesta': 'Voorstel verzenden',
    'escribiendo': 'is aan het typen',
    'estado_pipeline': 'Kandidatuur-pipeline',
    'eval_abrev': 'beoord.',
    'eval_anterior': 'Vorige',
    'eval_asignadas': 'Mijn toegewezen',
    'eval_cargando': 'Beoordeling laden...',
    'eval_comentario_placeholder': 'Licht uw score toe...',
    'eval_comentario_voto': 'Toelichting bij eindstem',
    'eval_confirmar_desc': 'Na verzending kunt u deze niet meer wijzigen, tenzij de Master deze ontgrendelt.',
    'eval_confirmar_envio': 'Beoordeling verzenden',
    'eval_conflicto_interes': 'Belangenconflict: u komt uit hetzelfde land als de kandidaat-stad voor Capital.',
    'eval_desfavorable': 'Negatief',
    'eval_enviada_desc': 'Uw beoordeling is correct geregistreerd.',
    'eval_enviada_titulo': 'Beoordeling verzonden',
    'eval_enviadas': 'verzonden',
    'eval_enviar': 'Verzenden',
    'eval_favorable': 'Positief',
    'eval_habilitada': 'Beoordeling ingeschakeld',
    'eval_ir_motor': 'Naar beoordelingsmodule',
    'eval_lista': 'Beoordelaars',
    'eval_mi_evaluacion': 'Mijn beoordeling',
    'eval_mis_candidaturas': 'Mijn kandidaturen',
    'eval_motor_titulo': 'Beoordelingsmodule',
    'eval_notas_comentario': 'Notities en opmerkingen',
    'eval_registrados': 'Geregistreerd',
    'eval_seccion': 'Sectie',
    'eval_siguiente': 'Volgende',
    'eval_sin_activas': 'Geen actieve kandidaturen',
    'eval_sin_asignadas': 'Geen toegewezen kandidaturen',
    'eval_sin_asignadas_desc': 'De Master wijst kandidaturen toe aan uw commissie.',
    'eval_stat_asignadas': 'Toegewezen',
    'eval_stat_completadas': 'Voltooid',
    'eval_stat_pendientes': 'In behandeling',
    'eval_todas': 'Alle actieve',
    'eval_todas_activas': 'Actieve kandidaturen',
    'eval_todas_aviso': 'Alleen-lezen. Volledige details alleen voor uw toegewezen kandidaturen.',
    'eval_total_seccion': 'Score voor deze sectie',
    'eval_ver_escala': 'Puntenschaal bekijken',
    'eval_voto_final': 'Eindstem',
    'eval_voto_informativo': 'Uw stem is adviserend. De eindbeslissing ligt bij de ACES Master.',
    'evaluacion_titulo': 'Beoordeling',
    'evaluaciones_enviadas': 'beoordelingen verzonden',
    'evaluadores_asignados': 'beoordelaars toegewezen',
    'fecha_regreso': 'Terugreisdatum',
    'fecha_salida': 'Vertrekdatum',
    'filtro_todas': 'Alle',
    'gala_asistencia_confirmada': 'Aanwezigheid bevestigd',
    'gala_invitacion_titulo': 'Uitnodiging voor het gala',
    'gala_pendiente_desc': 'ACES activeert uw uitnodiging zodra het zover is.',
    'gala_pendiente_invitacion': 'Uitnodiging in behandeling',
    'gala_representantes': 'Vertegenwoordigers',
    'gala_sin_datos': 'Geen galagegevens',
    'gala_sin_datos_desc': 'Geen informatie over de ceremonie voor dit jaar.',
    'gala_sin_representantes': 'Geen vertegenwoordigers toegevoegd',
    'galardon': 'Onderscheiding',
    'general_error': 'Er is een fout opgetreden',
    'general_reintentar': 'Opnieuw proberen',
    'generar_codigo': 'Code genereren',
    'generar_codigo_titulo': 'Nieuwe toegangscode',
    'guardando': 'Opslaan...',
    'guardar': 'Opslaan',
    'guardar_config': 'Instellingen opslaan',
    'hora': 'Tijd',
    'llegada': 'Aankomst',
    'lugar': 'Locatie',
    'marcar_leidas': 'Alles als gelezen markeren',
    'master_panel_desc': 'Volledige controle over kandidaturen, beoordelingen en beslissingen.',
    'master_recientes': 'Recente kandidaturen',
    'master_saludo': 'ACES-paneel',
    'master_sin_candidaturas': 'Nog geen kandidaturen',
    'mod_chat': 'ACES-chat',
    'mod_documentos': 'Documenten',
    'mod_pagos': 'Betalingen',
    'mod_titularidad': 'Titel',
    'mod_viaje': 'Logistiek',
    'nombre_documento': 'Documentnaam',
    'nombre_hotel': 'Naam van het hotel',
    'notif_sin_leer': 'Ongelezen',
    'notif_sin_notifs': 'Geen meldingen',
    'nueva_candidatura': 'Nieuwe kandidatuur',
    'nueva_propuesta': 'Nieuw voorstel',
    'num_habitaciones': 'Aantal kamers',
    'origen': 'Vertrekpunt',
    'pago_instrucciones': 'Voer de bankoverschrijving uit en upload het betaalbewijs.',
    'pais': 'Land',
    'perfil_apellidos': 'Achternaam',
    'perfil_cargo': 'Functie',
    'perfil_idioma': 'App-taal',
    'perfil_nombre': 'Voornaam',
    'perfil_notificaciones': 'Meldingen',
    'perfil_pais': 'Land',
    'perfil_telefono': 'Telefoon',
    'precio_aprox': 'Geschatte prijs (€)',
    'proponer_vuelo': 'Vlucht',
    'rechazar': 'Afwijzen',
    'salida': 'Vertrek',
    'seleccionar': 'Selecteren',
    'sin_candidaturas': 'Geen kandidaturen',
    'sin_candidaturas_desc': 'Geen kandidaturen voor dit filter.',
    'sin_documentos_desc': 'Upload de vereiste documenten voor uw kandidatuur.',
    'sin_evaluaciones': 'Geen beoordelingen',
    'sin_pagos_desc': 'De betalingen van uw kandidatuur verschijnen hier.',
    'stat_activas': 'Actief',
    'stat_decision': 'Beslissing in behandeling',
    'stat_evaluacion': 'In beoordeling',
    'stat_notif': 'Ongelezen',
    'stat_titulos': 'Actieve titels',
    'stat_total': 'Totaal',
    'subir_documento': 'Document uploaden',
    'subir_nota': 'Selecteer het bestand op uw apparaat',
    'tab_candidatura': 'Kandidatuur',
    'tab_candidaturas': 'Kandidaturen',
    'tab_config': 'Instellingen',
    'tab_documentos': 'Documenten',
    'tab_evaluaciones': 'Beoordelingen',
    'tab_evaluadores': 'Beoordelaars',
    'tab_global': 'Alle',
    'tab_notif': 'Meldingen',
    'tab_pagos': 'Betalingen',
    'tab_perfil': 'Profiel',
    'tab_recursos': 'Bronnen',
    'tab_resumen': 'Overzicht',
    'tab_viaje': 'Logistiek',
    'tipo_codigo': 'Codetype',
    'tit_ano_titulo': 'Titeljaar',
    'tit_evidencias': 'Geüploade bewijsstukken',
    'tit_item_calendario': 'Sportkalender',
    'tit_item_congreso': 'Congres of conferentie',
    'tit_item_imagen': 'Correct gebruik van de titel',
    'tit_item_memoria': 'Eindverslag',
    'tit_no_aplica': 'Geen titeljaar',
    'tit_no_aplica_desc': 'Deze module wordt actief wanneer uw stad een ACES-onderscheiding wint.',
    'tit_sanciones': 'Sancties',
    'tit_sin_datos': 'Geen actieve titels',
    'tit_titulo': 'Titeljaar',
    'toca_copiar': 'Tik op de code om te kopiëren',
    'vence': 'Vervalt',
    'ver_comprobante': 'Betaalbewijs bekijken',
    'viaje_aviso_privacidad': 'De identiteit van de beoordelaars is vertrouwelijk. U ziet alleen data en logistiek.',
    'viaje_sin_propuestas': 'Geen reisvoorstellen',
    'viaje_sin_propuestas_desc': 'Stel opties voor vlucht, hotel en agenda voor het bezoek voor.',
    'visita_evaluadores': 'Bezoek van beoordelaars',
    'visita_programada': 'Bezoek gepland',
    'visita_sin_programar': 'Bezoek nog niet gepland',
    'visita_titulo': 'Beoordelingsbezoek',
    'check_in': 'Inchecken',
    'check_out': 'Uitchecken',
    'stages': 'Fasen',
    'Q3_nombre': 'jul-sep',
    'eval_abreviado': 'beoord.',
    'sin_fecha_visita': 'Geen bezoekdatum',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Opmerking bij de sectie',
    'eval_comentario_seccion_placeholder': 'Algemene opmerking over de sectie (optioneel)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Fout: {0}',
    'pdf_evaluacion': 'Evaluatie als pdf',
    'pdf_informe_titulo': 'ACES Cities Network — Evaluatierapport',
    'pdf_ciudad': 'Stad',
    'pdf_evaluador': 'Beoordelaar',
    'pdf_fecha': 'Datum',
    'pdf_total': 'Totaalscore',
    'pdf_secciones': 'Secties',
    'pdf_voto_final': 'Eindstem',
    'pdf_comentario_voto': 'Toelichting bij de stem',
    'pdf_no_evaluada': 'Niet beoordeeld',
    'pdf_generado_por': 'Gegenereerd door ACES Cities Network · {0}',
    'email_placeholder': 'naam@voorbeeld.nl',
    'ej_nombre_persona': 'Bijv. Anna de Vries',
    'ej_aeropuerto': 'Bijv. Amsterdam (AMS)',
    'pdf_permitir_popups': 'Sta pop-ups toe om de pdf te exporteren',
    'confirmar': 'Bevestigen',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Let op',
    'confirmar_eliminar_doc': 'Dit document verwijderen? Dit kan niet ongedaan worden gemaakt.',
    'confirmar_eliminar_logistica': 'Dit logistiekdocument verwijderen?',
    'confirmar_notificar_titulo': 'Stad op de hoogte brengen',
    'confirmar_retroceso_titulo': 'Terugzetten bevestigen',
    'eliminado': 'Verwijderd',
    'quitar_delegado_titulo': 'Afgevaardigde verwijderen',
    'warning_quitar_adjudicada_titulo': 'Toekenning intrekken',
    'warning_retroceso_2': 'BEVESTIGEN? Gegevens worden definitief verwijderd (data, galaregistraties enz.). Dit kan NIET ongedaan worden gemaakt.',
    'warning_retroceso_titulo': 'Status terugzetten',
    'eval_pts': 'ptn',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Vluchtboeking',
    'viaje_tipo_reserva_hotel': 'Hotelboeking',
    'reserva_generica': 'Boeking',
  },
  'pt-BR': {
    // P0-REG 23sep2026
    'codigo_no_encontrado': 'Não encontramos esse código. Verifique se está completo, por exemplo: ACESCN-EVAL-7SNBX5',
    'codigo_usado': 'Este código já foi utilizado. Se você já se cadastrou, faça login. Caso contrário, peça um novo código à ACES.',
    'codigo_expirado': 'Este código expirou. Peça um novo código à ACES.',
    'codigo_admin': 'Este é um código de administração e não serve para se cadastrar aqui. Entre em contato com a ACES.',
    'registro_error_general': 'Não foi possível concluir o cadastro e nenhuma conta foi criada. Tente novamente; se falhar de novo, entre em contato com a ACES.',
    'email_ya_registrado_login': 'Este email já tem uma conta. Toque em "Entrar" e, se não lembrar a senha, use "Esqueceu a senha?".',
    'nueva_gala_btn': 'Criar gala',
    'programar_visita': 'Agendar visita de avaliação',
    'guardar_notas': 'Salvar notas',
    'historial_estados': 'Histórico de estados',
    'notas_privadas_hint': 'Notas privadas sobre esta candidatura (visível apenas para masters)...',
    'voto_emitido': 'Voto emitido:',
    'voto_en_contra': 'Contra',
    'voto_a_favor': 'A favor',
    'voto_final_desc': 'A candidatura está em fase de votação. Emita o seu voto.',
    'voto_final_titulo': 'Voto final necessário',
    'app_nombre': 'ACES Cities Network',
    'titularidades_pronto': 'Titularidades — em breve',
    'email_abierto': 'Seu cliente de email abriu',
    'cargo_hint': 'Ex.: Secretário de Esportes',
    'password_repetir_hint': 'Repita a senha',
    'password_min': 'Mínimo 6 caracteres',
    'placeholder_apellido_ej': 'Silva',
    'placeholder_nombre_ej': 'Maria',
    'error_guardar': 'Erro ao salvar',
    'error_label': 'Erro',
    'error_subir': 'Erro ao enviar',
    'error_cambiar_password': 'Erro ao alterar senha',
    'candidatura_no_encontrada': 'Candidatura não encontrada',
    'puntuacion_final': 'Pontuação final',
    'placeholder_destino': 'Buenos Aires (EZE)',
    'placeholder_aeropuerto': 'Madrid (MAD)',
    'destino_label': 'Destino',
    'origen_label': 'Origem',
    'notif_actividad_desc': 'A atividade das suas candidaturas aparecerá aqui.',
    'placeholder_ej_espana': 'Ex.: Espanha',
    'placeholder_ej_madrid': 'Ex.: Madrid',
    'gala_lugar_hint': 'Ex.: Palácio de Congressos',
    'gala_titulo_hint': 'Ex.: Gala ACES América 2026',
    'gala_descripcion_hint': 'Descrição do evento...',
    'gala_pais': 'País do evento',
    'gala_ciudad': 'Cidade do evento',
    'gala_lugar': 'Local da cerimônia',
    'gala_titulo_label': 'Título da gala',
    'visible_ciudades': 'Visível para cidades',
    'nueva_gala': 'Nova gala',
    'sin_galas': 'Nenhuma gala configurada',
    'gala_gestion': 'Gestão da cerimônia de gala',
    'gala_aces_titulo': 'Gala ACES',
    'codigo_copiado': 'Código copiado',
    'error_generar_codigo': 'Erro ao gerar código',
    'nombre_eval_email': 'Nome do avaliador (para email)',
    'invitar_evaluador': 'Convidar avaliador',
    'sin_evaluadores': 'Nenhum avaliador registrado',
    'preview': 'Visualizar',
    'ver_todos': 'Ver todos',
    'total_candidaturas': 'Total de candidaturas',
    'titulos_adjudicados': 'Títulos adjudicados',
    'tamano_comite': 'Tamanho do comitê (avaliadores)',
    'sanciones_asistencia': 'Sanções por ausência (€)',
    'tasas_participacion': 'Taxas de participação (€)',
    'config_sistema_perfil': 'Sistema e perfil',
    'sin_candidaturas_desc2': 'Tente mudar os filtros ou crie uma nova.',
    'placeholder_pais_ej': 'Ex.: Argentina',
    'placeholder_ciudad_ej': 'Ex.: Buenos Aires',
    'buscar_evaluador': 'Buscar avaliador...',
    'notas_decision_hint': 'Notas internas sobre a decisão...',
    'concepto_placeholder': 'Ex.: Taxa de participação 2026',
    'sin_jefe_asignado': 'Nenhum chefe atribuído',
    'jefe_comision': 'Chefe da comissão',
    'ciudad_label': 'Cidade',
    'descargar_app_store': 'Baixar na App Store',
    'aforo_maximo': 'Capacidade máxima',
    'descripcion_label': 'Descrição',
    'convocatoria_label': 'Convocatória',
    'abrir_email': 'Abrir email',
    'crear_gala': 'Criar gala',
    'en_evaluacion': 'Em avaliação',
    'emails_institucionales': 'Emails institucionais',
    'email_evaluador': 'Email do avaliador',
    'codigo_acceso_label': 'Código de acesso',
    'codigos_acceso': 'Códigos de acesso',
    'seleccionar_galardon': 'Selecionar galardão...',
    'todos_galardones': 'Todos os galardões',
    'todos_estados': 'Todos os estados',
    'cargando_dashboard': 'Carregando...',
    'candidaturas_recientes': 'Candidaturas recentes',
    'candidaturas_activas': 'Candidaturas ativas',
    'alertas_sistema': 'Alertas do sistema',
    'accesos_rapidos': 'Ações rápidas',
    'viaje_titulo': 'Viagem',
    'nuevo': 'Novo',
    'estado': 'Estado',
    'abrir_votacion': 'Abrir votação',
    'accion_anadir_evaluador': 'Adicionar avaliador',
    'accion_master': 'Ação master',
    'accion_nueva_candidatura': 'Nova candidatura',
    'accion_ver_alertas': 'Ver alertas',
    'actividad': 'Actividad',
    'agenda_notas': 'Notas internas',
    'agenda_notas_hint': 'Ex: O avaliador será recebido pelo Presidente...',
    'agenda_pdf_listo': 'PDF da agenda anexado',
    'agenda_propuesta_enviada': 'Evento da agenda enviado',
    'agenda_subir_pdf': 'Carregar PDF da agenda completa (opcional)',
    'agenda_tipo_evento': 'Tipo de evento',
    'agenda_titulo_evento': 'Título do evento',
    'agenda_vacia': 'Agenda vazia',
    'alerta_decision_pendiente': 'Decisão pendente',
    'alerta_docs_pendientes': 'Documentos pendentes',
    'alerta_pago_vencido': 'Pagamento vencido',
    'alerta_sin_evaluadores': 'Sem avaliadores atribuídos',
    'alertas_titulo': 'Alertas',
    'anos': 'anos',
    'anterior': 'Anterior',
    'apellidos': 'Sobrenome',
    'aprobar': 'Aprobar',
    'asignacion_ciudad_hint': 'Ex: Lisboa',
    'asignacion_ciudad_salida': 'Cidade de partida para a visita',
    'asignacion_ciudad_salida_desc': 'A cidade a partir da qual partirá para a visita de avaliação.',
    'asignacion_compartir_ciudad': 'Partilhar telefone com a cidade',
    'asignacion_compartir_ciudad_desc': 'A cidade poderá ver o seu número de telefone e WhatsApp.',
    'asignacion_compartir_eval_desc': 'Os outros avaliadores desta candidatura poderão ver o seu contacto.',
    'asignacion_compartir_evaluadores': 'Partilhar com outros avaliadores',
    'asignacion_confirmar': 'Confirmar e começar',
    'asignacion_nota': 'Nota para a cidade (opcional)',
    'asignacion_nota_desc': 'Esta nota será visível para a equipa da cidade candidata.',
    'asignacion_nota_hint': 'Ex: Chego de comboio na terça de manhã...',
    'asignacion_privacidad': 'Privacidade e contacto',
    'asignacion_sub': 'Antes de começar, configure os seus dados de contacto para esta candidatura.',
    'asignacion_titulo': 'Nova atribuição',
    'asignar_ciudad_titulo': 'Atribuir cidade',
    'asignar_evaluador': 'Atribuir avaliador',
    'auth_cargando': 'Iniciando...',
    'auth_cerrar_sesion': 'Cerrar sesión',
    'auth_email': 'Email',
    'auth_entrar': 'Iniciar sesión',
    'auth_error_credenciales': 'Email o contraseña incorrectos.',
    'auth_error_red': 'Sin conexión a internet.',
    'auth_password': 'Palavra-passe',
    'auth_subtitulo': 'Plataforma de candidaturas deportivas ACES',
    'avanzar_a': 'Avanzar a',
    'borrar': 'Eliminar',
    'borrar_todas': 'Eliminar tudo',
    'buscar_ciudad_email': 'Pesquisar cidade, email...',
    'buscar_pais': 'Pesquisar país...',
    'buscar_placeholder': 'Buscar ciudad, galardón...',
    'cambios': 'Cambios',
    'campos_obligatorios': 'Preencha todos os campos obrigatórios.',
    'cancelar': 'Cancelar',
    'candidatura_asignada_ok': 'Candidatura atribuída',
    'cargando_candidatura': 'A carregar candidatura...',
    'cargo': 'Cargo',
    'cat_carta': 'Carta de intenção',
    'cat_eventos': 'Eventos',
    'cat_galardones': 'Prémios anteriores',
    'cat_infra': 'Infraestructura',
    'cat_otros': 'Otros',
    'cat_presupuesto': 'Presupuesto',
    'categoria': 'Categoría',
    'cerrar': 'Cerrar',
    'cerrar_votacion': 'Fechar votação',
    'chat_ciudad': 'Chat con ACES',
    'chat_ciudad_aces': 'Chat com ACES',
    'chat_ciudad_aces_desc': 'Comunicação direta com a equipa ACES Europa.',
    'chat_conversaciones': 'Conversas',
    'chat_elige_conversacion': 'Escolha com quem quer conversar',
    'chat_escribir': 'Escribe un mensaje...',
    'chat_interno': 'Chat de comisión',
    'chat_interno_desc': 'Canal privado entre avaliadores e ACES. A cidade não tem acesso.',
    'chat_mis_chats': 'Os meus chats',
    'chat_sin_activos': 'Sem chats ativos',
    'chat_sin_activos_desc': 'Os chats com candidaturas aparecerão aqui',
    'chat_sin_mensajes': 'Sem mensagens',
    'chat_adjuntar': 'Anexar arquivo',
    'chat_adjunto_expira': 'Arquivo disponivel por 7 dias',
    'chat_adjunto_max': 'Arquivo muito grande (max 10MB)',
    'chat_borrar': 'Apagar para todos',
    'chat_buscar_conv': 'Buscar cidade ou premio...',
    'chat_confirmar_borrar': 'Apagar esta mensagem para todos?',
    'chat_filtro_no_leidas': 'Nao lidas',
    'chat_filtro_todas': 'Todas',
    'chat_mensaje_borrado': 'Mensagem apagada',
    'chat_no_leidos': 'nao lidas',
    'chat_activas': 'chats ativos',
    'chat_recargar': 'Atualizar',
    'chat_responder': 'Responder',
    'chat_sin_no_leidos': 'Tudo lido',
    'warn_poblacion_min': 'Populacao minima necessaria',
    'warn_poblacion_max': 'Populacao maxima permitida',
    'warn_actual': 'Atual',
    'warn_max_candidaturas': 'Maximo de candidaturas para este premio',
    'warn_actuales': 'Atuais',
    'warn_espera': 'Periodo de espera',
    'warn_anos': 'anos',
    'warn_ultima': 'Ultima premiacao',
    'warn_elegible_desde': 'Elegivel a partir de',
    'warn_elegibilidad': 'Avisos de elegibilidade',
    'warn_override': 'Override Master: criar candidatura mesmo assim',
    'warn_override_required': 'Ha avisos de elegibilidade. Marque Override para continuar.',
    'tasa_auto': 'Sera criado pagamento automatico de',
    'poblacion_label': 'Populacao',
    'galardon_label': 'Premio',
    'calendario_procesal': 'Calendario processual (Art. 15)',
    'regla_25_titulo': 'Regra 2.5 pontos (Art. 15)',
    'regla_25_desc': 'A diferenca entre os dois primeiros e',
    'regla_25_info': 'O Master pode premiar o segundo classificado se justificado.',
    'regla_25_justificacion_hint': 'Justifique a decisao, especialmente se a regra 2.5 se aplicar...',
    'resumen_puntuaciones': 'Pontuacoes dos avaliadores',
    'candidatura_adjudicada': 'Candidatura premiada!',
    'error_campos_obligatorios': 'Cidade, pais e premio sao obrigatorios.',
    'checklist_aprobado': 'APROVADA',
    'checklist_titulo': 'Requisitos de documentação',
    'ciudad': 'Ciudad',
    'ciudad_asignada': 'Cidade atribuída',
    'ciudad_asignar': 'Atribuir',
    'ciudad_cambiar': 'Alterar',
    'ciudad_cargo': 'Cargo',
    'ciudad_contacto_principal': 'Contacto principal',
    'ciudad_desde': 'Cidade de partida',
    'ciudad_email': 'Email',
    'ciudad_historico': 'Historial',
    'ciudad_modulos': 'Módulos',
    'ciudad_nombre': 'Nome',
    'ciudad_recursos': 'Recursos ACES',
    'ciudad_rol': 'Função',
    'ciudad_salida': 'Cidade de partida',
    'ciudad_salida_desc': 'A cidade candidata precisa saber de onde viaja para reservar o seu voo.',
    'ciudad_salida_hint': 'Ex: Lisboa, Porto...',
    'ciudad_salida_pendiente': 'Cidade de partida pendente',
    'ciudad_sin_asignar': 'Sem cidade atribuída',
    'ciudad_sin_candidatura': 'Sin candidatura activa',
    'ciudad_sin_candidatura_desc': 'Contacta con ACES para iniciar el proceso.',
    'ciudad_telefono': 'Telefone',
    'codigo_activando': 'Activando...',
    'codigo_activar': 'Activar código',
    'codigo_error_invalido': 'Código inválido o ya utilizado.',
    'codigo_generado_label': 'CÓDIGO GERADO',
    'codigo_invalido': 'Código inválido ou já utilizado.',
    'codigo_placeholder': 'ACESCN-TIPO-XXXXXX',
    'codigo_subtitulo': 'Introduce el código ACESCN que te proporcionó ACES.',
    'codigo_titulo': 'Código de acceso',
    'codigo_vacio': 'Insira seu código de acesso.',
    'codigo_validar': 'Validar código',
    'codigos_disponibles': 'Disponibles',
    'codigos_generados': 'Códigos generados',
    'codigos_usados': 'Códigos usados',
    'comision_sin_otros': 'Só você na comissão',
    'comision_sin_otros_desc': 'Ainda não foram atribuídos outros avaliadores a esta candidatura.',
    'comision_titulo': 'Comissão de avaliação',
    'completado': 'completado',
    'comprobante_desc': 'Carregue o comprovativo de transferência bancária em PDF ou imagem.',
    'comprobante_subido': 'Comprovante enviado com sucesso',
    'comprobante_titulo': 'Comprovativo de pagamento',
    'config_comite': 'Tamanho do comité',
    'config_convocatorias': 'Convocatorias abiertas',
    'config_correos_desc': 'Emails usados para notificações oficiais.',
    'config_correos_titulo': 'Emails institucionais',
    'config_guardada': 'Configuración guardada',
    'config_sanciones': 'Sanciones por no asistencia a gala (€)',
    'config_sistema_titulo': 'Configuração do sistema',
    'config_tasas': 'Tasas de participación (€)',
    'confirmada': 'Confirmada',
    'confirmando': 'Confirmando...',
    'confirmar_asistencia': 'Confirmar asistencia',
    'contacto_principal': 'Contacto principal',
    'continuar': 'Continuar',
    'continuar_evaluacion': 'Continuar avaliação',
    'convocatoria': 'Convocatoria',
    'creando': 'Creando...',
    'crear_candidatura': 'Crear candidatura',
    'crear_cuenta': 'Criar conta',
    'dashboard_accesos_rapidos': 'Acessos rápidos',
    'dashboard_awos_sub': 'Registe as suas atividades desportivas.',
    'dashboard_awos_titulo': 'AWoS Ativo',
    'dashboard_documentos': 'Documentos',
    'dashboard_estado': 'Estado candidatura',
    'dashboard_mensajes': 'Mensagens',
    'dashboard_pagos_pendientes': 'Pagamentos pendentes',
    'datos_opcionales': 'Estes campos são opcionais e podem ser atualizados no seu perfil.',
    'de': 'de',
    'decision_adjudicar': 'Adjudicar',
    'decision_advertencia': 'Esta decisión es inapelable y quedará registrada permanentemente.',
    'decision_confirmar': 'Confirmar decisión',
    'decision_nav': 'Decisión final',
    'decision_notas': 'Notas de la decisión (obligatorio)',
    'decision_rechazar': 'No adjudicar',
    'decision_selecciona': 'Selecciona la decisión',
    'decision_titulo': 'Decisión final',
    'desbloquear': 'Desbloquear',
    'desde': 'desde',
    'destino': 'Destino',
    'dia': 'Día',
    'dias': 'días',
    'dias_label': 'dias',
    'dias_visita_label': 'dias de visita',
    'doc_subido_ok': 'Documento enviado com sucesso',
    'docs_pendientes': 'Docs pendentes',
    'documento_pendiente': 'Documento a aguardar receção',
    'duracion_visita_label': 'DURAÇÃO DA VISITA',
    'editar': 'Editar',
    'eliminar': 'Eliminar',
    'eliminar_cuenta': 'Eliminar mi cuenta',
    'eliminar_cuenta_desc': 'Esta acción es irreversible. Tus datos serán anonimizados conforme al RGPD.',
    'eliminar_cuenta_password': 'Introduce tu contraseña para confirmar',
    'eliminar_cuenta_titulo': 'Eliminar cuenta',
    'eliminar_documento': 'Eliminar documento',
    'email_ciudad_label': 'EMAIL DA CIDADE',
    'email_contacto': 'Email de contacto',
    'email_enviado': 'Email enviado com sucesso',
    'email_enviar': 'Enviar email oficial',
    'email_idioma': 'Idioma do destinatário',
    'email_invalido': 'E-mail inválido.',
    'email_preview': 'Pré-visualização do email',
    'email_remitente': 'Enviar de',
    'email_ya_registrado': 'Este e-mail já está cadastrado.',
    'emitir_factura_titulo': 'Emitir fatura',
    'emitir_nueva_factura': 'Emitir nova fatura',
    'enviada': 'Enviada',
    'enviado_por_aces': 'Enviado pela ACES',
    'enviando': 'A enviar...',
    'enviar': 'Enviar',
    'enviar_evaluacion': 'Enviar avaliação',
    'enviar_propuesta': 'Enviar propuesta',
    'eres_jefe_comision': 'É chefe de comissão',
    'error_generico': 'Ocorreu um erro. Tente novamente.',
    'escribiendo': 'está escribiendo',
    'estado_aceptada': 'Aceite',
    'estado_adjudicada': 'Adjudicada',
    'estado_decision': 'Decisão pendente',
    'estado_documentacion': 'Documentação',
    'estado_evaluacion': 'Em avaliação',
    'estado_pipeline': 'Pipeline de candidatura',
    'estado_rechazada': 'Não adjudicada',
    'estado_solicitada': 'Candidatada',
    'estado_visita': 'Visita agendada',
    'estado_votacion': 'Em votação',
    'eval_abrev': 'aval.',
    'eval_abrir_motor': 'Abrir motor de avaliação',
    'eval_anterior': 'Anterior',
    'eval_asignadas': 'Mis asignadas',
    'eval_asignado_ok': 'Avaliador atribuído',
    'eval_bonus': 'Bonus',
    'eval_cargando': 'Cargando evaluación...',
    'eval_comentario_placeholder': 'Comenta tu puntuación...',
    'eval_comentario_voto': 'Comentario al voto final',
    'eval_comision_pendiente': 'Informação dos avaliadores disponível em breve.',
    'eval_comision_titulo': 'Avaliadores atribuídos',
    'eval_confirmar_desc': 'Una vez enviada no podrás modificarla sin que el Master la desbloquee.',
    'eval_confirmar_envio': 'Enviar evaluación',
    'eval_conflicto_interes': 'Conflicto de interés: eres del mismo país que la ciudad candidata a Capital.',
    'eval_desfavorable': 'Desfavorable',
    'eval_enviada_desc': 'Tu evaluación ha sido registrada correctamente.',
    'eval_enviada_ok': 'Avaliação enviada com sucesso',
    'eval_enviada_titulo': 'Evaluación enviada',
    'eval_enviadas': 'enviadas',
    'eval_enviar': 'Enviar',
    'eval_enviar_btn': 'Enviar',
    'eval_favorable': 'Favorable',
    'eval_habilitada': 'Evaluación habilitada',
    'eval_ir_motor': 'Ir al motor de evaluación',
    'eval_lista': 'Evaluadores',
    'eval_mi_evaluacion': 'Mi evaluación',
    'eval_mis_candidaturas': 'Mis candidaturas',
    'eval_motor_titulo': 'Motor de evaluación',
    'eval_no_habilitada': 'A avaliação ainda não foi habilitada pela ACES.',
    'eval_notas_comentario': 'Notas y comentarios',
    'eval_quitado': 'Avaliador removido',
    'eval_registrados': 'Registrados',
    'eval_seccion': 'Sección',
    'eval_siguiente': 'Siguiente',
    'eval_sin_activas': 'Sin candidaturas activas',
    'eval_sin_asignadas': 'Sin candidaturas asignadas',
    'eval_sin_asignadas_desc': 'El Master asignará candidaturas a tu comisión.',
    'eval_sin_documentos': 'Sem documentos',
    'eval_sin_documentos_desc': 'A cidade ainda não carregou documentos.',
    'eval_sin_reservas': 'Sem reservas ainda',
    'eval_stat_asignadas': 'Asignadas',
    'eval_stat_completadas': 'Completadas',
    'eval_stat_pendientes': 'Pendientes',
    'eval_todas': 'Todas activas',
    'eval_todas_activas': 'Candidaturas activas',
    'eval_todas_aviso': 'Vista de solo lectura. Detalle completo solo para tus candidaturas asignadas.',
    'eval_total_seccion': 'Puntuación de esta sección',
    'eval_ver_escala': 'Ver escala de puntuación',
    'eval_voto_final': 'Voto final',
    'eval_voto_informativo': 'Tu voto es informativo. La decisión final corresponde al Master ACES.',
    'evaluacion_titulo': 'Evaluación',
    'evaluaciones_enviadas': 'evaluaciones enviadas',
    'evaluadores_asignados': 'evaluadores asignados',
    'evaluadores_asignados_label': 'AVALIADORES ATRIBUÍDOS',
    'evento_almuerzo': 'Almoço',
    'evento_cena': 'Jantar',
    'evento_desayuno': 'Pequeno-almoço',
    'evento_descanso': 'Descanso',
    'evento_llegada': 'Chegada',
    'evento_otro': 'Outro',
    'evento_recepcion': 'Receção',
    'evento_reunion': 'Reunião',
    'evento_rueda_prensa': 'Conferência de imprensa',
    'evento_salida': 'Partida',
    'evento_traslado': 'Transferência',
    'evento_visita': 'Visita',
    'factura_creada_ok': 'Fatura registrada. Agora envie o PDF.',
    'factura_detalle': 'Detalhe / Conceito ampliado',
    'factura_detalle_hint': 'Descrição detalhada dos serviços, condições de pagamento, dados bancários...',
    'factura_subida_ok': 'Fatura enviada com sucesso',
    'facturas_aces': 'Da ACES',
    'fecha_llegada_label': 'DATA DE CHEGADA',
    'fecha_regreso': 'Fecha de regreso',
    'fecha_salida': 'Fecha de salida',
    'fecha_vencimiento_label': 'DATA DE VENCIMENTO',
    'filtro_estado': 'Estado',
    'filtro_tipo': 'Tipo',
    'filtro_todas': 'Todas',
    'filtro_todos': 'Todos',
    'gala_asistencia_confirmada': 'Asistencia confirmada',
    'gala_invitacion_titulo': 'Invitación a la Gala',
    'gala_pendiente_desc': 'ACES activará tu invitación cuando llegue el momento.',
    'gala_pendiente_invitacion': 'Invitación pendiente',
    'gala_representantes': 'Representantes',
    'gala_sin_datos': 'Sin datos de gala',
    'gala_sin_datos_desc': 'No hay información de la ceremonia para este año.',
    'gala_sin_representantes': 'Sin representantes añadidos',
    'galardon': 'Galardón',
    'general_error': 'Ha ocurrido un error',
    'general_reintentar': 'Reintentar',
    'generar_codigo': 'Generar código',
    'generar_codigo_titulo': 'Nuevo código de acceso',
    'gestionar_comision': 'Gerir comissão',
    'guardado': 'Guardado',
    'guardando': 'Guardando...',
    'guardar': 'Guardar',
    'guardar_ciudad_salida': 'Guardar cidade de partida',
    'guardar_config': 'Guardar configuración',
    'guardar_y_siguiente': 'Salvar e próximo',
    'historico_titulo': 'Candidaturas anteriores',
    'hora': 'Hora',
    'hora_fin_opc': 'Hora fim (opcional)',
    'hora_inicio': 'Hora início',
    'idioma_titulo': 'Idioma da interface',
    'iniciar_evaluacion': 'Iniciar avaliação',
    'invitacion_enviada': 'Convite enviado',
    'invitar_ciudad_titulo': 'Convidar cidade',
    'invitar_codigo_generado': 'Código gerado',
    'invitar_copiar': 'Copiar',
    'invitar_cuerpo_eval': 'Convidamos-o(a) a aderir ao ACES Cities Network como avaliador(a).\\n\\nO seu código é:',
    'invitar_email': 'Enviar por email',
    'invitar_evaluador_sub': 'Gere um código e partilhe por WhatsApp ou email',
    'invitar_evaluador_titulo': 'Convidar avaliador',
    'invitar_generar_codigo': 'Gerar código de acesso',
    'invitar_nombre': 'Nome do avaliador',
    'invitar_pie': 'Descarregue a app, registe-se e introduza o seu código.\\n\\n— ACES',
    'invitar_saludo': 'Caro(a)',
    'invitar_whatsapp': 'Enviar por WhatsApp',
    'jefe_comision_ninguno': 'Sem chefe atribuído',
    'jefe_comision_sin_eval': 'Atribua avaliadores primeiro para designar um chefe.',
    'jefe_comision_titulo': 'Chefe de comissão',
    'jefe_designado_ok': 'Chefe de comissão designado',
    'jefe_eliminado_ok': 'Chefe de comissão removido',
    'llegada': 'Llegada',
    'llegada_label': 'Chegada',
    'login_crear_cuenta': 'Primeira vez? Criar conta →',
    'login_olvide_contrasena': 'Esqueceu a palavra-passe?',
    'login_proximamente': 'Em breve',
    'login_recuperar_desc': 'Introduza o seu email e enviaremos um link para redefinir a palavra-passe.',
    'login_recuperar_titulo': 'Recuperar acesso',
    'login_requiere_codigo': 'O acesso ao Cities Network requer um código de convite ACES.',
    'login_restablecer': 'Redefinir palavra-passe',
    'login_titulo': 'ACES Cities Network',
    'lugar': 'Lugar',
    'marcar_leidas': 'Marcar todas leídas',
    'master_label': 'MASTER ACES',
    'master_panel_desc': 'Control total de candidaturas, evaluaciones y decisiones.',
    'master_recientes': 'Candidaturas recientes',
    'master_saludo': 'Panel ACES',
    'master_sin_candidaturas': 'Sin candidaturas aún',
    'mi_evaluacion': 'Minha avaliação',
    'mis_pagos': 'Meus pagamentos',
    'mod_chat': 'Chat ACES',
    'mod_documentos': 'Documentos',
    'mod_facturas_pagos': 'Faturas e pagamentos',
    'mod_gala': 'Gala',
    'mod_pagos': 'Pagos',
    'mod_titularidad': 'Titularidad',
    'mod_viaje': 'Logística',
    'modo_evaluador': 'Avaliador',
    'modo_master': 'Master',
    'motor_evaluacion': 'Motor de avaliação',
    'no_configurado': 'Não configurado — edite seu perfil',
    'nombre': 'Nome',
    'nombre_documento': 'Nombre del documento',
    'nombre_hotel': 'Nombre del hotel',
    'notas_hint': 'Ex: Aterrar no T4, hotel recomendado...',
    'notas_internas_label': 'NOTAS INTERNAS (opcional)',
    'notif_candidatura_actualizada': 'Candidatura atualizada',
    'notif_candidatura_desasignada': 'Candidatura removida',
    'notif_documento_revisado': 'Documento revisto',
    'notif_estado_actualizado': 'Estado atualizado',
    'notif_evaluacion_completada': 'Avaliação concluída',
    'notif_limpiar_desc': 'Todas as notificações serão eliminadas. Esta ação não pode ser desfeita.',
    'notif_limpiar_todas': 'Limpar tudo',
    'notif_marcar_leida': 'Marcar como lida',
    'notif_nueva_asignacion': 'Nova candidatura atribuída',
    'notif_pago_vencido': 'Pagamento próximo do vencimento',
    'notif_sin_leer': 'Sin leer',
    'notif_sin_notifs': 'Sin notificaciones',
    'notif_visita_programada': 'Visita de avaliação agendada',
    'notificar_ciudad': 'Notificar cidade',
    'nueva_candidatura': 'Nueva candidatura',
    'nueva_propuesta': 'Nueva propuesta',
    'num_habitaciones': 'Número de habitaciones',
    'origen': 'Origen',
    'pago_enviar_recordatorio': 'Abrir email',
    'pago_factura': 'Fatura',
    'pago_instrucciones': 'Realiza la transferencia bancaria y sube el comprobante.',
    'pago_recibido': 'Recebido',
    'pago_recordatorio': 'Lembrete',
    'pago_recordatorio_desc': 'O seu cliente de email abrirá com a mensagem.',
    'pago_recordatorio_titulo': 'Enviar lembrete de pagamento',
    'pagos_ciudad': 'Os meus pagamentos',
    'pagos_pendientes': 'Pagamentos pendentes',
    'pais': 'País',
    'pais_buscar': 'Pesquisar país...',
    'pais_seleccionado': 'País selecionado',
    'pais_seleccionar': 'Selecionar país',
    'paso_datos': 'Dados da fatura',
    'paso_subir_pdf': 'Enviar PDF da fatura',
    'password_actual': 'Senha atual',
    'password_cambiada': 'Senha alterada com sucesso',
    'password_cambiar': 'Alterar senha',
    'password_corta': 'A senha deve ter pelo menos 6 caracteres.',
    'password_nueva': 'Nova senha',
    'password_repetir': 'Repetir senha',
    'passwords_no_coinciden': 'As senhas não correspondem.',
    'error_red': 'Erro de rede. Verifique sua conexão com a Internet.',
    'error_demasiados_intentos': 'Muitas tentativas. Aguarde um momento e tente novamente.',
    // Hitos candidatura + doc types
    'hito_carta_solicitud': 'Carta de candidatura recebida',
    'hito_aprobada': 'Candidatura aprovada',
    'hito_reglamento_enviado': 'Regulamento enviado para assinatura',
    'hito_reglamento_firmado': 'Regulamento assinado recebido',
    'hito_datos_factura': 'Dados de faturamento recebidos',
    'hito_pago_confirmado': 'Pagamento confirmado',
    'hito_fechas_visita': 'Datas de visita propostas',
    'hito_comision_creada': 'Comissão de avaliação criada',
    'hito_viajes_cerrados': 'Viagens finalizadas',
    'hito_agenda_enviada': 'Agenda enviada',
    'hito_bid_file': 'BID File recebido',
    'doc_tipo_carta_solicitud': 'Carta de candidatura',
    'doc_tipo_agenda_visita': 'Agenda da visita',
    // Logistica simplificada
    'mod_logistica': 'Log\u00edstica',
    'agenda_vacia_ciudad': 'Nenhuma agenda enviada. Envie o PDF da agenda.',
    'agenda_aviso_master': 'A agenda \u00e9 vis\u00edvel para avaliadores e a cidade. Envie o PDF definitivo.',
    // Evaluador logistica
    'eval_agenda_vacia_desc': 'ACES publicar\u00e1 a agenda da visita quando dispon\u00edvel.',
    'eval_reservas_desc': 'Suas reservas de voo e hotel confirmadas aparecer\u00e3o aqui.',
    'eval_sin_reservas_desc': 'ACES ou a cidade enviar\u00e3o suas reservas quando confirmadas.',
    'perfil_actualizado': 'Perfil atualizado',
    'perfil_apellidos': 'Apellidos',
    'perfil_cambiar_foto': 'Foto de perfil',
    'perfil_cargo': 'Cargo',
    'perfil_ciudad': 'Cidade',
    'perfil_compartir_ciudad': 'Partilhar telefone com cidades',
    'perfil_compartir_ciudad_desc': 'As cidades candidatas poderão ver o seu número de contacto.',
    'perfil_compartir_eval_desc': 'Os avaliadores da sua comissão poderão ver o seu contacto.',
    'perfil_compartir_evaluadores': 'Partilhar com outros avaliadores',
    'perfil_contacto': 'Contacto',
    'perfil_cuenta': 'Conta',
    'perfil_datos': 'Dados pessoais',
    'perfil_datos_evaluador': 'Dados da comissão',
    'perfil_datos_personales': 'Dados pessoais',
    'perfil_elegir_foto': 'Escolher foto',
    'perfil_eval_config': 'Configurações do avaliador',
    'perfil_evaluador': 'Configurações de avaliador',
    'perfil_fecha_nac': 'Data de nascimento',
    'perfil_foto_actualizada': 'Foto atualizada',
    'perfil_guardado': 'Perfil salvo com sucesso',
    'perfil_guardar': 'Salvar perfil',
    'perfil_idioma': 'Idioma de la app',
    'perfil_nombre': 'Nombre',
    'perfil_notificaciones': 'Notificaciones',
    'perfil_pais': 'País',
    'perfil_provincia': 'Província',
    'perfil_talla': 'Tamanho polo',
    'perfil_telefono': 'Teléfono',
    'perfil_titulo': 'Meu perfil',
    'perfil_ubicacion': 'Localização',
    'pipeline_aceptada_desc': 'Candidatura aceite. Prepare a documentação necessária.',
    'pipeline_adjudicada_desc': 'Parabéns! A sua cidade recebeu o título ACES.',
    'pipeline_decision_desc': 'A decisão final está a ser preparada pela ACES.',
    'pipeline_documentacion_desc': 'Estamos a rever a sua documentação.',
    'pipeline_evaluacion_desc': 'A comissão de avaliação está a analisar a sua candidatura.',
    'pipeline_rechazada_desc': 'A sua candidatura não foi selecionada neste concurso.',
    'pipeline_solicitada_desc': 'A sua candidatura foi recebida e está a ser analisada.',
    'pipeline_visita_desc': 'A visita de avaliação à sua cidade está a ser organizada.',
    'pipeline_votacion_desc': 'A comissão está a deliberar sobre a sua candidatura.',
    'precio_aprox': 'Precio aproximado (€)',
    'precio_estimado': 'Preço estimado (€)',
    'preview_email_label': 'PREVISUALIZAÇÃO DO EMAIL',
    'programar_visita_titulo': 'Agendar visita',
    'proponer_agenda': 'Agenda',
    'proponer_hotel': 'Hotel',
    'proponer_vuelo': 'Vuelo',
    'provincia': 'Província / Estado',
    'provincia_seleccionar': 'Selecionar província / região',
    'rechazar': 'Rechazar',
    'recomendaciones_titulo': 'Recomendações',
    'recordatorio_asunto': 'Lembrete de pagamento — {ciudad}',
    'recordatorio_cuerpo': 'Caro(a) equipa de {ciudad},\\n\\nLembramos que o pagamento de: {concepto} está pendente.\\n\\nAgradecemos que efetue a transferência o mais brevemente possível.\\n\\nAtenciosamente,\\nACES',
    'reg_ciudad': 'Cidade / Município *',
    'reg_creando': 'A criar conta...',
    'reg_crear_cuenta': 'Criar conta',
    'reg_pais': 'País *',
    'reg_provincia': 'Província / Região',
    'reg_resumen_titulo': 'Resumo da conta',
    'reg_telefono': 'Telefone de contacto *',
    'reg_tipo': 'Tipo de acesso',
    'reg_ubicacion_sub': 'Informações da sua organização',
    'reg_ubicacion_titulo': 'A sua localização',
    'registro_cancelar_salir': 'Cancelar e sair',
    'registro_codigo_label': 'CÓDIGO DE ACESSO ACES',
    'registro_contrasena_label': 'PALAVRA-PASSE',
    'registro_crear_cuenta': 'Crie a sua conta',
    'registro_datos_personales': 'Dados pessoais',
    'registro_elige_rol': 'Com que função acede ao Cities Network?',
    'registro_email_label': 'EMAIL',
    'registro_paso_1': 'Passo 1 de 3',
    'registro_paso_2': 'Passo 2 de 3',
    'registro_paso_2_desc': 'Estas informações são usadas para a logística das visitas de avaliação.',
    'registro_paso_3': 'Passo 3 de 3',
    'registro_siguiente': 'Seguinte →',
    'registro_verifica_desc': 'Enviámos-lhe um email de verificação. Abra-o e clique no link antes de continuar.',
    'registro_verifica_titulo': 'Verifique o seu email',
    'rol_ciudad': 'Cidade',
    'rol_evaluador': 'Avaliador',
    'rol_master': 'Master ACES',
    'salida': 'Salida',
    'salida_label': 'Partida',
    'saludo_buenas_noches': 'Boa noite,',
    'saludo_buenas_tardes': 'Boa tarde,',
    'saludo_buenos_dias': 'Bom dia,',
    'sancion_capital': 'Capital of Sport',
    'sancion_city': 'City of Sport',
    'sancion_town': 'Town of Sport',
    'seccion': 'Seção',
    'seleccionar': 'Seleccionar',
    'seleccionar_pais': 'Selecionar país',
    'seleccionar_provincia': 'Selecionar província',
    'sin_agenda': 'Sem agenda',
    'sin_agenda_desc': 'A cidade ainda não propôs um calendário de visita.',
    'sin_candidaturas': 'Sin candidaturas',
    'sin_candidaturas_desc': 'No hay candidaturas con este filtro.',
    'sin_ciudad_asignada': 'Sem cidade atribuída',
    'sin_codigos_disponibles': 'Nenhum código disponível',
    'sin_documentos': 'Sin documentos',
    'sin_documentos_desc': 'Sube los documentos requeridos para tu candidatura.',
    'sin_evaluaciones': 'Sin evaluaciones',
    'sin_evaluadores_desc': 'Registe avaliadores com um código ACESCN-EVAL-xxx.',
    'sin_evaluadores_disponibles': 'Sem avaliadores registados',
    'sin_facturas_aces': 'Sem faturas recebidas',
    'sin_facturas_aces_desc': 'As faturas enviadas pela ACES aparecerão aqui.',
    'sin_notificaciones': 'Sem notificações',
    'sin_notificaciones_desc': 'A atividade das suas candidaturas aparecerá aqui.',
    'sin_pagos': 'Sin pagos',
    'sin_pagos_desc': 'Los pagos de tu candidatura aparecerán aquí.',
    'stat_activas': 'Activas',
    'stat_decision': 'Decisión pendiente',
    'stat_dias_visita': 'Dias até visita',
    'stat_docs_pendientes': 'Docs pendentes',
    'stat_evaluacion': 'En evaluación',
    'stat_mensajes_nuevos': 'Novas mensagens',
    'stat_notif': 'Sin leer',
    'stat_pagos_pendientes': 'Pagamentos pendentes',
    'stat_sin_visita': 'Sem visita marcada',
    'stat_titulos': 'Títulos activos',
    'stat_total': 'Total',
    'subir_comprobante': 'Enviar comprovante',
    'subir_documento': 'Subir documento',
    'subir_factura': 'Carregar fatura',
    'subir_factura_desc': 'Carregue o PDF da fatura. A cidade poderá descarregá-lo do seu painel.',
    'subir_factura_titulo': 'Carregar fatura PDF',
    'subir_nota': 'Selecciona el archivo desde tu dispositivo',
    'tab_agenda': 'Agenda',
    'tab_candidatura': 'Candidatura',
    'tab_candidaturas': 'Candidaturas',
    'tab_chat': 'Chat',
    'tab_config': 'Configuración',
    'tab_documentos': 'Documentos',
    'tab_evaluaciones': 'Evaluaciones',
    'tab_evaluadores': 'Evaluadores',
    'tab_gala': 'Gala',
    'tab_global': 'Global',
    'tab_inicio': 'Início',
    'tab_notif': 'Notificaciones',
    'tab_pagos': 'Pagos',
    'tab_perfil': 'Perfil',
    'tab_recursos': 'Recursos',
    'tab_resumen': 'Resumen',
    'tab_viaje': 'Logística',
    'talla_polo': 'Tamanho do polo',
    'telefono': 'Telefone',
    'template_no_disponible': 'O modelo de avaliação ainda não está disponível.',
    'tipo_codigo': 'Tipo de código',
    'tit_ano_titulo': 'Año de titularidad',
    'tit_evidencias': 'Evidencias subidas',
    'tit_item_calendario': 'Calendario deportivo',
    'tit_item_congreso': 'Congreso o conferencia',
    'tit_item_imagen': 'Uso correcto del título',
    'tit_item_memoria': 'Memoria final',
    'tit_no_aplica': 'Sin año de titularidad',
    'tit_no_aplica_desc': 'Este módulo se activa cuando tu ciudad gana un galardón ACES.',
    'tit_sanciones': 'Sanciones',
    'tit_sin_datos': 'Sin titularidades activas',
    'tit_titulo': 'Año de titularidad',
    'toca_abrir_documento': 'Toque para abrir o documento',
    'toca_copiar': 'Toca el código para copiar',
    'toca_para_abrir': 'Toque para abrir',
    'toca_para_copiar': 'Toque para copiar',
    'tomar_decision': 'Decisión final',
    'tu_ciudad_salida': 'A sua cidade de partida',
    'upload_error': 'Erro ao carregar',
    'upload_exito': 'Carregado com sucesso!',
    'upload_formatos': 'PDF, JPG ou PNG · máx. 20 MB',
    'upload_no_cierres': 'Não feche a app',
    'upload_reintentar': 'Tentar novamente',
    'upload_subiendo': 'A carregar ficheiro...',
    'vence': 'Vence',
    'ver_comprobante': 'Ver comprobante',
    'ver_detalle': 'Ver detalhe',
    'ver_documento_adjunto': 'Ver documento anexo',
    'ver_factura': 'Ver fatura',
    'verifica_desc': 'Enviamos um e-mail de verificação. Verifique sua caixa de entrada.',
    'verifica_reenviar': 'Reenviar e-mail de verificação',
    'viaje_aviso_privacidad': 'La identidad de los evaluadores es confidencial. Solo verás fechas y logística.',
    'viaje_ciudad_salida': 'Sua cidade de partida para voos',
    'viaje_proponer_vuelo': 'Propor voo',
    'viaje_propuesta_enviada': 'Proposta enviada com sucesso',
    'viaje_sin_propuestas': 'Sin propuestas de viaje',
    'viaje_sin_propuestas_desc': 'Propón opciones de vuelo, hotel y agenda para la visita.',
    'visita_evaluadores': 'Visita de evaluadores',
    'visita_programada': 'Visita programada',
    'visita_sin_programar': 'Visita aún no programada',
    'visita_titulo': 'Visita de evaluación',
    'volver': 'Voltar',
    'votacion_abierta': 'Votação aberta',
    'votacion_cerrada': 'Votação fechada',
    'walkthrough_ver_guia': 'Ver guia de início',
    'whatsapp': 'WhatsApp (com prefixo)',
    'ya_tengo_cuenta': 'Já tem uma conta?',
    'tab_titularidades': 'Titularidades',
    'acciones_rapidas': 'Ações rápidas',
    'evaluadores_titulo': 'Avaliadores',
    'evaluadores_registrados': 'Avaliadores registados',
    'codigos_disponibles_label': 'Códigos disponíveis',
    'evaluadores_seccion': 'Avaliadores',
    'codigos_acceso_titulo': 'Códigos de acesso',
    'config_pais': 'País',
    'config_telefono': 'Telefone',
    'config_correos_inst': 'E-mails institucionais',
    'config_capital': 'Capital',
    'config_city': 'Cidade',
    'config_town': 'Município',
    'evaluacion_habilitada': 'Avaliação ativada',
    'evaluaciones_titulo_card': 'Avaliações',
    'decision_final_titulo': 'Decisão final',
    'gestionar_comision_titulo': 'Gerir comissão',
    'programar_visita_modal': 'Agendar visita de avaliação',
    'fecha_llegada': 'Data de chegada',
    'req_documentacion': 'Requisitos de documentação',
    'todo_leido': 'Tudo lido',
    'confirmar_borrar_notifs': 'Eliminar todas as notificações?',
    'gala_creada_ok': 'Gala criada com sucesso',
    'gala_error_crear': 'Erro ao criar gala',
    'gala_activada': 'Gala ativada para cidades',
    'gala_desactivada': 'Gala desativada',
    'titularidades_titulo': 'Titularidades',
    'titularidades_desc': 'Cidades com título ACES ativo e acompanhamento de obrigações',
    'obligaciones_titulo': 'Obrigações do titular',
    'obligacion_imagen': 'Respeitar as regras de imagem ACES',
    'obligacion_calendario': 'Elaborar calendário desportivo anual',
    'obligacion_congreso': 'Organizar congresso ou competição internacional',
    'obligacion_memoria': 'Apresentar relatório e conclusões anuais',
    'obligacion_awos': 'Participar ativamente no AWoS/EWoS',
    'cumplidas': 'cumpridas',
    'viaje_confirmar': 'Confirmar proposta',
    'viaje_rechazar': 'Rejeitar proposta',
    'viaje_confirmado': 'Proposta confirmada',
    'viaje_rechazado': 'Proposta rejeitada',
    'nota_respuesta': 'Nota de resposta (opcional)',
    'voto_favor_confirm': 'Confirmar voto favorável?',
    'voto_contra_confirm': 'Confirmar voto contra?',
    'historial_sin_cambios': 'Nenhuma alteração de estado registada',
    'candidatura_buscar': 'Pesquisar cidade, prémio...',
    'candidatura_ciudad_ph': 'Ex: Buenos Aires',
    'candidatura_pais_ph': 'Ex: Argentina',
    'candidatura_email_ph': 'cidade@email.com',
    'dias_visita': 'dias de visita',
    'propuestas_viaje': 'Propostas de viagem',
    'sin_propuestas_viaje': 'Sem propostas de viagem',
    'sin_propuestas_desc': 'Os avaliadores ainda não propuseram itinerário.',
    'sin_evaluaciones_desc': 'Atribua avaliadores e ative a avaliação.',
    'seleccionar_pdf': 'Selecionar PDF',
    'rechazar_candidatura': 'Rejeitar candidatura',
    'motivo_rechazo': 'Motivo da rejeição (obrigatório)',
    'tit_sin_datos_desc': 'As cidades atribuídas aparecerão aqui automaticamente.',
    'marcado_cumplido': 'Marcado como cumprido',
    'desmarcado': 'Desmarcado',
    'finalizada': 'Finalizada',
    'finalizadas': 'Finalizadas',
    'notas_label': 'Notas',
    'sin_leer': 'não lidos',
    'confirmar_cerrar_sesion': 'Terminar sessão?',
    'email_aces_europa': 'E-mail ACES Europa',
    'email_aces_america': 'E-mail ACES Américas',
    'gala_fecha_evento': 'Data do evento',
    'gala_primera_desc': 'Crie a primeira gala para começar a gerir as cerimónias.',
    'evaluadores_gestion': 'Gestão da comissão de avaliação ACES',
    'adjudicar': 'Adjudicar',
    'adjudicada_ok': 'Candidatura adjudicada!',
    'candidatura_rechazada': 'Candidatura rejeitada',
    'error_decision': 'Erro ao registar decisão',
    'evaluador_asignado': 'Avaliador atribuído',
    'evaluador_quitado': 'Avaliador removido',
    'jefe_designado': 'Chefe de comissão designado',
    'jefe_eliminado': 'Chefe de comissão removido',
    'notas_guardadas': 'Notas guardadas',
    'notas_visita_hint': 'Ex.: Hotel recomendado, instruções aeroporto...',
    'visita_ok': 'Visita agendada com sucesso',
    'error_visita': 'Erro ao agendar visita',
    'evaluacion_hab_ok': 'Avaliação ativada',
    'evaluacion_deshab_ok': 'Avaliação desativada',
    'programar': 'Agendar',
    'confirmar_decision': 'Confirmar decisão',
    'cambiar_modo': 'Mudar modo',
    'de_preposicion': 'de',
    'notas_decision_label': 'Notas da decisão (opcional)',
    'generar': 'Gerar',
    'tab_chat_label': 'Chat',
    'bid_file_recibido': 'BID File recebido',
    'documentos_firmados': 'Documentos assinados',
    'pago_confirmado': 'Pagamento confirmado',
    'subiendo_label': 'A carregar...',
    'pagado_label': 'Pago',
    'factura_label': 'Fatura',
    'marcar_factura': 'Marcar fatura como emitida',
    'desmarcar_factura': 'Desmarcar fatura',
    'marcar_pago': 'Marcar pagamento recebido',
    'desmarcar_pago': 'Desmarcar pagamento',
    'evaluacion_enviada': 'Enviada',
    'disponible_label': 'Disponível',
    'ver_codigos_btn': 'Ver códigos',
    'invitar_eval_btn': 'Convidar avaliador',
    'generar_codigo_btn': 'Gerar novo código',
    'idioma_destinatario': 'Idioma do destinatário',
    'candidaturas_count': 'candidaturas',
    'sin_alertas_ok': 'Tudo em ordem. Sem alertas pendentes.',
    'sin_galas_configuradas': 'Nenhuma gala configurada',
    'gala_activada_ciudades': 'Gala ativada para cidades',
    'ver_alertas_label': 'Ver alertas',
    'modo_evaluador_activo': 'Modo avaliador ativo',
    'modo_master_activo': 'Vista Master ACES',
    'cambiar_a_eval': 'Modo avaliador',
    'cambiar_a_master': 'Voltar a Master',
    'doc_tipo_bid': 'BID File',
    'doc_tipo_reglamento': 'Regulamento',
    'doc_tipo_comprobante': 'Comprovativo de pagamento',
    'doc_tipo_contrato': 'Contrato',
    'doc_tipo_memoria': 'Relatório',
    'doc_tipo_pres': 'Apresentação',
    'doc_tipo_otro': 'Outro',
    'selecciona_tipo_doc': 'Que tipo de documento?',
    'todos_label': 'Todos',
    'hotel_sin_nombre': 'Hotel',
    'agenda_evento': 'Evento',
    'mis_propuestas': 'As minhas propostas',
    'propuestas_label': 'propostas',
    'ciudad_hotel': 'Cidade',
    'check_in': 'Check-in',
    'check_out': 'Check-out',
    'precio_noche': '€/noite',
    'hotel_notas_hint': 'Ex.: Quarto duplo, pequeno-almoço incluído...',
    'vuelo_notas_hint': 'Ex.: Voo direto, escala em Madrid...',
    'fecha_label': 'Data',
    'hora_label': 'Hora',
    'lugar_label': 'Local',
    'tipo_reunion': 'Reunião',
    'tipo_visita_instalacion': 'Visita à instalação',
    'tipo_acto': 'Ato oficial',
    'tipo_almuerzo': 'Almoço / Jantar',
    'tipo_transporte': 'Transporte',
    'tipo_otro': 'Outro',
    'galardones_titulo': 'Prémios',
    'reglamentos_titulo': 'Regulamentos',
    'sin_candidatura_titulo': 'Nenhuma candidatura atribuída',
    'sin_candidatura_desc': 'A sua conta ainda não tem uma candidatura associada.',
    'bienvenida_ciudad_saludo': 'Olá, {nombre}',
    'bienvenida_ciudad_titulo': 'A tua conta está ativa',
    'bienvenida_ciudad_desc': 'Estamos a preparar a tua candidatura. Assim que a equipa ACES te atribuir uma, aparecerá aqui com todo o acompanhamento.',
    'bienvenida_ciudad_chip_activa': 'Conta ativa',
    'bienvenida_ciudad_chip_espera': 'A aguardar atribuição',
    'bienvenida_ciudad_contacto': 'Tens dúvidas? Contacta a ACES',
    'chat_ciudad_desc': 'Comunicação direta com a equipa ACES.',
    'mensajes_label': 'Mensagens',
    'motor_seccion_de': 'de',
    'gala_confirmar_desc': 'Indique se a sua cidade comparecerá à cerimónia de gala.',
    'eval_completadas': 'Completadas',
    'secciones_completadas': 'secções concluídas',
    'evaluaciones_enviadas_abrev': 'avaliações enviadas',
    'awos_activa_desc': 'Registe a sua atividade física e aceda aos eventos ACES',
    'descargar_app': 'App Store',
    'eval_viaje_aviso': 'Os seus dados de viagem são visíveis apenas para a ACES.',
    'eval_docs_solo_lectura': 'Pode ver os documentos submetidos pela cidade.',
    'conflicto_titulo': 'Declaração de conflito de interesses',
    'conflicto_desc': 'Antes de avaliar, confirme que não tem conflito de interesses.',
    'conflicto_sin_conflicto': 'Sem conflito — continuar',
    'conflicto_con_conflicto': 'Tenho um conflito',
    'conflicto_aviso': 'Notifique a ACES imediatamente.',
    'sin_fecha': 'Sem data',
    'pipeline_titulo': 'Pipeline de candidaturas',
    'revenue_titulo': 'Receitas',
    'revenue_total': 'Total faturado',
    'cobrado': 'Cobrado',
    'visitas_proximas': 'Visitas proximas',
    'paises_titulo': 'Por pais',
    'awos_banner_desc': 'Registre sua atividade fisica e acesse os eventos ACES',
    'fecha_limite_confirmar': 'Prazo para confirmar',
    'info_parlamento': 'Info Parlamento Europeu',
    'info_venue': 'Local',
    'norma_hotel': 'Regras hotel',
    'norma_vuelo': 'Regras voo',
    'programa_dia': 'Programa do dia',
    'sin_programa': 'Sem programa',
    'actividad_placeholder': 'Atividade...',
    'anadir': 'Adicionar',
    'representantes_label': 'Representantes',
    'confirmados_label': 'Confirmados',
    'fecha_limite': 'Prazo',
    'deadline_pasada': 'Prazo expirado',
    'restantes': 'restantes',
    'anadir_representante': 'Adicionar representante',
    'sin_representantes': 'Sem representantes',
    'representante_anadido': 'Representante adicionado',
    'representante_eliminado': 'Representante removido',
    'programa_actualizado': 'Programa atualizado',
    'confirmado': 'CONFIRMADO',
    'nombre_label': 'Nome completo',
    'cargo_label': 'Cargo',
    'telefono_label': 'Telefone',
    'logistica_evaluadores': 'Logistica avaliadores',
    'vuelo_short': 'Voo',
    'hotel_short': 'Hotel',
    'docs_obligatorios_galardon': 'Documentos obrigatorios',
    'evidencia_subida': 'Evidencia enviada',
    'sancion_anadida': 'Sancao registrada',
    'memoria_subida': 'Relatorio final enviado',
    'nueva_sancion': 'Nova sancao',
    'motivo_sancion': 'Motivo',
    'motivo_sancion_hint': 'Ex: Nao comparecimento ao gala',
    'importe_label': 'Valor',
    'divisa_label': 'Moeda',
    'registrar_sancion': 'Registrar sancao',
    'subir_evidencia': 'Enviar',
    'memoria_final_titulo': 'Relatorio final',
    'memoria_deadline': 'Antes de 31 de janeiro',
    'subir_memoria': 'Enviar relatorio final (PDF)',
    'sin_sanciones': 'Sem sancoes',
    'evidencias_short': 'evidencias',
    'memoria_ok': 'Relatorio OK',
    'sanciones_short': 'sancoes',
    'dias_en_fase': 'Dias na fase',
    'proximo_pago': 'Proximo pagamento',
    'vencido': 'Vencido',
    'visita_label': 'Visita',
    // === Paquete 2 — 85 keys faltantes (pt-BR) ===
    'abrir_nueva_pestana': 'Abrir em nova aba',
    'android_label': 'Android',
    'android_store': 'Google Play',
    'articulos_label': 'Artigos',
    'auth_accediendo': 'Entrando...',
    'auth_email_enviado': 'Email enviado. Verifique sua caixa de entrada.',
    'auth_enviar_enlace': 'Enviar link',
    'auth_error_intentos': 'Muitas tentativas. Aguarde um momento.',
    'auth_error_password': 'Senha incorreta',
    'auth_error_reset': 'Erro ao enviar email de recuperacao',
    'auth_error_usuario': 'Usuario nao encontrado',
    'auth_introduce_email': 'Digite seu email',
    'auth_olvido_password': 'Esqueci minha senha',
    'auth_recuperar': 'Redefinir senha',
    'auth_recuperar_desc': 'Enviaremos um link para redefinir sua senha.',
    'aw_h': 'Semana Americana do Esporte',
    'aw_lbl': 'AWoS',
    'aw_p': 'Celebre o esporte e a atividade fisica com sua cidade durante a Semana Americana do Esporte.',
    'bonus_desc': 'Pontos adicionais por iniciativas destacadas',
    'buscar_articulo': 'Buscar artigo...',
    'buscar_recursos': 'Buscar em recursos...',
    'comite_evaluacion': 'Comite de avaliacao',
    'confirmar_eliminar_pago': 'Tem certeza que deseja excluir este pagamento?',
    'cookie_accept': 'Aceitar',
    'cookie_more': 'Mais informacoes',
    'cookie_msg': 'Usamos cookies essenciais para o funcionamento do site.',
    'cookie_reject': 'Rejeitar',
    'criterios_elegibilidad': 'Criterios de elegibilidade',
    'cta_b1': 'Apresentar candidatura',
    'cta_b2': 'Contactar ACES',
    'cta_h': 'Comece sua candidatura hoje',
    'cta_p': 'Junte-se a rede de cidades europeias do esporte e transforme sua comunidade.',
    'descargar_factura': 'Baixar fatura',
    'docs_drag_drop': 'Arraste arquivos aqui ou clique para selecionar',
    'docs_obligatorios': 'Documentos obrigatorios',
    'eval_actual': 'Avaliacao atual',
    'eval_comentario_voto_placeholder': 'Comentario sobre seu voto (opcional)...',
    'eval_max_puntos': 'Pontuacao maxima',
    'feats': 'Funcionalidades',
    'footer_contact': 'Contato',
    'footer_legal': 'Aviso legal',
    'footer_privacy': 'Politica de privacidade',
    'ft_h': 'Tudo o que voce precisa',
    'ft_lbl': 'Funcionalidades',
    'general_volver': 'Voltar',
    'hero_cta1': 'Apresentar candidatura',
    'hero_cta2': 'Conhecer o processo',
    'hero_h1a': 'Sua cidade merece',
    'hero_h1b': 'ser reconhecida',
    'hero_sub': 'ACES Cities Network conecta cidades, avaliadores e organismos esportivos em uma plataforma.',
    'ios_label': 'iOS',
    'ios_store': 'App Store',
    'limpiar': 'Limpar',
    'login_subtitulo': 'Acesse sua conta ACES Cities Network',
    'marcar_todas_leidas': 'Marcar todas como lidas',
    'nav_acceder': 'Acessar',
    'nav_funciones': 'Funcoes',
    'nav_galardones': 'Premios',
    'nav_proceso': 'Processo',
    'nav_registro': 'Registro',
    'nav_roles': 'Funcoes',
    'notif_todas_leidas': 'Todas as notificacoes marcadas como lidas',
    'pago_eliminado': 'Pagamento excluido',
    'pendiente': 'Pendente',
    'pendiente_label': 'Pendente',
    'pipe_h': 'Processo transparente',
    'pipe_lbl': 'Pipeline',
    'pipe_p': 'Acompanhe cada fase da sua candidatura em tempo real.',
    'preambulo': 'Preambulo',
    'recursos_aces_desc': 'Premios, regulamentos e documentacao oficial ACES.',
    'recursos_aces_titulo': 'Recursos ACES',
    'reglamentos_seed': 'Regulamentos carregados com sucesso',
    'regulacion_sin_articulos': 'Este regulamento nao possui artigos.',
    'roles_h': 'Para cada funcao',
    'roles_lbl': 'Funcoes',
    'roles_p': 'Cidades, avaliadores e administradores em uma plataforma.',
    'sancion_incumplimiento': 'Sancao por descumprimento',
    'sin_articulos': 'Sem artigos',
    'sin_galardones': 'Nenhum premio disponivel',
    'sin_reglamentos': 'Nenhum regulamento disponivel',
    'sin_recursos': 'Nenhum recurso disponivel',
    'sin_resultados': 'Sem resultados',
    'stages': 'Fases',
    'tasa_inscripcion': 'Taxa de inscricao',
    'todas': 'Todas',
    'ver_candidatura': 'Ver candidatura',
    'reserva_sin_evaluador': 'Geral (sem avaliador atribuido)',
    'agenda_subida_ok': 'Agenda enviada com sucesso',
    'agenda_vacia_desc': 'Envie o PDF da agenda da visita.',
    'agenda_visita_titulo': 'Agenda da visita',
    'reserva_subida_ok': 'Reserva enviada com sucesso',
    'reservas_titulo': 'Reservas',
    'reservas_desc_master': 'Envie as reservas de voo e hotel confirmadas como PDF. Pode selecionar o avaliador correspondente.',
    'reservas_desc_ciudad': 'Envie as reservas de voo e hotel confirmadas como PDF.',
    'sin_reservas': 'Sem reservas',
    'sin_reservas_desc': 'Envie os PDFs das reservas.',
    'doc_eliminado': 'Documento eliminado',
    'preview_pdf_hint': 'Os PDFs abrem num novo separador do navegador.',
    'descargar': 'Descarregar',
    'con_pago_confirmado': 'com pagamento confirmado (marco)',
    'pendientes_pago': 'pendentes',
    'sin_datos_pagos': 'Sem dados de pagamentos registados',
    'subir_agenda': 'Enviar agenda (PDF)',
    'subir_reserva': 'Enviar reserva',
    'eval_no_asignado': 'Não está atribuído à comissão de avaliação desta candidatura.',
    'ciudad_hitos_titulo': 'Status da sua candidatura',
    'hito_factura_recibida': 'Fatura recebida',
    'eval_mis_evaluaciones': 'Minhas avaliações',
    'eval_sin_bid': 'A cidade ainda não enviou o BID File.',
    'voto_final_desc_motor': 'Emita seu voto final com base na avaliação.',
    'chat_comision': 'Chat comissão',
    'tit_comunicacion_ok': 'Comunicação oficial OK',
    'tit_derechos_factura_env': 'Direitos de imagem: fatura enviada',
    'tit_derechos_pagado': 'Direitos de imagem: paga',
    'tit_q1': 'Relatório trimestral Q1',
    'tit_q2': 'Relatório trimestral Q2',
    'tit_q3': 'Relatório trimestral Q3',
    'tit_q4': 'Relatório trimestral Q4',
    'tit_premio_n1': 'Prêmio N1: Participa?',
    'tit_green_city': 'Green City of the Year',
    'sancion_nueva': 'Nova sanção',
    'motivo': 'Motivo',
    'si': 'Sim',
    'no': 'Não',
    'nueva': 'Nova',
    'sanciones': 'Sanções',
    'pagada': 'Paga',

    'borrar_candidatura': 'Excluir candidatura',
    'borrar_candidatura_desc': 'Exclui permanentemente a candidatura e todos os dados associados.',
    'confirmar_borrar_candidatura': 'Excluir esta candidatura? Esta acao NAO pode ser desfeita.',
    'confirmar_borrar_candidatura_2': 'TEM CERTEZA? TODOS os documentos, pagamentos, avaliacoes e chats serao excluidos.',
    'candidatura_eliminada': 'Candidatura excluida',
    'zona_peligrosa': 'Zona perigosa',
    'contacto_ciudad': 'Contato da cidade',
    'sin_ciudad_vinculada': 'Nenhum usuario cidade vinculado',
    'cambiar_ciudad': 'Alterar',
    'vincular_ciudad': 'Vincular',
    'vincular_ciudad_titulo': 'Vincular usuario cidade',
    'vinculado_actual': 'Vinculado atualmente',
    'desvincular': 'Desvincular',
    'buscar_usuario_ciudad': 'Buscar por nome, email ou cidade...',
    'sin_usuarios_ciudad': 'Nenhum usuario com funcao cidade registrado',
    'ciudad_vinculada_ok': 'Cidade vinculada com sucesso',
    'ciudad_desvinculada': 'Cidade desvinculada',
    'vincular': 'Vincular',
    'codigo_generado': 'Codigo gerado',
    'codigo_generado_ok': 'Codigo da cidade gerado',
    'codigo_vinculado_candidatura': 'Pre-vinculado a esta candidatura',
    'idioma_carta': 'Idioma da carta',
    'carta_copiada': 'Carta copiada para a area de transferencia',
    'copiar_carta': 'Copiar',
    'enviar_invitacion': 'Abrir email',
    'email_cliente_abierto': 'Cliente de email aberto',
    'estado_avanza_aceptada': 'Candidatura aceita automaticamente',
    'estado_avanza_documentacion': 'Avancando para fase de documentacao',
    'estado_avanza_visita': 'Avancando para fase de visita',
    'estado_avanza_evaluacion': 'Avancando para fase de avaliacao',
    'confirmar_avance_estado': 'Avancar status para',
    'estado_cambiado': 'Status alterado para',
    'eval_ciudades_galardonadas': 'Cidades premiadas',
    // ── Delegado + Checklist retroceso (15 abril 2026) ──
    'delegado_titulo': 'Delegado',
    'delegado_desc': 'O delegado pode ver o status da candidatura e documentos pendentes.',
    'asignar_delegado': 'Atribuir',
    'cambiar_delegado': 'Alterar',
    'sin_delegado': 'Sem delegado atribuído',
    'confirmar_quitar_delegado': 'Remover delegado desta candidatura?',
    'delegado_quitado': 'Delegado removido',
    'delegado_asignado': 'Delegado atribuído',
    'delegado_existente': 'Usuário existente',
    'delegado_invitar': 'Convidar por email',
    'generar_codigo_delegado': 'Gerar código de delegado',
    'codigo_delegado_generado': 'Código gerado — envie o email',
    'nombre_delegado_hint': 'Nome do delegado',
    'email_delegado_hint': 'email@exemplo.com',
    'confirmar_retroceso_estado': 'Retroceder status para',
    'accion_gala': 'Convidar para Gala',
    'accion_gala_desc': 'Confirma o gala e adiciona a cidade ao evento do ano.',
    'accion_notificar': 'Marcar como notificada',
    'accion_notificar_desc_simple': 'Muda o estado para notificada. A comunicação à cidade é feita fora do app.',
    'accion_premio': 'Entregar prêmio',
    'accion_titularidad': 'Ativar titularidade',
    'activar_titularidad': 'Ativar titularidade',
    'anos_label': 'Anos',
    'aprobar_informe': 'Aprovar',
    'archivo_muy_grande': 'O arquivo excede 50 MB',
    'badge': 'Insígnia',
    'cambiar_estado': 'Mudar estado',
    'candidatura_actualizada': 'Candidatura atualizada',
    'chat_ayer': 'Ontem',
    'chat_hoy': 'Hoje',
    'chat_primer_mensaje': 'Envie a primeira mensagem',
    'checklist_obligaciones': 'Obrigações',
    'ciudad_notificada': 'Cidade notificada',
    'comentario_rechazo': 'Comentário obrigatório para a rejeição:',
    'comite_label': 'Comitê',
    'confirmar_cambio_estado': 'Confirmar mudança de estado?',
    'confirmar_gala': 'Confirmar gala',
    'confirmar_notificar': 'Marcar como notificada?',
    'confirmar_pago': 'Confirmar pagamento recebido',
    'Copiado': 'Copiado',
    'delegado_info_restriccion': 'Como delegado você pode ver o estado do pipeline e a agenda de visita. Para acessar o motor de avaliação ou o BID File, solicite atribuição como avaliador à ACES.',
    'delegado_mis_candidaturas': 'Como delegado',
    'delegado_vista': 'Visão de delegado',
    'delegado_vista_restringida': 'Visão restrita: apenas pipeline, agenda e documentos pendentes. Sem pagamentos ou avaliações.',
    'derechos_imagen': 'Direitos de imagem',
    'editar_candidatura': 'Editar candidatura',
    'Eliminado': 'Eliminado',
    'email': 'Email',
    'emitir_factura': 'Emitir fatura (PDF)',
    'entre_miembros': 'Entre',
    'espera_repetir': 'Espera para repetir',
    'estado_actualizado': 'Estado atualizado',
    'estado_gala_confirmada': 'Gala confirmado',
    'estado_notificada': 'Notificada',
    'estado_notificada_rechazo': 'Rejeição notificada',
    'estado_premio_otorgado': 'Prêmio concedido',
    'estado_titularidad_activa': 'Titularidade ativa',
    'eval_comentario_criterio': 'Comentários sobre este critério...',
    'factura': 'Fatura',
    'factura_emitida': 'Fatura enviada',
    'fase_candidatura': 'Candidatura',
    'fase_seguimiento': 'Acompanhamento',
    'gala_confirmada_ok': 'Gala confirmado',
    'Guardado': 'Salvo',
    'hito_agenda': 'Agenda de visita aceita',
    'hito_carta': 'Carta de solicitação aceita',
    'hito_pago': 'Fatura paga',
    'hito_reglamento_env': 'Regulamento recebido',
    'hito_reglamento_firm': 'Regulamento assinado',
    'hito_viajes': 'Logística de viagem concluída',
    'image_rights': 'Direitos de imagem',
    'importe': 'Valor',
    'informe_aprobado': 'Relatório aprovado',
    'informe_rechazado': 'Relatório rejeitado',
    'informe_subido': 'Relatório enviado',
    'informes_trimestrales': 'Relatórios trimestrais',
    'marcar_notificada': 'Marcar como notificada',
    'marcar_premio': 'Marcar prêmio entregue',
    'max_candidatos': 'Máx. candidatos',
    'miembros_label': 'Membros',
    'notificar_rechazo': 'Notificar rejeição',
    'nueva_version': 'Nova versão',
    'ocultar': 'Ocultar',
    'permisos_documento': 'Permissões do documento',
    'permisos_guardados': 'Permissões salvas',
    'poblacion_maxima': 'População máxima',
    'poblacion_minima': 'População mínima',
    'rechazar_informe': 'Rejeitar',
    'region_africa': 'África',
    'region_americas': 'Américas',
    'region_asia': 'Ásia',
    'region_europa': 'Europa',
    'region_mundial': 'Mundial',
    'region_oceania': 'Oceania',
    'reglamentos_pendientes': 'Regulamentos pendentes',
    'seleccionar_tipo': 'Tipo de documento',
    'sin_resultados_busqueda': 'Nenhum resultado encontrado',
    'subir_informe': 'Enviar relatório',
    'tasa_label': 'Taxa',
    'tipo_anexo': 'Anexo',
    'tipo_especial': 'Especial',
    'tipo_no_permitido': 'Tipo de arquivo não permitido. Use PDF, DOC, DOCX, XLS, XLSX, JPG ou PNG',
    'tipo_principal': 'Principal',
    'titularidad_activa_label': 'Titularidade ativa',
    'titularidad_creada': 'Titularidade criada',
    'titularidad_panel': 'Minha titularidade',
    'tomar_decision_final': 'Tomar decisão final',
    'ver_documento': 'Ver',
    'ver_escala': 'Ver escala',
    'ver_reglamento': 'Ver regulamento completo',
    'ver_seguimiento': 'Ver acompanhamento de titularidade',
    'visible_admin': 'Admin',
    'visible_ciudad': 'Cidade',
    'visible_evaluador': 'Avaliador',
    'visible_master': 'Master',
    'visible_para': 'Visível para',
    'warning_quitar_adjudicada': 'Retroceder antes de "Adjudicada" removerá a marca de adjudicação permanente.',
    'warning_retroceso': 'Tem certeza que deseja retroceder o estado?',
    'y_label': 'e',
    'Q1_nombre': 'Jan-Mar',
    'Q2_nombre': 'Abr-Jun',
    'Q3_nombre': 'Jul-Set',
    'Q4_nombre': 'Out-Dez',
    'informe_pendiente': 'Pendente',
    'pago_pendiente': 'Pendente',
    'checklist_logo_aces': 'Uso correto do logo ACES',
    'checklist_memoria_anual': 'Relatório anual entregue',
    'checklist_congreso': 'Participação no congresso ACES',
    'checklist_imagen_corporativa': 'Imagem corporativa atualizada',
    'checklist_calendario_deportivo': 'Calendário esportivo publicado',
    'asignar_evaluadores': 'Atribuir avaliadores',
    'notas_internas_opcional': 'Notas internas (opcional)',
    'estado_candidatura': 'Status da candidatura',
    'hito_carta_recibida': 'Carta de solicitação recebida',
    'hito_candidatura_aceptada': 'Candidatura aceita',
    'hito_reglamento_enviado': 'Regulamento enviado',
    'hito_reglamento_firmado': 'Regulamento assinado',
    'hito_datos_facturacion': 'Dados de faturamento recebidos',
    'hito_pago_confirmado': 'Pagamento confirmado',
    'hito_fechas_visita': 'Datas de visita aceitas',
    'hito_comision_cerrada': 'Comissão fechada',
    'hito_reservas_completadas': 'Reservas concluídas',
    'hito_agenda_subida': 'Agenda enviada',
    'hito_bid_file_recibido': 'BID File recebido',
    'editar_visita': 'Editar visita',
    'programar_visita_btn': 'Agendar visita',
    'gestionar_comision': 'Gerenciar comissão',
    'pagos_titulo': 'Pagamentos',
    'sin_pagos': 'Sem pagamentos registrados',
    'factura_marcada': 'Fatura marcada',
    'factura_desmarcada': 'Fatura desmarcada',
    'pago_confirmado_label': 'Pagamento confirmado',
    'pago_desmarcado': 'Pagamento niet gemarkeerd',
    'vence_label': 'Vencimento',
    'factura_label': 'Fatura',
    'pagado_label': 'Pago',
    'documentos_titulo': 'Documentos',
    'archivos_count': 'arquivo',
    'archivos_count_plural': 'arquivos',
    'subir_btn': 'Enviar',
    'sin_documentos': 'Sem documentos enviados',
    'aprobado_label': 'Aprovado',
    'rechazado_label': 'Rejeitado',
    'sin_permisos': 'Sem permissões',
    'ver_label': 'Ver',
    'logistica_titulo': 'Logística',
    'agenda_visita': 'Agenda de visita',
    'subir_pdf': 'Enviar PDF',
    'sin_agenda': 'Sem agenda enviada',
    'reservas_titulo': 'Reservas',
    'general_sin_eval': 'Geral (sem avaliador)',
    'subir_reserva': 'Enviar reserva',
    'sin_reservas': 'Sem reservas enviadas',
    'agenda_subida_ok': 'Agenda enviada',
    'reserva_subida_ok': 'Reserva enviada',
    'evaluador_actualizado': 'Avaliador atualizado',
    'general_todos_eval': 'Geral (todos os avaliadores)',
    'cambiar_evaluador': 'Alterar avaliador',
    'evaluaciones_titulo': 'Avaliações',
    'enviada_label': 'enviada',
    'enviadas_label': 'enviadas',
    'en_progreso_label': 'em andamento',
    'comision_asignada': 'Comissão atribuída',
    'evaluador_label': 'avaliador',
    'evaluadores_label': 'avaliadores',
    'jefe_label': 'Chefe',
    'sin_empezar': 'Não iniciado',
    'sin_evaluadores': 'Sem avaliadores atribuídos',
    'enviada_badge': 'Enviada',
    'favorable_label': 'Favorável',
    'desfavorable_label': 'Desfavorável',
    'desbloquear_label': 'Desbloquear',
    'evaluacion_desbloqueada': 'Avaliação desbloqueada',
    'error_desbloquear': 'Erro ao desbloquear',
    'pdf_generado': 'PDF gerado',
    'error_pdf': 'Erro ao gerar PDF',
    'en_progreso_badge': 'Em andamento',
    'tomar_decision': 'Tomar decisão final',
    'cerrar_menu': 'Fechar menu',
    'compartir_tel_ciudad': 'Compartilhar telefone com a cidade candidata',
    'compartir_tel_eval': 'Compartilhar telefone com outros avaliadores',
    'notas_internas': 'Notas internas',
    'notas_privadas_placeholder': 'Notas privadas...',
    'guardado_ok': 'Salvo',
    'generar_btn': 'Gerar',
    'copiado_ok': 'Copiado',
    'idioma_destinatario': 'Idioma do destinatário',
    'codigo_acceso_modal': 'Código de acesso',
    'gala_activa': 'ATIVA',
    'gala_inactiva': 'INATIVA',
    'calendario_carta': 'Carta do prefeito: 30 mar',
    'calendario_bid': 'Arquivo BID: 30 jun',
    'calendario_preseleccion': 'Pré-seleção: 31 jul',
    'calendario_visitas': 'Visitas: out',
    'calendario_gala': 'Gala: nov',
    'calendario_titularidad': 'Titularidade: 1 jan seguinte',
    'candidatura_singular': 'candidatura',
    'candidaturas_plural': 'candidaturas',
    'doc_tipo_bid_file': 'Arquivo BID',
    'doc_tipo_presentacion': 'Apresentação',
    'progreso_inicio': 'Início',
    'progreso_adjudicada': 'Adjudicada',
    'hab_label': 'hab.',
    'eval_abreviado': 'aval.',
    'min_poblacion_label': 'População mín.',
    'max_poblacion_label': 'População máx.',
    'max_candidatos_label': 'Máximo candidatos',
    'espera_label': 'Período de espera',
    'anos_label': 'anos',
    'image_rights': 'Direitos de imagem',
    'comite_label': 'Comitê',
    'miembros_label': 'membros',
    'usado_label': 'USADO',
    'disponibles_count': 'Disponíveis',
    'usados_count': 'Usados',
    'codigos_disponibles_count': 'Códigos disponíveis',
    'hotel_placeholder': 'Hotel designado, check-in, regras...',
    'vuelo_placeholder': 'Aeroporto, horários, classe...',
    'parlamento_placeholder': 'Endereço, normas de acesso, protocolo...',
    'dni_pasaporte': 'RG / Passaporte',
    'cerrar_menu': 'Fechar menu',
    // P1-I18N 23sep2026 (overrides: el último valor gana)
    'voto_emitido': 'Voto registrado:',
    'password_min': 'Mínimo de 6 caracteres',
    'titulos_adjudicados': 'Títulos concedidos',
    'estado': 'Status',
    'actividad': 'Atividade',
    'aprobar': 'Aprovar',
    'auth_cargando': 'Entrando...',
    'auth_cerrar_sesion': 'Sair',
    'auth_entrar': 'Entrar',
    'auth_error_credenciales': 'Email ou senha incorretos.',
    'auth_error_red': 'Sem conexão com a internet.',
    'auth_subtitulo': 'Plataforma de candidaturas esportivas ACES',
    'avanzar_a': 'Avançar para',
    'buscar_placeholder': 'Buscar cidade, prêmio...',
    'cambios': 'Alterações',
    'cat_infra': 'Infraestrutura',
    'cat_otros': 'Outros',
    'cat_presupuesto': 'Orçamento',
    'categoria': 'Categoria',
    'cerrar': 'Fechar',
    'chat_ciudad': 'Chat com a ACES',
    'chat_escribir': 'Escreva uma mensagem...',
    'chat_interno': 'Chat da comissão',
    'warn_espera': 'Período de espera',
    'ciudad': 'Cidade',
    'ciudad_contacto_principal': 'Contato principal',
    'ciudad_historico': 'Histórico',
    'ciudad_sin_candidatura': 'Sem candidatura ativa',
    'ciudad_sin_candidatura_desc': 'Entre em contato com a ACES para iniciar o processo.',
    'codigo_activando': 'Ativando...',
    'codigo_activar': 'Ativar código',
    'codigo_error_invalido': 'Código inválido ou já utilizado.',
    'codigo_subtitulo': 'Insira o código ACESCN fornecido pela ACES.',
    'codigo_titulo': 'Código de acesso',
    'codigos_disponibles': 'Disponíveis',
    'codigos_generados': 'Códigos gerados',
    'completado': 'concluído',
    'config_convocatorias': 'Chamadas abertas',
    'config_guardada': 'Configurações salvas',
    'config_sanciones': 'Multas por ausência na gala (€)',
    'config_tasas': 'Taxas de participação (€)',
    'confirmar_asistencia': 'Confirmar presença',
    'contacto_principal': 'Contato principal',
    'convocatoria': 'Edição',
    'creando': 'Criando...',
    'crear_candidatura': 'Criar candidatura',
    'dashboard_estado': 'Status da candidatura',
    'decision_adjudicar': 'Conceder',
    'decision_advertencia': 'Esta decisão é inapelável e ficará registrada permanentemente.',
    'decision_confirmar': 'Confirmar decisão',
    'decision_nav': 'Decisão final',
    'decision_notas': 'Notas da decisão (obrigatório)',
    'decision_rechazar': 'Não conceder',
    'decision_selecciona': 'Selecione a decisão',
    'decision_titulo': 'Decisão final',
    'dias': 'dias',
    'eliminar': 'Excluir',
    'eliminar_cuenta': 'Excluir minha conta',
    'eliminar_cuenta_desc': 'Esta ação é irreversível. Seus dados serão anonimizados conforme o RGPD.',
    'eliminar_cuenta_password': 'Digite sua senha para confirmar',
    'eliminar_cuenta_titulo': 'Excluir conta',
    'eliminar_documento': 'Excluir documento',
    'email_contacto': 'Email de contato',
    'enviar_propuesta': 'Enviar proposta',
    'escribiendo': 'está digitando',
    'estado_adjudicada': 'Concedida',
    'estado_pipeline': 'Pipeline da candidatura',
    'eval_asignadas': 'Minhas atribuídas',
    'eval_bonus': 'Bônus',
    'eval_cargando': 'Carregando avaliação...',
    'eval_comentario_placeholder': 'Comente sua pontuação...',
    'eval_comentario_voto': 'Comentário sobre o voto final',
    'eval_confirmar_desc': 'Depois de enviada, você não poderá modificá-la sem que o Master a desbloqueie.',
    'eval_confirmar_envio': 'Enviar avaliação',
    'eval_conflicto_interes': 'Conflito de interesse: você é do mesmo país que a cidade candidata a Capital.',
    'eval_desfavorable': 'Desfavorável',
    'eval_enviada_desc': 'Sua avaliação foi registrada com sucesso.',
    'eval_enviada_titulo': 'Avaliação enviada',
    'eval_favorable': 'Favorável',
    'eval_habilitada': 'Avaliação habilitada',
    'eval_ir_motor': 'Ir para o motor de avaliação',
    'eval_lista': 'Avaliadores',
    'eval_mi_evaluacion': 'Minha avaliação',
    'eval_mis_candidaturas': 'Minhas candidaturas',
    'eval_motor_titulo': 'Motor de avaliação',
    'eval_notas_comentario': 'Notas e comentários',
    'eval_registrados': 'Cadastrados',
    'eval_seccion': 'Seção',
    'eval_siguiente': 'Próximo',
    'eval_sin_activas': 'Sem candidaturas ativas',
    'eval_sin_asignadas': 'Sem candidaturas atribuídas',
    'eval_sin_asignadas_desc': 'O Master atribuirá candidaturas à sua comissão.',
    'eval_stat_asignadas': 'Atribuídas',
    'eval_stat_completadas': 'Concluídas',
    'eval_stat_pendientes': 'Pendentes',
    'eval_todas': 'Todas ativas',
    'eval_todas_activas': 'Candidaturas ativas',
    'eval_todas_aviso': 'Visualização somente leitura. Detalhes completos apenas para suas candidaturas atribuídas.',
    'eval_total_seccion': 'Pontuação desta seção',
    'eval_ver_escala': 'Ver escala de pontuação',
    'eval_voto_informativo': 'Seu voto é consultivo. A decisão final cabe ao Master ACES.',
    'evaluacion_titulo': 'Avaliação',
    'evaluaciones_enviadas': 'avaliações enviadas',
    'evaluadores_asignados': 'avaliadores atribuídos',
    'fecha_regreso': 'Data de volta',
    'fecha_salida': 'Data de ida',
    'filtro_estado': 'Status',
    'gala_asistencia_confirmada': 'Presença confirmada',
    'gala_invitacion_titulo': 'Convite para a Gala',
    'gala_pendiente_desc': 'A ACES ativará seu convite quando chegar o momento.',
    'gala_pendiente_invitacion': 'Convite pendente',
    'gala_sin_datos': 'Sem dados da gala',
    'gala_sin_datos_desc': 'Não há informações da cerimônia para este ano.',
    'gala_sin_representantes': 'Nenhum representante adicionado',
    'galardon': 'Prêmio',
    'general_error': 'Ocorreu um erro',
    'general_reintentar': 'Tentar novamente',
    'generar_codigo': 'Gerar código',
    'generar_codigo_titulo': 'Novo código de acesso',
    'guardado': 'Salvo',
    'guardando': 'Salvando...',
    'guardar': 'Salvar',
    'guardar_config': 'Salvar configurações',
    'hora': 'Horário',
    'llegada': 'Chegada',
    'lugar': 'Local',
    'marcar_leidas': 'Marcar todas como lidas',
    'master_panel_desc': 'Controle total de candidaturas, avaliações e decisões.',
    'master_recientes': 'Candidaturas recentes',
    'master_saludo': 'Painel ACES',
    'master_sin_candidaturas': 'Nenhuma candidatura ainda',
    'mod_pagos': 'Pagamentos',
    'mod_titularidad': 'Titularidade',
    'nombre_documento': 'Nome do documento',
    'nombre_hotel': 'Nome do hotel',
    'notif_sin_leer': 'Não lidas',
    'notif_sin_notifs': 'Sem notificações',
    'nueva_candidatura': 'Nova candidatura',
    'nueva_propuesta': 'Nova proposta',
    'num_habitaciones': 'Número de quartos',
    'origen': 'Origem',
    'pago_instrucciones': 'Faça a transferência bancária e envie o comprovante.',
    'perfil_apellidos': 'Sobrenome',
    'perfil_contacto': 'Contato',
    'perfil_idioma': 'Idioma do app',
    'perfil_nombre': 'Nome',
    'perfil_notificaciones': 'Notificações',
    'perfil_telefono': 'Telefone',
    'precio_aprox': 'Preço aproximado (€)',
    'proponer_vuelo': 'Voo',
    'rechazar': 'Rejeitar',
    'salida': 'Saída',
    'seleccionar': 'Selecionar',
    'sin_candidaturas': 'Sem candidaturas',
    'sin_candidaturas_desc': 'Não há candidaturas com este filtro.',
    'sin_documentos_desc': 'Envie os documentos exigidos para sua candidatura.',
    'sin_evaluaciones': 'Sem avaliações',
    'sin_pagos_desc': 'Os pagamentos da sua candidatura aparecerão aqui.',
    'stat_activas': 'Ativas',
    'stat_decision': 'Decisão pendente',
    'stat_evaluacion': 'Em avaliação',
    'stat_notif': 'Não lidas',
    'stat_titulos': 'Títulos ativos',
    'subir_documento': 'Carregar documento',
    'subir_nota': 'Selecione o arquivo no seu dispositivo',
    'tab_config': 'Configurações',
    'tab_evaluaciones': 'Avaliações',
    'tab_evaluadores': 'Avaliadores',
    'tab_notif': 'Notificações',
    'tab_pagos': 'Pagamentos',
    'tab_resumen': 'Resumo',
    'tit_ano_titulo': 'Ano de titularidade',
    'tit_evidencias': 'Evidências enviadas',
    'tit_item_calendario': 'Calendário esportivo',
    'tit_item_congreso': 'Congresso ou conferência',
    'tit_item_imagen': 'Uso correto do título',
    'tit_item_memoria': 'Relatório final',
    'tit_no_aplica': 'Sem ano de titularidade',
    'tit_no_aplica_desc': 'Este módulo é ativado quando sua cidade ganha um prêmio ACES.',
    'tit_sanciones': 'Multas',
    'tit_sin_datos': 'Sem titularidades ativas',
    'tit_titulo': 'Ano de titularidade',
    'toca_copiar': 'Toque no código para copiar',
    'ver_comprobante': 'Ver comprovante',
    'viaje_aviso_privacidad': 'A identidade dos avaliadores é confidencial. Você verá apenas datas e logística.',
    'viaje_sin_propuestas': 'Sem propostas de viagem',
    'viaje_sin_propuestas_desc': 'Proponha opções de voo, hotel e agenda para a visita.',
    'visita_evaluadores': 'Visita dos avaliadores',
    'visita_programada': 'Visita agendada',
    'visita_sin_programar': 'Visita ainda não agendada',
    'visita_titulo': 'Visita de avaliação',
    'adjudicar': 'Conceder',
    'notas_guardadas': 'Notas salvas',
    'modo_master_activo': 'Visão Master ACES',
    'hora_label': 'Horário',
    'eval_completadas': 'Concluídas',
    'subir_reserva_hint': 'Envie o PDF da reserva de voo ou hotel confirmada.',
    'subir_reserva_hint_eval': 'Envie o PDF da sua reserva de voo ou hotel.',
    'login_sin_cuenta': 'Não tem conta?',
    'agenda_oficial_titulo': 'Agenda oficial da visita',
    'agenda_anadir_evento': 'Adicionar evento',
    'agenda_editar_evento': 'Editar evento',
    'agenda_oficial_aviso': 'Esta agenda é visível para os avaliadores. A cidade vê datas e logística, mas não os nomes dos avaliadores.',
    'agenda_oficial_vacia': 'Ainda não há eventos publicados. Adicione o programa da visita para que os avaliadores possam vê-lo.',
    'publicar_evento': 'Publicar evento',
    'evento_publicado': 'Evento publicado na agenda',
    'evento_guardado': 'Evento atualizado',
    'evento_eliminado': 'Evento excluído',
    'confirmar_eliminar': 'Excluir este evento?',
    'guardar_cambios': 'Salvar alterações',
    'cobrado': 'Recebido',
    'visitas_proximas': 'Próximas visitas',
    'paises_titulo': 'Por país',
    'evidencias_short': 'evidências',
    'nav_registro': 'Cadastro',
    'preambulo': 'Preâmbulo',
    'doc_eliminado': 'Documento excluído',
    'revenue_cobrado': 'Recebido',
    'revenue_pendiente': 'Pendente',
    'codigo_vinculado_candidatura': 'Pré-vinculado a esta candidatura',
    'Eliminado': 'Excluído',
    'agenda_visita': 'Agenda da visita',
    'progreso_adjudicada': 'Concedida',
    'max_candidatos_label': 'Máximo de candidatos',
    'sin_fecha_visita': 'Sem data de visita',
    // Brief 3 (23sep2026): comentario general por sección del motor
    'eval_comentario_seccion': 'Comentário da seção',
    'eval_comentario_seccion_placeholder': 'Comentário geral da seção (opcional)',
    // Barrido español fijo — 23sep2026
    'error_con_detalle': 'Erro: {0}',
    'pdf_evaluacion': 'Avaliação em PDF',
    'pdf_informe_titulo': 'ACES Cities Network — Relatório de avaliação',
    'pdf_ciudad': 'Cidade',
    'pdf_evaluador': 'Avaliador',
    'pdf_fecha': 'Data',
    'pdf_total': 'Pontuação total',
    'pdf_secciones': 'Seções',
    'pdf_voto_final': 'Voto final',
    'pdf_comentario_voto': 'Comentário do voto',
    'pdf_no_evaluada': 'Não avaliada',
    'pdf_generado_por': 'Gerado por ACES Cities Network · {0}',
    'email_placeholder': 'nome@exemplo.com',
    'ej_nombre_persona': 'Ex.: Maria Silva',
    'ej_aeropuerto': 'Ex.: São Paulo (GRU)',
    'pdf_permitir_popups': 'Permita pop-ups para exportar o PDF',
    'confirmar': 'Confirmar',
    // Barrido español fijo — 23sep2026
    'aceptar': 'OK',
    'atencion': 'Atenção',
    'confirmar_eliminar_doc': 'Excluir este documento? Esta ação não pode ser desfeita.',
    'confirmar_eliminar_logistica': 'Excluir este documento de logística?',
    'confirmar_notificar_titulo': 'Notificar a cidade',
    'confirmar_retroceso_titulo': 'Confirmar retrocesso',
    'eliminado': 'Excluído',
    'quitar_delegado_titulo': 'Remover delegado',
    'warning_quitar_adjudicada_titulo': 'Remover premiação',
    'warning_retroceso_2': 'CONFIRMAR? Os dados serão excluídos de forma irreversível (datas, registros da cerimônia etc.). Esta ação NÃO pode ser desfeita.',
    'warning_retroceso_titulo': 'Retroceder status',
    'eval_pts': 'pts',
    // Corrección de acentos — 23sep2026
    'codigo_generado': 'Código gerado',
    // Barrido español fijo — 23sep2026
    'viaje_tipo_reserva_vuelo': 'Reserva de voo',
    'viaje_tipo_reserva_hotel': 'Reserva de hotel',
    'reserva_generica': 'Reserva',
  }
};

export default strings;